// @ts-ignore
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Cgu: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  CurrencyCode: { input: any; output: any; }
  Date: { input: Date; output: Date; }
  DateTime: { input: Date; output: Date; }
  DetailValue: { input: any; output: any; }
  EmailAddress: { input: string; output: string; }
  GeoFeatureCode: { input: any; output: any; }
  HTML: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Latitude: { input: number; output: number; }
  Longitude: { input: number; output: number; }
  Markdown: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  PhoneInput: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RRule: { input: string; output: string; }
  Siret: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  TopLevelCondition: { input: any; output: any; }
  URL: { input: string; output: string; }
  /** from graphql-upload-ts */
  Upload: { input: any; output: any; }
}

export interface AbTest {
  createdAt: Scalars['DateTime']['output'];
  currentVersion?: Maybe<AbTestVersion>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versions?: Maybe<Array<AbTestVersion>>;
}

export interface AbTestVersion {
  abTest: AbTest;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  options: Array<AbTestVersionOption>;
  startAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface AbTestVersionInput {
  distribution: Scalars['Int']['input'];
  value: Scalars['String']['input'];
}

export interface AbTestVersionOption {
  abTestVersion: AbTestVersion;
  createdAt: Scalars['DateTime']['output'];
  distribution: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
}

export interface AbuseType {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

/** User access to an action */
export interface Access {
  /** Number of actions left */
  actionsLeft?: Maybe<Scalars['Int']['output']>;
  currentSubscription: SubscriptionType;
  /** Extra data like picture ids seen */
  extraData?: Maybe<AccessExtraData>;
  /** If the action is limited or not */
  isLimited: Scalars['Boolean']['output'];
  /** Name of the action requested */
  name: AccessName;
  /** Access reset at date (utc) */
  resetAt?: Maybe<Scalars['DateTime']['output']>;
  /** Next level of subscription type */
  upgradeTo?: Maybe<SubscriptionType>;
  /** Debug */
  userId?: Maybe<Scalars['Int']['output']>;
}

export enum AccessConfig {
  AddKiss = 'addKiss',
  Default = 'default',
  Visit = 'visit'
}

export interface AccessExtraData {
  slugs: Array<Scalars['ID']['output']>;
}

export enum AccessName {
  AddBookmark = 'addBookmark',
  AddKiss = 'addKiss',
  DoMiniSpeedflirt = 'doMiniSpeedflirt',
  DoSpeedflirt = 'doSpeedflirt',
  EnlargePicture = 'enlargePicture',
  FavoriteGame = 'favoriteGame',
  PictureLike = 'pictureLike',
  PictureView = 'pictureView',
  ProfileVisit = 'profileVisit',
  ReadMessage = 'readMessage',
  RollbackFavoriteGame = 'rollbackFavoriteGame',
  RollbackSpeedflirt = 'rollbackSpeedflirt',
  SearchCity = 'searchCity',
  SearchRelationshipTag = 'searchRelationshipTag',
  SeeRelationshipTag = 'seeRelationshipTag',
  SeeSnap = 'seeSnap',
  SendMessage = 'sendMessage',
  SkipFavoriteGame = 'skipFavoriteGame',
  SwipeFromLikeList = 'swipeFromLikeList',
  WhoVisitMyProfile = 'whoVisitMyProfile'
}

export interface AccountingQuery {
  pendingPayment: PendingPaymentQuery;
}

export interface AchievementEvent extends GamificationEvent, RewardEvent {
  eventType: GamificationEventType;
  payload: AchievementEventPayload;
  reward?: Maybe<Reward>;
}

export interface AchievementEventPayload {
  countReached: Scalars['Int']['output'];
  currentCount: Scalars['Int']['output'];
  stepReached: Scalars['Int']['output'];
  type: AchievementType;
}

export enum AchievementType {
  BuyBoost = 'BuyBoost',
  BuyFastPass = 'BuyFastPass',
  BuySuperLike = 'BuySuperLike',
  FastPassReceived = 'FastPassReceived',
  LevelUp = 'LevelUp',
  LikeReceived = 'LikeReceived',
  LikeSent = 'LikeSent',
  Login = 'Login',
  Match = 'Match',
  MessageSent = 'MessageSent',
  PictureAdd = 'PictureAdd',
  Premium = 'Premium',
  SecondChanceGiven = 'SecondChanceGiven',
  SnapAdd = 'SnapAdd',
  SuperLikeReceived = 'SuperLikeReceived',
  Swipes = 'Swipes',
  VisitReceived = 'VisitReceived',
  LikesReceived = 'likesReceived'
}

export type ActionCta = ActionOnRedirectCta | ActionOnSlugCta;

export interface ActionExtra {
  action: ActionQuota;
  amount: Scalars['Int']['output'];
  expireAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
}

export enum ActionOnRedirect {
  AddPicture = 'ADD_PICTURE',
  AddSnap = 'ADD_SNAP',
  Message = 'MESSAGE',
  Models = 'MODELS',
  MyProfile = 'MY_PROFILE',
  Premium = 'PREMIUM',
  Profile = 'PROFILE',
  Search = 'SEARCH',
  SearchDistance = 'SEARCH_DISTANCE',
  SearchLastlogin = 'SEARCH_LASTLOGIN',
  SecondChance = 'SECOND_CHANCE',
  Speedflirt = 'SPEEDFLIRT',
  Subscribers = 'SUBSCRIBERS',
  Visits = 'VISITS'
}

export interface ActionOnRedirectCta {
  enumRedirect?: Maybe<ActionOnRedirect>;
}

export interface ActionOnRedirectFeed {
  enumRedirect?: Maybe<ActionOnRedirect>;
  urlRedirect?: Maybe<Scalars['String']['output']>;
}

export enum ActionOnSlug {
  AcceptPrivatePicAuth = 'ACCEPT_PRIVATE_PIC_AUTH',
  Comment = 'COMMENT',
  Like = 'LIKE'
}

export interface ActionOnSlugCta {
  action: ActionOnSlug;
  slug?: Maybe<Scalars['String']['output']>;
}

export enum ActionOnSwitch {
  SwitchNudityFilter = 'SWITCH_NUDITY_FILTER'
}

export interface ActionQuota {
  free?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  premium?: Maybe<Scalars['Int']['output']>;
  quotaType: UhcType;
  trial?: Maybe<Scalars['Int']['output']>;
}

export interface ActionQuotaInput {
  free?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  premium?: InputMaybe<Scalars['Int']['input']>;
  quotaType: UhcType;
  trial?: InputMaybe<Scalars['Int']['input']>;
}

export enum ActiveLanguage {
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pt = 'PT'
}

export enum ActivityLogType {
  AcceptedRetractionRenunciationPayment = 'ACCEPTED_RETRACTION_RENUNCIATION_PAYMENT',
  AcceptedRetractionRenunciationVision = 'ACCEPTED_RETRACTION_RENUNCIATION_VISION',
  Boost_72H = 'BOOST_72H',
  GotFirstTrustPilotSurvey = 'GOT_FIRST_TRUST_PILOT_SURVEY',
  GotSecondTrustPilotSurvey = 'GOT_SECOND_TRUST_PILOT_SURVEY',
  RebillReminder = 'REBILL_REMINDER',
  ReceivedUnsubscriptionGift = 'RECEIVED_UNSUBSCRIPTION_GIFT',
  SeenCoachingWelcome = 'SEEN_COACHING_WELCOME',
  SeenDailyAddSnap = 'SEEN_DAILY_ADD_SNAP',
  SeenFavoriteGameTutorial = 'SEEN_FAVORITE_GAME_TUTORIAL',
  SeenFeedTutorial = 'SEEN_FEED_TUTORIAL',
  SeenGeneratedPicture = 'SEEN_GENERATED_PICTURE',
  SeenLayerEndBoost = 'SEEN_LAYER_END_BOOST',
  SeenLayerRebillReminder = 'SEEN_LAYER_REBILL_REMINDER',
  SeenSnapTutorial = 'SEEN_SNAP_TUTORIAL',
  SeenSpeedflirtTutorial = 'SEEN_SPEEDFLIRT_TUTORIAL',
  SeenTipsPhotoRatingFilter = 'SEEN_TIPS_PHOTO_RATING_FILTER',
  SeenTipsSfBirthdateRequired = 'SEEN_TIPS_SF_BIRTHDATE_REQUIRED',
  SeenTipsSfPictureRequired = 'SEEN_TIPS_SF_PICTURE_REQUIRED',
  SeenWelcomeSnap = 'SEEN_WELCOME_SNAP'
}

export interface AdEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node: AdItem;
}

export interface AdItem {
  height: Scalars['Int']['output'];
  html: Scalars['String']['output'];
  slot: Ads;
  sourceId: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
}

export interface Address {
  city: Scalars['String']['output'];
  countryIso: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPreferred: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
}

export enum AddressType {
  Billing = 'BILLING',
  Default = 'DEFAULT'
}

export interface AdminPaymentMutation {
  addInflow?: Maybe<UpdatedInflowsResponse>;
  deleteOutflow?: Maybe<Scalars['Boolean']['output']>;
  /** Generates an outflow without the need for a payment request previously made. */
  forceOutflow: OutflowResponse;
  /** Generates an outflow based on a payment request previously made. */
  generateOutflow: OutflowResponse;
  requestPayment?: Maybe<RequestPaymentResponse>;
  /** If the input is an empty array, it will validate all pending payments. */
  validate?: Maybe<Array<Maybe<ValidatePendingPaymentResponse>>>;
}


export interface AdminPaymentMutationAddInflowArgs {
  input: InflowInput;
}


export interface AdminPaymentMutationDeleteOutflowArgs {
  input: OutflowDeleteInput;
}


export interface AdminPaymentMutationForceOutflowArgs {
  input: ForceOutflowInput;
}


export interface AdminPaymentMutationGenerateOutflowArgs {
  input: OutflowInput;
}


export interface AdminPaymentMutationRequestPaymentArgs {
  input: RequestPaymentAdminInput;
}


export interface AdminPaymentMutationValidateArgs {
  input: Array<InputMaybe<ValidatePendingPaymentInput>>;
}

export enum AdminRole {
  Biz = 'BIZ',
  Coaching = 'COACHING',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  Data = 'DATA',
  Dating = 'DATING',
  External = 'EXTERNAL',
  Front = 'FRONT',
  Legal = 'LEGAL',
  Manager = 'MANAGER',
  MarketingDesign = 'MARKETING_DESIGN',
  MarketingProduct = 'MARKETING_PRODUCT',
  Payment = 'PAYMENT',
  Sysadmin = 'SYSADMIN'
}

export interface AdminUser {
  birthDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['EmailAddress']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  fullname: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  login: Scalars['String']['output'];
  picture?: Maybe<Scalars['URL']['output']>;
  roles?: Maybe<Array<AdminRole>>;
}


export interface AdminUserPictureArgs {
  size?: InputMaybe<Scalars['Int']['input']>;
}

export type AdminUserInfo = AffiliateManager | SuperUser;

export enum AdminUserRole {
  Accounting = 'ACCOUNTING',
  AffiliateManager = 'AFFILIATE_MANAGER',
  Superuser = 'SUPERUSER'
}

export enum Ads {
  Alert = 'ALERT',
  Contacts = 'CONTACTS',
  FeedsCarousel = 'FEEDS_CAROUSEL',
  FeedsFull = 'FEEDS_FULL',
  FeedsFullCarousel = 'FEEDS_FULL_CAROUSEL',
  FeedsGrid = 'FEEDS_GRID',
  FeedsTwoThird = 'FEEDS_TWO_THIRD',
  FeedFullPage = 'FEED_FULL_PAGE',
  FeedModal = 'FEED_MODAL',
  Footer1 = 'FOOTER1',
  Footer2 = 'FOOTER2',
  Footer3 = 'FOOTER3',
  Menu = 'MENU',
  Search = 'SEARCH',
  Search2 = 'SEARCH2',
  Snaps = 'SNAPS',
  Speedflirt = 'SPEEDFLIRT',
  Speedflirt4S = 'SPEEDFLIRT4S',
  Userlist = 'USERLIST'
}

export enum AdsAction {
  Click = 'CLICK',
  View = 'VIEW'
}

export enum AdsType {
  Boost = 'BOOST',
  Coaching = 'COACHING',
  CoachingExternal = 'COACHING_EXTERNAL',
  Dating = 'DATING'
}

export interface Affiliate {
  addresses?: Maybe<Array<Address>>;
  affiliateManager?: Maybe<AffiliateManager>;
  /** All channel domains that are associated with this affiliate. */
  channelDomains?: Maybe<Array<ChannelDomain>>;
  commonUserId: Scalars['Int']['output'];
  companies?: Maybe<Array<AffiliateCompany>>;
  contract?: Maybe<Contract>;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Array<Maybe<AffiliateDetail>>>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoices?: Maybe<Array<Invoice>>;
  isEnabled: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  language?: Maybe<Language>;
  legacyUserId?: Maybe<Scalars['ID']['output']>;
  login: Scalars['String']['output'];
  newsletter: Scalars['Boolean']['output'];
  payment: AffiliatePayment;
  paymentMethods?: Maybe<Array<AffiliatePaymentMethod>>;
  people?: Maybe<Array<Person>>;
  preferredAddress?: Maybe<Address>;
  preferredCompany?: Maybe<AffiliateCompany>;
  sites?: Maybe<Array<AffiliateSite>>;
  sponsor?: Maybe<Affiliate>;
  sponsored?: Maybe<Array<Maybe<SponsorshipInfo>>>;
  sudoCommonUserId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}


export interface AffiliateDetailsArgs {
  input?: InputMaybe<InputGetAffiliateDetail>;
}


export interface AffiliateSponsoredArgs {
  period?: InputMaybe<Scalars['Date']['input']>;
}

export interface AffiliateCompanies {
  companies?: Maybe<Array<AffiliateCompany>>;
}

export interface AffiliateCompany {
  duns?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPreferred: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  noVat: Scalars['Boolean']['output'];
  vat?: Maybe<Scalars['String']['output']>;
}

export type AffiliateCompanyCreateResult = AffiliateCompany | AffiliateCompanyValidationError;

export type AffiliateCompanyUpdateResult = AffiliateCompanies | AffiliateCompanyValidationError;

export interface AffiliateCompanyValidationError extends Error {
  message: Scalars['String']['output'];
}

export interface AffiliateConnection extends PaginationConnection {
  edges?: Maybe<Array<AffiliateEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface AffiliateConnectionLog {
  affiliateId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  ip: Scalars['String']['output'];
  /** When an affiliate manager or super user connects to an affiliate's account from the CRM, this value will be filled with the first and last name of the <sudo user>. */
  sudoUser?: Maybe<Scalars['String']['output']>;
}

export interface AffiliateConnectionLogConnection extends PaginationConnection {
  edges?: Maybe<Array<AffiliateConnectionLogEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface AffiliateConnectionLogEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<AffiliateConnectionLog>;
}

export interface AffiliateDetail {
  affiliateId: Scalars['Int']['output'];
  input: DetailInput;
}

export interface AffiliateDetails {
  affiliateId: Scalars['Int']['output'];
  inputs: Array<DetailInput>;
}

export interface AffiliateEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Affiliate>;
}

export interface AffiliateLoggedMutation {
  createAddress?: Maybe<Address>;
  createCompany: AffiliateCompanyCreateResult;
  createContactMethodForPerson: ContactMethodForPersonCreateResponse;
  createPaymentMethod?: Maybe<AffiliatePaymentMethod>;
  createPerson?: Maybe<PersonCreateResponse>;
  deleteAddress?: Maybe<Array<Address>>;
  deleteCompany?: Maybe<Array<AffiliateCompany>>;
  deleteContactMethodForPerson?: Maybe<Array<ContactMethod>>;
  deletePaymentMethod: Scalars['Boolean']['output'];
  deletePerson?: Maybe<Array<Person>>;
  payment: AffiliatePayment;
  saveDetail?: Maybe<AffiliateDetail>;
  saveDetails?: Maybe<AffiliateDetails>;
  savePersonDetail?: Maybe<PersonDetail>;
  savePersonDetails?: Maybe<PersonDetails>;
  setPreferredAddress?: Maybe<Array<Address>>;
  setPreferredCompany?: Maybe<Array<AffiliateCompany>>;
  setPreferredPerson?: Maybe<Array<Person>>;
  updateAddress?: Maybe<Array<Address>>;
  updateCompany: AffiliateCompanyUpdateResult;
  updateContactMethodForPerson: ContactMethodForPersonUpdateResponse;
  updateDefaultPaymentMethod: AffiliatePaymentMethod;
  updateIsInternal: Scalars['Boolean']['output'];
  updateMainEmail: UpdateMainEmailResponse;
  updateNewsletter: BooleanOrError;
  updatePaymentMethod: AffiliatePaymentMethod;
  updatePerson?: Maybe<PersonUpdateResponse>;
}


export interface AffiliateLoggedMutationCreateAddressArgs {
  input: InputCreateAddress;
}


export interface AffiliateLoggedMutationCreateCompanyArgs {
  input: InputCreateAffiliateCompany;
}


export interface AffiliateLoggedMutationCreateContactMethodForPersonArgs {
  input: InputCreateContactMethodForPerson;
}


export interface AffiliateLoggedMutationCreatePaymentMethodArgs {
  input: InputCreateAffiliatePaymentMethod;
}


export interface AffiliateLoggedMutationCreatePersonArgs {
  input: InputCreatePerson;
}


export interface AffiliateLoggedMutationDeleteAddressArgs {
  input: InputDeleteAddress;
}


export interface AffiliateLoggedMutationDeleteCompanyArgs {
  input: InputDeleteAffiliateCompany;
}


export interface AffiliateLoggedMutationDeleteContactMethodForPersonArgs {
  input: InputDeleteContactMethodForPerson;
}


export interface AffiliateLoggedMutationDeletePaymentMethodArgs {
  id: Scalars['Int']['input'];
}


export interface AffiliateLoggedMutationDeletePersonArgs {
  input: InputDeletePerson;
}


export interface AffiliateLoggedMutationSaveDetailArgs {
  input: InputSaveAffiliateDetail;
}


export interface AffiliateLoggedMutationSaveDetailsArgs {
  input: InputSaveAffiliateDetails;
}


export interface AffiliateLoggedMutationSavePersonDetailArgs {
  input: InputSavePersonDetail;
}


export interface AffiliateLoggedMutationSavePersonDetailsArgs {
  input: InputSavePersonDetails;
}


export interface AffiliateLoggedMutationSetPreferredAddressArgs {
  input: InputSetPreferredAddress;
}


export interface AffiliateLoggedMutationSetPreferredCompanyArgs {
  input: InputSetPreferredAffiliateCompany;
}


export interface AffiliateLoggedMutationSetPreferredPersonArgs {
  input: InputSetPreferredPerson;
}


export interface AffiliateLoggedMutationUpdateAddressArgs {
  input: InputUpdateAddress;
}


export interface AffiliateLoggedMutationUpdateCompanyArgs {
  input: InputUpdateAffiliateCompany;
}


export interface AffiliateLoggedMutationUpdateContactMethodForPersonArgs {
  input: InputUpdateContactMethodForPerson;
}


export interface AffiliateLoggedMutationUpdateDefaultPaymentMethodArgs {
  defaultPaymentMethodId: Scalars['Int']['input'];
}


export interface AffiliateLoggedMutationUpdateIsInternalArgs {
  isInternal: Scalars['Boolean']['input'];
}


export interface AffiliateLoggedMutationUpdateMainEmailArgs {
  email: Scalars['String']['input'];
}


export interface AffiliateLoggedMutationUpdateNewsletterArgs {
  enabled: Scalars['Boolean']['input'];
}


export interface AffiliateLoggedMutationUpdatePaymentMethodArgs {
  input: InputUpdateAffiliatePaymentMethod;
}


export interface AffiliateLoggedMutationUpdatePersonArgs {
  input: InputUpdatePerson;
}

export interface AffiliateManager {
  activity: AffiliateManagerActivity;
  commonUserId: Scalars['Int']['output'];
  /** All the contact methods available for the affiliate manager */
  contactMethods: Array<ContactMethod>;
  /** All the contact methods of the affiliate manager that can be visible on the homepage of Prelinker */
  contactMethodsHomepage: Array<ContactMethod>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHomepageVisible?: Maybe<Scalars['Boolean']['output']>;
  /** All the languages that the affiliate manager can speak */
  languages?: Maybe<Array<Language>>;
  lastname: Scalars['String']['output'];
  /** Nickname is primarily used for ETL to DWH */
  nickname: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
}

export enum AffiliateManagerActivity {
  Aff = 'Aff',
  AffGc = 'Aff_GC',
  App = 'App',
  Comp = 'Comp',
  Mdb = 'Mdb',
  Ppc = 'PPC',
  PpcF = 'PPC_F',
  Seo = 'SEO',
  Social = 'Social'
}

export interface AffiliateManagerConnection extends PaginationConnection {
  edges?: Maybe<Array<AffiliateManagerEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface AffiliateManagerDimensions {
  disabled_at?: Maybe<Scalars['String']['output']>;
  manager_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface AffiliateManagerEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<AffiliateManager>;
}

export interface AffiliateManagerLoggedMutation {
  admin: BizAdminMutation;
  /** Create a new channel domain. Currently only an affiliate manager has the rights to create a channel domain. */
  createChannelDomain?: Maybe<ChannelDomain>;
  createContactMethod?: Maybe<ContactMethod>;
  deleteContactMethod?: Maybe<Scalars['Boolean']['output']>;
  payment: AdminPaymentMutation;
  sponsorship: SponsorshipMutation;
  /** Update a channel domain. Currently only an affiliate manager has the rights to update a channel domain. */
  updateChannelDomain?: Maybe<ChannelDomain>;
  updateContactMethod?: Maybe<ContactMethod>;
}


export interface AffiliateManagerLoggedMutationCreateChannelDomainArgs {
  input: InputCreateChannelDomain;
}


export interface AffiliateManagerLoggedMutationCreateContactMethodArgs {
  input: InputCreateContactMethodForAffiliateManager;
}


export interface AffiliateManagerLoggedMutationDeleteContactMethodArgs {
  input: InputDeleteContactMethodForAffiliateManager;
}


export interface AffiliateManagerLoggedMutationUpdateChannelDomainArgs {
  input: InputUpdateChannelDomain;
}


export interface AffiliateManagerLoggedMutationUpdateContactMethodArgs {
  input: InputUpdateContactMethodForAffiliateManager;
}

export interface AffiliateManagerMutation {
  refreshToken: SignInResponse;
  resetPassword: AffiliateManagerResetPasswordResponse;
  sendEmailResetPassword: Scalars['Boolean']['output'];
  signUp?: Maybe<SignInBizResult>;
  update?: Maybe<AffiliateManager>;
}


export interface AffiliateManagerMutationRefreshTokenArgs {
  token: Scalars['String']['input'];
}


export interface AffiliateManagerMutationResetPasswordArgs {
  input: InputResetAmPassword;
}


export interface AffiliateManagerMutationSendEmailResetPasswordArgs {
  input: InputSendEmailResetAmPassword;
}


export interface AffiliateManagerMutationSignUpArgs {
  input: InputCreateAffiliateManager;
}


export interface AffiliateManagerMutationUpdateArgs {
  input: InputUpdateAffiliateManager;
}

export interface AffiliateManagerQuery {
  /** Get all affiliate managers that are actives. If you provide a language_id, it will return only the affiliate managers that can speak this language. */
  actives?: Maybe<Array<AffiliateManager>>;
  /** Get all affiliate managers that are note deleted. */
  all?: Maybe<Array<AffiliateManager>>;
  /** Specific to "Call" project. Get all affiliate managers prepared for dimensions aggregator. */
  dimensionsAggregator?: Maybe<Array<AffiliateManagerDimensions>>;
  get?: Maybe<AffiliateManager>;
  /** Get all affiliate managers that are enabled. */
  getEnabled?: Maybe<Array<AffiliateManager>>;
  /** Get all affiliate managers that can be visible on the homepage (even if the affiliate manager is enable or not) */
  homepageList?: Maybe<Array<AffiliateManager>>;
  /** Get am list. Can be filtered by ids. */
  list?: Maybe<AffiliateManagerConnection>;
}


export interface AffiliateManagerQueryActivesArgs {
  languageId?: InputMaybe<Scalars['Int']['input']>;
}


export interface AffiliateManagerQueryGetArgs {
  id: Scalars['Int']['input'];
}


export interface AffiliateManagerQueryListArgs {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}

export interface AffiliateManagerResetPassword {
  success: Scalars['Boolean']['output'];
}

export type AffiliateManagerResetPasswordResponse = AffiliateManagerResetPassword | AffiliateManagerValidationError;

export interface AffiliateManagerValidationError extends Error {
  message: Scalars['String']['output'];
}

export interface AffiliateMutation {
  homepageContact?: Maybe<Scalars['Boolean']['output']>;
  refreshToken: SignInResponse;
  resetPassword: Scalars['Boolean']['output'];
  resetPasswordAsAM: Scalars['Boolean']['output'];
  sendEmailResetPassword: Scalars['Boolean']['output'];
  signIn: SignInResponse;
  signInAsAffiliate: SignInResponse;
  signUp: SignUpResponse;
  unsubscribeNewsletter: Scalars['Boolean']['output'];
  updateAffiliateAM: Affiliate;
  updateDisabledAccount: BooleanOrError;
  updateSite: Scalars['Boolean']['output'];
}


export interface AffiliateMutationHomepageContactArgs {
  payload: InputHomepageContact;
}


export interface AffiliateMutationRefreshTokenArgs {
  token: Scalars['String']['input'];
}


export interface AffiliateMutationResetPasswordArgs {
  input: InputResetPassword;
}


export interface AffiliateMutationResetPasswordAsAmArgs {
  input: InputResetPasswordAsAm;
}


export interface AffiliateMutationSendEmailResetPasswordArgs {
  input: InputSendEmailResetPasswordWithCaptcha;
}


export interface AffiliateMutationSignInArgs {
  input: InputSignInAffiliate;
}


export interface AffiliateMutationSignInAsAffiliateArgs {
  input: InputSignInAsAffiliate;
}


export interface AffiliateMutationSignUpArgs {
  input: InputCreateAffiliate;
}


export interface AffiliateMutationUnsubscribeNewsletterArgs {
  input: InputUnsubscribeNewsletter;
}


export interface AffiliateMutationUpdateAffiliateAmArgs {
  input: InputUpdateAffiliateAm;
}


export interface AffiliateMutationUpdateDisabledAccountArgs {
  input: InputDisableAffiliate;
}


export interface AffiliateMutationUpdateSiteArgs {
  input: InputAffiliateSiteUpdate;
}

export interface AffiliatePayment {
  deletePendingPayment?: Maybe<Scalars['Boolean']['output']>;
  inflows: InflowConnectionResponse;
  outflows: OutflowConnectionResponse;
  pending?: Maybe<PendingPayment>;
  requestPayment?: Maybe<RequestPaymentResponse>;
  totalBalance: TotalBalance;
}


export interface AffiliatePaymentDeletePendingPaymentArgs {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
}


export interface AffiliatePaymentInflowsArgs {
  input: InputGetInflows;
}


export interface AffiliatePaymentOutflowsArgs {
  input: InputGetOutflows;
}


export interface AffiliatePaymentRequestPaymentArgs {
  input: RequestPaymentInput;
}

export interface AffiliatePaymentMethod {
  affiliate: Affiliate;
  affiliateId: Scalars['Int']['output'];
  configuration: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export enum AffiliatePaymentMethodType {
  Cheque = 'CHEQUE',
  Paxum = 'PAXUM',
  Payoneer = 'PAYONEER',
  Paypal = 'PAYPAL',
  Wiretransfer = 'WIRETRANSFER'
}

export interface AffiliateQuery {
  all?: Maybe<AffiliateConnection>;
  byEmail?: Maybe<Affiliate>;
  get?: Maybe<Affiliate>;
}


export interface AffiliateQueryAllArgs {
  input?: InputMaybe<InputAllAffiliates>;
}


export interface AffiliateQueryByEmailArgs {
  affiliateEmail: Scalars['String']['input'];
}


export interface AffiliateQueryGetArgs {
  affiliateId: Scalars['Int']['input'];
}

export type AffiliateResults = Affiliate | SponsorshipError;

export interface AffiliateSite {
  id: Scalars['Int']['output'];
  isCoregEnable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
}

export interface AgreementInterface {
  slug: Scalars['ID']['output'];
  status: AgreementStatus;
}

export enum AgreementStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING'
}

export enum AgreementType {
  Cpg = 'CPG'
}

export interface AndroidOrder {
  acknowledged: Scalars['Boolean']['input'];
  autoRenewing: Scalars['Boolean']['input'];
  /** uhc-7-1100150591 */
  obfuscatedAccountId: Scalars['String']['input'];
  /** Android purchaseId (ex:GPA.1111-1111-1111-11111) */
  orderId: Scalars['String']['input'];
  /** com.daryl.spiice */
  packageName: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  /** #TODO use ENUM ? */
  purchaseState: Scalars['Int']['input'];
  /** unix timestamp */
  purchaseTime: Scalars['BigInt']['input'];
  purchaseToken: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}

export interface ApplePayToken {
  paymentData: PaymentDataApple;
  paymentMethod: PaymentMethodApple;
  transactionIdentifier: Scalars['String']['input'];
}

export interface Badword {
  actions?: Maybe<Array<BadwordAction>>;
  environment: BadwordEnvironment;
  id: Scalars['Int']['output'];
  word: Scalars['String']['output'];
}

export interface BadwordAction {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export enum BadwordEnvironment {
  Biz = 'BIZ',
  Dating = 'DATING'
}

export interface BadwordInput {
  actions?: InputMaybe<Array<Scalars['Int']['input']>>;
  environment: BadwordEnvironment;
  word: Scalars['String']['input'];
}

export type BannerAction = BannerActionRedirect | BannerActionSwitch;

export interface BannerActionRedirect {
  redirect: ActionOnRedirect;
}

export interface BannerActionSwitch {
  action: ActionOnSwitch;
}

export interface BelongsToUhc {
  user?: Maybe<UserHasChannelInterface>;
}

export interface BinInfo {
  bankname?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  countryIso?: Maybe<Scalars['String']['output']>;
  scheme?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface BizAdminMutation {
  payment: AdminPaymentMutation;
  signIn: SignInFlApiResult;
  signUp: BizAdminUser;
}


export interface BizAdminMutationSignInArgs {
  input: InputSignInAdmin;
}


export interface BizAdminMutationSignUpArgs {
  input: InputCreateAdminUser;
}

export interface BizAdminQuery {
  me?: Maybe<BizAdminUser>;
}

export interface BizAdminUser {
  role: AdminUserRole;
  user: AdminUserInfo;
}

export enum BizRoles {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  Webmaster = 'WEBMASTER'
}

export interface BizTag {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
}

export interface BizTool {
  config: Scalars['JSON']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  showExternalOffer: Scalars['Boolean']['output'];
  showInternalOffer: Scalars['Boolean']['output'];
  showWhiteLabel: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface BizToolCache {
  cache: Scalars['String']['output'];
  cacheId: Scalars['Float']['output'];
  cacheKey: Scalars['String']['output'];
}

export interface BizToolConfig {
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  siteId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  webmaster: Webmaster;
}

export interface BlacklistedDomain {
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
}

export enum BlurReason {
  Censored = 'CENSORED',
  Generated = 'GENERATED',
  NotApproved = 'NOT_APPROVED',
  NotBlurred = 'NOT_BLURRED',
  Private = 'PRIVATE',
  SafeMode = 'SAFE_MODE'
}

export interface BookmarkEvent extends InteractionEvent, ListEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
}


export interface BookmarkEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export type BooleanOrError = BooleanResponse | ErrorWithMessage;

export interface BooleanResponse {
  success: Scalars['Boolean']['output'];
}

export interface BooleanResult {
  errors?: Maybe<Array<CustomError>>;
  succeed: Scalars['Boolean']['output'];
}

export type BooleanResults = RemoveResponse | SponsorshipError;

export interface Brand {
  commissionTypeId: Scalars['Int']['output'];
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  modelSiteId: Scalars['Int']['output'];
  url: Scalars['String']['output'];
}

export interface BrandConnection extends PaginationConnection {
  edges?: Maybe<Array<BrandEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface BrandEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Brand>;
}

export interface BrandGroup {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  template: Scalars['String']['output'];
}

export interface BumpEvent {
  /** How much the counter has been incremented */
  bumpCount: Scalars['Int']['output'];
}

export interface BumpSubscriber extends BumpEvent {
  bumpCount: Scalars['Int']['output'];
}

export interface BumpVisit extends BumpEvent {
  bumpCount: Scalars['Int']['output'];
}

export interface BusinessUnit {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface BusinessUnitAdminMutation {
  createBusinessUnit: CreateBusinessUnitResponse;
  /** Deletes a business unit. This will also delete all option assignments related to this business unit (`levelType` 'ACTIVITY'). */
  deleteBusinessUnit: Scalars['Boolean']['output'];
  updateBusinessUnit: UpdateBusinessUnitResponse;
}


export interface BusinessUnitAdminMutationCreateBusinessUnitArgs {
  input: CreateBusinessUnitInput;
}


export interface BusinessUnitAdminMutationDeleteBusinessUnitArgs {
  id: Scalars['Int']['input'];
}


export interface BusinessUnitAdminMutationUpdateBusinessUnitArgs {
  input: UpdateBusinessUnitInput;
}

export interface BusinessUnitAdminQuery {
  businessUnits?: Maybe<BusinessUnitConnection>;
}


export interface BusinessUnitAdminQueryBusinessUnitsArgs {
  input: BusinessUnitsInput;
}

export interface BusinessUnitConnection extends PaginationConnection {
  edges?: Maybe<Array<BusinessUnitEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface BusinessUnitEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<BusinessUnit>;
}

export interface BusinessUnitError extends Error {
  message: Scalars['String']['output'];
}

export interface BusinessUnitFilterInput {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
}

export interface BusinessUnitsInput {
  filters?: InputMaybe<BusinessUnitFilterInput>;
  options?: InputMaybe<PaginationOptions>;
}

export interface BuyInput {
  /** Optional, if not provided, the default will be used (from paymentkey) */
  backendClientId?: InputMaybe<Scalars['Int']['input']>;
  displayId?: InputMaybe<Scalars['Int']['input']>;
  failureURL?: InputMaybe<Scalars['URL']['input']>;
  layer?: InputMaybe<LayerPayment>;
  paymentKey: Scalars['ID']['input'];
  /** one or the other */
  products?: InputMaybe<Array<ProductInput>>;
  /** The id of the purchase when retrying a failed payment */
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  successURL?: InputMaybe<Scalars['URL']['input']>;
}

export type BuyResponse = BuyResponseError | BuyResponseRedirect | BuyResponseSuccess;

export interface BuyResponseError extends Error {
  message: Scalars['String']['output'];
  purchase?: Maybe<PaymentPurchase>;
}

export interface BuyResponseRedirect {
  purchase: PaymentPurchase;
  redirectURL: Scalars['URL']['output'];
}

export interface BuyResponseSuccess {
  purchase: PaymentPurchase;
}

export interface ByPlateformDatingProduct {
  desktop: Array<DatingProduct>;
  mobile: Array<DatingProduct>;
}

export interface Cancellable {
  cancellable: Scalars['Boolean']['output'];
}

export interface Card {
  bin?: Maybe<CardBin>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  holder?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
}

export interface CardBin {
  bankname?: Maybe<Scalars['String']['output']>;
  bin?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  scheme?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface CardExpiration {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}

export interface CardInput {
  /** The first 6 digits of the card number */
  bin: Scalars['String']['input'];
  holderName: Scalars['String']['input'];
  /** From cpg */
  token: Scalars['String']['input'];
}

export interface CertifTag {
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
}

export interface Challenge {
  description: Scalars['String']['output'];
  displayEndAt?: Maybe<Scalars['DateTime']['output']>;
  displayStartAt?: Maybe<Scalars['DateTime']['output']>;
  excludedAffiliates?: Maybe<Array<Scalars['Int']['output']>>;
  label: Scalars['String']['output'];
  method: Scalars['String']['output'];
  params?: Maybe<ChallengeParams>;
  periodEndAt?: Maybe<Scalars['DateTime']['output']>;
  periodStartAt?: Maybe<Scalars['DateTime']['output']>;
  preview: Scalars['String']['output'];
  referenceEndAt?: Maybe<Scalars['DateTime']['output']>;
  referenceStartAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface ChallengeConnection extends PaginationConnection {
  edges?: Maybe<Array<ChallengeEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface ChallengeEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Challenge>;
}

export interface ChallengeParams {
  function: Scalars['String']['output'];
  period: Scalars['Int']['output'];
  period_reference: Scalars['Int']['output'];
}

export interface ChangePassword {
  allChannels?: Maybe<Array<Token>>;
  currentChannel?: Maybe<Token>;
  errors?: Maybe<Array<CustomError>>;
}

export interface Channel extends Sluggable {
  enabled: Scalars['Boolean']['output'];
  facebookApplications?: Maybe<Array<FacebookApplication>>;
  faq?: Maybe<Array<FaqTopic>>;
  genderList?: Maybe<Array<GenderModel>>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** Moderation item still to review */
  pendingReviewCounters: ModerationCount;
  slug: Scalars['ID']['output'];
  type: ChannelType;
}


export interface ChannelFacebookApplicationsArgs {
  filter?: InputMaybe<ChannelFacebookApplicationFilter>;
}


export interface ChannelPendingReviewCountersArgs {
  localeCodes: Array<Scalars['String']['input']>;
}

/** A channel domain is a domain that is associated with a channel and an affiliate. It allows you to link a white label to the domain in question. */
export interface ChannelDomain {
  /** The affiliate associated with this channel domain */
  affiliate?: Maybe<Affiliate>;
  /** @deprecated Use the affiliate field instead. This field will be removed in the future */
  affiliateId?: Maybe<Scalars['Int']['output']>;
  /** The channel chosen for the channel domain (love, sexy, ...) */
  channel: Channel;
  /** @deprecated Use the channel field instead. This field will be removed in the future */
  channelId?: Maybe<Scalars['Int']['output']>;
  /** The domain provided by the affiliate */
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  siteLogoId: Scalars['Int']['output'];
  siteStyleId: Scalars['Int']['output'];
  /** The status of the channel domain, only the affiliate manager should update it */
  status: ChannelDomainStatus;
  /** @deprecated Use the status field instead. This field will be removed in the future */
  statusId?: Maybe<Scalars['Int']['output']>;
}

export interface ChannelDomainConnection extends PaginationConnection {
  edges?: Maybe<Array<ChannelDomainEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface ChannelDomainEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<ChannelDomain>;
}

export interface ChannelDomainStatus {
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
}

export interface ChannelFacebookApplicationFilter {
  defaultApplication?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum ChannelType {
  Sexy = 'SEXY',
  Soft = 'SOFT'
}

export interface Chargeback {
  amount: Scalars['Float']['output'];
  chargebackReasonId?: Maybe<Scalars['Int']['output']>;
  chargebackedAt?: Maybe<Scalars['Date']['output']>;
  cpgChargebackQueueId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  currencyCode: Scalars['CurrencyCode']['output'];
  datingPaymentOrderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  origin: Scalars['String']['output'];
  partialCard: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  paymentAttemptId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
}

export interface ChargebackResponse {
  chargeback?: Maybe<Chargeback>;
}

export enum ChargebackStatus {
  Identified = 'IDENTIFIED',
  NotFound = 'NOT_FOUND',
  WaitingForIdentification = 'WAITING_FOR_IDENTIFICATION'
}

export interface ClickTag {
  url?: Maybe<Scalars['URL']['output']>;
}

export interface CoachingAbTest {
  currentVersion?: Maybe<CoachingAbTestVersion>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  versions?: Maybe<Array<CoachingAbTestVersion>>;
}

export interface CoachingAbTestOption {
  distribution: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  value: Scalars['String']['output'];
}

export interface CoachingAbTestVersion {
  description: Scalars['String']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  options?: Maybe<Array<CoachingAbTestOption>>;
  startAt: Scalars['DateTime']['output'];
}

export interface CoachingAdminSearchUhns {
  nicheId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}

export enum CoachingCampaignJob {
  Daily = 'DAILY',
  EightPm = 'EIGHT_PM',
  Rebill = 'REBILL',
  Weekly = 'WEEKLY'
}

export interface CoachingCapsule {
  audioContent?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  levelPosition: Scalars['Int']['output'];
  pagination?: Maybe<CoachingCapsulePagination>;
  position: Scalars['Int']['output'];
  release?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
  status: CoachingCapsuleStatus;
  teasing?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<CoachingTheme>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uriSlug: Scalars['String']['output'];
  videoContent?: Maybe<Scalars['String']['output']>;
}


export interface CoachingCapsulePaginationArgs {
  next?: InputMaybe<Scalars['Boolean']['input']>;
  previous?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CoachingCapsuleByUserInput {
  capsuleSlug?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Boolean']['input']>;
  themeSlug?: InputMaybe<Scalars['String']['input']>;
}

export interface CoachingCapsulePagination {
  next?: Maybe<CoachingCapsule>;
  previous?: Maybe<CoachingCapsule>;
}

export enum CoachingCapsuleStatus {
  Completed = 'COMPLETED',
  Locked = 'LOCKED',
  Opened = 'OPENED',
  Reading = 'READING',
  Unlocked = 'UNLOCKED'
}

export interface CoachingCheckEmail {
  message?: Maybe<Scalars['String']['output']>;
  switchDomain?: Maybe<Scalars['String']['output']>;
  user: Scalars['Boolean']['output'];
  userHasNiche: Scalars['Boolean']['output'];
}

export interface CoachingCompanyHasRedirectDomain {
  companyId: Scalars['Int']['output'];
  domain: Scalars['String']['output'];
}

export interface CoachingContentLayerPayment {
  content: Scalars['String']['output'];
  model: CoachingContentLayerPaymentModel;
  modelId: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  thumbnail: Scalars['String']['output'];
}

export enum CoachingContentLayerPaymentModel {
  Article = 'ARTICLE',
  Niche = 'NICHE',
  Site = 'SITE',
  Theme = 'THEME'
}

export interface CoachingCreateAbTestOptionInput {
  abTestVersionId: Scalars['Int']['input'];
  distribution: Scalars['Int']['input'];
  value: Scalars['String']['input'];
}

export interface CoachingCreateAbTestVersionInput {
  abTestId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt: Scalars['DateTime']['input'];
}

export interface CoachingCreateCapsuleInput {
  author?: InputMaybe<Scalars['JSON']['input']>;
  enabled: Scalars['Boolean']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['JSON']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  release?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['JSON']['input']>;
  slug: Scalars['String']['input'];
  teasing?: InputMaybe<Scalars['String']['input']>;
  theme: Scalars['Int']['input'];
  title: Scalars['String']['input'];
}

export interface CoachingCreateCompanyHasRedirectDomainInput {
  companyId: Scalars['Int']['input'];
  domain: Scalars['String']['input'];
}

export interface CoachingCreateContentsLayerPaymentInput {
  content: Scalars['String']['input'];
  model: CoachingContentLayerPaymentModel;
  modelId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  thumbnail: Scalars['String']['input'];
}

export interface CoachingCreateEbookInput {
  hasAudio: Scalars['Boolean']['input'];
  hasPdf: Scalars['Boolean']['input'];
  model: CoachingEbookModel;
  modelId: Scalars['Int']['input'];
}

export interface CoachingCreateNicheInput {
  enabled: Scalars['Boolean']['input'];
  genders?: InputMaybe<Array<Gender>>;
  internalName: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
}

export interface CoachingCreateSiteInput {
  companyId: Scalars['Int']['input'];
  domain: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  https?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  niche: Scalars['Int']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
}

export interface CoachingCreateThemeInput {
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  internalName: Scalars['String']['input'];
  niche: Scalars['Int']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
}

export interface CoachingCreateWordingContentsInput {
  category: Scalars['String']['input'];
  content: Scalars['String']['input'];
  model: CoachingWordingContentModel;
  modelId: Scalars['Int']['input'];
}

export interface CoachingEbook {
  hasAudio: Scalars['Boolean']['output'];
  hasPdf: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  model: CoachingEbookModel;
  modelId: Scalars['Int']['output'];
}

export enum CoachingEbookModel {
  Niche = 'NICHE',
  Theme = 'THEME'
}

export interface CoachingEvent {
  capsuleId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
}

export interface CoachingLevel {
  capsules?: Maybe<Array<CoachingCapsule>>;
  count: Scalars['Int']['output'];
  current: Scalars['Boolean']['output'];
  finished: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  unlocked: Scalars['Boolean']['output'];
}

export interface CoachingMutationAbTest {
  createAbTest?: Maybe<CoachingAbTest>;
  createAbTestOption?: Maybe<Array<CoachingAbTestOption>>;
  createAbTestVersion?: Maybe<CoachingAbTestVersion>;
}


export interface CoachingMutationAbTestCreateAbTestArgs {
  label: Scalars['String']['input'];
}


export interface CoachingMutationAbTestCreateAbTestOptionArgs {
  inputs: Array<CoachingCreateAbTestOptionInput>;
}


export interface CoachingMutationAbTestCreateAbTestVersionArgs {
  input: CoachingCreateAbTestVersionInput;
}

export interface CoachingMutationAdmin {
  abTest?: Maybe<CoachingMutationAbTest>;
  capsule?: Maybe<CoachingMutationCapsule>;
  companyRedirectDomain?: Maybe<CoachingMutationCompanyHasRedirectDomain>;
  contentLayerPayment?: Maybe<CoachingMutationContentLayerPayment>;
  ebook?: Maybe<CoachingMutationEbook>;
  mails?: Maybe<CoachingMutationMails>;
  niche?: Maybe<CoachingMutationNiche>;
  site?: Maybe<CoachingMutationSite>;
  theme?: Maybe<CoachingMutationTheme>;
  user?: Maybe<CoachingMutationUser>;
  /** Update user has niche */
  userHasNiche: Scalars['Boolean']['output'];
  wordingContent?: Maybe<CoachingMutationWordingContent>;
  worker?: Maybe<CoachingMutationWorker>;
}


export interface CoachingMutationAdminUserHasNicheArgs {
  action: CoachingMutationAdminUserHasNicheAction;
  registrationUniqueId: Scalars['Int']['input'];
}

export enum CoachingMutationAdminUserHasNicheAction {
  Delete = 'DELETE',
  Reactivate = 'REACTIVATE',
  Refund = 'REFUND',
  StopNotification = 'STOP_NOTIFICATION',
  Update = 'UPDATE'
}

export enum CoachingMutationAdminWordingContentAction {
  Delete = 'DELETE',
  MoveDown = 'MOVE_DOWN',
  MoveUp = 'MOVE_UP'
}

export interface CoachingMutationCapsule {
  create?: Maybe<CoachingCapsule>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingCapsule>;
}


export interface CoachingMutationCapsuleCreateArgs {
  input: CoachingCreateCapsuleInput;
}


export interface CoachingMutationCapsuleDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface CoachingMutationCapsuleUpdateArgs {
  id: Scalars['Int']['input'];
  input: CoachingCreateCapsuleInput;
}

export interface CoachingMutationCompanyHasRedirectDomain {
  create?: Maybe<CoachingCompanyHasRedirectDomain>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingCompanyHasRedirectDomain>;
}


export interface CoachingMutationCompanyHasRedirectDomainCreateArgs {
  input: CoachingCreateCompanyHasRedirectDomainInput;
}


export interface CoachingMutationCompanyHasRedirectDomainDeleteArgs {
  companyId: Scalars['Int']['input'];
}


export interface CoachingMutationCompanyHasRedirectDomainUpdateArgs {
  input: CoachingCreateCompanyHasRedirectDomainInput;
}

export interface CoachingMutationContentLayerPayment {
  create?: Maybe<CoachingContentLayerPayment>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingContentLayerPayment>;
}


export interface CoachingMutationContentLayerPaymentCreateArgs {
  input: CoachingCreateContentsLayerPaymentInput;
}


export interface CoachingMutationContentLayerPaymentDeleteArgs {
  model: CoachingContentLayerPaymentModel;
  modelId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
}


export interface CoachingMutationContentLayerPaymentUpdateArgs {
  input: CoachingCreateContentsLayerPaymentInput;
}

export interface CoachingMutationEbook {
  create?: Maybe<CoachingEbook>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingEbook>;
}


export interface CoachingMutationEbookCreateArgs {
  input: CoachingCreateEbookInput;
}


export interface CoachingMutationEbookDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface CoachingMutationEbookUpdateArgs {
  id: Scalars['Int']['input'];
  input: CoachingCreateEbookInput;
}

export interface CoachingMutationMails {
  stopRebill?: Maybe<Scalars['Boolean']['output']>;
}


export interface CoachingMutationMailsStopRebillArgs {
  domain: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

export interface CoachingMutationMediaTimecodeInput {
  mediaType: MediaType;
  model: UserHasMediaTimecodeModel;
  modelId: Scalars['Int']['input'];
  timecodeInSeconds: Scalars['Int']['input'];
}

export interface CoachingMutationNs {
  admin?: Maybe<CoachingMutationAdmin>;
  linkUserDating?: Maybe<Scalars['Int']['output']>;
  me?: Maybe<CoachingMutationUserHasNiche>;
  rebill: Scalars['Boolean']['output'];
  registerUser: CoachingRegisterUser;
  resetPassword: CoachingResetPassword;
  signIn: Scalars['String']['output'];
  version: Scalars['String']['output'];
  /** contact form bellow phone number */
  zendeskContact: Scalars['Float']['output'];
}


export interface CoachingMutationNsLinkUserDatingArgs {
  datingId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}


export interface CoachingMutationNsRebillArgs {
  rebillable: Scalars['Boolean']['input'];
}


export interface CoachingMutationNsRegisterUserArgs {
  data: CoachingRegisterUserInput;
}


export interface CoachingMutationNsResetPasswordArgs {
  email: Scalars['String']['input'];
  host: Scalars['String']['input'];
}


export interface CoachingMutationNsSignInArgs {
  email: Scalars['String']['input'];
  host: Scalars['String']['input'];
  password: Scalars['String']['input'];
}


export interface CoachingMutationNsZendeskContactArgs {
  input: ZendeskContactInput;
}

export interface CoachingMutationNiche {
  create?: Maybe<CoachingNiche>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingNiche>;
}


export interface CoachingMutationNicheCreateArgs {
  input: CoachingCreateNicheInput;
}


export interface CoachingMutationNicheDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface CoachingMutationNicheUpdateArgs {
  id: Scalars['Int']['input'];
  input: CoachingCreateNicheInput;
}

export interface CoachingMutationSite {
  create?: Maybe<CoachingSite>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingSite>;
}


export interface CoachingMutationSiteCreateArgs {
  input: CoachingCreateSiteInput;
}


export interface CoachingMutationSiteDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface CoachingMutationSiteUpdateArgs {
  id: Scalars['Int']['input'];
  input: CoachingCreateSiteInput;
}

export interface CoachingMutationTheme {
  create?: Maybe<CoachingTheme>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingTheme>;
}


export interface CoachingMutationThemeCreateArgs {
  input: CoachingCreateThemeInput;
}


export interface CoachingMutationThemeDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface CoachingMutationThemeUpdateArgs {
  id: Scalars['Int']['input'];
  input: CoachingCreateThemeInput;
}

export interface CoachingMutationThemePreference {
  position: Scalars['Int']['input'];
  themeId: Scalars['Int']['input'];
}

export interface CoachingMutationUser {
  delete?: Maybe<Scalars['Boolean']['output']>;
  reactivate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use adminMutation */
  stopNotification?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CoachingUser>;
}


export interface CoachingMutationUserDeleteArgs {
  datingId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nicheId: Scalars['Int']['input'];
}


export interface CoachingMutationUserReactivateArgs {
  datingId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nicheId: Scalars['Int']['input'];
}


export interface CoachingMutationUserStopNotificationArgs {
  nicheId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}


export interface CoachingMutationUserUpdateArgs {
  data: CoachingUpdateUserInput;
  id: Scalars['Int']['input'];
}

export interface CoachingMutationUserHasNiche {
  askConfirmationEmail: Scalars['Boolean']['output'];
  capsuleStatus?: Maybe<Scalars['Boolean']['output']>;
  confirmEmail: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  generatePassword?: Maybe<Scalars['Boolean']['output']>;
  logConnection?: Maybe<Scalars['Boolean']['output']>;
  rebill?: Maybe<Scalars['Boolean']['output']>;
  setBirthDate: Scalars['Boolean']['output'];
  setMediaTimecode: Scalars['Boolean']['output'];
  setPseudo: Scalars['Boolean']['output'];
  setThemePreference: Array<CoachingTheme>;
  update?: Maybe<CoachingUserHasNiche>;
}


export interface CoachingMutationUserHasNicheAskConfirmationEmailArgs {
  host: Scalars['String']['input'];
}


export interface CoachingMutationUserHasNicheCapsuleStatusArgs {
  id: Scalars['Int']['input'];
  status: CoachingCapsuleStatus;
}


export interface CoachingMutationUserHasNicheGeneratePasswordArgs {
  password: Scalars['String']['input'];
}


export interface CoachingMutationUserHasNicheLogConnectionArgs {
  source?: InputMaybe<CoachingSourceConnection>;
}


export interface CoachingMutationUserHasNicheRebillArgs {
  rebillable: Scalars['Boolean']['input'];
}


export interface CoachingMutationUserHasNicheSetBirthDateArgs {
  bornDate: Scalars['String']['input'];
}


export interface CoachingMutationUserHasNicheSetMediaTimecodeArgs {
  input: CoachingMutationMediaTimecodeInput;
}


export interface CoachingMutationUserHasNicheSetPseudoArgs {
  pseudo: Scalars['String']['input'];
}


export interface CoachingMutationUserHasNicheSetThemePreferenceArgs {
  input?: InputMaybe<Array<CoachingMutationThemePreference>>;
}


export interface CoachingMutationUserHasNicheUpdateArgs {
  data: CoachingUserUpdateInput;
}

export interface CoachingMutationWordingContent {
  create?: Maybe<Array<Maybe<CoachingWordingContent>>>;
  operation?: Maybe<Array<Maybe<CoachingWordingContent>>>;
  update?: Maybe<Array<Maybe<CoachingWordingContent>>>;
}


export interface CoachingMutationWordingContentCreateArgs {
  input: CoachingCreateWordingContentsInput;
}


export interface CoachingMutationWordingContentOperationArgs {
  action: CoachingMutationAdminWordingContentAction;
  id: Scalars['Int']['input'];
}


export interface CoachingMutationWordingContentUpdateArgs {
  input: CoachingUpdateWordingContentsInput;
}

export interface CoachingMutationWorker {
  rescheduleJobs?: Maybe<Scalars['JSON']['output']>;
  startCampaignJob?: Maybe<Scalars['JSON']['output']>;
}


export interface CoachingMutationWorkerStartCampaignJobArgs {
  delirerOnly: Scalars['Boolean']['input'];
  worker?: InputMaybe<CoachingCampaignJob>;
}

export interface CoachingNiche {
  enabled?: Maybe<Scalars['Boolean']['output']>;
  genders?: Maybe<Array<Gender>>;
  id: Scalars['Int']['output'];
  /** ex: Success, Attraction, Performance, ... */
  internalName: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<CoachingTheme>>;
}

export enum CoachingNotificationFrequency {
  Daily = 'DAILY',
  Disabled = 'DISABLED',
  Weekly = 'WEEKLY'
}

export interface CoachingOrder {
  active?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  disablePeriod?: Maybe<DateRange>;
  enablePeriod?: Maybe<DateRange>;
  lengthPeriod?: Maybe<Scalars['Int']['output']>;
  nextDisablePeriod?: Maybe<DateRange>;
  rebillSlug?: Maybe<Scalars['ID']['output']>;
  rebillable?: Maybe<Scalars['Boolean']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['ID']['output']>;
  source: CoachingOrderSource;
  symbol?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
}

export enum CoachingOrderSource {
  NewPayment = 'NEW_PAYMENT',
  OldPayment = 'OLD_PAYMENT'
}

export interface CoachingQueryAdmin {
  abTests: Array<CoachingAbTest>;
  admin: AdminUser;
  capsules?: Maybe<Array<CoachingCapsule>>;
  companyRedirectDomains?: Maybe<Array<CoachingCompanyHasRedirectDomain>>;
  contentsLayerPayment: Array<Maybe<CoachingContentLayerPayment>>;
  disabledWordingContents: Array<Maybe<CoachingWordingContent>>;
  ebooks?: Maybe<Array<Maybe<CoachingEbook>>>;
  niches?: Maybe<Array<CoachingNiche>>;
  sites?: Maybe<Array<CoachingSite>>;
  themes?: Maybe<Array<CoachingTheme>>;
  uhn?: Maybe<CoachingUserHasNiche>;
  uhns?: Maybe<Array<CoachingUserHasNiche>>;
  user?: Maybe<CoachingUser>;
  users?: Maybe<Array<CoachingUser>>;
  wordingContents?: Maybe<Array<Maybe<CoachingWordingContent>>>;
  worker?: Maybe<CoachingQueryWorker>;
}


export interface CoachingQueryAdminCapsulesArgs {
  theme?: InputMaybe<Scalars['Int']['input']>;
}


export interface CoachingQueryAdminDisabledWordingContentsArgs {
  category: Scalars['String']['input'];
  model: CoachingWordingContentModel;
  modelId: Scalars['Int']['input'];
}


export interface CoachingQueryAdminSitesArgs {
  niche?: InputMaybe<Scalars['Int']['input']>;
}


export interface CoachingQueryAdminThemesArgs {
  niche?: InputMaybe<Scalars['Int']['input']>;
}


export interface CoachingQueryAdminUhnArgs {
  nicheId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}


export interface CoachingQueryAdminUhnsArgs {
  keys: Array<CoachingAdminSearchUhns>;
}


export interface CoachingQueryAdminUserArgs {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}


export interface CoachingQueryAdminUsersArgs {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

export interface CoachingQueryNs {
  admin?: Maybe<CoachingQueryAdmin>;
  checkEmail: CoachingCheckEmail;
  companyRedirect?: Maybe<Company>;
  contentLayerPayment: Array<Maybe<CoachingContentLayerPayment>>;
  ebook?: Maybe<CoachingEbook>;
  languages: Array<UserLanguage>;
  me: CoachingUserHasNiche;
  pga?: Maybe<CoachingQueryPga>;
  randomUsernames: Array<Scalars['String']['output']>;
  site?: Maybe<CoachingSite>;
  sites?: Maybe<Array<CoachingSite>>;
  transformDatingToken: Scalars['String']['output'];
  version: Scalars['String']['output'];
  wordingContents: Array<Maybe<CoachingWordingContent>>;
}


export interface CoachingQueryNsCheckEmailArgs {
  email: Scalars['String']['input'];
  host: Scalars['String']['input'];
  useIpqs?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface CoachingQueryNsCompanyRedirectArgs {
  host: Scalars['String']['input'];
}


export interface CoachingQueryNsContentLayerPaymentArgs {
  model: CoachingContentLayerPaymentModel;
  modelId: Scalars['Int']['input'];
}


export interface CoachingQueryNsEbookArgs {
  model: CoachingEbookModel;
  modelId: Scalars['Int']['input'];
}


export interface CoachingQueryNsSiteArgs {
  host: Scalars['String']['input'];
}


export interface CoachingQueryNsSitesArgs {
  company: Scalars['Int']['input'];
}


export interface CoachingQueryNsTransformDatingTokenArgs {
  datingToken: Scalars['String']['input'];
}


export interface CoachingQueryNsWordingContentsArgs {
  category: Scalars['String']['input'];
  model: CoachingWordingContentModel;
  modelId: Scalars['Int']['input'];
}

export interface CoachingQueryPga {
  ordersByCreditCard: Array<CoachingOrder>;
  ordersByEmail: Scalars['Boolean']['output'];
}


export interface CoachingQueryPgaOrdersByCreditCardArgs {
  amount: Scalars['Float']['input'];
  date: Scalars['Date']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  panEnd: Scalars['String']['input'];
  panStart: Scalars['String']['input'];
}


export interface CoachingQueryPgaOrdersByEmailArgs {
  email: Scalars['String']['input'];
  nicheId: Scalars['Int']['input'];
}

export interface CoachingQueryWorker {
  metrics?: Maybe<Scalars['JSON']['output']>;
}


export interface CoachingQueryWorkerMetricsArgs {
  end?: InputMaybe<Scalars['Int']['input']>;
  queueName: CoachingCampaignJob;
  start?: InputMaybe<Scalars['Int']['input']>;
  type: CoachingQueueType;
}

export enum CoachingQueueType {
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export interface CoachingRegisterUser {
  redirectURL: Scalars['String']['output'];
  token: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
}

export interface CoachingRegisterUserInput {
  bornDate?: InputMaybe<Scalars['String']['input']>;
  clickId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  datingId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  host?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
  /** Host where the user is registered */
  nicheId?: InputMaybe<Scalars['Int']['input']>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  pseudo?: InputMaybe<Scalars['String']['input']>;
  webmasterId: Scalars['Int']['input'];
}

export interface CoachingResetPassword {
  refunded?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface CoachingSite {
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  datingSiteId?: Maybe<Scalars['Int']['output']>;
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  /** ex: 10recipesforsuccess.com */
  https: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  niche?: Maybe<CoachingNiche>;
  options?: Maybe<CoachingSiteOptions>;
  redirectURL?: Maybe<Scalars['String']['output']>;
  /** global terms */
  termsOfService?: Maybe<Scalars['HTML']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
}


export interface CoachingSiteTermsOfServiceArgs {
  type: TermsOfServiceType;
}


export interface CoachingSiteThumbnailArgs {
  type?: InputMaybe<CoachingSiteThumbnailType>;
}

export interface CoachingSiteGoogleOptions {
  analytics?: Maybe<Scalars['String']['output']>;
  recaptcha?: Maybe<Scalars['String']['output']>;
}

export interface CoachingSiteOptions {
  company?: Maybe<Scalars['String']['output']>;
  descripteur?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  google?: Maybe<CoachingSiteGoogleOptions>;
  hotjar?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  style?: Maybe<CoachingSiteStyleOptions>;
  zendesk?: Maybe<CoachingSiteZendeskOptions>;
}

export interface CoachingSiteStyleOptions {
  theme?: Maybe<Scalars['JSON']['output']>;
}

export enum CoachingSiteThumbnailType {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export interface CoachingSiteZendeskOptions {
  key?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
}

export enum CoachingSourceConnection {
  Dating = 'DATING',
  LoginCoaching = 'LOGIN_COACHING',
  MailCoaching = 'MAIL_COACHING',
  PgaCoaching = 'PGA_COACHING'
}

export interface CoachingTheme {
  audioContent?: Maybe<Scalars['String']['output']>;
  capsules?: Maybe<Array<CoachingCapsule>>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** ex: Body (Coaching), Seduction (Attraction) */
  internalName: Scalars['String']['output'];
  niche?: Maybe<CoachingNiche>;
  position?: Maybe<Scalars['Int']['output']>;
  preferencePosition?: Maybe<Scalars['Int']['output']>;
  progressPercentage: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  totalMembers: Scalars['Int']['output'];
}

export interface CoachingUpdateUserInput {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
}

export interface CoachingUpdateWordingContentsInput {
  content: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}

export interface CoachingUser extends HasPaymentHistory {
  birthdate?: Maybe<Scalars['Date']['output']>;
  /** methods */
  connections?: Maybe<Array<CoachingUserConnection>>;
  /** user fields */
  email: Scalars['EmailAddress']['output'];
  emailValidatedAt?: Maybe<Scalars['Date']['output']>;
  gender: Gender;
  geoname?: Maybe<Geoname>;
  id: Scalars['Int']['output'];
  idDating?: Maybe<Scalars['Int']['output']>;
  locale?: Maybe<Locale>;
  purchaseHistory?: Maybe<Array<PaymentPurchase>>;
  source: Scalars['String']['output'];
  userHasNiches?: Maybe<Array<CoachingUserHasNiche>>;
}


export interface CoachingUserPurchaseHistoryArgs {
  successfulOnly?: Scalars['Boolean']['input'];
}

export interface CoachingUserConnection {
  date: Scalars['Date']['output'];
  ip: Scalars['String']['output'];
  nicheId: Scalars['Int']['output'];
  source: Scalars['String']['output'];
}

export interface CoachingUserHasNiche extends HasPaymentCapabilities, HasPaymentHistory {
  abTest?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  autoconnectLink: Scalars['String']['output'];
  /** @deprecated Use availableMethodsWithConfig instead */
  availableMethods?: Maybe<Array<MethodType>>;
  availableMethodsWithConfig?: Maybe<Array<MethodTypeWithConfig>>;
  beRebilled: Scalars['Boolean']['output'];
  capsule?: Maybe<CoachingCapsule>;
  capsuleEvents: Array<CoachingEvent>;
  coachingOrders?: Maybe<Array<CoachingOrder>>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentCoachingOrder?: Maybe<CoachingOrder>;
  datingToken?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  getInvoiceUrl?: Maybe<Scalars['URL']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  /** resolver */
  hasPreferenceThemes: Scalars['Boolean']['output'];
  hasStandaloneAccess: Scalars['Boolean']['output'];
  language?: Maybe<UserLanguage>;
  legend: Scalars['Boolean']['output'];
  levels: Array<CoachingLevel>;
  mediaTimecodes?: Maybe<Array<Maybe<UserHasMediaTimecode>>>;
  membership: MembershipDetails;
  needPreferenceThemes: Scalars['Boolean']['output'];
  nextPaymentAccount?: Maybe<Scalars['Int']['output']>;
  niche: CoachingNiche;
  nicheId: Scalars['Int']['output'];
  notificationFrequency: CoachingNotificationFrequency;
  paymentKey: Scalars['ID']['output'];
  permanentAccess?: Maybe<Scalars['Boolean']['output']>;
  premium: Scalars['Boolean']['output'];
  premiumDays: Scalars['Int']['output'];
  product: UserProduct;
  purchaseHistory?: Maybe<Array<PaymentPurchase>>;
  registrationUniqueId: Scalars['Int']['output'];
  site: CoachingSite;
  theme: CoachingTheme;
  themes: Array<CoachingTheme>;
  token?: Maybe<Scalars['ID']['output']>;
  trialDays: Scalars['Int']['output'];
  /** class */
  user: CoachingUser;
  userHasChannel?: Maybe<UserHasChannel>;
  userId: Scalars['Int']['output'];
  webmasterId: Scalars['Int']['output'];
}


export interface CoachingUserHasNicheAbTestArgs {
  id: Scalars['Int']['input'];
}


export interface CoachingUserHasNicheAvailableMethodsArgs {
  tryCount: Scalars['Int']['input'];
}


export interface CoachingUserHasNicheAvailableMethodsWithConfigArgs {
  tryCount: Scalars['Int']['input'];
}


export interface CoachingUserHasNicheCapsuleArgs {
  search: CoachingCapsuleByUserInput;
}


export interface CoachingUserHasNicheGetInvoiceUrlArgs {
  isNewPay?: Scalars['Boolean']['input'];
  orderId: Scalars['String']['input'];
}


export interface CoachingUserHasNicheProductArgs {
  productId: Scalars['Int']['input'];
}


export interface CoachingUserHasNichePurchaseHistoryArgs {
  successfulOnly?: Scalars['Boolean']['input'];
}


export interface CoachingUserHasNicheThemeArgs {
  slug: Scalars['String']['input'];
}

export interface CoachingUserUpdateInput {
  languageId?: InputMaybe<Scalars['Int']['input']>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  notificationFrequency?: InputMaybe<CoachingNotificationFrequency>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  pseudo?: InputMaybe<Scalars['String']['input']>;
}

export interface CoachingWordingContent {
  adminId: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  model: CoachingWordingContentModel;
  modelId: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
}

export enum CoachingWordingContentModel {
  Article = 'ARTICLE',
  Ebook = 'EBOOK',
  Niche = 'NICHE',
  Site = 'SITE',
  Theme = 'THEME'
}

export enum ColorConversionTo {
  Hsl = 'HSL',
  Rgb = 'RGB'
}

export interface Comment extends Sluggable {
  content?: Maybe<Scalars['String']['output']>;
  likedAt?: Maybe<Scalars['DateTime']['output']>;
  object?: Maybe<Commentable>;
  slug: Scalars['ID']['output'];
  /** Writer */
  user: UserHasChannelInterface;
}

export interface CommentConnection extends PaginationConnection {
  edges?: Maybe<Array<CommentEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface CommentEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Comment>;
}

export interface CommentEvent extends InteractionEvent, ListEvent, ListViewableEvent {
  comment: Comment;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface CommentEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface CommentLikedEvent extends InteractionEvent, ListEvent, ListViewableEvent {
  comment: Comment;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface CommentLikedEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface Commentable {
  comments?: Maybe<CommentConnection>;
  /** Object owner */
  owner?: Maybe<UserHasChannelInterface>;
}


export interface CommentableCommentsArgs {
  options?: InputMaybe<PaginationOptions>;
}

export interface Company extends Sluggable, WithTermsOfService {
  address: Scalars['String']['output'];
  allSites?: Maybe<Array<Site>>;
  country?: Maybe<Country>;
  cpgConfig?: Maybe<CpgConfig>;
  domainName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pgas?: Maybe<Array<Maybe<Pga>>>;
  phoneNumber?: Maybe<PhoneNumber>;
  phoneSupport?: Maybe<PhoneSupport>;
  registrationNumber: Scalars['String']['output'];
  sites?: Maybe<SiteList>;
  slug: Scalars['ID']['output'];
  termsOfService?: Maybe<Scalars['Markdown']['output']>;
  termsOfServiceHTML?: Maybe<Scalars['HTML']['output']>;
}


export interface CompanySitesArgs {
  options?: InputMaybe<PaginationOptions>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
}


export interface CompanyTermsOfServiceArgs {
  type: TermsOfServiceType;
}


export interface CompanyTermsOfServiceHtmlArgs {
  type: TermsOfServiceType;
}

export interface ConnectionEdge {
  cursor: Scalars['ID']['output'];
}

export enum ConsumableType {
  UserBoost = 'UserBoost'
}

export interface ContactConnection extends PaginationConnection {
  edges?: Maybe<Array<ContactEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface ContactEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<ContactMessageEdge>;
}

/** RECEIVED, SENT and WAITING are deprecated */
export enum ContactFilter {
  All = 'ALL',
  Received = 'RECEIVED',
  Sent = 'SENT',
  Unread = 'UNREAD',
  Waiting = 'WAITING'
}

export interface ContactMessage {
  /** Tells if the user is still a contact */
  available: Scalars['Boolean']['output'];
  lastMessage: IMessage;
  /** Return 1 if last message is unread, 0 otherwise */
  nbNewMessages: Scalars['Int']['output'];
  user?: Maybe<ConversationInterface>;
}

export type ContactMessageEdge = AdItem | ContactMessage;

export interface ContactMethod {
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isPreferred: Scalars['Boolean']['output'];
  type: ContactMethodType;
  value: Scalars['String']['output'];
}

export type ContactMethodForPersonCreateResponse = ContactMethod | ContactMethodForPersonError;

export interface ContactMethodForPersonError extends Error {
  message: Scalars['String']['output'];
}

export type ContactMethodForPersonUpdateResponse = ContactMethodForPersonError | ContactMethods;

export enum ContactMethodType {
  Email = 'EMAIL',
  Instagram = 'INSTAGRAM',
  Phone = 'PHONE',
  Slack = 'SLACK',
  Snapchat = 'SNAPCHAT',
  Teams = 'TEAMS',
  Telegram = 'TELEGRAM',
  Tiktok = 'TIKTOK',
  Whatsapp = 'WHATSAPP'
}

export interface ContactMethods {
  contactMethods: Array<ContactMethod>;
}

export interface Continent extends GeonameBaseType {
  code: Scalars['String']['output'];
  countries: Array<Country>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}


export interface ContinentNameArgs {
  language?: InputMaybe<Scalars['String']['input']>;
}

export interface Contract {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  premium: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
}

export interface ConversationInterface {
  /** Events between users (connected) */
  conversation?: Maybe<MessageFeed>;
  displayName: Scalars['String']['output'];
}


export interface ConversationInterfaceConversationArgs {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageType?: InputMaybe<MessageType>;
}

export enum CookieType {
  Didomi = 'DIDOMI'
}

export interface Coordinates {
  /** Distance to a given coordinate in meters or relative to logged user */
  distance?: Maybe<Scalars['Int']['output']>;
  /** GPS Latitude */
  lat: Scalars['Latitude']['output'];
  /** GPS Longitude */
  lng: Scalars['Longitude']['output'];
}


export interface CoordinatesDistanceArgs {
  to?: InputMaybe<ICoordinates>;
}

export interface Country extends GeonameBaseType {
  area?: Maybe<Scalars['Int']['output']>;
  callingCode?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<Geoname>;
  continent?: Maybe<Continent>;
  currency?: Maybe<Currency>;
  /** Emoji flag */
  flag?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  iso: Scalars['CountryCode']['output'];
  iso3: Scalars['String']['output'];
  languages?: Maybe<Array<Scalars['String']['output']>>;
  /** Legacy Id ex 78=FR */
  legacyId?: Maybe<Scalars['Int']['output']>;
  mostPopulated?: Maybe<Array<Geoname>>;
  name: Scalars['String']['output'];
  neighbours?: Maybe<Array<Country>>;
  population?: Maybe<Scalars['Int']['output']>;
  tld?: Maybe<Scalars['String']['output']>;
}


export interface CountryMostPopulatedArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['GeoFeatureCode']['input'];
}


export interface CountryNameArgs {
  language?: InputMaybe<Scalars['String']['input']>;
}

export interface CountryCallingCode {
  code: Scalars['Int']['output'];
  country: Country;
}

export interface CpgAgreement extends AgreementInterface, Sluggable {
  method: PaymentMethod;
  slug: Scalars['ID']['output'];
  status: AgreementStatus;
}

export interface CpgConfig {
  jsKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
}

export interface CpgGooglePayConfig {
  environment: Scalars['String']['output'];
  gateway: Scalars['String']['output'];
  gatewayMerchantId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
}

export interface Creatable {
  created?: Maybe<Created>;
}

export interface CreateBusinessUnitInput {
  label: Scalars['String']['input'];
}

export type CreateBusinessUnitResponse = BusinessUnit | BusinessUnitError;

export interface CreateOptionAssignmentInput {
  isFinal: Scalars['Boolean']['input'];
  levelId: Scalars['Int']['input'];
  levelType: OptionAssignmentLevelType;
  optionId: Scalars['Int']['input'];
  value: Scalars['String']['input'];
}

export type CreateOptionAssignmentResponse = OptionAssignment | OptionAssignmentError;

export interface CreateOptionDefinitionInput {
  defaultValue: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}

export type CreateOptionDefinitionResponse = OptionDefinition | OptionDefinitionError;

export interface Created {
  at: Scalars['DateTime']['output'];
  by: AdminUser;
}

export interface CredentialsError extends CustomError, Error {
  code: Scalars['ID']['output'];
  message: Scalars['String']['output'];
}

export interface Criteria extends Sluggable {
  id: Scalars['Int']['output'];
  internalLabel: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiple: Scalars['Boolean']['output'];
  slug: Scalars['ID']['output'];
  /** @deprecated use valuesNext */
  values?: Maybe<Array<CriteriaValue>>;
  valuesNext?: Maybe<Array<ICriteriaValue>>;
}

export interface CriteriaGroup {
  criterias?: Maybe<Array<Criteria>>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface CriteriaParam {
  id: Scalars['Int']['input'];
  values?: InputMaybe<Array<Scalars['Int']['input']>>;
}

/** deprecated, use interface ICriteriaValue */
export interface CriteriaValue extends Sluggable {
  criteria?: Maybe<Criteria>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  searchLabel?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
}

export interface CriterionFilter {
  /** Internal label */
  label: Scalars['String']['input'];
  values: Array<Scalars['Int']['input']>;
}

export interface CrmMutation {
  /** @deprecated Use signIn from BizAdminMutation */
  signIn: SignInFlApiResult;
  /** @deprecated Use signUp from BizAdminMutation */
  signUp: UserCrm;
}


export interface CrmMutationSignInArgs {
  input: InputSignInCrm;
}


export interface CrmMutationSignUpArgs {
  input: InputCreateCrmUser;
}

export interface CrmQuery {
  /** @deprecated Use me from CrmQuery instead */
  me?: Maybe<UserCrm>;
}

export interface Cta {
  buttonText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface CtaBtn {
  text: Scalars['String']['output'];
}

export enum CtaContext {
  Chat = 'CHAT',
  Like = 'LIKE',
  LikeReceived = 'LIKE_RECEIVED'
}

export interface Currency {
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
}

export interface CurrentDevice {
  /** Current user's device type based on user-agent */
  deviceType?: Maybe<DeviceType>;
  /** Current user's OS based on user-agent */
  os?: Maybe<Scalars['String']['output']>;
}

export interface CustomError {
  code: Scalars['ID']['output'];
  message: Scalars['String']['output'];
}

export interface CustomerInfoInput {
  addressLines?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
}

export interface DateFilter {
  operator: Operator;
  value: Scalars['DateTime']['input'];
}

export interface DateRange {
  endAt?: Maybe<Scalars['DateTime']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface DateRangeInput {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface DatingAction {
  actionId: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
}

export interface DatingBuyInput {
  displayId?: InputMaybe<Scalars['Int']['input']>;
  failureURL?: InputMaybe<Scalars['URL']['input']>;
  layer?: InputMaybe<LayerPayment>;
  paymentKey: Scalars['ID']['input'];
  products?: InputMaybe<Array<DatingProductInput>>;
  /** The id of the purchase when retrying a failed payment */
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  successURL?: InputMaybe<Scalars['URL']['input']>;
}

export type DatingOrCoachingSite = CoachingSite | Site;

export interface DatingProduct {
  id: Scalars['Int']['output'];
  isUpsell: Scalars['Boolean']['output'];
  siteId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: DatingProductType;
}

export interface DatingProductInput {
  productId: Scalars['Int']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  type: ProductType;
}

export enum DatingProductType {
  Coaching = 'COACHING',
  Dating = 'DATING'
}

export interface DefaultError extends CustomError, Error {
  code: Scalars['ID']['output'];
  message: Scalars['String']['output'];
}

export interface DefaultExtraConfig extends ProphecyFunnelVersionExtraConfig {
  raw?: Maybe<Scalars['JSON']['output']>;
}

export type DefaultPicture = GeneratedPicture | UserPicture;

export interface DefaultPictureFilter {
  createdAt?: InputMaybe<DateFilter>;
  person?: InputMaybe<Scalars['Boolean']['input']>;
  /** Either : G, PG or R */
  ratings?: InputMaybe<Array<MediaRating>>;
}

export interface DefaultSearch extends Sluggable {
  defaultSearchHasSex?: Maybe<DefaultSearchHasSex>;
  defaultSearchHasSexHasCriteriaValue?: Maybe<Array<DefaultSearchHasSexHasCriteriaValue>>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  webmaster?: Maybe<Webmaster>;
}


export interface DefaultSearchDefaultSearchHasSexArgs {
  sex: SexDefaultSearch;
}


export interface DefaultSearchDefaultSearchHasSexHasCriteriaValueArgs {
  sex: SexDefaultSearch;
}

export interface DefaultSearchBiz {
  affiliate?: Maybe<Affiliate>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface DefaultSearchConnection extends PaginationConnection {
  edges?: Maybe<Array<DefaultSearchEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface DefaultSearchEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<DefaultSearchBiz>;
}

export interface DefaultSearchFilter {
  createdAt?: InputMaybe<DateFilter>;
  hasPicture?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<DateFilter>;
  relationshipTag?: InputMaybe<Array<RelationshipTagValue>>;
  userLocation?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface DefaultSearchHasSex {
  ageMax?: Maybe<Scalars['Int']['output']>;
  ageMin?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  heightMax?: Maybe<Scalars['Int']['output']>;
  heightMin?: Maybe<Scalars['Int']['output']>;
  locationRange?: Maybe<LocationRange>;
  sex: SexDefaultSearch;
  weightMax?: Maybe<Scalars['Int']['output']>;
  weightMin?: Maybe<Scalars['Int']['output']>;
}

export interface DefaultSearchHasSexHasCriteriaValue {
  criteriaValue: CriteriaValue;
  sex: SexDefaultSearch;
}

export interface DefaultSearchShowcase {
  defaultSearchShowcaseGroupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  site?: Maybe<Site>;
}

export interface Deletable {
  deleted?: Maybe<Deleted>;
}

export enum DeleteDirection {
  Both = 'BOTH',
  Me = 'ME'
}

export interface DeleteReason {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface Deleted {
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<AdminUser>;
}

export interface DeletedInfo {
  at: Scalars['DateTime']['output'];
  by?: Maybe<AdminUser>;
  reason?: Maybe<Scalars['String']['output']>;
}

export interface DeployEvent {
  commitId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isProd?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Scalars['String']['output']>;
  user: Scalars['String']['output'];
}

export interface DetailInput {
  authorId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  type?: Maybe<DetailInputType>;
  userVals?: Maybe<Scalars['JSON']['output']>;
  vals?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
}

export enum DetailInputType {
  Checkbox = 'CHECKBOX',
  Radio = 'RADIO',
  Select = 'SELECT',
  SelectMultiple = 'SELECT_MULTIPLE',
  Textbox = 'TEXTBOX',
  TextboxMultiple = 'TEXTBOX_MULTIPLE'
}

export interface DeviceInput {
  colorDepth: Scalars['Int']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timezone: Scalars['Int']['input'];
}

export enum DeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Unknown = 'UNKNOWN'
}

export enum Direction {
  From = 'FROM',
  To = 'TO'
}

export interface DiscoveryCategory {
  items: Array<DiscoveryItem>;
  label: Scalars['String']['output'];
  type: DiscoveryCategoryEnum;
}

export enum DiscoveryCategoryEnum {
  Availability = 'AVAILABILITY',
  Community = 'COMMUNITY',
  Hobby = 'HOBBY',
  RelationshipTag = 'RELATIONSHIP_TAG',
  Zodiac = 'ZODIAC'
}

export interface DiscoveryItem {
  background?: Maybe<Scalars['URL']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelDescription: Scalars['String']['output'];
  sign?: Maybe<ZodiacSign>;
  speedflirtSort?: Maybe<SpeedflirtSort>;
  type: DiscoveryCategoryEnum;
}

export interface DynamicConfigKey {
  description?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<DynamicConfigValue>>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface DynamicConfigValue {
  admin?: Maybe<AdminUser>;
  createdAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
}

export interface EmailStatus {
  time?: Maybe<Scalars['DateTime']['output']>;
  type: EmailStatusType;
}

export enum EmailStatusType {
  Bounced = 'BOUNCED',
  Validated = 'VALIDATED'
}

export enum EmptyPageTip {
  Complete = 'COMPLETE',
  Description = 'DESCRIPTION',
  Hobbies = 'HOBBIES',
  Picture = 'PICTURE',
  Snap = 'SNAP'
}

export enum EnableRebillSource {
  LayerReactivate = 'LAYER_REACTIVATE',
  MySubscriptionCurrentPurchase = 'MY_SUBSCRIPTION_CURRENT_PURCHASE',
  MySubscriptionOtherSitePurchase = 'MY_SUBSCRIPTION_OTHER_SITE_PURCHASE',
  UpgradeDisabledPurchase = 'UPGRADE_DISABLED_PURCHASE'
}

export enum EnableStatus {
  Both = 'BOTH',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export interface Error {
  message: Scalars['String']['output'];
}

export interface ErrorWithMessage extends Error {
  message: Scalars['String']['output'];
}

export interface EventDescription {
  description: Scalars['String']['input'];
  reason?: InputMaybe<Reason>;
  source: PaymentEventSource;
}

export enum EventSource {
  Blacklist = 'Blacklist',
  BlockedProfileTips = 'BlockedProfileTips',
  Chat = 'Chat',
  ChatSpeedDating = 'ChatSpeedDating',
  ConquestList = 'ConquestList',
  Coregistration = 'Coregistration',
  DailySnap = 'DailySnap',
  Dalle = 'Dalle',
  Direct = 'Direct',
  EmptyMessageTips = 'EmptyMessageTips',
  FavoriteGame = 'FavoriteGame',
  FavoriteGameOpenProfile = 'FavoriteGameOpenProfile',
  FavoriteList = 'FavoriteList',
  FeedAnniversary = 'FeedAnniversary',
  FeedAvailability = 'FeedAvailability',
  FeedChangedDisplayName = 'FeedChangedDisplayName',
  FeedComeback = 'FeedComeback',
  FeedComment = 'FeedComment',
  FeedCommentLike = 'FeedCommentLike',
  FeedCtaDescription = 'FeedCtaDescription',
  FeedCtaHobbies = 'FeedCtaHobbies',
  FeedCtaPicture = 'FeedCtaPicture',
  FeedCtaPicturePrivate = 'FeedCtaPicturePrivate',
  FeedCtaPremium = 'FeedCtaPremium',
  FeedCtaSnap = 'FeedCtaSnap',
  FeedCtaSpeedflirt = 'FeedCtaSpeedflirt',
  FeedCtaTrial = 'FeedCtaTrial',
  FeedDescription = 'FeedDescription',
  FeedExpiredMatch = 'FeedExpiredMatch',
  FeedExpiredMatchCarousel = 'FeedExpiredMatchCarousel',
  FeedExpiredMatchGrid = 'FeedExpiredMatchGrid',
  FeedFavoriteGame = 'FeedFavoriteGame',
  FeedGuess = 'FeedGuess',
  FeedHeaderAnniversary = 'FeedHeaderAnniversary',
  FeedHeaderAvailability = 'FeedHeaderAvailability',
  FeedHeaderComeback = 'FeedHeaderComeback',
  FeedHeaderDescription = 'FeedHeaderDescription',
  FeedHeaderExpiredMatch = 'FeedHeaderExpiredMatch',
  FeedHeaderHobbies = 'FeedHeaderHobbies',
  FeedHeaderHobbyOne = 'FeedHeaderHobbyOne',
  FeedHeaderMatch = 'FeedHeaderMatch',
  FeedHeaderMatchReminder = 'FeedHeaderMatchReminder',
  FeedHeaderOnline = 'FeedHeaderOnline',
  FeedHeaderPicture = 'FeedHeaderPicture',
  FeedHeaderPictureCarousel = 'FeedHeaderPictureCarousel',
  FeedHeaderPictureChat = 'FeedHeaderPictureChat',
  FeedHeaderPictureLike = 'FeedHeaderPictureLike',
  FeedHeaderPretenderMessage = 'FeedHeaderPretenderMessage',
  FeedHeaderRelationshipTag = 'FeedHeaderRelationshipTag',
  FeedHeaderSearchPopularity = 'FeedHeaderSearchPopularity',
  FeedHeaderSnap = 'FeedHeaderSnap',
  FeedHeaderSnapComment = 'FeedHeaderSnapComment',
  FeedHeaderSnapLike = 'FeedHeaderSnapLike',
  FeedHeaderSubscribers = 'FeedHeaderSubscribers',
  FeedHeaderUnansweredMessage = 'FeedHeaderUnansweredMessage',
  FeedHeaderVisit = 'FeedHeaderVisit',
  FeedHobbies = 'FeedHobbies',
  FeedMatch = 'FeedMatch',
  FeedMatchCarousel = 'FeedMatchCarousel',
  FeedMatchReminder = 'FeedMatchReminder',
  FeedMessage = 'FeedMessage',
  FeedMiniSpeedflirt = 'FeedMiniSpeedflirt',
  FeedOnline = 'FeedOnline',
  FeedOnlineCarousel = 'FeedOnlineCarousel',
  FeedOnlineGrid = 'FeedOnlineGrid',
  FeedPicture = 'FeedPicture',
  FeedPictureAuthorization = 'FeedPictureAuthorization',
  FeedPictureAuthorizationReceived = 'FeedPictureAuthorizationReceived',
  FeedPictureCarousel = 'FeedPictureCarousel',
  FeedPictureChat = 'FeedPictureChat',
  FeedPictureLike = 'FeedPictureLike',
  FeedPretenderCarousel = 'FeedPretenderCarousel',
  FeedPretenderGrid = 'FeedPretenderGrid',
  FeedPretenderMessage = 'FeedPretenderMessage',
  FeedPretenderMessageMiniLike = 'FeedPretenderMessageMiniLike',
  FeedRelationshipTag = 'FeedRelationshipTag',
  FeedSearchAge = 'FeedSearchAge',
  FeedSearchAgeCarousel = 'FeedSearchAgeCarousel',
  FeedSearchAgeGrid = 'FeedSearchAgeGrid',
  FeedSearchAstroCompatibility = 'FeedSearchAstroCompatibility',
  FeedSearchAstroCompatibilityCarousel = 'FeedSearchAstroCompatibilityCarousel',
  FeedSearchAstroCompatibilityGrid = 'FeedSearchAstroCompatibilityGrid',
  FeedSearchAvailabilityCarousel = 'FeedSearchAvailabilityCarousel',
  FeedSearchAvailabilityGrid = 'FeedSearchAvailabilityGrid',
  FeedSearchClose = 'FeedSearchClose',
  FeedSearchCloseCarousel = 'FeedSearchCloseCarousel',
  FeedSearchCloseGrid = 'FeedSearchCloseGrid',
  FeedSearchDefault = 'FeedSearchDefault',
  FeedSearchDefaultCarousel = 'FeedSearchDefaultCarousel',
  FeedSearchDefaultGrid = 'FeedSearchDefaultGrid',
  FeedSearchHobbies = 'FeedSearchHobbies',
  FeedSearchHobbiesCarousel = 'FeedSearchHobbiesCarousel',
  FeedSearchHobbiesGrid = 'FeedSearchHobbiesGrid',
  FeedSearchHobbyOne = 'FeedSearchHobbyOne',
  FeedSearchHobbyOneCarousel = 'FeedSearchHobbyOneCarousel',
  FeedSearchHobbyOneGrid = 'FeedSearchHobbyOneGrid',
  FeedSearchJobCarousel = 'FeedSearchJobCarousel',
  FeedSearchJobGrid = 'FeedSearchJobGrid',
  FeedSearchJobsCarousel = 'FeedSearchJobsCarousel',
  FeedSearchJobsGrid = 'FeedSearchJobsGrid',
  FeedSearchLastApprovedPicture = 'FeedSearchLastApprovedPicture',
  FeedSearchLastApprovedPictureCarousel = 'FeedSearchLastApprovedPictureCarousel',
  FeedSearchLastApprovedPictureGrid = 'FeedSearchLastApprovedPictureGrid',
  FeedSearchLastOnline = 'FeedSearchLastOnline',
  FeedSearchLastOnlineCarousel = 'FeedSearchLastOnlineCarousel',
  FeedSearchLastOnlineGrid = 'FeedSearchLastOnlineGrid',
  FeedSearchLastRegistered = 'FeedSearchLastRegistered',
  FeedSearchLastRegisteredCarousel = 'FeedSearchLastRegisteredCarousel',
  FeedSearchLastRegisteredGrid = 'FeedSearchLastRegisteredGrid',
  FeedSearchLocation = 'FeedSearchLocation',
  FeedSearchLocationCarousel = 'FeedSearchLocationCarousel',
  FeedSearchLocationGrid = 'FeedSearchLocationGrid',
  FeedSearchOnline = 'FeedSearchOnline',
  FeedSearchOnlineCarousel = 'FeedSearchOnlineCarousel',
  FeedSearchOnlineGrid = 'FeedSearchOnlineGrid',
  FeedSearchPopularity = 'FeedSearchPopularity',
  FeedSearchPopularityCarousel = 'FeedSearchPopularityCarousel',
  FeedSearchPopularityGrid = 'FeedSearchPopularityGrid',
  FeedSearchRelationshipTag = 'FeedSearchRelationshipTag',
  FeedSearchRelationshipTagCarousel = 'FeedSearchRelationshipTagCarousel',
  FeedSearchRelationshipTagGrid = 'FeedSearchRelationshipTagGrid',
  FeedSearchRelationshipTagOthers = 'FeedSearchRelationshipTagOthers',
  FeedSearchRelationshipTagOthersCarousel = 'FeedSearchRelationshipTagOthersCarousel',
  FeedSearchRelationshipTagOthersGrid = 'FeedSearchRelationshipTagOthersGrid',
  FeedSecondChance = 'FeedSecondChance',
  FeedSecondChanceCarousel = 'FeedSecondChanceCarousel',
  FeedSecondChanceGrid = 'FeedSecondChanceGrid',
  FeedSnap = 'FeedSnap',
  FeedSnapComment = 'FeedSnapComment',
  FeedSnapLike = 'FeedSnapLike',
  FeedSnapList = 'FeedSnapList',
  FeedSnapVideoList = 'FeedSnapVideoList',
  FeedSnapbar = 'FeedSnapbar',
  FeedSubscribers = 'FeedSubscribers',
  FeedSubscribersCarousel = 'FeedSubscribersCarousel',
  FeedSubscribersGrid = 'FeedSubscribersGrid',
  FeedSubscribersMiniLike = 'FeedSubscribersMiniLike',
  FeedTipsLocation = 'FeedTipsLocation',
  FeedTipsRejectedDescription = 'FeedTipsRejectedDescription',
  FeedTipsRejectedPicture = 'FeedTipsRejectedPicture',
  FeedTipsRejectedSnap = 'FeedTipsRejectedSnap',
  FeedUnansweredMessage = 'FeedUnansweredMessage',
  FeedUnknown = 'FeedUnknown',
  FeedUnstartedConversation = 'FeedUnstartedConversation',
  FeedVisit = 'FeedVisit',
  FeedVisitCarousel = 'FeedVisitCarousel',
  FeedVisitGrid = 'FeedVisitGrid',
  Flux = 'Flux',
  LayerSpeedflirtAdvantages = 'LayerSpeedflirtAdvantages',
  Legacy = 'Legacy',
  LikesDone = 'LikesDone',
  LikesReceived = 'LikesReceived',
  LikesTips = 'LikesTips',
  ListsPictureAuthorizationTips = 'ListsPictureAuthorizationTips',
  LocalNotification = 'LocalNotification',
  Match = 'Match',
  MidJourney = 'MidJourney',
  MyMediaViewer = 'MyMediaViewer',
  MyProfileCta = 'MyProfileCta',
  MyProfileGeneratedPicture = 'MyProfileGeneratedPicture',
  MyProfilePhotoViewer = 'MyProfilePhotoViewer',
  MyProfilePictures = 'MyProfilePictures',
  MyProfilePost = 'MyProfilePost',
  MyProfileSnaps = 'MyProfileSnaps',
  MyProfileTips = 'MyProfileTips',
  NotificationPush = 'NotificationPush',
  NotificationTips = 'NotificationTips',
  PictureAuthorizationFromList = 'PictureAuthorizationFromList',
  PictureAuthorizationToList = 'PictureAuthorizationToList',
  PictureLikeList = 'PictureLikeList',
  PretendantList = 'PretendantList',
  Profile = 'Profile',
  ProfileDesktop = 'ProfileDesktop',
  Prophecy = 'Prophecy',
  ProphecyOpenAi = 'ProphecyOpenAi',
  RejectedCta = 'RejectedCta',
  Search = 'Search',
  SelectionList = 'SelectionList',
  SlideCardSubscription = 'SlideCardSubscription',
  Snap = 'Snap',
  SnapLikeList = 'SnapLikeList',
  Speedflirt = 'Speedflirt',
  SpeedflirtCommunity = 'SpeedflirtCommunity',
  SpeedflirtDesktop = 'SpeedflirtDesktop',
  SpeedflirtHobbies = 'SpeedflirtHobbies',
  SpeedflirtMood = 'SpeedflirtMood',
  SpeedflirtRelationshipTag = 'SpeedflirtRelationshipTag',
  SpeedflirtTips = 'SpeedflirtTips',
  SpeedflirtZodiac = 'SpeedflirtZodiac',
  Tabbar = 'Tabbar',
  TipsBoostProfile = 'TipsBoostProfile',
  TipsFromSnaps = 'TipsFromSnaps',
  TipsGhostedMessage = 'TipsGhostedMessage',
  Unknown = 'Unknown',
  UnstartedConversation = 'UnstartedConversation',
  VisitsFrom = 'VisitsFrom',
  VisitsFromDesktop = 'VisitsFromDesktop',
  VisitsTo = 'VisitsTo',
  VisitsToDesktop = 'VisitsToDesktop',
  LikeList = 'likeList',
  SecondChanceList = 'secondChanceList'
}

export enum EventTypeCommon {
  Authorised = 'AUTHORISED',
  Cancelled = 'CANCELLED',
  CancelledAsked = 'CANCELLED_ASKED',
  Captured = 'CAPTURED',
  ChargedBack = 'CHARGED_BACK',
  ChargedBackReversal = 'CHARGED_BACK_REVERSAL',
  Cron = 'CRON',
  Dispute = 'DISPUTE',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  FraudAlert = 'FRAUD_ALERT',
  InformationSupplied = 'INFORMATION_SUPPLIED',
  Layer = 'LAYER',
  Mailed = 'MAILED',
  Miscellaneous = 'MISCELLANEOUS',
  Pending = 'PENDING',
  RebillFailed = 'REBILL_FAILED',
  RebillQueued = 'REBILL_QUEUED',
  RebillUnsubscribeFeesQueued = 'REBILL_UNSUBSCRIBE_FEES_QUEUED',
  Redirect = 'REDIRECT',
  Refunded = 'REFUNDED',
  RefundAsked = 'REFUND_ASKED',
  RefundRefused = 'REFUND_REFUSED',
  Refused = 'REFUSED',
  ResumeRebill = 'RESUME_REBILL',
  RiskBlockPayment = 'RISK_BLOCK_PAYMENT',
  RiskForce_3Ds = 'RISK_FORCE_3DS',
  Settled = 'SETTLED',
  Start = 'START',
  StopRebill = 'STOP_REBILL'
}

export interface ExternalSignInResult {
  id: Scalars['ID']['output'];
  providerId: Scalars['Int']['output'];
  url: Scalars['URL']['output'];
}

export interface FacebookApplication {
  channel: Channel;
  host: Scalars['String']['output'];
  isChannelDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
}

export interface FacebookUser {
  accessToken: Scalars['String']['output'];
  facebookUserId: Scalars['Int']['output'];
}

export interface FaqAnswer {
  id: Scalars['Int']['output'];
  label: Scalars['Markdown']['output'];
  labelHTML?: Maybe<Scalars['HTML']['output']>;
}

export interface FaqFeedback {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface FaqItem {
  answer?: Maybe<FaqAnswer>;
  question: FaqQuestion;
}

export interface FaqQuestion {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface FaqTopic {
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<FaqItem>>;
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  subtopics?: Maybe<Array<FaqTopic>>;
}

export interface FavoriteGame {
  profiles: Array<UserSearchDocument>;
}

export interface Feed extends Feedable, Sluggable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content?: Maybe<FeedContent>;
  createdAt: Scalars['DateTime']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  header?: Maybe<FeedHeader>;
  score?: Maybe<Scalars['Float']['output']>;
  slug: Scalars['ID']['output'];
  source: EventSource;
  viewed?: Maybe<Scalars['Int']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
}

export type FeedAction = FeedActionOnSlug | FeedActionRedirect;

export interface FeedActionLabel {
  click: FeedAction;
  icon?: Maybe<IconFeed>;
  position?: Maybe<FeedCtaPosition>;
  text?: Maybe<Scalars['String']['output']>;
}

export interface FeedActionOnSlug {
  action: ActionOnSlug;
  actionAlreadyDone?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
}

export interface FeedActionRedirect {
  redirect: ActionOnRedirectFeed;
  slug?: Maybe<Scalars['String']['output']>;
}

export interface FeedBottom extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export enum FeedCtaPosition {
  Default = 'DEFAULT',
  OverBottom = 'OVER_BOTTOM',
  OverCenter = 'OVER_CENTER'
}

export type FeedContent = FeedContentAds | FeedContentCrossSite | FeedContentCta | FeedContentFavorite | FeedContentGuess | FeedContentMiniSpeedflirt | FeedContentPicture | FeedContentPictureBatch | FeedContentProfile | FeedContentProfiles | FeedContentReactionPicture | FeedContentSingleRow | FeedContentSnaps | FeedContentSnapsVideo | FeedContentUnknown | FeedContentUserEvent | FeedContentUserInteraction;

export interface FeedContentAds {
  ads?: Maybe<AdItem>;
  contentTypeName: Scalars['String']['output'];
}

export interface FeedContentCrossSite {
  contentTypeName: Scalars['String']['output'];
}

export interface FeedContentCta {
  contentTypeName: Scalars['String']['output'];
  cta: FeedCtaType;
  format?: Maybe<FeedCtaFormat>;
}

export interface FeedContentFavorite {
  contentTypeName: Scalars['String']['output'];
  games: Array<FavoriteGame>;
}

export interface FeedContentGuess {
  contentTypeName: Scalars['String']['output'];
  guesses?: Maybe<Array<GuessGame>>;
}

export interface FeedContentMiniSpeedflirt {
  contentTypeName: Scalars['String']['output'];
  speedflirt?: Maybe<Array<SpeedflirtList>>;
}

export interface FeedContentPicture extends FeedContentPictureInterface {
  contentTypeName: Scalars['String']['output'];
  picture?: Maybe<FeedUserPicture>;
  text?: Maybe<Scalars['String']['output']>;
}


export interface FeedContentPicturePictureArgs {
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface FeedContentPictureBatch {
  contentTypeName: Scalars['String']['output'];
  format?: Maybe<FeedFormatType>;
  pictures?: Maybe<Array<FeedPicture>>;
}

export interface FeedContentPictureInterface {
  contentTypeName: Scalars['String']['output'];
  picture?: Maybe<FeedUserPicture>;
  text?: Maybe<Scalars['String']['output']>;
}


export interface FeedContentPictureInterfacePictureArgs {
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface FeedContentProfile {
  contentTypeName: Scalars['String']['output'];
  format?: Maybe<FeedFormatType>;
  profile: FeedProfile;
}

export interface FeedContentProfiles {
  contentTypeName: Scalars['String']['output'];
  format?: Maybe<FeedFormatType>;
  profiles: Array<FeedProfileNode>;
}

export interface FeedContentReactionPicture extends FeedContentPictureInterface {
  contentTypeName: Scalars['String']['output'];
  picture?: Maybe<FeedUserPicture>;
  reactions: Array<Reaction>;
  text?: Maybe<Scalars['String']['output']>;
}


export interface FeedContentReactionPicturePictureArgs {
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface FeedContentSingleRow {
  action: FeedAction;
  contentTypeName: Scalars['String']['output'];
  ctaRow?: Maybe<SingleRowAction>;
  date?: Maybe<Scalars['DateTime']['output']>;
  subTitles?: Maybe<Array<Maybe<SubTitle>>>;
  title: Scalars['String']['output'];
  uhc: UserHasChannelInterface;
}

export interface FeedContentSnaps {
  contentTypeName: Scalars['String']['output'];
  snaps?: Maybe<Array<Snap>>;
}

export interface FeedContentSnapsVideo {
  contentTypeName: Scalars['String']['output'];
  snaps?: Maybe<Array<Snap>>;
}

export interface FeedContentUnknown {
  contentTypeName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
}

export interface FeedContentUserEvent {
  contentTypeName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureWithIcon>;
}

export interface FeedContentUserInteraction {
  background?: Maybe<PictureSource>;
  contentTypeName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<IconFeed>;
  pictureFrom?: Maybe<PictureWithIcon>;
  pictureTo?: Maybe<PictureWithIcon>;
  title: Scalars['String']['output'];
  userFrom: UserHasChannelInterface;
}


export interface FeedContentUserInteractionBackgroundArgs {
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface FeedCrossSites extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedCta extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeaderTitle>;
  source: EventSource;
  staticSlug?: Maybe<Scalars['ID']['output']>;
}

export enum FeedCtaFormat {
  Default = 'DEFAULT',
  Small = 'SMALL'
}

export enum FeedCtaType {
  Description = 'DESCRIPTION',
  Hobbies = 'HOBBIES',
  Location = 'LOCATION',
  Picture = 'PICTURE',
  PicturePrivate = 'PICTURE_PRIVATE',
  Premium = 'PREMIUM',
  RejectedDescription = 'REJECTED_DESCRIPTION',
  RejectedPicture = 'REJECTED_PICTURE',
  RejectedSnap = 'REJECTED_SNAP',
  Snap = 'SNAP',
  Speedflirt = 'SPEEDFLIRT',
  Trial = 'TRIAL'
}

export interface FeedCustom extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedFavoriteGame extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeaderTitle>;
  source: EventSource;
}

export enum FeedFormatType {
  Carousel_1 = 'CAROUSEL_1',
  Carousel_2 = 'CAROUSEL_2',
  CarouselPicture = 'CAROUSEL_PICTURE',
  Grid = 'GRID',
  MiniLikes = 'MINI_LIKES',
  MiniSpeedflirt = 'MINI_SPEEDFLIRT',
  Single = 'SINGLE'
}

export interface FeedGuess extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeaderTitle>;
  source: EventSource;
}

export interface FeedHeader {
  subTitles?: Maybe<Array<Maybe<SubTitle>>>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface FeedHeaderTitle extends FeedHeader {
  action?: Maybe<FeedAction>;
  icon?: Maybe<IconFeed>;
  subTitles?: Maybe<Array<Maybe<SubTitle>>>;
  title: Scalars['String']['output'];
}

export interface FeedHeaderUser extends FeedHeader {
  date?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<IconFeed>;
  source: EventSource;
  subTitles?: Maybe<Array<Maybe<SubTitle>>>;
  title: Scalars['String']['output'];
  user: UserHasChannelInterface;
}

export interface FeedList {
  bottom: Scalars['Boolean']['output'];
  edges?: Maybe<Array<Feedable>>;
}

export interface FeedMiniSpeedflirt extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedOnline extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  online?: Maybe<Array<UserHasChannelInterface>>;
  source: EventSource;
}

export interface FeedPicture {
  action?: Maybe<FeedActionLabel>;
  picture?: Maybe<FeedUserPicture>;
  user?: Maybe<UserHasChannelInterface>;
}

export interface FeedProfile {
  action?: Maybe<FeedActionLabel>;
  highlight?: Maybe<FeedUserProfileHighlight>;
  user?: Maybe<UserHasChannelInterface>;
}

export type FeedProfileNode = AdItem | FeedProfile;

export interface FeedSearch extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedSnaps extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedSnapsVideo extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export type FeedUserPicture = GeneratedPicture | MessagePicture | PictureUrl | Snap | UserPicture;

export enum FeedUserProfileHighlight {
  Availability = 'AVAILABILITY',
  Description = 'DESCRIPTION',
  DisplayName = 'DISPLAY_NAME',
  Hobbies = 'HOBBIES',
  RelationshipTag = 'RELATIONSHIP_TAG'
}

export interface Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content?: Maybe<FeedContent>;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedbackType {
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
}

export interface Feeds extends Feedable {
  actions?: Maybe<Array<FeedActionLabel>>;
  content: FeedContent;
  feedsInfos: Array<FeedsInfos>;
  header?: Maybe<FeedHeader>;
  source: EventSource;
}

export interface FeedsInfos {
  createdAt: Scalars['DateTime']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  slug: Scalars['ID']['output'];
  viewed?: Maybe<Scalars['Int']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface Fees {
  currency?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
}

export interface File {
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
}

export interface Fingerprint extends HasCoordinates {
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  createdAt: Scalars['Date']['output'];
  device: Scalars['String']['output'];
  fingerprint: Scalars['String']['output'];
  geoname?: Maybe<Geoname>;
  ip: Scalars['String']['output'];
  isBot?: Maybe<Scalars['Boolean']['output']>;
  isIncognito?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Locale>;
  platform?: Maybe<Scalars['String']['output']>;
  screenH?: Maybe<Scalars['Int']['output']>;
  screenW?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedCount: Scalars['Int']['output'];
}

export enum FingerprintSource {
  Chat = 'CHAT',
  Payment = 'PAYMENT',
  Signin = 'SIGNIN',
  Signup = 'SIGNUP'
}

export interface FontAwesomeCriteriaValue extends ICriteriaValue, Sluggable {
  backgroundUrl?: Maybe<Scalars['URL']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Criteria>;
  icons: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  searchLabel?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
}

export interface ForceOutflowInput {
  affiliateId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['Int']['input'];
  period: Scalars['Int']['input'];
}

export interface FraudReview {
  /** Get the assigned user or assign one if none for fraud review */
  assign?: Maybe<UserHasChannel>;
  /** Review users to either ban or deny suspect behavior */
  review?: Maybe<BooleanResult>;
  /** Skip the fraud review */
  skip?: Maybe<BooleanResult>;
}


export interface FraudReviewReviewArgs {
  users: Array<FraudReviewPair>;
}


export interface FraudReviewSkipArgs {
  userId: Scalars['Int']['input'];
}

export interface FraudReviewPair {
  /** Tells if the user should be ban (user is fraud) */
  delete: Scalars['Boolean']['input'];
  /** Slug of the user's UHC */
  slug: Scalars['ID']['input'];
}

export interface FraudRule extends FraudRuleInterface {
  isBlacklisted?: Maybe<Scalars['Boolean']['output']>;
  isGhost?: Maybe<Scalars['Boolean']['output']>;
  isWhitelisted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
}

export interface FraudRuleGroup extends FraudRuleInterface {
  isBlacklisted?: Maybe<Scalars['Boolean']['output']>;
  isWhitelisted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rules?: Maybe<Array<FraudRule>>;
  score?: Maybe<Scalars['Float']['output']>;
}

export interface FraudRuleInterface {
  isBlacklisted?: Maybe<Scalars['Boolean']['output']>;
  isWhitelisted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
}

export interface FrontTranslation {
  alias: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface FunnelsInput {
  distribution: Scalars['Float']['input'];
  extraConfig: Scalars['String']['input'];
  funnel: Scalars['ID']['input'];
  index: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface GamificationEvent {
  eventType: GamificationEventType;
}

export type GamificationEventResult = AchievementEvent | LevelUpEvent | LoginEvent | PointsAcquiredEvent;

export enum GamificationEventType {
  Achievement = 'ACHIEVEMENT',
  LevelUp = 'LEVEL_UP',
  Login = 'LOGIN',
  PointsAquired = 'POINTS_AQUIRED'
}

export enum GamificationRewardItemType {
  Boost24h = 'Boost24h',
  FastPass = 'FastPass',
  RollbackSf = 'RollbackSF',
  SnapView = 'SnapView',
  SuperLike = 'SuperLike',
  Swipe = 'Swipe'
}

export enum Gender {
  Couple = 'COUPLE',
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum GenderLabelType {
  Default = 'DEFAULT',
  Emoji = 'EMOJI',
  Phrase = 'PHRASE',
  Symbol = 'SYMBOL'
}

export interface GenderModel {
  id: Gender;
  label?: Maybe<Scalars['String']['output']>;
  legacyId: Scalars['Int']['output'];
}


export interface GenderModelLabelArgs {
  language?: InputMaybe<Scalars['String']['input']>;
  plural?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<GenderLabelType>;
}

export enum GenderType {
  Couple = 'COUPLE',
  Man = 'MAN',
  Woman = 'WOMAN'
}

export interface GeneratedPicture extends PictureInterface {
  blurStatus: BlurReason;
  blurhash?: Maybe<Scalars['String']['output']>;
  sources: PictureSrcSet;
  user?: Maybe<UserHasChannelInterface>;
}


export interface GeneratedPictureSourcesArgs {
  safemode?: InputMaybe<Safemode>;
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export enum GeoAccuracy {
  Closest = 'CLOSEST',
  Popularity = 'POPULARITY'
}

export enum GeoFindType {
  Admin = 'ADMIN',
  City = 'CITY',
  Zipcode = 'ZIPCODE'
}

export interface Geoname extends GeonameBaseType, Sluggable {
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  /** Geoname Id */
  id: Scalars['Int']['output'];
  mostPopulated?: Maybe<Array<Geoname>>;
  name: Scalars['String']['output'];
  /** Display more information than just the geoname's name Currently dealing with USA And Canada ex: Dallas, TX Toronto, ON */
  niceName: Scalars['String']['output'];
  niceParent?: Maybe<GeonameBaseType>;
  parent?: Maybe<GeonameBaseType>;
  population?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['ID']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
}


export interface GeonameMostPopulatedArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['GeoFeatureCode']['input'];
}


export interface GeonameNameArgs {
  language?: InputMaybe<Scalars['String']['input']>;
}


export interface GeonameNiceNameArgs {
  language?: InputMaybe<Scalars['String']['input']>;
}

export interface GeonameBaseType {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}


export interface GeonameBaseTypeNameArgs {
  language?: InputMaybe<Scalars['String']['input']>;
}

export interface GooglePayIntermediateSigningKey {
  signatures: Array<Scalars['String']['input']>;
  signedKey: Scalars['String']['input'];
}

export interface GooglePayToken {
  /** gatewayMerchantId used to genetate this token */
  gatewayMerchantId: Scalars['String']['input'];
  /** for ECv2 only */
  intermediateSigningKey?: InputMaybe<GooglePayIntermediateSigningKey>;
  protocolVersion: VersionGooglePay;
  signature: Scalars['String']['input'];
  signedMessage: Scalars['String']['input'];
}

export interface GrantExtraInput {
  actionId: Scalars['Int']['input'];
  amount: Scalars['Int']['input'];
  /** RRUle format, no expiration if null */
  duration?: InputMaybe<Scalars['RRule']['input']>;
}

export interface GreylistIp {
  cidr: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  ip: Scalars['IPv4']['output'];
  type: GreylistType;
}

export enum GreylistType {
  Black = 'BLACK',
  White = 'WHITE'
}

export enum GsmSource {
  Profile = 'PROFILE',
  Registration = 'REGISTRATION',
  ValidationLayer = 'VALIDATION_LAYER'
}

export interface GuessGame {
  loose: Array<UserHasChannel>;
  win: UserHasChannel;
}

export interface HasCoordinates {
  /** Real coordinates */
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  /** Closests matching geoname */
  geoname?: Maybe<Geoname>;
}

export interface HasPaymentCapabilities {
  availableMethodsWithConfig?: Maybe<Array<MethodTypeWithConfig>>;
  membership: MembershipDetails;
  nextPaymentAccount?: Maybe<Scalars['Int']['output']>;
  paymentKey: Scalars['ID']['output'];
  product: UserProduct;
}


export interface HasPaymentCapabilitiesAvailableMethodsWithConfigArgs {
  tryCount: Scalars['Int']['input'];
}


export interface HasPaymentCapabilitiesProductArgs {
  productId: Scalars['Int']['input'];
}

export interface HasPaymentEventInterface {
  events?: Maybe<Array<PaymentEvent>>;
}

export interface HasPaymentHistory {
  purchaseHistory?: Maybe<Array<PaymentPurchase>>;
}


export interface HasPaymentHistoryPurchaseHistoryArgs {
  successfulOnly?: Scalars['Boolean']['input'];
}

export interface HasSnaps {
  snaps?: Maybe<Array<Snap>>;
}

export interface HeaderApplePay {
  applicationData?: InputMaybe<Scalars['String']['input']>;
  /** For version : EC_v1 */
  ephemeralPublicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyHash: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
  /** For version : RSA_v1 */
  wrappedKey?: InputMaybe<Scalars['String']['input']>;
}

export type HeightWeight = MultipleHeightWeight | SingleHeightWeight;

export interface ICriteriaValue {
  backgroundUrl?: Maybe<Scalars['URL']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Criteria>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  searchLabel?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
}

export interface IMessage {
  createdAt: Scalars['DateTime']['output'];
  /** Get message direction relative to a given user (or auth if authentiied) */
  direction: Direction;
  from: UserHasChannelInterface;
  /** Date when the recipient opened the message */
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  /** Message type id */
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
}


export interface IMessageDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface IpLog extends HasCoordinates {
  at: Scalars['DateTime']['output'];
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  geoname?: Maybe<Geoname>;
  ip: Scalars['String']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isp?: Maybe<Scalars['String']['output']>;
  /** dial-up, cellular, cable/DSL, and corporate connection speeds. */
  type?: Maybe<Scalars['String']['output']>;
}

export interface IRelationshipTag {
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelShort: Scalars['String']['output'];
}

export interface IceBreaker extends BelongsToUhc, Reviewable, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  isAiGenerated: Scalars['Boolean']['output'];
  isPredefined: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Reviewed>;
  slug: Scalars['ID']['output'];
  user?: Maybe<UserHasChannelInterface>;
}

export interface Icon {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface IconData {
  content: Scalars['String']['output'];
  format: IconType;
}

export interface IconFeed {
  color?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Scalars['Int']['output']>;
  iconData: Scalars['String']['output'];
  iconType: IconType;
}

export enum IconType {
  /** Use filename as data */
  File = 'FILE',
  /** Use awesome icons classes as data */
  FontAwesome = 'FONT_AWESOME',
  /** use by emoji icon */
  Text = 'TEXT'
}

export interface Inflow {
  affiliate: Affiliate;
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  period: Scalars['Int']['output'];
  type: InflowType;
}

export type InflowConnectionResponse = InflowError | InflowsConnection;

export interface InflowEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Inflow>;
}

export interface InflowError extends Error {
  message: Scalars['String']['output'];
}

export interface InflowInput {
  affiliateId: Scalars['Int']['input'];
  period: Scalars['Int']['input'];
  updatePaymentRequest?: InputMaybe<Scalars['Boolean']['input']>;
  values: Array<InflowValue>;
}

export interface InflowItems {
  items?: Maybe<Array<Inflow>>;
}

export type InflowResponse = Inflow | InflowError;

export enum InflowType {
  Bonus = 'BONUS',
  Challenge = 'CHALLENGE',
  CrossSell = 'CROSS_SELL',
  External = 'EXTERNAL',
  Extra = 'EXTRA',
  Lead = 'LEAD',
  Membership = 'MEMBERSHIP',
  Refunded = 'REFUNDED',
  Sponsorship = 'SPONSORSHIP'
}

export interface InflowValue {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  type: InflowType;
}

export interface InflowsConnection extends PaginationConnection {
  edges: Array<InflowEdge>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface InfluxField {
  key: Scalars['String']['input'];
  valueBool?: InputMaybe<Scalars['Boolean']['input']>;
  valueFloat?: InputMaybe<Scalars['Float']['input']>;
  valueInt?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
}

export enum InfluxPushDevice {
  Webpush = 'WEBPUSH'
}

export enum InfluxPushStatus {
  Error = 'ERROR',
  Opened = 'OPENED',
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export interface InfluxTag {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export interface InformationsSecondChance {
  age?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  hobbies: Array<CriteriaValue>;
  relation?: Maybe<UserRelationshipTag>;
}

export interface InputAffiliateSiteUpdate {
  isCoregEnable?: InputMaybe<Scalars['Boolean']['input']>;
  siteId: Scalars['Int']['input'];
}

export interface InputAllAffiliates {
  filters?: InputMaybe<InputAllAffiliatesFilters>;
  options?: InputMaybe<PaginationOptions>;
}

export interface InputAllAffiliatesFilters {
  affiliateManagerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sponsorAffiliateId?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputAllChannelDomains {
  filters?: InputMaybe<InputAllChannelDomainsFilters>;
  options?: InputMaybe<PaginationOptions>;
}

/** These are the filters that can be used to search for channel domains. */
export interface InputAllChannelDomainsFilters {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputChallengeParams {
  function: Scalars['String']['input'];
  period: Scalars['Int']['input'];
  period_reference: Scalars['Int']['input'];
}

export interface InputChangeLanguage {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  languageCode: Scalars['String']['input'];
}

export interface InputCreateAddress {
  city: Scalars['String']['input'];
  countryIso: Scalars['String']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  type: AddressType;
  zipCode: Scalars['String']['input'];
}

export interface InputCreateAdminUser {
  affiliateManager?: InputMaybe<InputCreateAffiliateManager>;
  role: AdminUserRole;
  superUser?: InputMaybe<InputCreateSuperUser>;
}

export interface InputCreateAffiliate {
  address: InputCreateAddress;
  affiliateManagerId?: InputMaybe<Scalars['Int']['input']>;
  cgu: Scalars['Cgu']['input'];
  company?: InputMaybe<InputCreateAffiliateCompany>;
  email: Scalars['EmailAddress']['input'];
  firstname: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  login: Scalars['String']['input'];
  newsletter: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  preferredContactTimes?: InputMaybe<Array<Scalars['Int']['input']>>;
  source?: InputMaybe<Array<Scalars['Int']['input']>>;
  sponsorAffiliateId?: InputMaybe<Scalars['Int']['input']>;
  teams: Scalars['String']['input'];
}

export interface InputCreateAffiliateCompany {
  duns?: InputMaybe<Scalars['String']['input']>;
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  noVat?: InputMaybe<Scalars['Boolean']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
}

export interface InputCreateAffiliateConnectionLog {
  affiliateId: Scalars['Int']['input'];
  ip: Scalars['String']['input'];
  sudoCommonUserId?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputCreateAffiliateManager {
  activity: AffiliateManagerActivity;
  email: Scalars['EmailAddress']['input'];
  firstname: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHomepageVisible?: InputMaybe<Scalars['Boolean']['input']>;
  languageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastname: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}

export interface InputCreateAffiliateManagerHasContactMethod {
  contactMethodId: Scalars['Int']['input'];
  isPreferred: Scalars['Boolean']['input'];
}

export interface InputCreateAffiliatePaymentMethod {
  configuration: Scalars['JSON']['input'];
  enabled: Scalars['Boolean']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

export interface InputCreateBrand {
  commissionTypeId: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['Int']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  modelSiteId: Scalars['Int']['input'];
  url: Scalars['URL']['input'];
}

export interface InputCreateBrandGroup {
  /** Only for affiliate manager */
  label: Scalars['String']['input'];
  template: Scalars['String']['input'];
}

export interface InputCreateChallenge {
  description: Scalars['String']['input'];
  displayEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedAffiliatesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  label: Scalars['String']['input'];
  method: Scalars['String']['input'];
  params?: InputMaybe<InputChallengeParams>;
  periodEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  periodStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  preview: Scalars['URL']['input'];
  referenceEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  referenceStartAt?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface InputCreateChannelDomain {
  affiliateId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
  domain: Scalars['String']['input'];
  siteLogoId: Scalars['Int']['input'];
  siteStyleId: Scalars['Int']['input'];
  statusId: Scalars['Int']['input'];
}

export interface InputCreateContactMethodForAffiliateManager {
  affiliateManagerId?: InputMaybe<Scalars['Int']['input']>;
  isPreferred: Scalars['Boolean']['input'];
  type: ContactMethodType;
  value: Scalars['String']['input'];
}

export interface InputCreateContactMethodForPerson {
  isPreferred: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['Int']['input'];
  type: ContactMethodType;
  value: Scalars['String']['input'];
}

export interface InputCreateCrmUser {
  affiliateManager?: InputMaybe<InputCreateAffiliateManager>;
  role: UserCrmRole;
  superUser?: InputMaybe<InputCreateSuperUser>;
}

export interface InputCreateDefaultSearch {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
}

export interface InputCreatePerson {
  authorId?: InputMaybe<Scalars['Int']['input']>;
  firstname: Scalars['String']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  languageId: Scalars['Int']['input'];
  lastname: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}

export interface InputCreatePersonHasContactMethod {
  contactMethodId: Scalars['Int']['input'];
  isPreferred: Scalars['Boolean']['input'];
  personId: Scalars['Int']['input'];
}

export interface InputCreateSuperUser {
  email: Scalars['EmailAddress']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface InputCreateTag {
  /** Currently the UUID author id */
  authorId?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
}

export interface InputCreateTask {
  affiliateManagerId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetAffiliateId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export interface InputDeleteAddress {
  id: Scalars['Int']['input'];
}

export interface InputDeleteAffiliateCompany {
  id: Scalars['Int']['input'];
}

export interface InputDeleteContactMethodForAffiliateManager {
  affiliateManagerId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
}

export interface InputDeleteContactMethodForPerson {
  id: Scalars['Int']['input'];
  personId: Scalars['Int']['input'];
}

export interface InputDeletePerson {
  id: Scalars['Int']['input'];
}

export interface InputDeleteTag {
  id: Scalars['String']['input'];
}

export interface InputDisableAffiliate {
  affiliateId: Scalars['Int']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface InputFilterBrand {
  urlContains: Scalars['String']['input'];
}

export interface InputGetAffiliateConnectionLogs {
  affiliateId: Scalars['Int']['input'];
  options?: InputMaybe<PaginationOptions>;
}

export interface InputGetAffiliateDetail {
  inputIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inputNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface InputGetInflows {
  filters?: InputMaybe<InputGetInflowsFilters>;
  options?: InputMaybe<PaginationOptions>;
}

export interface InputGetInflowsFilters {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<InflowType>;
}

export interface InputGetInvoicePdf {
  /** In the Bizion scenario, the affiliateId will be retrieved from the token to avoid any data mutation. In the CRM scenario, the affiliateId will be provided in the giving input. */
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  period: Scalars['Int']['input'];
}

export interface InputGetInvoices {
  filters?: InputMaybe<InputGetInvoicesFilters>;
  options?: InputMaybe<PaginationOptions>;
}

export interface InputGetInvoicesFilters {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  affiliateLogin?: InputMaybe<Scalars['String']['input']>;
  affiliateStatus?: InputMaybe<Scalars['String']['input']>;
  hasVatRate?: InputMaybe<Scalars['Boolean']['input']>;
  internalAffiliate?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Array<AffiliatePaymentMethodType>>;
  period?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputGetOutflows {
  filters?: InputMaybe<InputGetOutflowsFilters>;
  options?: InputMaybe<PaginationOptions>;
}

export interface InputGetOutflowsFilters {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasVat?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputGetPendingPayment {
  filters?: InputMaybe<InputGetPendingPaymentFilters>;
  options?: InputMaybe<PaginationOptions>;
}

export interface InputGetPendingPaymentFilters {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputGetPersonDetail {
  inputIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inputNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface InputHomepageContact {
  captchaToken: Scalars['String']['input'];
  message: Scalars['String']['input'];
  senderEmail: Scalars['String']['input'];
  subject: Scalars['String']['input'];
}

export interface InputOutflowPdf {
  /** In the Bizion scenario, the affiliateId will be retrieved from the token to avoid any data mutation. In the CRM scenario, the affiliateId will be provided in the giving input. */
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputPendingPaymentCsv {
  affiliateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}

export interface InputPendingPaymentPaginationFilters {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputPendingPaymentPaginationOptions {
  filters?: InputMaybe<InputPendingPaymentPaginationFilters>;
  options?: InputMaybe<PaginationOptions>;
}

export interface InputQueryTemplate {
  brandId: Scalars['Int']['input'];
}

export interface InputResetAmPassword {
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface InputResetPassword {
  captchaToken: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface InputResetPasswordAsAm {
  affiliateId: Scalars['Int']['input'];
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface InputSaveAffiliateDetail {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  inputId: Scalars['Int']['input'];
  vals: Scalars['JSON']['input'];
}

export interface InputSaveAffiliateDetails {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  detailsValue: Array<DetailValueInput>;
}

export interface InputSavePersonDetail {
  inputId: Scalars['Int']['input'];
  personId: Scalars['Int']['input'];
  vals: Scalars['JSON']['input'];
}

export interface InputSavePersonDetails {
  detailsValue: Array<DetailValueInput>;
  personId: Scalars['Int']['input'];
}

export interface InputSendEmailResetAmPassword {
  email: Scalars['String']['input'];
}

export interface InputSendEmailResetPasswordWithCaptcha {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
}

export interface InputSetPreferredAddress {
  id: Scalars['Int']['input'];
}

export interface InputSetPreferredAffiliateCompany {
  id: Scalars['Int']['input'];
}

export interface InputSetPreferredPerson {
  id: Scalars['Int']['input'];
}

export interface InputSignInAdmin {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface InputSignInAffiliate {
  captchaToken: Scalars['String']['input'];
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface InputSignInAffiliateManager {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface InputSignInAsAffiliate {
  email: Scalars['String']['input'];
  ip?: InputMaybe<Scalars['String']['input']>;
  sudoCommonUserId?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputSignInCrm {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface InputSiteInfo {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  /** Brand (aka dss) alias */
  ba?: InputMaybe<Scalars['String']['input']>;
  hostname: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  /** Template alias */
  ta?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUnsubscribeNewsletter {
  state: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
}

export interface InputUpdateAddress {
  city?: InputMaybe<Scalars['String']['input']>;
  countryIso?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUpdateAffiliateAm {
  affiliateId: Scalars['Int']['input'];
  affiliateManagerId: Scalars['Int']['input'];
}

export interface InputUpdateAffiliateCompany {
  duns?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noVat?: InputMaybe<Scalars['Boolean']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUpdateAffiliateManager {
  activity?: InputMaybe<AffiliateManagerActivity>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHomepageVisible?: InputMaybe<Scalars['Boolean']['input']>;
  languageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUpdateAffiliateManagerHasContactMethod {
  contactMethodId: Scalars['Int']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface InputUpdateAffiliatePaymentMethod {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUpdateBrand {
  commissionTypeId?: InputMaybe<Scalars['Int']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  modelSiteId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
}

export interface InputUpdateChannelDomain {
  affiliateId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  siteLogoId: Scalars['Int']['input'];
  siteStyleId: Scalars['Int']['input'];
  statusId: Scalars['Int']['input'];
}

export interface InputUpdateContactMethodForAffiliateManager {
  affiliateManagerId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ContactMethodType>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUpdateContactMethodForPerson {
  id?: InputMaybe<Scalars['Int']['input']>;
  isPreferred: Scalars['Boolean']['input'];
  personId: Scalars['Int']['input'];
  type: ContactMethodType;
  value: Scalars['String']['input'];
}

export interface InputUpdateDefaultSearch {
  affiliateId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
}

export interface InputUpdatePerson {
  firstname?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUpdateTag {
  /** Currently the UUID author id */
  authorId?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
}

export interface InputUpdateTask {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetAffiliateId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export enum Interaction {
  Like = 'LIKE',
  Message = 'MESSAGE',
  Visit = 'VISIT'
}

export interface InteractionCta {
  action: ActionCta;
  icon: IconData;
  label: Scalars['String']['output'];
}

export interface InteractionEvent {
  createdAt: Scalars['DateTime']['output'];
  /** relative to connected user */
  user: UserHasChannelInterface;
}

export enum InteractionType {
  Afterboost = 'AFTERBOOST',
  AfterFirstMembership = 'AFTER_FIRST_MEMBERSHIP'
}

export interface InternalCriteriaValue extends ICriteriaValue, Sluggable {
  backgroundUrl?: Maybe<Scalars['URL']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Criteria>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  searchLabel?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
}

export enum InternalRegistionRedirectDestination {
  Confirmation = 'CONFIRMATION',
  Payment = 'PAYMENT'
}

export interface InternalRegistrationResponse {
  connectionUrl?: Maybe<Scalars['URL']['output']>;
  redirectToPage?: Maybe<InternalRegistionRedirectDestination>;
  redirectToUrl?: Maybe<Scalars['URL']['output']>;
  success: Scalars['Boolean']['output'];
}

/** Interval for user_has_channel_count */
export enum IntervalUhc {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export interface InvitationMessageEvent extends InteractionEvent {
  createdAt: Scalars['DateTime']['output'];
  user: UserHasChannelInterface;
}

export interface Invoice {
  affiliate: Affiliate;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<AffiliatePaymentMethod>;
  /** The period of the invoice, in the format "YYYYMM" */
  period: Scalars['Int']['output'];
  revenueCrossselling: Scalars['Float']['output'];
  revenueExternal: Scalars['Float']['output'];
  revenueExtra: Scalars['Float']['output'];
  revenueLead: Scalars['Float']['output'];
  revenueMembership: Scalars['Float']['output'];
  revenuePostponed: Scalars['Float']['output'];
  revenueReported: Scalars['Float']['output'];
  revenueSponsor: Scalars['Float']['output'];
  /** The available status for an invoice can be "PAID", "AWAITING_REQUEST", "AWAITING_PAYMENT" or "POSTPONED" */
  status: InvoiceStatusType;
  vatRate: Scalars['Float']['output'];
}

export interface InvoiceEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Invoice>;
}

export interface InvoicePdf {
  affiliateId: Scalars['Int']['output'];
  base64: Scalars['String']['output'];
  /** Field not required => No id for legacies invoices */
  outflowId?: Maybe<Scalars['Int']['output']>;
  period: Scalars['Int']['output'];
}

export interface InvoiceQuery {
  invoices?: Maybe<InvoicesConnection>;
  /** From Bizion, only one invoice can be requested at a time. From the CRM, multiple invoices can be requested at a time. */
  pdf?: Maybe<Array<Maybe<InvoicePdf>>>;
}


export interface InvoiceQueryInvoicesArgs {
  input: InputGetInvoices;
}


export interface InvoiceQueryPdfArgs {
  input: Array<InputGetInvoicePdf>;
}

export enum InvoiceStatusType {
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingRequest = 'AWAITING_REQUEST',
  Paid = 'PAID',
  Postponed = 'POSTPONED'
}

export interface InvoicesConnection extends PaginationConnection {
  edges?: Maybe<Array<InvoiceEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface InvoicesPdf {
  items: Array<Maybe<InvoicePdf>>;
}

export interface IosPushPayload {
  appname: Scalars['String']['input'];
  appversion: Scalars['String']['input'];
  devicemodel: Scalars['String']['input'];
  devicename: Scalars['String']['input'];
  devicetoken: Scalars['String']['input'];
  deviceuid: Scalars['String']['input'];
  deviceversion: Scalars['String']['input'];
  pushalert: IosPushSettings;
  pushbadge: IosPushSettings;
  pushsound: IosPushSettings;
}

export enum IosPushSettings {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export interface KissEvent extends InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface KissEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface LandingPage {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  host: Scalars['String']['output'];
  httpsStatus: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  landingPageStatusId: Scalars['Int']['output'];
  site: Site;
  template: Scalars['String']['output'];
  templateTypeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface Language {
  code: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  locale?: Maybe<Locale>;
  name: Scalars['String']['output'];
}

export type Layer = LayerCoachingWelcome | LayerDailySnap | LayerDescriptor | LayerEndBoost | LayerGeneratedPicture | LayerMailValidation | LayerRebillReminder | LayerRejectPicture;

export interface LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  /** Lower priority field means layer should be displayed first */
  priority: Scalars['Int']['output'];
}

export enum LayerCategory {
  Middle = 'MIDDLE',
  ProfileHighlight = 'PROFILE_HIGHLIGHT',
  Warning = 'WARNING'
}

export interface LayerCoachingWelcome extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
}

export interface LayerDailySnap extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
}

export interface LayerDescriptor extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  descriptor: Scalars['String']['output'];
  name: LayerName;
  priority: Scalars['Int']['output'];
}

export interface LayerEndBoost extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
}

export interface LayerGeneratedPicture extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
}

export interface LayerMailValidation extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
  type: ValidationLayer;
}

export enum LayerName {
  CoachingWelcome = 'COACHING_WELCOME',
  DailySnap = 'DAILY_SNAP',
  Descriptor = 'DESCRIPTOR',
  EndBoost = 'END_BOOST',
  GeneratedPicture = 'GENERATED_PICTURE',
  MailValidation = 'MAIL_VALIDATION',
  RebillReminder = 'REBILL_REMINDER',
  RejectPicture = 'REJECT_PICTURE'
}

export enum LayerPayment {
  InSite = 'IN_SITE',
  PaymentPage = 'PAYMENT_PAGE'
}

export interface LayerRebillReminder extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
  rebillDate: Scalars['Date']['output'];
}

export interface LayerRejectPicture extends LayerBase {
  canClose: Scalars['Boolean']['output'];
  category: LayerCategory;
  name: LayerName;
  priority: Scalars['Int']['output'];
}

export interface LevelInfo {
  level: Scalars['Int']['output'];
  xpCurrentLevel: Scalars['Int']['output'];
  xpToNextLevel: Scalars['Int']['output'];
  xpTotal: Scalars['Int']['output'];
}

export interface LevelUpEvent extends GamificationEvent, RewardEvent {
  eventType: GamificationEventType;
  payload: LevelUpEventPayload;
  reward?: Maybe<Reward>;
}

export interface LevelUpEventPayload {
  level: Scalars['Int']['output'];
}

export interface LikeReceived {
  createdAt: Scalars['DateTime']['output'];
  slug: Scalars['ID']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}

export interface LikeReceivedEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<LikeReceivedNode>;
}

export type LikeReceivedNode = AdItem | LikeReceived;

export interface LikesReceivedConnection extends PaginationConnection {
  edges?: Maybe<Array<LikeReceivedEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface LikesRemainingConnection extends PaginationConnection {
  edges?: Maybe<Array<UhcEdge>>;
  pageInfo: PageInfoNext;
  tagsCount?: Maybe<Array<TagCount>>;
  totalCount: Scalars['Int']['output'];
}

export enum ListAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export interface ListEvent {
  createdAt: Scalars['DateTime']['output'];
  /** relative to connected user */
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  /** relative to connected user */
  user: UserHasChannelInterface;
}

export interface ListViewableEvent {
  createdAt: Scalars['DateTime']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}

export interface Locale {
  code: Scalars['String']['output'];
  country?: Maybe<Country>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  parent?: Maybe<Locale>;
}

export interface Location extends HasCoordinates {
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  geoname?: Maybe<Geoname>;
}

export interface LocationCountry {
  currencyId?: Maybe<Scalars['Int']['output']>;
  englishName: Scalars['String']['output'];
  frenchName: Scalars['String']['output'];
  iso: Scalars['String']['output'];
  iso3: Scalars['String']['output'];
  nativeName: Scalars['String']['output'];
}

export enum LocationRange {
  Country = 'COUNTRY',
  Proximity = 'PROXIMITY'
}

export interface LocationSearch {
  coordinates?: InputMaybe<ICoordinates>;
  /** Country iso code */
  country?: InputMaybe<Scalars['String']['input']>;
  geonameId?: InputMaybe<Scalars['Int']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  /** Should limit search to same country */
  limitToCountry?: InputMaybe<Scalars['Boolean']['input']>;
  /** In kilometers default to 10km */
  radius?: InputMaybe<Scalars['Int']['input']>;
}

export interface LoginEvent extends GamificationEvent, RewardEvent {
  eventType: GamificationEventType;
  reward?: Maybe<Reward>;
  stepReached?: Maybe<Scalars['Int']['output']>;
}

export interface Ltr {
  conversion?: Maybe<Scalars['Int']['output']>;
  mail_validation_doi?: Maybe<Scalars['Int']['output']>;
  register?: Maybe<Scalars['Int']['output']>;
}

export interface MailCampaign {
  sendNewsletterFromPrelinker: Scalars['Boolean']['output'];
}


export interface MailCampaignSendNewsletterFromPrelinkerArgs {
  input: SendNewsletterInput;
}

export interface MailHistory {
  bounces?: Maybe<Array<MailHistoryDetails>>;
  mailSentId: Scalars['Int']['output'];
  mailtplLabel: Scalars['String']['output'];
  mailtplSectionLabel: Scalars['String']['output'];
  sentAt: Scalars['String']['output'];
  trackings?: Maybe<Array<MailHistoryDetails>>;
}

export interface MailHistoryDetails {
  date: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface MatchAwaitingEvent extends InteractionEvent {
  createdAt: Scalars['DateTime']['output'];
  user: UserHasChannelInterface;
}

export interface MatchEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<MatchEvent>;
}

export interface MatchEvent extends InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MatchEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MatchListConnection extends PaginationConnection {
  edges?: Maybe<Array<MatchEdge>>;
  pageInfo: PageInfoNext;
  /** @deprecated Also count shadowban, use newMatchesCount instead */
  totalCount: Scalars['Int']['output'];
}

export enum MediaAccess {
  All = 'ALL',
  Censored = 'CENSORED',
  Default = 'DEFAULT',
  Private = 'PRIVATE'
}

export enum MediaRating {
  G = 'G',
  Nr = 'NR',
  Pg = 'PG',
  R = 'R'
}

export enum MediaType {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export interface MembershipDetails {
  account?: Maybe<PaymentAccount>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  /** ip is computed based on the requester */
  ip?: Maybe<Scalars['String']['output']>;
  /** ISP is computed based on the requester's ip */
  isp?: Maybe<Scalars['String']['output']>;
  product?: Maybe<UserProduct>;
  startsAt?: Maybe<Scalars['Date']['output']>;
  type: MembershipType;
}

export enum MembershipType {
  Free = 'FREE',
  Premium = 'PREMIUM',
  Trial = 'TRIAL'
}

export interface MenuBanner {
  ctaAction: BannerAction;
  ctaLabel: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface MerchantAccount extends Sluggable {
  acquirer?: Maybe<Scalars['String']['output']>;
  amountCap: Scalars['Int']['output'];
  amountCapLastDay: Scalars['Int']['output'];
  amountCapTotal: Scalars['Int']['output'];
  amountProcessedLastDay: Scalars['Int']['output'];
  amountProcessedLastMonth: Scalars['Int']['output'];
  amountProcessedTotalLastMonth: Scalars['Int']['output'];
  cbPercent?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<Company>;
  descriptor: Scalars['String']['output'];
  label: Scalars['String']['output'];
  method: PaymentMethod;
  slug: Scalars['ID']['output'];
}

export interface MessageCommentEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  comment: Comment;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageCommentEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageContent {
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
}

export interface MessageCtaPictureEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  /** Slug of the message that its referring to */
  messageSlug: Scalars['ID']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageCtaPictureEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageDescriptionRequest extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageDescriptionRequestDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageFeed {
  edges?: Maybe<Array<ListEvent>>;
  pageInfo?: Maybe<PageInfo>;
}

export interface MessageLikeEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageLikeEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageMatchEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageMatchEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessagePicture extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  picture?: Maybe<PictureSource>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  ttl?: Maybe<Scalars['Int']['output']>;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessagePictureDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}


export interface MessagePicturePictureArgs {
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface MessagePictureLikeEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId: Scalars['Int']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  picture?: Maybe<PictureSrcSet>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessagePictureLikeEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}


export interface MessagePictureLikeEventPictureArgs {
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface MessagePictureRequest extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessagePictureRequestDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessagePrivatePictureRequest extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessagePrivatePictureRequestDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageReactionEvent extends IMessage, InteractionEvent, ListEvent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId?: Maybe<Scalars['String']['output']>;
  messageSubjectId?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
}


export interface MessageReactionEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageReadEvent extends IMessage, InteractionEvent, ListEvent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId?: Maybe<Scalars['String']['output']>;
  messageSubjectId?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
}


export interface MessageReadEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageSnapLikeEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId: Scalars['Int']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  snap?: Maybe<Snap>;
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageSnapLikeEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageSystemWelcomeFemale extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageSystemWelcomeFemaleDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageSystemWelcomeMale extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageSystemWelcomeMaleDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageText extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  contentHighlighted: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageTextDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export enum MessageType {
  Events = 'EVENTS'
}

export enum MessageTypes {
  Audio = 'Audio',
  Badword = 'Badword',
  CommentEvent = 'CommentEvent',
  CtaPictureEvent = 'CtaPictureEvent',
  DescriptionRequest = 'DescriptionRequest',
  LikeEvent = 'LikeEvent',
  MatchEvent = 'MatchEvent',
  Minimatching = 'Minimatching',
  Picture = 'Picture',
  PictureLikedEvent = 'PictureLikedEvent',
  Presentation = 'Presentation',
  PrivatePictureAuthorization = 'PrivatePictureAuthorization',
  Quiz = 'Quiz',
  SendPicture = 'SendPicture',
  SnapLikedEvent = 'SnapLikedEvent',
  Speedflirt = 'Speedflirt',
  Text = 'Text',
  Video = 'Video',
  VideoConversation = 'VideoConversation',
  VisitEvent = 'VisitEvent',
  WelcomeBack = 'WelcomeBack',
  WelcomeExitActivity = 'WelcomeExitActivity',
  WelcomeOffline = 'WelcomeOffline',
  WelcomeOnline = 'WelcomeOnline',
  WelcomeSpeedDatingOffline = 'WelcomeSpeedDatingOffline',
  WelcomeSpeedDatingOnline = 'WelcomeSpeedDatingOnline'
}

export interface MessageVideoAccepted extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId?: Maybe<Scalars['String']['output']>;
  messageSubjectId?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageVideoAcceptedDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageVideoClosed extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId?: Maybe<Scalars['String']['output']>;
  messageSubjectId?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageVideoClosedDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageVideoRequest extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  archived?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  messageContentId?: Maybe<Scalars['String']['output']>;
  messageSubjectId?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageVideoRequestDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageVisitEvent extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageVisitEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface MessageWelcome extends IMessage, InteractionEvent, ListEvent, ListViewableEvent, MessageContent, Sluggable {
  /** Will be null if requested without membership */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reaction?: Maybe<Reaction>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  type: Scalars['Int']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface MessageWelcomeDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export enum MethodType {
  Agreement = 'Agreement',
  Applepay = 'Applepay',
  Card = 'Card',
  Gift = 'Gift',
  Googlepay = 'Googlepay'
}

export interface MethodTypeWithConfig {
  config?: Maybe<CpgGooglePayConfig>;
  script: Array<Scalars['String']['output']>;
  type: MethodType;
}

export interface MidInfo {
  accountId: Scalars['Int']['output'];
  accountLabel: Scalars['String']['output'];
  cpgPspId: Scalars['Int']['output'];
  cpgPspLabel: Scalars['String']['output'];
  methodId: Scalars['Int']['output'];
  methodLabel: Scalars['String']['output'];
}

export interface MinMax {
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

export interface MinMaxInt {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
}

export interface ModerationCount {
  description: Scalars['Int']['output'];
  icebreaker: Scalars['Int']['output'];
  picture: Scalars['Int']['output'];
  profile: Scalars['Int']['output'];
  report: Scalars['Int']['output'];
  snap: Scalars['Int']['output'];
  underage: Scalars['Int']['output'];
}

export interface MultipleHeightWeight {
  list?: Maybe<Array<SingleHeightWeight>>;
}

export interface MutableComment extends MutableDeletable, MutableLikeable, MutableSluggable, Reportable {
  delete: Scalars['Boolean']['output'];
  like: Scalars['Boolean']['output'];
  open: Scalars['Boolean']['output'];
  /** Report something wrong with a comment */
  report?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['ID']['output'];
}


export interface MutableCommentDeleteArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutableCommentReportArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportType;
}

export interface MutableCommentable {
  comment: Comment;
}


export interface MutableCommentableCommentArgs {
  text: Scalars['String']['input'];
}

export interface MutableConfiguration {
  /** Add a new badword */
  addBadword?: Maybe<Badword>;
  /** Create a new blacklisted location */
  blacklistCountry?: Maybe<Scalars['Boolean']['output']>;
  /** Create a new blacklisted domain */
  blacklistDomain?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a badword */
  deleteBadword?: Maybe<BooleanResult>;
  /** Change a dynamic configuration value */
  dynamicConfiguration?: Maybe<Scalars['Boolean']['output']>;
  /** Edit a badword (/!\ actions are overwritten ! If no actions array given, destroy all actions) */
  editBadword?: Maybe<Badword>;
  /** Create if doesnt exists a new faq feedback */
  faqFeedback?: Maybe<Scalars['Boolean']['output']>;
  /** Create a new greylist ip */
  greylistIp?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutableConfigurationAddBadwordArgs {
  badword: BadwordInput;
}


export interface MutableConfigurationBlacklistCountryArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  iso: Scalars['CountryCode']['input'];
}


export interface MutableConfigurationBlacklistDomainArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['String']['input'];
}


export interface MutableConfigurationDeleteBadwordArgs {
  id: Scalars['Int']['input'];
}


export interface MutableConfigurationDynamicConfigurationArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}


export interface MutableConfigurationEditBadwordArgs {
  badword: BadwordInput;
  id: Scalars['Int']['input'];
}


export interface MutableConfigurationFaqFeedbackArgs {
  answer: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutableConfigurationGreylistIpArgs {
  cidr: Scalars['Int']['input'];
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  ip: Scalars['IPv4']['input'];
  type: GreylistType;
}

export interface MutableDeletable {
  delete: Scalars['Boolean']['output'];
}


export interface MutableDeletableDeleteArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutableFeed extends MutableSluggable {
  open: Scalars['Boolean']['output'];
  slug: Scalars['ID']['output'];
}

export interface MutableKissEvent extends MutableSluggable, MutableViewable {
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}

export interface MutableLikeable {
  like: Scalars['Boolean']['output'];
}

export interface MutableMatchEvent extends MutableSluggable, MutableViewable {
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}

export interface MutableMerchantAccount extends MutableSluggable {
  acquirer: BooleanResult;
  amountCap: BooleanResult;
  amountCapLastDay: BooleanResult;
  amountCapTotal: BooleanResult;
  cbPercent: BooleanResult;
  descriptor: BooleanResult;
  label: BooleanResult;
  slug: Scalars['ID']['output'];
}


export interface MutableMerchantAccountAcquirerArgs {
  acquirer: Scalars['String']['input'];
}


export interface MutableMerchantAccountAmountCapArgs {
  amountCap: Scalars['Int']['input'];
}


export interface MutableMerchantAccountAmountCapLastDayArgs {
  amountCapLastDay: Scalars['Int']['input'];
}


export interface MutableMerchantAccountAmountCapTotalArgs {
  amountCapTotal: Scalars['Int']['input'];
}


export interface MutableMerchantAccountCbPercentArgs {
  cbPercent?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutableMerchantAccountDescriptorArgs {
  descriptor: Scalars['String']['input'];
}


export interface MutableMerchantAccountLabelArgs {
  label: Scalars['String']['input'];
}

export interface MutableMessage extends MutableOpenable, MutableSluggable, Reportable {
  delete: Scalars['Boolean']['output'];
  /** React to a message, if no reaction is provided, delete the reaction */
  like: Scalars['Boolean']['output'];
  /** Used by php to trigger (must be removed along php) */
  notify?: Maybe<Scalars['Boolean']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  /** Report something wrong with a comment */
  report?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['ID']['output'];
  viewLikeReceived?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutableMessageDeleteArgs {
  direction?: InputMaybe<DeleteDirection>;
}


export interface MutableMessageLikeArgs {
  reaction?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutableMessageReportArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportType;
}

export interface MutableMessageSystem extends MutableOpenable, MutableSluggable {
  open?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['ID']['output'];
}

export interface MutableOpenable {
  open?: Maybe<Scalars['Boolean']['output']>;
}

export interface MutableOrder extends MutableSluggable {
  authorise?: Maybe<BooleanResult>;
  clearCache?: Maybe<BooleanResult>;
  dispute?: Maybe<BooleanResult>;
  refund?: Maybe<BooleanResult>;
  slug: Scalars['ID']['output'];
}


export interface MutableOrderRefundArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  disableEmail?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutablePicture extends MutableCommentable, MutableDeletable, MutableRating, MutableReviewable, MutableSluggable, Reportable {
  access: Scalars['Boolean']['output'];
  comment: Comment;
  delete: Scalars['Boolean']['output'];
  like: Scalars['Boolean']['output'];
  rating: Scalars['Boolean']['output'];
  /** Report something wrong with a comment */
  report?: Maybe<Scalars['Boolean']['output']>;
  review: BooleanResult;
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}


export interface MutablePictureAccessArgs {
  access: MediaAccess;
}


export interface MutablePictureCommentArgs {
  text: Scalars['String']['input'];
}


export interface MutablePictureDeleteArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutablePictureLikeArgs {
  action: ListAction;
  reaction?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<EventSource>;
}


export interface MutablePictureRatingArgs {
  rating: MediaRating;
}


export interface MutablePictureReportArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportType;
}


export interface MutablePictureReviewArgs {
  status: ReviewStatus;
}


export interface MutablePictureViewArgs {
  source?: InputMaybe<EventSource>;
}

export interface MutablePictureAuthorizationEvent extends MutableSluggable, MutableViewable {
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}

export interface MutablePictureLike extends MutableSluggable, MutableViewable {
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}

export interface MutablePurchase extends MutableSluggable {
  slug: Scalars['ID']['output'];
  update?: Maybe<BooleanResult>;
  /** reason is for stop_rebill reason and source is for enable rebill. Both are not mandatory but at least one of them is required depending of the status of rebillable */
  updateRebill?: Maybe<BooleanResult>;
}


export interface MutablePurchaseUpdateArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  zendesk?: InputMaybe<ZendeskInput>;
}


export interface MutablePurchaseUpdateRebillArgs {
  category?: InputMaybe<StopRebillCategory>;
  force?: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  rebillable: Scalars['Boolean']['input'];
  source?: InputMaybe<EnableRebillSource>;
  zendesk?: InputMaybe<ZendeskInput>;
}

export interface MutableRating {
  rating: Scalars['Boolean']['output'];
}


export interface MutableRatingRatingArgs {
  rating: MediaRating;
}

export interface MutableReviewable {
  review: BooleanResult;
}


export interface MutableReviewableReviewArgs {
  status: ReviewStatus;
}

export interface MutableSite extends MutableSluggable {
  company: BooleanResult;
  id: Scalars['Int']['output'];
  slug: Scalars['ID']['output'];
}


export interface MutableSiteCompanyArgs {
  companyId: Scalars['Int']['input'];
}

export interface MutableSluggable {
  slug: Scalars['ID']['output'];
}

export interface MutableSnap extends MutableCommentable, MutableDeletable, MutableRating, MutableReviewable, MutableSluggable, Reportable {
  comment: Comment;
  delete: Scalars['Boolean']['output'];
  like: Scalars['Boolean']['output'];
  rating: Scalars['Boolean']['output'];
  /** Report something wrong with a comment */
  report?: Maybe<Scalars['Boolean']['output']>;
  review: BooleanResult;
  reviewLabel: BooleanResult;
  see: Scalars['Boolean']['output'];
  slug: Scalars['ID']['output'];
  /** Update snap text, duration and style. Note that if a style field isn't provided, it's value will be set to null and fallback to the default value. */
  update: Scalars['Boolean']['output'];
}


export interface MutableSnapCommentArgs {
  text: Scalars['String']['input'];
}


export interface MutableSnapDeleteArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutableSnapLikeArgs {
  action?: InputMaybe<ListAction>;
  reaction?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<EventSource>;
}


export interface MutableSnapRatingArgs {
  rating: MediaRating;
}


export interface MutableSnapReportArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportType;
}


export interface MutableSnapReviewArgs {
  status: ReviewStatus;
}


export interface MutableSnapReviewLabelArgs {
  status: ReviewStatus;
}


export interface MutableSnapSeeArgs {
  source?: InputMaybe<EventSource>;
}


export interface MutableSnapUpdateArgs {
  duration?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SnapFilter>;
  font?: InputMaybe<SnapFont>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
  positionY?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textBackground?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  textSize?: InputMaybe<Scalars['Int']['input']>;
}

export interface MutableSnapLikeEvent extends MutableSluggable, MutableViewable {
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}

export interface MutableSubscriberEvent extends MutableSluggable, MutableViewable {
  slug: Scalars['ID']['output'];
  view: Scalars['Boolean']['output'];
}

export interface MutableUser extends MutableSluggable {
  approve?: Maybe<BooleanResult>;
  /** Archive a user If the user has a channel, it will not be archived except if `archiveUhc` is true, in this case, the user and its channels will be archived If `temporary` is true (only when unarchive), the user will be re-archive after 7 days */
  archive?: Maybe<BooleanResult>;
  delete: Array<UhcDeleteResponseChannelized>;
  /** Set/Delete a user's phone number */
  phoneNumber?: Maybe<BooleanResult>;
  /** reasonId is mandatory if we add a shadowban */
  shadowban?: Maybe<BooleanResult>;
  slug: Scalars['ID']['output'];
  stopEmails?: Maybe<BooleanResult>;
  suspect?: Maybe<BooleanResult>;
  validatePhoneNumber?: Maybe<BooleanResult>;
  whitelist?: Maybe<BooleanResult>;
}


export interface MutableUserArchiveArgs {
  action?: InputMaybe<ListAction>;
  archiveUhc?: InputMaybe<Scalars['Boolean']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutableUserDeleteArgs {
  reason: Scalars['String']['input'];
  reasonId: Scalars['Int']['input'];
}


export interface MutableUserPhoneNumberArgs {
  number?: InputMaybe<Scalars['PhoneInput']['input']>;
  sourceId?: InputMaybe<GsmSource>;
}


export interface MutableUserShadowbanArgs {
  add?: InputMaybe<Scalars['Boolean']['input']>;
  reasonId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutableUserSuspectArgs {
  add?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutableUserValidatePhoneNumberArgs {
  code: Scalars['String']['input'];
}


export interface MutableUserWhitelistArgs {
  removes?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutableUserDescription extends MutableDeletable, MutableReviewable, MutableSluggable {
  delete: Scalars['Boolean']['output'];
  review: BooleanResult;
  slug: Scalars['ID']['output'];
}


export interface MutableUserDescriptionDeleteArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutableUserDescriptionReviewArgs {
  status: ReviewStatus;
}

export interface MutableUserFeedback extends MutableDeletable, MutableSluggable {
  delete: Scalars['Boolean']['output'];
  slug: Scalars['ID']['output'];
}


export interface MutableUserFeedbackDeleteArgs {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutableUserHasChannel extends MutableSluggable, Reportable {
  /** If `temporary` is true (only when unarchive), the user will be re-archive after 7 days */
  archive?: Maybe<BooleanResult>;
  delete: UhcDeleteResponse;
  feedback?: Maybe<BooleanResult>;
  gift?: Maybe<BooleanResult>;
  migratePurchases?: Maybe<BooleanResult>;
  /** @deprecated use /n/upload route instead */
  pictureUpload?: Maybe<UserPicture>;
  /** Endpoint to reset quota/ handle product, do not call this endpoint multiple times for the same orderId or it will reset the quota multiple times Make sure you called subscriptionChange before this endpoint, to clear the cache */
  purchasePostAuthorized: BooleanResult;
  /** Report something wrong with a user */
  report?: Maybe<Scalars['Boolean']['output']>;
  sendPhoneNumberValidationCode?: Maybe<BooleanResult>;
  /** Send a satisfaction email survey to user */
  sendSatisfactionMail?: Maybe<Scalars['Boolean']['output']>;
  sendWarning?: Maybe<BooleanResult>;
  slug: Scalars['ID']['output'];
  submitUnsubscriptionStep?: Maybe<BooleanResult>;
  /** Clear payment cache */
  subscriptionChange?: Maybe<BooleanResult>;
  switchCompany?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutableUserHasChannelArchiveArgs {
  action?: InputMaybe<ListAction>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutableUserHasChannelDeleteArgs {
  reason: Scalars['String']['input'];
  reasonId: Scalars['Int']['input'];
}


export interface MutableUserHasChannelFeedbackArgs {
  message: Scalars['String']['input'];
  typeId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutableUserHasChannelGiftArgs {
  productId: Scalars['Int']['input'];
}


export interface MutableUserHasChannelMigratePurchasesArgs {
  destination: IUserHasChannel;
}


export interface MutableUserHasChannelPictureUploadArgs {
  access?: InputMaybe<MediaAccess>;
  file: Scalars['Upload']['input'];
}


export interface MutableUserHasChannelPurchasePostAuthorizedArgs {
  orderId: Scalars['Int']['input'];
  trigger?: InputMaybe<PurchaseTrigger>;
}


export interface MutableUserHasChannelReportArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportType;
}


export interface MutableUserHasChannelSubmitUnsubscriptionStepArgs {
  stepSubmit: UnsubscribeStepSubmit;
}


export interface MutableUserHasChannelSubscriptionChangeArgs {
  orderId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutableUserHasChannelSwitchCompanyArgs {
  companyId: Scalars['Int']['input'];
}

export interface MutableViewable {
  view: Scalars['Boolean']['output'];
}

export interface Mutation {
  Coaching: CoachingMutationNs;
  /** Payment namespace */
  Payment: PaymentMutationNs;
  /** Admin mutation entry point */
  admin: MutationAdmin;
  /** Default access */
  affiliate: AffiliateMutation;
  /** Access from AM token and affiliateId input */
  affiliateFromInput: AffiliateLoggedMutation;
  /** Access from affiliate token or AM token from autolog CRM */
  affiliateFromToken: AffiliateLoggedMutation;
  affiliateManager?: Maybe<AffiliateManagerMutation>;
  /** To perform these mutations, you must be logged as an affiliate manager, provide a valid token in the Authorization header. */
  affiliateManagerFromToken?: Maybe<AffiliateManagerLoggedMutation>;
  /** Create a zendesk ticket for customer service */
  askToCustomerService?: Maybe<Scalars['Boolean']['output']>;
  biz?: Maybe<MutationBiz>;
  bizAdmin: BizAdminMutation;
  businessUnitAdminMutation: BusinessUnitAdminMutation;
  /** Configuration mutation entry point */
  configuration: MutableConfiguration;
  createTag?: Maybe<Tag>;
  /** @deprecated Use admin instead */
  crm?: Maybe<CrmMutation>;
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  deployEvent: DeployEvent;
  mailCampaign: MailCampaign;
  /** Metrics related endpoints */
  metrics: MutationMetrics;
  /** Get object from its slug for mutation */
  model?: Maybe<MutableSluggable>;
  /** Get objects from their slugs for mutation */
  models?: Maybe<Array<MutableSluggable>>;
  /** These mutations can only be used internally */
  optionAssignmentAdminMutation: OptionAssignmentAdminMutation;
  /** These mutations can only be used internally */
  optionDefinitionAdminMutation: OptionDefinitionAdminMutation;
  paymentMutation: PaymentMutation;
  portalRedirect: PortalRedirect;
  /** Prophecy mutation entry point */
  prophecy: MutationProphecy;
  /** Send android notification push (via Firebase) */
  pushAndroid?: Maybe<Scalars['JSON']['output']>;
  /** Send IOS notification push (via Apple Push Notification) */
  pushIOS?: Maybe<Scalars['JSON']['output']>;
  /** Registration entry point */
  registration?: Maybe<RegistrationMutation>;
  reviewReport?: Maybe<Scalars['Boolean']['output']>;
  ruler: RulerMutation;
  /** command: SIGHUP, SIGKILL, SIGTERM */
  serverCommand?: Maybe<BooleanResult>;
  synchronizeZendesk?: Maybe<Scalars['Boolean']['output']>;
  updateTag?: Maybe<Tag>;
  /** User mutation entry point */
  user: MutationUser;
  /** Allow connected user to perform action with given user has channel slug */
  withUser: MutationUserActions;
}


export interface MutationAffiliateFromInputArgs {
  affiliateId: Scalars['Int']['input'];
}


export interface MutationAskToCustomerServiceArgs {
  content: Scalars['String']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
}


export interface MutationCreateTagArgs {
  payload: InputCreateTag;
}


export interface MutationDeleteTagArgs {
  payload: InputDeleteTag;
}


export interface MutationDeployEventArgs {
  commitId: Scalars['ID']['input'];
  isProd: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  project: Scalars['String']['input'];
  user: Scalars['String']['input'];
}


export interface MutationModelArgs {
  slug: Scalars['ID']['input'];
}


export interface MutationModelsArgs {
  slugs: Array<Scalars['ID']['input']>;
}


export interface MutationPortalRedirectArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['URL']['input']>;
}


export interface MutationPushAndroidArgs {
  bundle?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['JSON']['input'];
}


export interface MutationPushIosArgs {
  payload: Scalars['JSON']['input'];
  token: Scalars['ID']['input'];
}


export interface MutationReviewReportArgs {
  approve: Scalars['Boolean']['input'];
  channelId: Scalars['Int']['input'];
  multiple: Scalars['Boolean']['input'];
  userIdFrom: Scalars['Int']['input'];
  userIdTo: Scalars['Int']['input'];
}


export interface MutationServerCommandArgs {
  command: Scalars['String']['input'];
  servers: Array<Scalars['ID']['input']>;
}


export interface MutationSynchronizeZendeskArgs {
  ticketId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}


export interface MutationUpdateTagArgs {
  payload: InputUpdateTag;
}


export interface MutationWithUserArgs {
  uhcSlug: Scalars['ID']['input'];
}

export interface MutationAbTest {
  deleteAbTest?: Maybe<Scalars['Boolean']['output']>;
  deleteOption?: Maybe<Scalars['Boolean']['output']>;
  deleteVersion?: Maybe<Scalars['Boolean']['output']>;
  editAbTest?: Maybe<AbTest>;
  editOption?: Maybe<AbTestVersionOption>;
  editVersion?: Maybe<AbTestVersion>;
  /** AB TEST */
  newAbTest?: Maybe<AbTest>;
  /** AB TEST OPTION */
  newOption?: Maybe<AbTestVersionOption>;
  /** AB TEST VERSION */
  newVersion?: Maybe<AbTestVersion>;
}


export interface MutationAbTestDeleteAbTestArgs {
  id: Scalars['Int']['input'];
}


export interface MutationAbTestDeleteOptionArgs {
  id: Scalars['Int']['input'];
}


export interface MutationAbTestDeleteVersionArgs {
  id: Scalars['Int']['input'];
}


export interface MutationAbTestEditAbTestArgs {
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
}


export interface MutationAbTestEditOptionArgs {
  id: Scalars['Int']['input'];
  option: AbTestVersionInput;
}


export interface MutationAbTestEditVersionArgs {
  description: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  startAt: Scalars['DateTime']['input'];
}


export interface MutationAbTestNewAbTestArgs {
  label: Scalars['String']['input'];
}


export interface MutationAbTestNewOptionArgs {
  abTestVersionId: Scalars['Int']['input'];
  option: AbTestVersionInput;
}


export interface MutationAbTestNewVersionArgs {
  abTestId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  options: Array<AbTestVersionInput>;
  startAt: Scalars['DateTime']['input'];
}

export interface MutationAdmin {
  abTests?: Maybe<MutationAbTest>;
  /** Archive a user If the user has a channel, it will not be archived except if `archiveUhc` is true, in this case, the user and its channels will be archived If `temporary` is true (only when unarchive), the user will be re-archive after 7 days */
  archive?: Maybe<BooleanResult>;
  /** Create a merchant account */
  createMerchantAccount?: Maybe<BooleanResult>;
  editActionQuota?: Maybe<Scalars['Boolean']['output']>;
  /** Edit an admin role Add by default or remove if `remove` is true */
  editAdminRole?: Maybe<BooleanResult>;
  /** Fraud review entry point (users with suspect behaviors) */
  fraudReview?: Maybe<FraudReview>;
  redisCommand?: Maybe<Scalars['String']['output']>;
}


export interface MutationAdminArchiveArgs {
  action?: InputMaybe<ListAction>;
  archiveUhc?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationAdminCreateMerchantAccountArgs {
  acquirer: Scalars['String']['input'];
  cbPercent?: InputMaybe<Scalars['Int']['input']>;
  descriptor: Scalars['String']['input'];
  label: Scalars['String']['input'];
  methodId: Scalars['Int']['input'];
}


export interface MutationAdminEditActionQuotaArgs {
  quota: Array<ActionQuotaInput>;
}


export interface MutationAdminEditAdminRoleArgs {
  adminUserId: Scalars['Int']['input'];
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<AdminRole>;
}


export interface MutationAdminRedisCommandArgs {
  args?: InputMaybe<Scalars['String']['input']>;
  command: Scalars['String']['input'];
  server?: InputMaybe<RedisServerEnum>;
}

export interface MutationBiz {
  tag?: Maybe<MutationBizTag>;
  tool?: Maybe<MutationBizTool>;
  webmaster?: Maybe<MutationWithWebmaster>;
}

export interface MutationBizLandingPageWithWebmaster {
  create?: Maybe<LandingPage>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationBizLandingPageWithWebmasterCreateArgs {
  host: Scalars['String']['input'];
  httpsStatus?: InputMaybe<Scalars['Boolean']['input']>;
  landingPageStatusId: Scalars['Int']['input'];
  siteId: Scalars['Int']['input'];
  template: Scalars['String']['input'];
  templateTypeId: Scalars['Int']['input'];
}


export interface MutationBizLandingPageWithWebmasterDeleteArgs {
  host: Scalars['String']['input'];
}


export interface MutationBizLandingPageWithWebmasterUpdateArgs {
  host: Scalars['String']['input'];
  httpsStatus?: InputMaybe<Scalars['Boolean']['input']>;
  landingPageStatusId: Scalars['Int']['input'];
  siteId: Scalars['Int']['input'];
  template: Scalars['String']['input'];
  templateTypeId: Scalars['Int']['input'];
}

export interface MutationBizTag {
  create?: Maybe<BizTag>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationBizTagCreateArgs {
  label?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
}


export interface MutationBizTagDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface MutationBizTagUpdateArgs {
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
}

export interface MutationBizTool {
  cache?: Maybe<MutationBizToolCache>;
  create?: Maybe<BizTool>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationBizToolCreateArgs {
  config?: InputMaybe<Scalars['JSON']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  showExternalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  showInternalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  showWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationBizToolDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface MutationBizToolUpdateArgs {
  config?: InputMaybe<Scalars['JSON']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  showExternalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  showInternalOffer?: InputMaybe<Scalars['Boolean']['input']>;
  showWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationBizToolCache {
  create?: Maybe<BizToolCache>;
}


export interface MutationBizToolCacheCreateArgs {
  cache: Scalars['String']['input'];
  cacheId: Scalars['Float']['input'];
  cacheKey: Scalars['String']['input'];
}

export interface MutationBizToolConfigWithWebmaster {
  create?: Maybe<BizToolConfig>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationBizToolConfigWithWebmasterCreateArgs {
  config?: InputMaybe<Scalars['JSON']['input']>;
  label: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationBizToolConfigWithWebmasterDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface MutationBizToolConfigWithWebmasterUpdateArgs {
  config?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationBizToolWithWebmaster {
  config?: Maybe<MutationBizToolConfigWithWebmaster>;
}

export interface MutationMetrics {
  /** Saving influx hit if no fields are provided, it will be value:1 hit */
  hit?: Maybe<Scalars['Boolean']['output']>;
  /** Saving push related metrics */
  save?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationMetricsHitArgs {
  fields?: InputMaybe<Array<InfluxField>>;
  measurement: Scalars['String']['input'];
  tags?: InputMaybe<Array<InfluxTag>>;
}


export interface MutationMetricsSaveArgs {
  device: InfluxPushDevice;
  status: InfluxPushStatus;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}

export interface MutationProphecy {
  /** Funnel create/update/delete, set tags/steps, publish */
  funnel?: Maybe<MutationProphecyFunnel>;
  /** Prophecy logs */
  hit?: Maybe<Scalars['Boolean']['output']>;
  /** Parameter create/update/delete, set values */
  parameter?: Maybe<MutationProphecyParameter>;
  /** Profile create/update/delete, set profile datas, load profile from user */
  profile?: Maybe<MutationProphecyProfile>;
  /** Profile data create/update/delete */
  profileData?: Maybe<MutationProphecyProfileData>;
  /** Step create/update/delete, set tags/parameters, review and publish test */
  step?: Maybe<MutationProphecyStep>;
  /** Submit a prophecy step (for profile completion) */
  submitStep?: Maybe<ProphecySubmitResult>;
  /** Tag create(/update/delete) */
  tag?: Maybe<MutationProphecyTag>;
  /** Test create/update/delete, set tags/funnel, publish */
  test?: Maybe<MutationProphecyTest>;
}


export interface MutationProphecyFunnelArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationProphecyHitArgs {
  stepVersionSlug: Scalars['ID']['input'];
}


export interface MutationProphecyParameterArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationProphecyProfileArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationProphecyProfileDataArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationProphecyStepArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationProphecySubmitStepArgs {
  inputs: Array<ProphecyStepInput>;
  isLastStep: Scalars['Boolean']['input'];
  nextStepPosition: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['ID']['input'];
}


export interface MutationProphecyTagArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationProphecyTestArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}

export interface MutationProphecyFunnel {
  addStep: ProphecyFunnel;
  addTags?: Maybe<Scalars['Boolean']['output']>;
  create: ProphecyFunnel;
  delete?: Maybe<Scalars['Boolean']['output']>;
  publish: ProphecyFunnel;
  removeStep?: Maybe<Scalars['Boolean']['output']>;
  removeTag?: Maybe<Scalars['Boolean']['output']>;
  save: ProphecyFunnel;
  setSteps: ProphecyFunnel;
  setTags?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationProphecyFunnelAddStepArgs {
  order: Scalars['Int']['input'];
  step: Scalars['ID']['input'];
}


export interface MutationProphecyFunnelAddTagsArgs {
  tags: Array<TagsInput>;
}


export interface MutationProphecyFunnelCreateArgs {
  context: ProphecyContext;
  customizedWeight?: Scalars['Boolean']['input'];
  enabled?: Scalars['Boolean']['input'];
  excludedFromTests?: Scalars['Boolean']['input'];
  modalFunnel?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rule: Scalars['String']['input'];
  tags?: InputMaybe<Array<TagsInput>>;
}


export interface MutationProphecyFunnelPublishArgs {
  comment: Scalars['String']['input'];
}


export interface MutationProphecyFunnelRemoveStepArgs {
  step: Scalars['ID']['input'];
}


export interface MutationProphecyFunnelRemoveTagArgs {
  tag: Scalars['ID']['input'];
}


export interface MutationProphecyFunnelSaveArgs {
  context?: InputMaybe<ProphecyContext>;
  customizedWeight?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludedFromTests?: InputMaybe<Scalars['Boolean']['input']>;
  extraConfig?: InputMaybe<Scalars['String']['input']>;
  modalFunnel?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationProphecyFunnelSetStepsArgs {
  steps: Array<InputMaybe<StepsInput>>;
}


export interface MutationProphecyFunnelSetTagsArgs {
  tags: Array<InputMaybe<TagsInput>>;
}

export interface MutationProphecyParameter {
  addValueType?: Maybe<Scalars['Boolean']['output']>;
  create?: Maybe<ProphecyParameter>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  removeValueType?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationProphecyParameterAddValueTypeArgs {
  value?: InputMaybe<Scalars['String']['input']>;
  valueTypeId: ProphecyValueType;
}


export interface MutationProphecyParameterCreateArgs {
  context: ProphecyContext;
  documentation?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  mandatory?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  parameterTypeId: ProphecyParameterType;
}


export interface MutationProphecyParameterRemoveValueTypeArgs {
  valueTypeId: ProphecyValueType;
}


export interface MutationProphecyParameterUpdateArgs {
  documentation?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameterTypeId?: InputMaybe<ProphecyParameterType>;
}

export interface MutationProphecyProfile {
  addProfileData: ProphecyProfile;
  create?: Maybe<ProphecyProfile>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  loadFromUser: ProphecyProfile;
  removeProfileData?: Maybe<Scalars['Boolean']['output']>;
  setProfileDatas: ProphecyProfile;
  update?: Maybe<ProphecyProfile>;
}


export interface MutationProphecyProfileAddProfileDataArgs {
  profileData: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}


export interface MutationProphecyProfileCreateArgs {
  name?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationProphecyProfileLoadFromUserArgs {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
}


export interface MutationProphecyProfileRemoveProfileDataArgs {
  profileData: Scalars['ID']['input'];
}


export interface MutationProphecyProfileSetProfileDatasArgs {
  profileDatas: Array<ProfileInput>;
}


export interface MutationProphecyProfileUpdateArgs {
  name: Scalars['String']['input'];
}

export interface MutationProphecyProfileData {
  create?: Maybe<ProphecyProfileData>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationProphecyProfileDataCreateArgs {
  internalLabel: Scalars['String']['input'];
  label: Scalars['String']['input'];
}


export interface MutationProphecyProfileDataUpdateArgs {
  label: Scalars['String']['input'];
}

export interface MutationProphecyStep {
  addParameters: ProphecyStep;
  addTags?: Maybe<Scalars['Boolean']['output']>;
  create: ProphecyStep;
  delete?: Maybe<Scalars['Boolean']['output']>;
  publish: ProphecyStep;
  removeParameter?: Maybe<Scalars['Boolean']['output']>;
  removeTag?: Maybe<Scalars['Boolean']['output']>;
  review: ProphecyStep;
  save: ProphecyStep;
  setParameters: ProphecyStep;
  setTags?: Maybe<Scalars['Boolean']['output']>;
  validate: ProphecyStep;
}


export interface MutationProphecyStepAddParametersArgs {
  parameters: Array<ParametersInput>;
}


export interface MutationProphecyStepAddTagsArgs {
  tags: Array<TagsInput>;
}


export interface MutationProphecyStepCreateArgs {
  context: ProphecyContext;
  name: Scalars['String']['input'];
  reviewRequested?: Scalars['Boolean']['input'];
  tags?: InputMaybe<Array<TagsInput>>;
}


export interface MutationProphecyStepRemoveParameterArgs {
  parameter: Scalars['ID']['input'];
}


export interface MutationProphecyStepRemoveTagArgs {
  tag: Scalars['ID']['input'];
}


export interface MutationProphecyStepSaveArgs {
  context?: InputMaybe<ProphecyContext>;
  css?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  js?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reviewRequested?: InputMaybe<Scalars['Boolean']['input']>;
  scss?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationProphecyStepSetParametersArgs {
  parameters: Array<ParametersInput>;
}


export interface MutationProphecyStepSetTagsArgs {
  tags: Array<InputMaybe<TagsInput>>;
}


export interface MutationProphecyStepValidateArgs {
  comment: Scalars['String']['input'];
}

export interface MutationProphecyTag {
  create?: Maybe<ProphecyTag>;
}


export interface MutationProphecyTagCreateArgs {
  name: Scalars['String']['input'];
  tagTypeId: ProphecyTagType;
}

export interface MutationProphecyTest {
  addFunnel?: Maybe<ProphecyTest>;
  addTags?: Maybe<Scalars['Boolean']['output']>;
  create: ProphecyTest;
  delete?: Maybe<Scalars['Boolean']['output']>;
  publish: ProphecyTest;
  removeFunnel?: Maybe<Scalars['Boolean']['output']>;
  removeTag?: Maybe<Scalars['Boolean']['output']>;
  save: ProphecyTest;
  setFunnels?: Maybe<ProphecyTest>;
  setTags?: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationProphecyTestAddFunnelArgs {
  funnel: FunnelsInput;
}


export interface MutationProphecyTestAddTagsArgs {
  tags: Array<TagsInput>;
}


export interface MutationProphecyTestCreateArgs {
  context: ProphecyContext;
  customizedWeight?: Scalars['Boolean']['input'];
  enabled?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rule: Scalars['String']['input'];
  tags?: InputMaybe<Array<TagsInput>>;
}


export interface MutationProphecyTestPublishArgs {
  comment: Scalars['String']['input'];
}


export interface MutationProphecyTestRemoveFunnelArgs {
  funnel: Scalars['ID']['input'];
}


export interface MutationProphecyTestRemoveTagArgs {
  tag: Scalars['ID']['input'];
}


export interface MutationProphecyTestSaveArgs {
  customizedWeight?: Scalars['Boolean']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationProphecyTestSetFunnelsArgs {
  funnels: Array<FunnelsInput>;
}


export interface MutationProphecyTestSetTagsArgs {
  tags: Array<InputMaybe<TagsInput>>;
}

export interface MutationSnap {
  /** View all snap likes and snap views */
  clearNotifications: Scalars['Boolean']['output'];
  /**
   * Delete a snap
   * @deprecated use MutableSnap
   */
  delete: Scalars['Boolean']['output'];
  /** Create a new UserPicture and make it default picture */
  setToProfilePicture: Scalars['Boolean']['output'];
}

/** Contains mutations related to users */
export interface MutationUser {
  /** Convert Fusion token to GraphQL Token */
  convertFToken?: Maybe<Token>;
  /** Action to reset password */
  lostPassword?: Maybe<BooleanResult>;
  /** Holds user's mutations */
  me?: Maybe<MutationWithUser>;
  /** Refresh a user's token */
  refreshToken?: Maybe<SignInResult>;
  /** Reset email status (bounced status) of a user */
  resetEmailStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Reset password for dating-messenger */
  resetPassword?: Maybe<BooleanResult>;
  /**
   * Sign in a user
   * @deprecated Deprecated once connection by email is up
   */
  signIn?: Maybe<SignInResult>;
  /** Sign in a user with its email (can return multiple SignInResult for each user's channel) */
  signInAllEmail?: Maybe<Array<SignInResult>>;
  /** Sign in a user with its email */
  signInEmail?: Maybe<SignInResult>;
  /** Register a new user */
  signUp?: Maybe<SignInResult>;
  /** Holds user's mutations on behalf of an admin */
  withUser?: Maybe<MutationWithUser>;
}


/** Contains mutations related to users */
export interface MutationUserConvertFTokenArgs {
  token: Scalars['String']['input'];
}


/** Contains mutations related to users */
export interface MutationUserLostPasswordArgs {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['EmailAddress']['input'];
}


/** Contains mutations related to users */
export interface MutationUserRefreshTokenArgs {
  token: Scalars['String']['input'];
}


/** Contains mutations related to users */
export interface MutationUserResetEmailStatusArgs {
  userId: Scalars['Int']['input'];
}


/** Contains mutations related to users */
export interface MutationUserResetPasswordArgs {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}


/** Contains mutations related to users */
export interface MutationUserSignInArgs {
  channelId: Scalars['Int']['input'];
  displayName: Scalars['String']['input'];
  password: Scalars['String']['input'];
}


/** Contains mutations related to users */
export interface MutationUserSignInAllEmailArgs {
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
}


/** Contains mutations related to users */
export interface MutationUserSignInEmailArgs {
  channelId: Scalars['Int']['input'];
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
}


/** Contains mutations related to users */
export interface MutationUserSignUpArgs {
  uhc: UserHasChannelSignUpInput;
  useSwitch?: InputMaybe<Scalars['Boolean']['input']>;
  user: UserSignUpInput;
}


/** Contains mutations related to users */
export interface MutationUserWithUserArgs {
  user: IUserHasChannel;
}

export interface MutationUserActions {
  /** Blacklist a user */
  blacklist: Scalars['Boolean']['output'];
  /** Bookmark a user profile */
  bookmark: Scalars['Boolean']['output'];
  /** Close the video conversation */
  closeVideoConversation: Scalars['Boolean']['output'];
  /** Delete a conversation with a user and remove it from the contact list */
  deleteConversation: Scalars['Boolean']['output'];
  /** Kiss a user. */
  kiss: Scalars['Boolean']['output'];
  /** Do a mini speedflirt */
  miniSpeedflirt: Scalars['Boolean']['output'];
  /** Give a user permisssion to see my private picture */
  privatePictureAuthorization: Scalars['Boolean']['output'];
  /** Reject from second chance */
  secondChance: Scalars['Boolean']['output'];
  /** Send description request (typically when user dont have description) */
  sendDescriptionRequest: MessageDescriptionRequest;
  /** Send message */
  sendMessage: MessageText;
  /** Send picture request (typically when user dont have pictures) */
  sendPictureRequest: MessagePictureRequest;
  /** Send private picture request */
  sendPrivatePictureRequest: MessagePrivatePictureRequest;
  /** Accept the video conversation */
  sendVideoConversationAccepted: Scalars['Boolean']['output'];
  /** Deny / cancel the video conversation request */
  sendVideoConversationCancelled: Scalars['Boolean']['output'];
  /** Send request to make a video conversation, only client available is "agora", roomId should be random string of max 32 chars */
  sendVideoConversationRequest: MessageVideoRequest;
  /** Speedflirt a user isMinispeedflirt is deprecated, use miniSpeedflirt endpoint instead */
  speedflirt: Scalars['Boolean']['output'];
  /** Subscribe to user */
  subscribe: Scalars['Boolean']['output'];
  /** Swipe card from like list */
  swipeLikeCard: Scalars['Boolean']['output'];
  /** Send typing event to peer */
  typing?: Maybe<Scalars['Boolean']['output']>;
  /** Unsubscribe to user */
  unsubscribe: Scalars['Boolean']['output'];
  /** view all message send by user */
  viewAllMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Visit a user profile. DirectAction = false will not decrement quota */
  visit: Scalars['Boolean']['output'];
}


export interface MutationUserActionsBlacklistArgs {
  action?: InputMaybe<ListAction>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationUserActionsBookmarkArgs {
  action?: InputMaybe<ListAction>;
}


export interface MutationUserActionsCloseVideoConversationArgs {
  slug: Scalars['ID']['input'];
}


export interface MutationUserActionsKissArgs {
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsMiniSpeedflirtArgs {
  action: SpeedflirtAction;
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsPrivatePictureAuthorizationArgs {
  action?: InputMaybe<ListAction>;
}


export interface MutationUserActionsSecondChanceArgs {
  action?: InputMaybe<ListAction>;
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsSendDescriptionRequestArgs {
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsSendMessageArgs {
  source?: InputMaybe<EventSource>;
  text: Scalars['String']['input'];
}


export interface MutationUserActionsSendPictureRequestArgs {
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsSendPrivatePictureRequestArgs {
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsSendVideoConversationAcceptedArgs {
  slug: Scalars['ID']['input'];
}


export interface MutationUserActionsSendVideoConversationCancelledArgs {
  slug: Scalars['ID']['input'];
}


export interface MutationUserActionsSendVideoConversationRequestArgs {
  clientId: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
}


export interface MutationUserActionsSpeedflirtArgs {
  action: SpeedflirtAction;
  isMiniSpeedflirt?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsSwipeLikeCardArgs {
  action?: InputMaybe<ListAction>;
  source?: InputMaybe<EventSource>;
}


export interface MutationUserActionsViewAllMessageArgs {
  allEvent?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationUserActionsVisitArgs {
  directAction?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EventSource>;
}

export interface MutationWithUser {
  /** Allows to perform actions with a target user like speedflirt, sending messages, typing ... (from the authentified user (auth)) */
  actions?: Maybe<MutationUserActions>;
  /** Returns true if consumable has been activated, false otherwise */
  activateConsumable: Scalars['Boolean']['output'];
  addViewPaymentBoost: Scalars['Boolean']['output'];
  ads: Scalars['Boolean']['output'];
  /** Save/Delete a push payload for user (android) ex: token = xxx, bundle = com.jacquiemichel_v3 */
  androidpush?: Maybe<Scalars['Boolean']['output']>;
  /** Change user's birthday */
  birthday: Scalars['Boolean']['output'];
  buyWithAgreement?: Maybe<BuyResponse>;
  buyWithAgreementLegacy: Scalars['Boolean']['output'];
  buyWithCard?: Maybe<BuyResponse>;
  cookie?: Maybe<Scalars['Boolean']['output']>;
  /** Change user's criterias, remove all previous values for each id in the input */
  criterias: Scalars['Boolean']['output'];
  crossRegister?: Maybe<ExternalSignInResult>;
  /** Change user's description, set null or '' to delete description */
  description?: Maybe<Scalars['Boolean']['output']>;
  /** Edit user details */
  details: Scalars['Boolean']['output'];
  /** Change user's displayName, user can only change once while it's unlimited for admins */
  displayName: BooleanResult;
  /** Change user's email (reset user's email status and send a new validation email) */
  email: Scalars['Boolean']['output'];
  /** Should be call when a favoriteGame feed is being played */
  favoriteGamePlayed: Scalars['Int']['output'];
  /** Add or update user's fingerprint */
  fingerprint: BooleanResult;
  /** Change user's gender */
  gender: Scalars['Boolean']['output'];
  /** Give the user extra action */
  grantExtraAction: Scalars['Boolean']['output'];
  /** Grant membership (trial or premium) to a user Date returned is the expiration date */
  grantMembership: Scalars['DateTime']['output'];
  /** metrics cm / sexId must be given if gender is a couple */
  height: Scalars['Boolean']['output'];
  /** Set hibernate status */
  hibernate: Scalars['Boolean']['output'];
  /** Change user's icebreaker, set null or '' to delete icebreaker */
  icebreaker?: Maybe<Scalars['Boolean']['output']>;
  /** Increment quota based on action */
  incrementQuota: Scalars['Boolean']['output'];
  /** orderId: android purchaseID (ex: GPA.1111-1111-1111-11111) subscriptionId: android productID: (ex: app_3month) */
  initAndroidOrder: BooleanResult;
  initIosOrder: BooleanResult;
  /** Save/Delete a push payload for user (ios) */
  iospush?: Maybe<Scalars['Boolean']['output']>;
  /** Change user's locale (e.g 'fr_FR') */
  language: Locale;
  /** Set User's location based on coordinates OR geonameid */
  location?: Maybe<Geoname>;
  /** insert a user activity log */
  logActivity: Scalars['Boolean']['output'];
  markExpiredMatches: Scalars['Boolean']['output'];
  notifiableRule: BooleanResult;
  /** Save notification settings for user */
  notifications?: Maybe<Scalars['Boolean']['output']>;
  /** openMessaging */
  openContactLists: Scalars['Boolean']['output'];
  /** Open a batch of feed */
  openFeedBatch: Scalars['Boolean']['output'];
  /** Open a notification */
  openNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Change user's password, if old password is generated, give empty string as old password */
  password?: Maybe<ChangePassword>;
  refreshAndroidOrder: BooleanResult;
  /** Subscribe an existing user to a channel */
  register?: Maybe<SignInResult>;
  /** Change user's relationship tag */
  relationshipTag: Scalars['Boolean']['output'];
  /** Returns true to indicate that user renounced to his retraction right and that an email has been sent to him. Returns false if user already renounced to it. No email is sent. */
  retractionRenunciation: Scalars['Boolean']['output'];
  /** Remove given extra action */
  revokeExtraAction: Scalars['Boolean']['output'];
  /** Revoke membership from a user, */
  revokeMembership: Scalars['Boolean']['output'];
  /** Change user's safemode */
  safeMode: Scalars['Boolean']['output'];
  saveFirebaseToken?: Maybe<Scalars['Boolean']['output']>;
  /** Set user descriptor as seen */
  sawDescriptor: Scalars['Boolean']['output'];
  /** Set user warning as seen */
  sawWarning: Scalars['Boolean']['output'];
  /** Change user's searches and/or location and/or criteria if input is provided */
  search: Scalars['Boolean']['output'];
  /** See all user's visits */
  seeAllVisits: Scalars['Boolean']['output'];
  /** Should be called when profile with badge is displayed on the screen */
  seeRelationshipTag: Scalars['Boolean']['output'];
  /** Change user's siteId */
  siteId: Scalars['Boolean']['output'];
  /** Perform action on a given snap */
  snap?: Maybe<MutationSnap>;
  tracker?: Maybe<BooleanResult>;
  unsubscribe?: Maybe<BooleanResult>;
  unsubscriptionGift?: Maybe<Scalars['Boolean']['output']>;
  updateMembership: Scalars['Boolean']['output'];
  /** Re-send validation email */
  validationEmail: Scalars['Boolean']['output'];
  viewGamificationEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Save/Delete a webpush payload */
  webpush?: Maybe<Scalars['Boolean']['output']>;
  /** metrics kg / sexId must be given if gender is a couple */
  weight: Scalars['Boolean']['output'];
}


export interface MutationWithUserActionsArgs {
  user: IUserHasChannel;
}


export interface MutationWithUserActivateConsumableArgs {
  type: ConsumableType;
}


export interface MutationWithUserAddViewPaymentBoostArgs {
  extFor: Scalars['Int']['input'];
  plateform: DeviceType;
}


export interface MutationWithUserAdsArgs {
  action: AdsAction;
  bannerId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  slot: Scalars['String']['input'];
  sourceId: Scalars['Int']['input'];
  type: AdsType;
}


export interface MutationWithUserAndroidpushArgs {
  bundle?: InputMaybe<Scalars['String']['input']>;
  revoke?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
}


export interface MutationWithUserBirthdayArgs {
  date: Scalars['Date']['input'];
}


export interface MutationWithUserBuyWithAgreementArgs {
  buy: DatingBuyInput;
  device: DeviceInput;
}


export interface MutationWithUserBuyWithAgreementLegacyArgs {
  accessType: Scalars['ID']['input'];
  device: DeviceInput;
  fingerprint: Scalars['String']['input'];
  followProfile?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['Int']['input'];
}


export interface MutationWithUserBuyWithCardArgs {
  buy: DatingBuyInput;
  card: CardInput;
  device: DeviceInput;
}


export interface MutationWithUserCookieArgs {
  type: CookieType;
  value: Scalars['String']['input'];
}


export interface MutationWithUserCriteriasArgs {
  criterias: Array<CriteriaParam>;
}


export interface MutationWithUserCrossRegisterArgs {
  externalProviderId: Scalars['Int']['input'];
}


export interface MutationWithUserDescriptionArgs {
  text?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationWithUserDetailsArgs {
  firstname?: InputMaybe<Scalars['String']['input']>;
  gsm?: InputMaybe<Scalars['PhoneInput']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationWithUserDisplayNameArgs {
  displayName: Scalars['String']['input'];
}


export interface MutationWithUserEmailArgs {
  email: Scalars['EmailAddress']['input'];
}


export interface MutationWithUserFingerprintArgs {
  bot?: InputMaybe<Scalars['Boolean']['input']>;
  fingerprint: Scalars['String']['input'];
  incognito?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  screenH?: InputMaybe<Scalars['Int']['input']>;
  screenW?: InputMaybe<Scalars['Int']['input']>;
  source: FingerprintSource;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userAgent: Scalars['String']['input'];
}


export interface MutationWithUserGenderArgs {
  gender: Gender;
}


export interface MutationWithUserGrantExtraActionArgs {
  actions: Array<GrantExtraInput>;
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationWithUserGrantMembershipArgs {
  duration: Scalars['RRule']['input'];
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  type: SubscriptionType;
}


export interface MutationWithUserHeightArgs {
  height?: InputMaybe<Scalars['Int']['input']>;
  sexId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationWithUserHibernateArgs {
  enable: Scalars['Boolean']['input'];
}


export interface MutationWithUserIcebreakerArgs {
  predefined?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationWithUserIncrementQuotaArgs {
  action: AccessName;
  checkFirst?: InputMaybe<Scalars['Boolean']['input']>;
  incrementNumber?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationWithUserInitAndroidOrderArgs {
  orderId: Scalars['String']['input'];
  packageName: Scalars['String']['input'];
  purchaseToken: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}


export interface MutationWithUserInitIosOrderArgs {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  verificationData: Scalars['String']['input'];
}


export interface MutationWithUserIospushArgs {
  payload: IosPushPayload;
  revoke?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationWithUserLanguageArgs {
  code: Scalars['String']['input'];
}


export interface MutationWithUserLocationArgs {
  coordinates?: InputMaybe<ICoordinates>;
  geonameId?: InputMaybe<Scalars['Int']['input']>;
  legacyLocationId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MutationWithUserLogActivityArgs {
  activity: ActivityLogType;
}


export interface MutationWithUserNotifiableRuleArgs {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<Scalars['RRule']['input']>;
  slug: Scalars['ID']['input'];
}


export interface MutationWithUserNotificationsArgs {
  advertising?: InputMaybe<Scalars['Boolean']['input']>;
  bookmark?: InputMaybe<Array<NotificationTarget>>;
  comment?: InputMaybe<Array<NotificationTarget>>;
  commentlike?: InputMaybe<Array<NotificationTarget>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Array<NotificationTarget>>;
  matching?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Array<NotificationTarget>>;
  messageread?: InputMaybe<Array<NotificationTarget>>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  online?: InputMaybe<Array<NotificationTarget>>;
  picturelike?: InputMaybe<Array<NotificationTarget>>;
  privateDataSharing?: InputMaybe<Scalars['Boolean']['input']>;
  privateauthorization?: InputMaybe<Array<NotificationTarget>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resetOnConnect?: InputMaybe<Scalars['Boolean']['input']>;
  snaplike?: InputMaybe<Array<NotificationTarget>>;
  speedflirt?: InputMaybe<Scalars['Boolean']['input']>;
  subscriber?: InputMaybe<Array<NotificationTarget>>;
  summary?: InputMaybe<Scalars['Boolean']['input']>;
  visit?: InputMaybe<Array<NotificationTarget>>;
  welcomemessage?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationWithUserOpenFeedBatchArgs {
  slugs: Array<Scalars['ID']['input']>;
}


export interface MutationWithUserOpenNotificationArgs {
  slug: Scalars['ID']['input'];
}


export interface MutationWithUserPasswordArgs {
  new: Scalars['String']['input'];
  old: Scalars['String']['input'];
}


export interface MutationWithUserRefreshAndroidOrderArgs {
  orders: Array<AndroidOrder>;
}


export interface MutationWithUserRegisterArgs {
  data: UserHasChannelSignUpInput;
}


export interface MutationWithUserRelationshipTagArgs {
  id: Scalars['Int']['input'];
}


export interface MutationWithUserRetractionRenunciationArgs {
  source: RetractionRenunciationSource;
}


export interface MutationWithUserRevokeExtraActionArgs {
  model: RevokeActionModel;
  modelId: Scalars['Int']['input'];
}


export interface MutationWithUserRevokeMembershipArgs {
  model: RevokeMembershipModel;
  modelId: Scalars['Int']['input'];
}


export interface MutationWithUserSafeModeArgs {
  value: Safemode;
}


export interface MutationWithUserSaveFirebaseTokenArgs {
  projectId?: InputMaybe<Scalars['String']['input']>;
  revoke?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
}


export interface MutationWithUserSearchArgs {
  criteria?: InputMaybe<Array<CriteriaParam>>;
  location?: InputMaybe<UserSearchLocationParams>;
  searches?: InputMaybe<Array<UserSearchParams>>;
}


export interface MutationWithUserSiteIdArgs {
  siteId: Scalars['Int']['input'];
}


export interface MutationWithUserSnapArgs {
  slug?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationWithUserTrackerArgs {
  display: TrackerDisplay;
  eventType: TrackerEventType;
  option?: InputMaybe<Scalars['String']['input']>;
  type: TrackerType;
}


export interface MutationWithUserUpdateMembershipArgs {
  enabled: Scalars['Boolean']['input'];
  expireAt: Scalars['Date']['input'];
  membershipId: Scalars['Int']['input'];
  startAt: Scalars['Date']['input'];
  type: SubscriptionType;
}


export interface MutationWithUserViewGamificationEventArgs {
  slug: Scalars['ID']['input'];
}


export interface MutationWithUserWebpushArgs {
  payload: Scalars['JSON']['input'];
  revoke?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MutationWithUserWeightArgs {
  sexId?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
}

export interface MutationWithWebmaster {
  landingPage?: Maybe<MutationBizLandingPageWithWebmaster>;
  tool?: Maybe<MutationBizToolWithWebmaster>;
}

export interface NodeServer {
  arch: Scalars['String']['output'];
  /** only defined to true when server is closing */
  closing?: Maybe<Scalars['Boolean']['output']>;
  cpus?: Maybe<Array<Scalars['JSON']['output']>>;
  env?: Maybe<Scalars['String']['output']>;
  hostname: Scalars['String']['output'];
  load?: Maybe<Array<Scalars['Float']['output']>>;
  memory?: Maybe<Scalars['JSON']['output']>;
  node: Scalars['String']['output'];
  package?: Maybe<Scalars['JSON']['output']>;
  pid: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
  service?: Maybe<Scalars['String']['output']>;
  uptime: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
}

export interface Notifiable extends Sluggable {
  label: Scalars['String']['output'];
  notifiableType: NotifiableType;
  notifications?: Maybe<Array<NotificationRule>>;
  rule?: Maybe<RuleSchedule>;
  slug: Scalars['ID']['output'];
}

export interface NotifiableType {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface NotificationReceived {
  connectionUrl: Scalars['URL']['output'];
  content: Scalars['String']['output'];
  from?: Maybe<UserHasChannel>;
  notificationType: NotificationType;
  receivedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
}

export interface NotificationRule {
  notificationType: NotificationType;
  rule?: Maybe<RuleSchedule>;
}

export interface NotificationSettings {
  advertising: Scalars['Boolean']['output'];
  bookmark?: Maybe<Array<NotificationTarget>>;
  comment?: Maybe<Array<NotificationTarget>>;
  commentlike?: Maybe<Array<NotificationTarget>>;
  counter?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  match?: Maybe<Array<NotificationTarget>>;
  matching: Scalars['Boolean']['output'];
  message?: Maybe<Array<NotificationTarget>>;
  messageread?: Maybe<Array<NotificationTarget>>;
  newsletter: Scalars['Boolean']['output'];
  online?: Maybe<Array<NotificationTarget>>;
  picturelike?: Maybe<Array<NotificationTarget>>;
  privateDataSharing: Scalars['Boolean']['output'];
  privateauthorization?: Maybe<Array<NotificationTarget>>;
  public: Scalars['Boolean']['output'];
  resetOnConnect?: Maybe<Scalars['Boolean']['output']>;
  snaplike?: Maybe<Array<NotificationTarget>>;
  speedflirt: Scalars['Boolean']['output'];
  subscriber?: Maybe<Array<NotificationTarget>>;
  summary: Scalars['Boolean']['output'];
  visit?: Maybe<Array<NotificationTarget>>;
  welcomemessage: Scalars['Boolean']['output'];
}

export enum NotificationTarget {
  Email = 'EMAIL',
  Messenger = 'MESSENGER',
  Mobile = 'MOBILE',
  Site = 'SITE'
}

export interface NotificationType {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export enum ObjectTypeId {
  Comment = 'Comment',
  Criteria = 'Criteria',
  Description = 'Description',
  Message = 'Message',
  PictureLike = 'PictureLike',
  Profile = 'Profile',
  RelationshipTag = 'RelationshipTag',
  Snap = 'Snap',
  UserPicture = 'UserPicture',
  ValueMonth = 'ValueMonth',
  ValueWeek = 'ValueWeek',
  ValueYear = 'ValueYear'
}

export interface OfferTemplate {
  followProfile?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new?: Maybe<Scalars['Boolean']['output']>;
  top?: Maybe<Scalars['Boolean']['output']>;
}

export interface OpeningHour {
  closes: Scalars['String']['output'];
  opens: Scalars['String']['output'];
  /** Monday = 0 [...] Sunday = 6 */
  weekDay: Scalars['Int']['output'];
}

export enum Operator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export interface Operators {
  label: Scalars['String']['output'];
  types?: Maybe<Array<RulerVariableType>>;
  value: Scalars['String']['output'];
}

/** Overload an option defined by the `OptionDefinition` for a given level */
export interface OptionAssignment {
  id: Scalars['Int']['output'];
  /** If this assignment is final, it cannot be overwritten by another assignment */
  isFinal: Scalars['Boolean']['output'];
  /** The level id for the assignment. For example, if a type of level is `CHANNEL`, this ID will represents the ID of the channel. */
  levelId: Scalars['Int']['output'];
  levelType: OptionAssignmentLevelType;
  /** The option definition this assignment is based on */
  option: OptionDefinition;
  value: Scalars['String']['output'];
}

export interface OptionAssignmentAdminMutation {
  createOptionAssignment: CreateOptionAssignmentResponse;
  deleteOptionAssignment: Scalars['Boolean']['output'];
  updateOptionAssignment: UpdateOptionAssignmentResponse;
}


export interface OptionAssignmentAdminMutationCreateOptionAssignmentArgs {
  input: CreateOptionAssignmentInput;
}


export interface OptionAssignmentAdminMutationDeleteOptionAssignmentArgs {
  id: Scalars['Int']['input'];
}


export interface OptionAssignmentAdminMutationUpdateOptionAssignmentArgs {
  input: UpdateOptionAssignmentInput;
}

export interface OptionAssignmentAdminQuery {
  optionAssignments?: Maybe<OptionAssignmentConnection>;
}


export interface OptionAssignmentAdminQueryOptionAssignmentsArgs {
  input: OptionAssignmentsInput;
}

export interface OptionAssignmentConnection extends PaginationConnection {
  edges?: Maybe<Array<OptionAssignmentEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface OptionAssignmentEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<OptionAssignment>;
}

export interface OptionAssignmentError extends Error {
  message: Scalars['String']['output'];
}

export interface OptionAssignmentFilterInput {
  id?: InputMaybe<Scalars['Int']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['Int']['input']>;
  levelType?: InputMaybe<OptionAssignmentLevelType>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export enum OptionAssignmentLevelType {
  Affiliate = 'AFFILIATE',
  Brand = 'BRAND',
  BusinessUnit = 'BUSINESS_UNIT',
  Channel = 'CHANNEL',
  Company = 'COMPANY',
  Site = 'SITE'
}

export interface OptionAssignmentsInput {
  filters?: InputMaybe<OptionAssignmentFilterInput>;
  options?: InputMaybe<PaginationOptions>;
}

/** Definition of a site option with its default value. This value can be overloaded via `OptionAssignment` */
export interface OptionDefinition {
  defaultValue: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
}

export interface OptionDefinitionAdminMutation {
  createOptionDefinition: CreateOptionDefinitionResponse;
  /** Deletes an option definition. This will also delete all option assignments for this option definition. */
  deleteOptionDefinition: Scalars['Boolean']['output'];
  updateOptionDefinition: UpdateOptionDefinitionResponse;
}


export interface OptionDefinitionAdminMutationCreateOptionDefinitionArgs {
  input: CreateOptionDefinitionInput;
}


export interface OptionDefinitionAdminMutationDeleteOptionDefinitionArgs {
  id: Scalars['Int']['input'];
}


export interface OptionDefinitionAdminMutationUpdateOptionDefinitionArgs {
  input: UpdateOptionDefinitionInput;
}

export interface OptionDefinitionAdminQuery {
  optionDefinitions?: Maybe<OptionDefinitionConnection>;
}


export interface OptionDefinitionAdminQueryOptionDefinitionsArgs {
  input: OptionDefinitionsInput;
}

export interface OptionDefinitionConnection extends PaginationConnection {
  edges?: Maybe<Array<OptionDefinitionEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface OptionDefinitionEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<OptionDefinition>;
}

export interface OptionDefinitionError extends Error {
  message: Scalars['String']['output'];
}

export interface OptionDefinitionFilterInput {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}

export interface OptionDefinitionsInput {
  filters?: InputMaybe<OptionDefinitionFilterInput>;
  options?: InputMaybe<PaginationOptions>;
}

export interface Order extends Sluggable {
  account?: Maybe<MerchantAccount>;
  attributeValues?: Maybe<Array<OrderAttributeValue>>;
  canRefund?: Maybe<Scalars['Boolean']['output']>;
  card?: Maybe<Card>;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  invoiceURL?: Maybe<Scalars['URL']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  isHighlight?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<PaymentMethod>;
  nextOrder?: Maybe<Order>;
  previousOrder?: Maybe<Order>;
  purchase?: Maybe<Purchase>;
  /** @deprecated use purchase */
  purchases?: Maybe<Array<Purchase>>;
  slug: Scalars['ID']['output'];
  transactions?: Maybe<Array<Transaction>>;
}

export interface OrderAttribute extends Sluggable {
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
}

export interface OrderAttributeValue {
  attribute: OrderAttribute;
  createdAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
}

export interface Outflow {
  affiliate: Affiliate;
  amount: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  paymentMethod?: Maybe<AffiliatePaymentMethod>;
  period: Scalars['Int']['output'];
  vat: Scalars['Float']['output'];
}

export type OutflowConnectionResponse = OutflowError | OutflowsConnection;

export interface OutflowDeleteInput {
  id: Scalars['Int']['input'];
  /** If true, the outflow will be recreated in the pending state. If false, a new inflow will be created with the type REFUNDED for the current date. */
  recreateInPending?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface OutflowEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Outflow>;
}

export interface OutflowError extends Error {
  message: Scalars['String']['output'];
}

export interface OutflowInput {
  affiliateId: Scalars['Int']['input'];
}

export type OutflowPdfResponse = InvoicesPdf | OutflowError;

export type OutflowResponse = Outflow | OutflowError;

export interface OutflowsConnection extends PaginationConnection {
  edges: Array<OutflowEdge>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface PageInfo {
  /** Cursor opaque ID */
  endCursor: Scalars['ID']['output'];
  /** Tell if there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** How many item in total */
  totalCount?: Maybe<Scalars['Int']['output']>;
}

export interface PageInfoNext {
  /** First opaque cursor ID from the edges list */
  firstCursor?: Maybe<Scalars['ID']['output']>;
  /** Tell if there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Tell if there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Last opaque cursor ID from the edges list */
  lastCursor?: Maybe<Scalars['ID']['output']>;
}

export interface PaginationConnection {
  edges?: Maybe<Array<ConnectionEdge>>;
  pageInfo?: Maybe<PageInfoNext>;
  totalCount: Scalars['Int']['output'];
}

export interface PaginationOptions {
  /** Elements after this cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Elements before this cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** N first elements */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** N last elements */
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ParameterHasValueType {
  parameter: ProphecyParameter;
  value?: Maybe<Scalars['String']['output']>;
  valueType: ProphecyValueType;
}

export interface ParametersInput {
  parameter: Scalars['ID']['input'];
}

export interface PasswordRuleError extends CustomError, Error {
  code: Scalars['ID']['output'];
  message: Scalars['String']['output'];
}

export interface PaymentAccount {
  acquirer?: Maybe<PaymentAcquirer>;
  capping?: Maybe<PaymentAccountCapping>;
  company?: Maybe<Company>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method?: Maybe<PaymentMethodType>;
}

export interface PaymentAccountCapping {
  amountCap?: Maybe<Scalars['Int']['output']>;
  amountCapLastDay?: Maybe<Scalars['Int']['output']>;
  amountCapTotal?: Maybe<Scalars['Int']['output']>;
  amountProcessedLastDay?: Maybe<Scalars['Int']['output']>;
  amountProcessedLastMonth?: Maybe<Scalars['Int']['output']>;
  amountProcessedTotalLastMonth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface PaymentAccountCpg extends PaymentAccount {
  acquirer?: Maybe<PaymentAcquirer>;
  capping?: Maybe<PaymentAccountCapping>;
  company?: Maybe<Company>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method?: Maybe<PaymentMethodType>;
  psp?: Maybe<PaymentCpgPsp>;
}

export interface PaymentAccountCpgInput {
  descriptor: Scalars['String']['input'];
  pspId: Scalars['Int']['input'];
}

export interface PaymentAccountGift extends PaymentAccount {
  acquirer?: Maybe<PaymentAcquirer>;
  capping?: Maybe<PaymentAccountCapping>;
  company?: Maybe<Company>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method?: Maybe<PaymentMethodType>;
}

export interface PaymentAccountInput {
  acquirerId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  cpg?: InputMaybe<PaymentAccountCpgInput>;
  label: Scalars['String']['input'];
  method: MethodType;
}

export interface PaymentAcquirer {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface PaymentAgreement {
  cvv?: InputMaybe<Scalars['String']['input']>;
}

export interface PaymentAttempt {
  account?: Maybe<PaymentAccount>;
  agreementUsed: Scalars['Boolean']['output'];
  card?: Maybe<PaymentPartialCard>;
  createdAt: Scalars['Date']['output'];
  events?: Maybe<Array<PaymentEvent>>;
  externalId?: Maybe<Scalars['String']['output']>;
}

export interface PaymentAttribute {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  values?: Maybe<Array<PaymentAttributeValue>>;
}

export interface PaymentAttributeValue {
  attribute: PaymentAttribute;
  coefficients?: Maybe<Array<PaymentAttributeValueCoefficient>>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface PaymentAttributeValueCoefficient {
  attributeValue: PaymentAttributeValue;
  coefficient: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  product?: Maybe<PaymentProductInterface>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface PaymentCard {
  cardTokenId: Scalars['String']['input'];
  cvv?: InputMaybe<Scalars['String']['input']>;
  expiration: CardExpiration;
  holder: Scalars['String']['input'];
  pan: Scalars['String']['input'];
  threeDsData?: InputMaybe<ThreedsData>;
}

export interface PaymentCpgPsp {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  rebillable: Scalars['Boolean']['output'];
  refundable: Scalars['Boolean']['output'];
}

export interface PaymentDataApple {
  data: Scalars['String']['input'];
  header: HeaderApplePay;
  signature: Scalars['String']['input'];
  version: VersionApplePay;
}

export interface PaymentEvent {
  cpgCode?: Maybe<PaymentEventCode>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pspCode?: Maybe<PaymentEventCode>;
}

export interface PaymentEventCode {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export enum PaymentEventSource {
  App = 'APP',
  Cpg = 'CPG',
  CpgCode = 'CPG_CODE',
  Cron = 'CRON',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  ExpressEndpointCpgGateway = 'EXPRESS_ENDPOINT_CPG_GATEWAY',
  PaymentPage = 'PAYMENT_PAGE',
  PgaCoaching = 'PGA_COACHING',
  PgaDating = 'PGA_DATING',
  Risk = 'RISK',
  Site = 'SITE',
  Svi = 'SVI'
}

export interface PaymentExtraConfig extends ProphecyFunnelVersionExtraConfig {
  force3DS: Scalars['Boolean']['output'];
  products?: Maybe<Array<Product>>;
  productsUpsellExternal?: Maybe<Array<Product>>;
  productsUpsellInternal?: Maybe<Array<Product>>;
  raw?: Maybe<Scalars['JSON']['output']>;
}

export interface PaymentIpLog {
  createdAt: Scalars['DateTime']['output'];
  ip: Scalars['String']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isp?: Maybe<Scalars['String']['output']>;
  /** dial-up, cellular, cable/DSL, and corporate connection speeds. */
  type?: Maybe<Scalars['String']['output']>;
}

export interface PaymentInvoice {
  companyId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ip?: Maybe<PaymentIpLog>;
  items: Array<PaymentInvoiceItem>;
}

export interface PaymentInvoiceItem {
  duration?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Price;
  rebillDuration?: Maybe<Scalars['String']['output']>;
  rebillLabel?: Maybe<Scalars['String']['output']>;
  rebillPrice?: Maybe<Price>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface PaymentMethod {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface PaymentMethodApple {
  displayName: Scalars['String']['input'];
  network: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

export interface PaymentMethodType {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface PaymentMutation {
  processPayment?: Maybe<PaymentResponse>;
  trackDisplay?: Maybe<Scalars['Boolean']['output']>;
  trackSubmit?: Maybe<Scalars['Boolean']['output']>;
}


export interface PaymentMutationProcessPaymentArgs {
  paymentRequest: PaymentRequest;
}


export interface PaymentMutationTrackDisplayArgs {
  extFor: Scalars['Int']['input'];
  platformId: TrackerDisplay;
}


export interface PaymentMutationTrackSubmitArgs {
  extFor: Scalars['Int']['input'];
  platformId: TrackerDisplay;
}

export interface PaymentMutationNs {
  addAccount?: Maybe<PaymentAccount>;
  addAcquirer?: Maybe<PaymentAcquirer>;
  addAttribute?: Maybe<PaymentAttribute>;
  addAttributeValue?: Maybe<PaymentAttribute>;
  addAttributeValueCoefficient?: Maybe<PaymentAttributeValueCoefficient>;
  addCapping?: Maybe<PaymentAccountCapping>;
  addCpgPsp?: Maybe<PaymentCpgPsp>;
  addPriceOverride?: Maybe<Scalars['Int']['output']>;
  applePayValidation?: Maybe<Scalars['JSON']['output']>;
  buyWithAgreement?: Maybe<BuyResponse>;
  buyWithApplePay?: Maybe<BuyResponse>;
  buyWithCard?: Maybe<BuyResponse>;
  buyWithGift?: Maybe<BuyResponse>;
  buyWithGooglePay?: Maybe<BuyResponse>;
  cancelRebill?: Maybe<Scalars['Boolean']['output']>;
  cpgChargeback?: Maybe<Scalars['Boolean']['output']>;
  createChargeback?: Maybe<ChargebackResponse>;
  /** Dispute a purchase id can be either a purchase or a rebill id (default purchase) */
  dispute: Scalars['Boolean']['output'];
  editPriceOverride?: Maybe<Scalars['Int']['output']>;
  logDisplay?: Maybe<Scalars['Int']['output']>;
  publishAttributeValueCoefficient?: Maybe<PaymentAttributeValueCoefficient>;
  /** Refund a purchase ids: purchased_item.ids to refund if none is provided, the entire purchase will be refunded */
  refundPurchase?: Maybe<Scalars['Boolean']['output']>;
  refundRebill?: Maybe<Scalars['Boolean']['output']>;
  removeAttribute?: Maybe<Scalars['Boolean']['output']>;
  removeAttributeValue?: Maybe<Scalars['Boolean']['output']>;
  removeAttributeValueCoefficient?: Maybe<Scalars['Boolean']['output']>;
  removePriceOverride?: Maybe<Scalars['Boolean']['output']>;
  resumeRebill?: Maybe<Scalars['Boolean']['output']>;
  setNextPaymentAccount?: Maybe<Scalars['Int']['output']>;
  stopRebill?: Maybe<Scalars['Boolean']['output']>;
  unsetNextPaymentAccount: Scalars['Boolean']['output'];
  updateChargeback?: Maybe<ChargebackResponse>;
  updatePaymentAttempt?: Maybe<Scalars['Boolean']['output']>;
  updateRebill?: Maybe<Scalars['Boolean']['output']>;
}


export interface PaymentMutationNsAddAccountArgs {
  data: PaymentAccountInput;
}


export interface PaymentMutationNsAddAcquirerArgs {
  label: Scalars['String']['input'];
}


export interface PaymentMutationNsAddAttributeArgs {
  label: Scalars['String']['input'];
}


export interface PaymentMutationNsAddAttributeValueArgs {
  attributeId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
}


export interface PaymentMutationNsAddAttributeValueCoefficientArgs {
  coefficient: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
}


export interface PaymentMutationNsAddCappingArgs {
  label: Scalars['String']['input'];
}


export interface PaymentMutationNsAddCpgPspArgs {
  cpgMethod: Scalars['String']['input'];
  label: Scalars['String']['input'];
}


export interface PaymentMutationNsAddPriceOverrideArgs {
  attributeValues: Array<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
}


export interface PaymentMutationNsApplePayValidationArgs {
  host: Scalars['String']['input'];
  validationURL: Scalars['URL']['input'];
}


export interface PaymentMutationNsBuyWithAgreementArgs {
  buy: BuyInput;
  device: DeviceInput;
}


export interface PaymentMutationNsBuyWithApplePayArgs {
  applePayToken: ApplePayToken;
  buy: BuyInput;
  customerInfo?: InputMaybe<CustomerInfoInput>;
  device: DeviceInput;
}


export interface PaymentMutationNsBuyWithCardArgs {
  buy: BuyInput;
  card: CardInput;
  device: DeviceInput;
}


export interface PaymentMutationNsBuyWithGiftArgs {
  buy: BuyInput;
}


export interface PaymentMutationNsBuyWithGooglePayArgs {
  buy: BuyInput;
  device: DeviceInput;
  googlePayToken: GooglePayToken;
}


export interface PaymentMutationNsCancelRebillArgs {
  eventDescription?: InputMaybe<EventDescription>;
  id: Scalars['Int']['input'];
  isRebill: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
}


export interface PaymentMutationNsCpgChargebackArgs {
  cpgId: Scalars['String']['input'];
  newPayment?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface PaymentMutationNsCreateChargebackArgs {
  amount: Scalars['Float']['input'];
  chargebackReasonId?: InputMaybe<Scalars['Int']['input']>;
  chargebackedAt?: InputMaybe<Scalars['Date']['input']>;
  cpgChargebackQueueId: Scalars['Int']['input'];
  currencyCode?: InputMaybe<Scalars['CurrencyCode']['input']>;
  datingPaymentOrderId?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['String']['input'];
  partialCard: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  paymentAttemptId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ChargebackStatus>;
}


export interface PaymentMutationNsDisputeArgs {
  id: Scalars['Int']['input'];
  isRebill?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface PaymentMutationNsEditPriceOverrideArgs {
  attributeValues: Array<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
}


export interface PaymentMutationNsLogDisplayArgs {
  abTestKey?: InputMaybe<Scalars['String']['input']>;
  extForId: Scalars['Int']['input'];
  templateId?: InputMaybe<PaymentPageTemplate>;
  userIdFor?: InputMaybe<Scalars['Int']['input']>;
}


export interface PaymentMutationNsPublishAttributeValueCoefficientArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentMutationNsRefundPurchaseArgs {
  eventDescription?: InputMaybe<EventDescription>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  purchaseId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}


export interface PaymentMutationNsRefundRebillArgs {
  eventDescription?: InputMaybe<EventDescription>;
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
}


export interface PaymentMutationNsRemoveAttributeArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentMutationNsRemoveAttributeValueArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentMutationNsRemoveAttributeValueCoefficientArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentMutationNsRemovePriceOverrideArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentMutationNsResumeRebillArgs {
  eventDescription?: InputMaybe<EventDescription>;
  itemId: Scalars['Int']['input'];
}


export interface PaymentMutationNsSetNextPaymentAccountArgs {
  accountId: Scalars['Int']['input'];
  remoteUserId: Scalars['Int']['input'];
  sourceType: UserSourceType;
  ttl: Scalars['Int']['input'];
  userSourceId: Scalars['Int']['input'];
}


export interface PaymentMutationNsStopRebillArgs {
  eventDescription?: InputMaybe<EventDescription>;
  itemId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  silent?: Scalars['Boolean']['input'];
}


export interface PaymentMutationNsUnsetNextPaymentAccountArgs {
  remoteUserId: Scalars['Int']['input'];
  sourceType: UserSourceType;
  userSourceId: Scalars['Int']['input'];
}


export interface PaymentMutationNsUpdateChargebackArgs {
  cpgChargebackQueueId: Scalars['Int']['input'];
  datingPaymentOrderId?: InputMaybe<Scalars['Int']['input']>;
  paymentAttemptId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ChargebackStatus>;
}


export interface PaymentMutationNsUpdatePaymentAttemptArgs {
  cpgCodeId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventDescription?: InputMaybe<EventDescription>;
  eventType: EventTypeCommon;
  id: Scalars['Int']['input'];
  pspCodeId?: InputMaybe<Scalars['Int']['input']>;
}


export interface PaymentMutationNsUpdateRebillArgs {
  eventDescription?: InputMaybe<EventDescription>;
  expiresAt: Scalars['Date']['input'];
  id: Scalars['Int']['input'];
}

export enum PaymentPageTemplate {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export enum PaymentPageType {
  Bill = 'BILL',
  Boost = 'BOOST',
  Default = 'DEFAULT'
}

export interface PaymentPartialCard {
  binInfo?: Maybe<BinInfo>;
  expiresAt: Scalars['Date']['output'];
  holder: Scalars['String']['output'];
  panEnd: Scalars['Int']['output'];
  panStart: Scalars['Int']['output'];
}

export interface PaymentProductInterface {
  /** Price in euro cents */
  basePrice: Scalars['Int']['output'];
  coefficients?: Maybe<Array<PaymentAttributeValueCoefficient>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  priceOverrides?: Maybe<Array<PriceOverride>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface PaymentProductMembership {
  id: Scalars['Int']['output'];
}

export interface PaymentPurchase extends Cancellable, HasPaymentEventInterface, Refundable {
  attempts?: Maybe<Array<PaymentPurchaseAttempt>>;
  cancellable: Scalars['Boolean']['output'];
  children?: Maybe<Array<PaymentPurchase>>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  events?: Maybe<Array<PaymentEvent>>;
  id: Scalars['Int']['output'];
  ip?: Maybe<PaymentIpLog>;
  /**
   * isActive means that the purchase has a successful, not refunded or cancelled payment
   * @deprecated Should use PurchasedItem.isActive instead
   */
  isActive: Scalars['Boolean']['output'];
  /** @deprecated use purchasedItems */
  purchasedItem?: Maybe<Array<PurchasedItem>>;
  purchasedItems?: Maybe<Array<PurchasedItem>>;
  refundable: Scalars['Boolean']['output'];
  total: Price;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface PaymentPurchaseAttempt extends HasPaymentEventInterface, PaymentAttempt {
  account?: Maybe<PaymentAccount>;
  agreementUsed: Scalars['Boolean']['output'];
  card?: Maybe<PaymentPartialCard>;
  createdAt: Scalars['Date']['output'];
  events?: Maybe<Array<PaymentEvent>>;
  externalId?: Maybe<Scalars['String']['output']>;
  purchase: PaymentPurchase;
}

export interface PaymentQuery {
  getInvoicePDF: OutflowPdfResponse;
  outflows: OutflowConnectionResponse;
}


export interface PaymentQueryGetInvoicePdfArgs {
  input: Array<InputOutflowPdf>;
}


export interface PaymentQueryOutflowsArgs {
  input: InputGetOutflows;
}

export interface PaymentQueryNs {
  accounts?: Maybe<Array<PaymentAccount>>;
  acquirers?: Maybe<Array<PaymentAcquirer>>;
  allMethods?: Maybe<Array<MethodType>>;
  attributes?: Maybe<Array<PaymentAttribute>>;
  cappings?: Maybe<Array<PaymentAccountCapping>>;
  cpgPsps?: Maybe<Array<PaymentCpgPsp>>;
  getRebillById: PaymentRebill;
  invoice?: Maybe<PaymentInvoice>;
  midMapping: Array<MidInfo>;
  products?: Maybe<Array<PaymentProductInterface>>;
  /** Get a purchase by id */
  purchase?: Maybe<PaymentPurchase>;
  purchaseHistory?: Maybe<PurchaseHistory>;
  /** panStart is the first 6 and panEnd is last 4 digits of the card */
  purchaseHistoryByCard?: Maybe<Array<PaymentPurchase>>;
  /** For debug purpose, until further implementation */
  purchaseStatus?: Maybe<Scalars['String']['output']>;
  searchUsers?: Maybe<Array<UserRemote>>;
  simulate?: Maybe<Array<SimulationResult>>;
  version: Scalars['String']['output'];
}


export interface PaymentQueryNsGetRebillByIdArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentQueryNsInvoiceArgs {
  id: Scalars['String']['input'];
}


export interface PaymentQueryNsMidMappingArgs {
  companyId: Scalars['Int']['input'];
}


export interface PaymentQueryNsPurchaseArgs {
  id: Scalars['Int']['input'];
}


export interface PaymentQueryNsPurchaseHistoryArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  userSourceType: UserSourceType;
}


export interface PaymentQueryNsPurchaseHistoryByCardArgs {
  amount: Scalars['Float']['input'];
  date: Scalars['Date']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  panEnd: Scalars['String']['input'];
  panStart: Scalars['String']['input'];
}


export interface PaymentQueryNsPurchaseStatusArgs {
  purchaseId: Scalars['Int']['input'];
}


export interface PaymentQueryNsSearchUsersArgs {
  search: Scalars['String']['input'];
}


export interface PaymentQueryNsSimulateArgs {
  attributeValueIds: Array<Scalars['Int']['input']>;
}

export interface PaymentRebill extends Cancellable, HasPaymentEventInterface, Refundable, Unsubscribtable {
  attempts?: Maybe<Array<PaymentRebillAttempt>>;
  cancellable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  events?: Maybe<Array<PaymentEvent>>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  /**
   * isActive means that the rebill has a successful, not refunded or cancelled payment
   * @deprecated Should use PurchasedItem.isActive instead
   */
  isActive: Scalars['Boolean']['output'];
  price: Price;
  product?: Maybe<PaymentProductInterface>;
  purchasedItemId: Scalars['Int']['output'];
  rebillPrice: Price;
  refundable: Scalars['Boolean']['output'];
  scenario: PaymentUnsubscriptionScenario;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface PaymentRebillAttempt extends HasPaymentEventInterface, PaymentAttempt {
  account?: Maybe<PaymentAccount>;
  agreementUsed: Scalars['Boolean']['output'];
  card?: Maybe<PaymentPartialCard>;
  createdAt: Scalars['Date']['output'];
  events?: Maybe<Array<PaymentEvent>>;
  externalId?: Maybe<Scalars['String']['output']>;
  rebill: PaymentRebill;
}

export interface PaymentRedirect {
  cancel?: InputMaybe<Scalars['URL']['input']>;
  success?: InputMaybe<Scalars['URL']['input']>;
}

export interface PaymentRequest {
  /** extFor */
  accessType?: InputMaybe<Scalars['Int']['input']>;
  agreementParam?: InputMaybe<PaymentAgreement>;
  cardParam?: InputMaybe<PaymentCard>;
  paymentType: PaymentType;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productUpsellExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productUpsellInternalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  redirect?: InputMaybe<PaymentRedirect>;
}

export interface PaymentResponse {
  nextUrl?: Maybe<Scalars['String']['output']>;
  paymentResult: PaymentResult;
}

export interface PaymentResult {
  product?: Maybe<Product>;
  status: PaymentStatus;
}

export enum PaymentScenarioType {
  BeginEnd = 'BeginEnd',
  NoConstraints = 'NoConstraints',
  NotApplicable = 'NotApplicable'
}

export enum PaymentStatus {
  Authorised = 'AUTHORISED',
  Failed = 'FAILED'
}

export enum PaymentType {
  Agreement = 'AGREEMENT',
  Card = 'CARD',
  Upgrade = 'UPGRADE'
}

export interface PaymentUnsubscriptionScenario {
  /** True if now is between startAt and endAt, false otherwise */
  canUnsubscribe: Scalars['Boolean']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  fees?: Maybe<Price>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  type: PaymentScenarioType;
}

export interface PendingPayment {
  affiliate: Affiliate;
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<AffiliatePaymentMethod>;
  period: Scalars['Int']['output'];
}

export interface PendingPaymentConnection extends PaginationConnection {
  edges?: Maybe<Array<PendingPaymentEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface PendingPaymentEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node: PendingPayment;
}

export interface PendingPaymentQuery {
  csv: Scalars['String']['output'];
  list?: Maybe<PendingPaymentConnection>;
}


export interface PendingPaymentQueryCsvArgs {
  input?: InputMaybe<InputPendingPaymentCsv>;
}


export interface PendingPaymentQueryListArgs {
  input?: InputMaybe<InputPendingPaymentPaginationOptions>;
}

export enum Period {
  Future = 'FUTURE',
  Past = 'PAST',
  Present = 'PRESENT'
}

export interface Person {
  contactMethods: Array<ContactMethod>;
  details?: Maybe<Array<Maybe<PersonDetail>>>;
  firstname: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPreferred: Scalars['Boolean']['output'];
  languageId?: Maybe<Scalars['Int']['output']>;
  lastname: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
}


export interface PersonDetailsArgs {
  input?: InputMaybe<InputGetPersonDetail>;
}

export type PersonCreateResponse = Person | PersonValidationError;

export interface PersonDetail {
  input: DetailInput;
  personId: Scalars['Int']['output'];
}

export interface PersonDetails {
  inputs: Array<DetailInput>;
  personId: Scalars['Int']['output'];
}

export type PersonUpdateResponse = PersonValidationError | Persons;

export interface PersonValidationError extends Error {
  message: Scalars['String']['output'];
}

export interface Persons {
  persons: Array<Person>;
}

export interface Pga extends Sluggable, WithTermsOfService {
  content?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['Int']['output'];
  logoUrl: Scalars['URL']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneSupport?: Maybe<PhoneSupport>;
  slug: Scalars['ID']['output'];
  templateName: Scalars['String']['output'];
  termsOfService?: Maybe<Scalars['Markdown']['output']>;
  termsOfServiceHTML?: Maybe<Scalars['HTML']['output']>;
  url: Scalars['URL']['output'];
}


export interface PgaTermsOfServiceArgs {
  type: TermsOfServiceType;
}


export interface PgaTermsOfServiceHtmlArgs {
  type: TermsOfServiceType;
}

export interface PgaOrders {
  connectionUrl: Scalars['URL']['output'];
  orderId: Scalars['Int']['output'];
  purchases?: Maybe<Array<Purchase>>;
  transactions?: Maybe<Array<Transaction>>;
}

export interface PgaOrdersResult {
  orders?: Maybe<Array<Maybe<PgaOrders>>>;
  status: Scalars['String']['output'];
}

export interface PhoneNumber {
  /** ISO 3166-2 */
  country?: Maybe<Country>;
  countryCallingCode?: Maybe<Scalars['String']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  isTwilio?: Maybe<Scalars['Boolean']['output']>;
  nationalNumber?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
}

export interface PhoneSupport {
  hours?: Maybe<Array<OpeningHour>>;
  number: PhoneNumber;
  timeZone: Scalars['String']['output'];
}

export interface PictureAuthorization {
  authorized: Scalars['Boolean']['output'];
  date?: Maybe<Scalars['Date']['output']>;
}

export interface PictureAuthorizationEvent extends InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface PictureAuthorizationEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface PictureInterface {
  sources: PictureSrcSet;
}


export interface PictureInterfaceSourcesArgs {
  safemode?: InputMaybe<Safemode>;
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface PictureLikeConnection extends PaginationConnection {
  edges?: Maybe<Array<PictureLikeEdge>>;
  pageInfo: PageInfoNext;
  /** @deprecated Also count shadowban, use `likes` or `reactions` instead. */
  totalCount: Scalars['Int']['output'];
}

export interface PictureLikeEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<PictureLikeEvent>;
}

export interface PictureLikeEvent extends InteractionEvent, ListEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  picture?: Maybe<UserPicture>;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface PictureLikeEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface PictureSource {
  /** Media type (image/jpeg or webp, gif...) */
  mime: Scalars['String']['output'];
  /** default to ratio 1 */
  url: Scalars['URL']['output'];
}


export interface PictureSourceUrlArgs {
  ratio?: InputMaybe<Scalars['Float']['input']>;
}

export interface PictureSrcSet {
  x1: Scalars['URL']['output'];
  /** @deprecated Will use UA's Accept header to return webp when needed */
  x1WebP?: Maybe<Scalars['URL']['output']>;
  x2: Scalars['URL']['output'];
  /** @deprecated Will use UA's Accept header to return webp when needed */
  x2WebP?: Maybe<Scalars['URL']['output']>;
  x3: Scalars['URL']['output'];
  /** @deprecated Will use UA's Accept header to return webp when needed */
  x3WebP?: Maybe<Scalars['URL']['output']>;
}

export enum PictureType {
  Full = 'FULL',
  Thumbnail = 'THUMBNAIL'
}

export interface PictureUrl {
  url?: Maybe<Scalars['String']['output']>;
}

export interface PictureWithIcon {
  icon?: Maybe<IconFeed>;
  picture?: Maybe<FeedUserPicture>;
}

export enum PlatformCat {
  Coaching = 'COACHING',
  CoachingMen = 'COACHING_MEN',
  Dating = 'DATING',
  Livecam = 'LIVECAM',
  Streaming = 'STREAMING',
  Vod = 'VOD'
}

export interface PointsAcquiredEvent extends GamificationEvent {
  eventType: GamificationEventType;
  points: Scalars['Int']['output'];
}

export interface PortalRedirect {
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  pattern: Scalars['String']['output'];
  redirect: Scalars['URL']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface PositionLimit {
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
}

export interface PredefinedIceBreaker {
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  relationshipTagId?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
}

export interface Presence {
  online: Scalars['Boolean']['output'];
  user?: Maybe<UserHasChannel>;
  userId: Scalars['Int']['output'];
}

export interface PresenceEvent extends InteractionEvent {
  createdAt: Scalars['DateTime']['output'];
  isOnline: Scalars['Boolean']['output'];
  user: UserHasChannelInterface;
}

export enum PreventPaymentTarget {
  Default = 'DEFAULT',
  IncludeConsumableInitials = 'INCLUDE_CONSUMABLE_INITIALS'
}

export interface Price {
  amount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use currencyCode instead */
  currency?: Maybe<Currency>;
  currencyCode?: Maybe<Scalars['CurrencyCode']['output']>;
}

export interface PriceOverride {
  attributeValues?: Maybe<Array<PaymentAttributeValue>>;
  by?: Maybe<AdminUser>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Price in euro cents */
  price: Scalars['Int']['output'];
  product: PaymentProductInterface;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface Product extends ProductInterface, Sluggable {
  /** Not implemented yet (may be deprecated) */
  gift?: Maybe<Product>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalLabel?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lengthUnit?: Maybe<ProductLengthUnit>;
  prepaidProduct?: Maybe<Product>;
  /** Provide the price of a product with a given unit (by default the unit is the product's one) */
  price?: Maybe<Price>;
  productCategory?: Maybe<ProductCategory>;
  rebillProduct?: Maybe<ProductRebill>;
  /** In percent, only filled when returned in a list */
  savings?: Maybe<Scalars['Int']['output']>;
  singleOfferProduct?: Maybe<Product>;
  slug: Scalars['ID']['output'];
  /** Not implemented yet (may be deprecated) */
  strikedPrice?: Maybe<Price>;
  trial: Scalars['Boolean']['output'];
}


export interface ProductPriceArgs {
  unit?: InputMaybe<ProductLengthUnit>;
}

export enum ProductCategory {
  BoostProduct = 'BoostProduct',
  MembershipProduct = 'MembershipProduct',
  UnknownProduct = 'UnknownProduct',
  UnsubscriptionFee = 'UnsubscriptionFee'
}

export interface ProductConsumable extends ProductInterface, Sluggable {
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalLabel?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lengthUnit?: Maybe<ProductLengthUnit>;
  /** Provide the price of a product with a given unit (by default the unit is the product's one) */
  price?: Maybe<Price>;
  quantity: Scalars['Int']['output'];
  slug: Scalars['ID']['output'];
  /** Not implemented yet (may be deprecated) */
  strikedPrice?: Maybe<Price>;
}


export interface ProductConsumablePriceArgs {
  unit?: InputMaybe<ProductLengthUnit>;
}

export interface ProductFilter {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ProductInput {
  priceCoefficientOverride?: InputMaybe<ProductPriceOverrideInput>;
  productId: Scalars['Int']['input'];
  remoteId: Scalars['Int']['input'];
  sourceId: Scalars['Int']['input'];
}

export interface ProductInterface {
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalLabel?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lengthUnit?: Maybe<ProductLengthUnit>;
  /** Provide the price of a product with a given unit (by default the unit is the product's one) */
  price?: Maybe<Price>;
  slug: Scalars['ID']['output'];
  /** Not implemented yet (may be deprecated) */
  strikedPrice?: Maybe<Price>;
}


export interface ProductInterfacePriceArgs {
  unit?: InputMaybe<ProductLengthUnit>;
}

export enum ProductLengthUnit {
  D = 'D',
  H = 'H',
  I = 'I',
  M = 'M',
  S = 'S',
  W = 'W',
  Y = 'Y'
}

export interface ProductMembership extends PaymentProductInterface {
  basePrice: Scalars['Int']['output'];
  coefficients?: Maybe<Array<PaymentAttributeValueCoefficient>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isTrial: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  priceOverrides?: Maybe<Array<PriceOverride>>;
  /** RRULE, FREQ=DAILY;INTERVAL=30 */
  rebillProduct?: Maybe<ProductMembership>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface ProductOther extends PaymentProductInterface {
  basePrice: Scalars['Int']['output'];
  coefficients?: Maybe<Array<PaymentAttributeValueCoefficient>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  priceOverrides?: Maybe<Array<PriceOverride>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface ProductPriceOverrideInput {
  bill: Scalars['Float']['input'];
  rebill: Scalars['Float']['input'];
}

export interface ProductQuota extends PaymentProductInterface {
  actions: Array<DatingAction>;
  basePrice: Scalars['Int']['output'];
  coefficients?: Maybe<Array<PaymentAttributeValueCoefficient>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  priceOverrides?: Maybe<Array<PriceOverride>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface ProductRebill extends ProductInterface, Sluggable {
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalLabel?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lengthUnit?: Maybe<ProductLengthUnit>;
  /** Provide the price of a product with a given unit (by default the unit is the product's one) */
  price?: Maybe<Price>;
  slug: Scalars['ID']['output'];
  /** Not implemented yet (may be deprecated) */
  strikedPrice?: Maybe<Price>;
}


export interface ProductRebillPriceArgs {
  unit?: InputMaybe<ProductLengthUnit>;
}

export enum ProductType {
  Coaching = 'COACHING',
  Dating = 'DATING'
}

export interface ProductUnsubscribeFees extends PaymentProductInterface {
  basePrice: Scalars['Int']['output'];
  coefficients?: Maybe<Array<PaymentAttributeValueCoefficient>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  priceOverrides?: Maybe<Array<PriceOverride>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface ProductWithSite {
  product: UserProduct;
  site?: Maybe<DatingOrCoachingSite>;
}

export interface ProfileInput {
  profileDataId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}

export enum ProfileTemplate {
  Criterias = 'CRITERIAS',
  Defaultphrase = 'DEFAULTPHRASE',
  Description = 'DESCRIPTION',
  Hobbies = 'HOBBIES'
}

export interface ProphecyCategory {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
}

export interface ProphecyCategoryFunnel extends Creatable, Deletable, ProphecyCategory, ProphecyTag, Sluggable {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  values: Array<ProphecyFunnel>;
}

export interface ProphecyCategoryStep extends Creatable, Deletable, ProphecyCategory, ProphecyTag, Sluggable {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  values: Array<ProphecyStep>;
}

export interface ProphecyCategoryTest extends Creatable, Deletable, ProphecyCategory, ProphecyTag, Sluggable {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  values: Array<ProphecyTest>;
}

export enum ProphecyContext {
  Dating = 'DATING',
  Payment = 'PAYMENT'
}

export interface ProphecyFunnel extends Creatable, Deletable, Sluggable {
  context: ProphecyContext;
  created: Created;
  deleted?: Maybe<Deleted>;
  /** Available only through a **TestVersion** */
  extra?: Maybe<ProphecyTestVersionHasFunnel>;
  history: Array<ProphecyFunnelVersion>;
  lastPublishedVersion?: Maybe<ProphecyFunnelVersion>;
  lastVersion: ProphecyFunnelVersion;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  tags?: Maybe<Array<ProphecyTagFunnel>>;
  testVersions: Array<ProphecyTestVersion>;
}


export interface ProphecyFunnelHistoryArgs {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
}


export interface ProphecyFunnelTestVersionsArgs {
  history?: Scalars['Boolean']['input'];
}

export interface ProphecyFunnelHasTag extends Creatable {
  created: Created;
  funnel: ProphecyFunnel;
  tag: ProphecyTagFunnel;
}

export type ProphecyFunnelOrTest = ProphecyFunnel | ProphecyTest;

export interface ProphecyFunnelVersion extends Creatable, Sluggable, Updatable {
  comment?: Maybe<Scalars['String']['output']>;
  created: Created;
  customizedWeight: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  excludedFromTests: Scalars['Boolean']['output'];
  /**
   * Deprecated, use extraConfiguration
   * @deprecated use extraConfiguration
   */
  extraConfig?: Maybe<Scalars['String']['output']>;
  extraConfiguration?: Maybe<ProphecyFunnelVersionExtraConfig>;
  funnel: ProphecyFunnel;
  mandatoryCheck: Scalars['Boolean']['output'];
  modalFunnel: Scalars['Boolean']['output'];
  /** Available only through a **Step** */
  order?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publisher?: Maybe<AdminUser>;
  rule?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
  steps: Array<ProphecyStep>;
  updated?: Maybe<Updated>;
  weight?: Maybe<Scalars['Int']['output']>;
}

export interface ProphecyFunnelVersionExtraConfig {
  raw?: Maybe<Scalars['JSON']['output']>;
}

export interface ProphecyParameter extends Creatable, Deletable, Sluggable {
  context: ProphecyContext;
  created: Created;
  deleted?: Maybe<Deleted>;
  documentation?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameterType: ProphecyParameterType;
  slug: Scalars['ID']['output'];
  stepVersions: Array<ProphecyStepVersion>;
  valueTypes: Array<ParameterHasValueType>;
}

export enum ProphecyParameterType {
  Field = 'FIELD',
  Variable = 'VARIABLE'
}

export interface ProphecyProfile extends Creatable, Sluggable, Updatable {
  created: Created;
  name: Scalars['String']['output'];
  profileDatas: Array<ProphecyProfileData>;
  slug: Scalars['ID']['output'];
  updated?: Maybe<Updated>;
}

export interface ProphecyProfileData extends Creatable, Sluggable, Updatable {
  created: Created;
  internalLabel: Scalars['String']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  updated?: Maybe<Updated>;
  /** Available only through a **Profile** */
  value?: Maybe<Scalars['String']['output']>;
}

export interface ProphecyProfileHasProfileData extends Creatable, Updatable {
  created: Created;
  profile: ProphecyProfile;
  profileData: ProphecyProfileData;
  updated?: Maybe<Updated>;
  value: Scalars['String']['output'];
}

export interface ProphecyRegistrationRedirection {
  redirectUrl: Scalars['String']['output'];
}

export type ProphecyRegistrationResult = ProphecyRegistrationRedirection | ProphecyRegistrationStepsResult;

export interface ProphecyRegistrationStepsResult {
  branchData?: Maybe<ProphecyTestVersionHasFunnel>;
  currentStep: Scalars['Int']['output'];
  funnel?: Maybe<ProphecyFunnelVersion>;
  steps: Array<ProphecyStep>;
}

export interface ProphecyRuler extends Creatable {
  created: Created;
  id: Scalars['Int']['output'];
  rule?: Maybe<Scalars['String']['output']>;
}

export interface ProphecyStep extends Creatable, Deletable, Sluggable, Updatable {
  context: ProphecyContext;
  created: Created;
  deleted?: Maybe<Deleted>;
  funnelVersions: Array<ProphecyFunnelVersion>;
  history: Array<ProphecyStepVersion>;
  lastPublishedVersion?: Maybe<ProphecyStepVersion>;
  lastVersion: ProphecyStepVersion;
  name: Scalars['String']['output'];
  /** Available only through a **FunnelVersion** */
  order?: Maybe<Scalars['Int']['output']>;
  reviewRequested: Scalars['Boolean']['output'];
  slug: Scalars['ID']['output'];
  tags: Array<ProphecyTagStep>;
  updated?: Maybe<Updated>;
}


export interface ProphecyStepFunnelVersionsArgs {
  history?: Scalars['Boolean']['input'];
}


export interface ProphecyStepHistoryArgs {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
}

export interface ProphecyStepHasTag extends Creatable {
  created?: Maybe<Created>;
  step: ProphecyStep;
  tag: ProphecyTagStep;
}

export interface ProphecyStepInput {
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  slug: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
}

export interface ProphecyStepVersion extends Creatable, Sluggable, Updatable {
  comment?: Maybe<Scalars['String']['output']>;
  created: Created;
  css?: Maybe<Scalars['String']['output']>;
  fields: Array<ProphecyParameter>;
  html?: Maybe<Scalars['String']['output']>;
  js?: Maybe<Scalars['String']['output']>;
  parameters: Array<ProphecyParameter>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publisher?: Maybe<AdminUser>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewer?: Maybe<AdminUser>;
  scss?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
  step: ProphecyStep;
  translatedHtml?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Updated>;
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  validator?: Maybe<AdminUser>;
  variables: Array<ProphecyParameter>;
}

export interface ProphecyStepVersionHasParameter extends Creatable, Deletable {
  created: Created;
  deleted?: Maybe<Deleted>;
  parameter: ProphecyParameter;
  stepVersion: ProphecyStepVersion;
}

export type ProphecySubmitResult = BooleanResult | RedirectResult;

export interface ProphecyTag {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
}

export interface ProphecyTagFunnel extends Creatable, Deletable, ProphecyTag, Sluggable {
  created: Created;
  deleted?: Maybe<Deleted>;
  funnels: Array<ProphecyFunnel>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
}

export interface ProphecyTagStep extends Creatable, Deletable, ProphecyTag, Sluggable {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  steps: Array<ProphecyStep>;
}

export interface ProphecyTagTest extends Creatable, Deletable, ProphecyTag, Sluggable {
  created: Created;
  deleted?: Maybe<Deleted>;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  tests: Array<ProphecyTest>;
}

export enum ProphecyTagType {
  Abtest = 'ABTEST',
  Funnel = 'FUNNEL',
  Step = 'STEP'
}

export interface ProphecyTest extends Deletable, Sluggable {
  context: ProphecyContext;
  deleted?: Maybe<Deleted>;
  history: Array<ProphecyTestVersion>;
  lastPublishedVersion?: Maybe<ProphecyTestVersion>;
  lastVersion: ProphecyTestVersion;
  name: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  tags?: Maybe<Array<ProphecyTagTest>>;
}


export interface ProphecyTestHistoryArgs {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
}

export interface ProphecyTestHasTag extends Creatable {
  created: Created;
  tag: ProphecyTagTest;
  test: ProphecyTest;
}

export interface ProphecyTestVersion extends Creatable, Publishable, Sluggable, Updatable {
  comment?: Maybe<Scalars['String']['output']>;
  created: Created;
  customizedWeight: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Available only through a **Funnel** */
  extra?: Maybe<ProphecyTestVersionHasFunnel>;
  funnels: Array<ProphecyFunnel>;
  published?: Maybe<Published>;
  rule?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
  test: ProphecyTest;
  updated?: Maybe<Updated>;
  weight?: Maybe<Scalars['Int']['output']>;
}

export interface ProphecyTestVersionHasFunnel {
  distribution: Scalars['Float']['output'];
  extraConfig?: Maybe<Scalars['String']['output']>;
  index: Scalars['String']['output'];
  name: Scalars['String']['output'];
  testVersionId: Scalars['Int']['output'];
}

export enum ProphecyValueType {
  Html = 'HTML',
  Js = 'JS'
}

export interface Publishable {
  published?: Maybe<Published>;
}

export interface Published {
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<AdminUser>;
}

export interface Purchase extends Sluggable {
  active: Scalars['Boolean']['output'];
  canStopRebill?: Maybe<Scalars['Boolean']['output']>;
  cancellable?: Maybe<Scalars['Boolean']['output']>;
  channelId: Scalars['Int']['output'];
  /** @deprecated Use unsubscribePeriod instead */
  disablePeriod?: Maybe<DateRange>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  enablePeriod?: Maybe<DateRange>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Price>;
  priceRebill?: Maybe<Price>;
  product?: Maybe<Product>;
  rebillable?: Maybe<Scalars['Boolean']['output']>;
  refunded?: Maybe<RefundStatus>;
  slug: Scalars['ID']['output'];
  stopRebills?: Maybe<Array<StopRebill>>;
  tag?: Maybe<PurchaseTag>;
  uhc?: Maybe<UserHasChannelInterface>;
  /** @deprecated Use unsubscribePolicyRaw instead */
  unsubscribePolicy: UnsubscribePolicy;
  unsubscribePolicyRaw?: Maybe<UnsubscribePolicyRaw>;
  userId: Scalars['Int']['output'];
}


export interface PurchaseUnsubscribePolicyArgs {
  fakeDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface PurchaseHistory {
  nextPage?: Maybe<Scalars['Int']['output']>;
  usersHistory: Array<Maybe<UserPaymentHistory>>;
}

export type PurchaseOrRebill = PaymentPurchase | PaymentRebill;

export enum PurchaseTag {
  Ended = 'ENDED',
  Premium = 'PREMIUM',
  Trial = 'TRIAL'
}

export enum PurchaseTrigger {
  Initial = 'INITIAL',
  ManualUpgrade = 'MANUAL_UPGRADE',
  Rebill = 'REBILL',
  RebillUpgrade = 'REBILL_UPGRADE'
}

export interface PurchasedItem extends HasPaymentEventInterface, Unsubscribtable {
  events?: Maybe<Array<PaymentEvent>>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  price: Price;
  product: PaymentProductInterface;
  rebillPrice?: Maybe<Price>;
  rebills?: Maybe<Array<PaymentRebill>>;
  scenario?: Maybe<PaymentUnsubscriptionScenario>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  userRemote: UserRemote;
}

export interface Query {
  Coaching: CoachingQueryNs;
  GoogleTagManager?: Maybe<QueryGoogleTagManager>;
  /** Payment namespace */
  Payment: PaymentQueryNs;
  accounting: AccountingQuery;
  /** Admin entry-point */
  admin: QueryAdmin;
  ads?: Maybe<AdItem>;
  affiliate: AffiliateQuery;
  affiliateConnectionLogs?: Maybe<AffiliateConnectionLogConnection>;
  affiliateFromToken: Affiliate;
  /** No authentication required to perform these queries */
  affiliateManager?: Maybe<AffiliateManagerQuery>;
  /** To perform these queries, you must be logged as an affiliate manager, provide a valid token in the Authorization header. It will return information about the logged affiliate manager. */
  affiliateManagerFromToken: AffiliateManager;
  biz?: Maybe<QueryBiz>;
  bizAdmin: BizAdminQuery;
  businessUnitAdminQuery: BusinessUnitAdminQuery;
  /** Retrieves a channel domain by its id. */
  channelDomain?: Maybe<ChannelDomain>;
  /** Retrieves all channel domains taking into account filters. */
  channelDomains?: Maybe<ChannelDomainConnection>;
  /** Configuration entry point */
  configuration: QueryConfiguration;
  criteria?: Maybe<Array<Criteria>>;
  /** Load criteria group for a given channel & gender With optional criterias ids */
  criteriaGroups?: Maybe<Array<CriteriaGroup>>;
  crm?: Maybe<CrmQuery>;
  /** Get default search for a webmaster */
  defaultSearch?: Maybe<Array<DefaultSearch>>;
  defaultSearchShowcaseByWebsite?: Maybe<DefaultSearchShowcase>;
  detailInputsRegister?: Maybe<Array<DetailInput>>;
  frontTranslations?: Maybe<Array<FrontTranslation>>;
  genders?: Maybe<Array<Maybe<GenderType>>>;
  /** Geoloc end point */
  geo: QueryGeo;
  /** i18n entry point */
  i18n: QueryI18n;
  invoice: InvoiceQuery;
  locationCountries?: Maybe<Array<LocationCountry>>;
  /** Get object from its slug */
  model?: Maybe<Sluggable>;
  /** Get objects from their slugs */
  models?: Maybe<Array<Sluggable>>;
  /** These queries can only be used internally */
  optionAssignmentAdminQuery: OptionAssignmentAdminQuery;
  /** These queries can only be used internally */
  optionDefinitionAdminQuery: OptionDefinitionAdminQuery;
  payment: PaymentQuery;
  /** PGA entry point */
  pga: QueryPga;
  /** Product entry-point */
  product: QueryProduct;
  /** Prophecy entry point */
  prophecy: QueryProphecy;
  /** Registration entry point */
  registration?: Maybe<RegistrationQuery>;
  ruler: RulerQuery;
  rulerFact?: Maybe<Scalars['JSON']['output']>;
  /** Return Uhc elligible for satisfaction */
  searchElligibleUserForSatisfaction?: Maybe<Array<Sluggable>>;
  /** Site entry point */
  site: QuerySite;
  siteByHost?: Maybe<Site>;
  siteInfos?: Maybe<SiteInfo>;
  siteOptionQuery: SiteOptionQuery;
  sitesByGroupId: Array<Site>;
  tags?: Maybe<TagConnection>;
  templateTypes?: Maybe<Array<TemplateType>>;
  templates?: Maybe<Array<Maybe<OfferTemplate>>>;
  /** User entry point */
  user: QueryUser;
  /** Get Node version, server instance, environment, package version and date */
  version: Scalars['String']['output'];
  versionBiz: Scalars['String']['output'];
  zodiacSigns?: Maybe<Array<Zodiac>>;
}


export interface QueryAdsArgs {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  dfptest?: InputMaybe<Scalars['Boolean']['input']>;
  genericAds?: Scalars['Boolean']['input'];
  listType?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  slot: Ads;
  sourceId?: InputMaybe<EventSource>;
}


export interface QueryAffiliateConnectionLogsArgs {
  input: InputGetAffiliateConnectionLogs;
}


export interface QueryChannelDomainArgs {
  id: Scalars['Int']['input'];
}


export interface QueryChannelDomainsArgs {
  input?: InputMaybe<InputAllChannelDomains>;
}


export interface QueryCriteriaArgs {
  internalLabels: Array<Scalars['String']['input']>;
}


export interface QueryCriteriaGroupsArgs {
  channelId: Scalars['Int']['input'];
  criteriaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  genderId: Scalars['Int']['input'];
}


export interface QueryDefaultSearchArgs {
  global?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryDefaultSearchShowcaseByWebsiteArgs {
  website: Scalars['String']['input'];
}


export interface QueryModelArgs {
  slug: Scalars['ID']['input'];
}


export interface QueryModelsArgs {
  slugs: Array<Scalars['ID']['input']>;
}


export interface QueryRulerFactArgs {
  categoryName: Scalars['String']['input'];
  facts: Scalars['JSON']['input'];
}


export interface QuerySearchElligibleUserForSatisfactionArgs {
  from?: InputMaybe<Scalars['Int']['input']>;
}


export interface QuerySiteByHostArgs {
  host: Scalars['String']['input'];
}


export interface QuerySiteInfosArgs {
  input: InputSiteInfo;
}


export interface QuerySitesByGroupIdArgs {
  groupId: Scalars['Int']['input'];
}


export interface QueryTagsArgs {
  options?: InputMaybe<PaginationOptions>;
}


export interface QueryTemplatesArgs {
  input: InputQueryTemplate;
}

export interface QueryAbTest {
  abTest?: Maybe<AbTest>;
  abTests?: Maybe<Array<AbTest>>;
}


export interface QueryAbTestAbTestArgs {
  id: Scalars['Int']['input'];
}

export interface QueryAdmin {
  abTests?: Maybe<QueryAbTest>;
  /** Get all Merchant accounts */
  accounts?: Maybe<Array<MerchantAccount>>;
  /** Get all UHC from a user id */
  allUserUHC?: Maybe<Array<UserHasChannel>>;
  /** Get all Companies */
  companies?: Maybe<Array<Company>>;
  dataloaders?: Maybe<QueryDataloaders>;
  deployEvents?: Maybe<Array<DeployEvent>>;
  getUserQuota?: Maybe<Scalars['String']['output']>;
  listActionQuota?: Maybe<Array<ActionQuota>>;
  mailHistory?: Maybe<Array<MailHistory>>;
  /** Infos about current admin */
  me?: Maybe<AdminUser>;
  /** List operators */
  operators?: Maybe<Array<AdminUser>>;
  /** Get all payment methods */
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  rebills?: Maybe<Rebill>;
  review?: Maybe<QueryReview>;
  /** Get models by a SQL query */
  searchModels?: Maybe<Array<Sluggable>>;
  token?: Maybe<Scalars['String']['output']>;
  /** Get the translated text (by google cloud translate) */
  translate?: Maybe<TranslateResult>;
  /** Get a uhc from user id and its channel id */
  userUHC?: Maybe<UserHasChannel>;
  users?: Maybe<Array<AdminUser>>;
}


export interface QueryAdminAccountsArgs {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  methodId?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryAdminAllUserUhcArgs {
  userId: Scalars['Int']['input'];
}


export interface QueryAdminDeployEventsArgs {
  isProd: Scalars['Boolean']['input'];
  range: DateRangeInput;
}


export interface QueryAdminGetUserQuotaArgs {
  user: IUserHasChannel;
}


export interface QueryAdminMailHistoryArgs {
  email: Scalars['String']['input'];
}


export interface QueryAdminReviewArgs {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  type: ReviewableObject;
}


export interface QueryAdminSearchModelsArgs {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  bind?: InputMaybe<Scalars['JSON']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  component?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  query: Scalars['String']['input'];
}


export interface QueryAdminTranslateArgs {
  text: Scalars['String']['input'];
  to: Scalars['String']['input'];
}


export interface QueryAdminUserUhcArgs {
  channelId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}

export interface QueryBiz {
  landingPage?: Maybe<QueryBizLandingPage>;
  tag?: Maybe<QueryBizTag>;
  tool?: Maybe<QueryBizTool>;
  webmaster?: Maybe<QueryWithWebmaster>;
}

export interface QueryBizLandingPage {
  byHost?: Maybe<LandingPage>;
}


export interface QueryBizLandingPageByHostArgs {
  host: Scalars['String']['input'];
}

export interface QueryBizLandingPageWithWebmaster {
  all?: Maybe<Array<Maybe<LandingPage>>>;
}


export interface QueryBizLandingPageWithWebmasterAllArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface QueryBizTag {
  all?: Maybe<Array<BizTag>>;
}

export interface QueryBizTool {
  all?: Maybe<Array<BizTool>>;
  cache?: Maybe<QueryBizToolCache>;
  config?: Maybe<QueryBizToolConfig>;
}


export interface QueryBizToolAllArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface QueryBizToolCache {
  byCacheId?: Maybe<BizToolCache>;
}


export interface QueryBizToolCacheByCacheIdArgs {
  cacheId: Scalars['Float']['input'];
}

export interface QueryBizToolConfig {
  all?: Maybe<Array<BizToolConfig>>;
  byId?: Maybe<BizToolConfig>;
  byPublicKey?: Maybe<BizToolConfig>;
}


export interface QueryBizToolConfigAllArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryBizToolConfigByIdArgs {
  id: Scalars['Int']['input'];
}


export interface QueryBizToolConfigByPublicKeyArgs {
  publicKey: Scalars['String']['input'];
}

export interface QueryConfiguration {
  /** Get all badwords for fraud (with filter available on environement and badword action id) */
  badwords?: Maybe<Array<Badword>>;
  /** Get all badwords action */
  badwordsActions?: Maybe<Array<BadwordAction>>;
  blacklistedCountries?: Maybe<Array<Country>>;
  blacklistedDomains?: Maybe<Array<BlacklistedDomain>>;
  /** Get all channels (enabled default true AND false) */
  channels?: Maybe<Array<Channel>>;
  /** Get gms calling code for all countries */
  countryCallingCodes?: Maybe<Array<CountryCallingCode>>;
  /** Get all delete reasons from dating_configuration */
  deleteReasons?: Maybe<Array<DeleteReason>>;
  /** Get a value of a dynamic configuration key */
  dynamicConfiguration?: Maybe<Scalars['String']['output']>;
  /** Get all dynamic configuration */
  dynamicConfigurations?: Maybe<Array<DynamicConfigKey>>;
  /** Get all faqFeedback */
  faqFeedback?: Maybe<Array<FaqFeedback>>;
  greylistIps?: Maybe<Array<GreylistIp>>;
  /** @deprecated Use locales instead */
  languages?: Maybe<Array<Language>>;
  /** Get all locales */
  locales?: Maybe<Array<Locale>>;
  /** Get all notifications rules presets */
  notificationsRulesPresets?: Maybe<Array<RuleSchedule>>;
  /** Get all reactions for a specific object type */
  reactions?: Maybe<Array<Reaction>>;
  /** Get all reports type (for reporting users) */
  reports?: Maybe<Array<ReportReason>>;
  rules: Rules;
  snapPreset?: Maybe<SnapPreset>;
}


export interface QueryConfigurationBadwordsArgs {
  action?: InputMaybe<Scalars['Int']['input']>;
  environment?: InputMaybe<BadwordEnvironment>;
}


export interface QueryConfigurationChannelsArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryConfigurationDynamicConfigurationArgs {
  key: Scalars['String']['input'];
}


export interface QueryConfigurationLanguagesArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryConfigurationLocalesArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryConfigurationReactionsArgs {
  objectTypeId: ObjectTypeId;
}

export interface QueryDataloaders {
  coaching?: Maybe<Array<Scalars['String']['output']>>;
  dating?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  payment?: Maybe<Array<Scalars['String']['output']>>;
}

export interface QueryGeo {
  /** Get the 7 continents */
  continents?: Maybe<Array<Continent>>;
  /** Reverse a coordinates to a location */
  coordinates?: Maybe<Geoname>;
  /** Get all countries */
  countries?: Maybe<Array<Country>>;
  /** Get a country by its iso code 2 (e.g 'FR') */
  country?: Maybe<Country>;
  /** Find the geoname of a city, administration, zipcode... */
  find?: Maybe<Array<Geoname>>;
  geoname?: Maybe<Geoname>;
  /** Find a location based on IPv4 or IPv6 */
  ip?: Maybe<Location>;
  /** Find geonames in a given radius Filtered by features code Sorted by population decsending radius in km */
  mostPopulated?: Maybe<Array<Geoname>>;
  /** Get the geoname for a given aws place id */
  placeDetails?: Maybe<Geoname>;
  /** Get suggestions from query (the beginning of a searched location) */
  typeahead?: Maybe<Array<TypeaheadResult>>;
}


export interface QueryGeoCoordinatesArgs {
  accuracy?: InputMaybe<GeoAccuracy>;
  coordinates: ICoordinates;
}


export interface QueryGeoCountryArgs {
  iso: Scalars['String']['input'];
}


export interface QueryGeoFindArgs {
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  type: GeoFindType;
}


export interface QueryGeoGeonameArgs {
  id: Scalars['Int']['input'];
}


export interface QueryGeoIpArgs {
  ip?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGeoMostPopulatedArgs {
  center: ICoordinates;
  fcodes: Array<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  population?: InputMaybe<MinMaxInt>;
  radius: Scalars['Int']['input'];
  sameCountry?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryGeoPlaceDetailsArgs {
  placeId: Scalars['ID']['input'];
}


export interface QueryGeoTypeaheadArgs {
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
}

export interface QueryGoogleTagManager {
  coachingLtr?: Maybe<Ltr>;
  id: Scalars['ID']['output'];
}


export interface QueryGoogleTagManagerCoachingLtrArgs {
  countryIso?: InputMaybe<Scalars['CountryCode']['input']>;
  nicheId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}

export interface QueryI18n {
  /** Get a translation from a french text */
  namespace?: Maybe<Scalars['JSON']['output']>;
}


export interface QueryI18nNamespaceArgs {
  language: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
}

export interface QueryPga {
  /** FAQ for PGA */
  faq?: Maybe<Array<FaqTopic>>;
  /** Requesting the 9 PGAs with the most processed payments for pgapp */
  mostProcessedPaymentsForPgapp?: Maybe<Array<Pga>>;
  /** Get orders from PGA */
  ordersByCreditCard?: Maybe<PgaOrdersResult>;
  ordersByEmail?: Maybe<PgaOrdersResult>;
  ordersByEmailAndPassword?: Maybe<PgaOrdersResult>;
  /** Requesting all PGAs. Ordered by name for pgapp */
  pgappList?: Maybe<Array<Pga>>;
}


export interface QueryPgaOrdersByCreditCardArgs {
  cardEnd: Scalars['String']['input'];
  cardStart: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  purchaseDate: Scalars['Date']['input'];
  purchasePrice: Scalars['Float']['input'];
}


export interface QueryPgaOrdersByEmailArgs {
  email: Scalars['String']['input'];
  purchaseDate: Scalars['Date']['input'];
  purchasePrice: Scalars['Float']['input'];
}


export interface QueryPgaOrdersByEmailAndPasswordArgs {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface QueryProduct {
  /** Get all products */
  products?: Maybe<Array<Product>>;
}


export interface QueryProductProductsArgs {
  filter: ProductFilter;
}

export interface QueryProphecy {
  /** Prophecy funnel entry point */
  funnel?: Maybe<QueryProphecyFunnel>;
  /** Get the registration steps for a user (to fill more informations) */
  getRegistrationSteps?: Maybe<ProphecyRegistrationResult>;
  /** Get all prophecy parameters (either field or variable) containing 'search' in their name */
  parameterSearch?: Maybe<Array<ProphecyParameter>>;
  /** Prophecy profile entry point */
  profile?: Maybe<QueryProphecyProfile>;
  /** Get a funnel that correspond to a (not registered yet) user input */
  run?: Maybe<ProphecyFunnelVersion>;
  /** Simulate which funnels would be possible from a user input */
  simulate?: Maybe<Array<ProphecyFunnelOrTest>>;
  /** Prophecy step entry point */
  step?: Maybe<QueryProphecyStep>;
  /** Prophecy tags entry point */
  tag?: Maybe<QueryProphecyTag>;
  /** Prophecy AB test entry point */
  test?: Maybe<QueryProphecyTest>;
  /** Test the validity of a user input */
  validate?: Maybe<BooleanResult>;
  /** Get ruler configuration: condition behaviors, actions, operators, variables and defaultElementValue */
  workflowConfiguration?: Maybe<Scalars['JSON']['output']>;
}


export interface QueryProphecyGetRegistrationStepsArgs {
  context: ProphecyContext;
}


export interface QueryProphecyParameterSearchArgs {
  context?: InputMaybe<ProphecyContext>;
  deleted?: Scalars['Boolean']['input'];
  parameterType?: InputMaybe<ProphecyParameterType>;
  search?: Scalars['String']['input'];
}


export interface QueryProphecyRunArgs {
  context: ProphecyContext;
  data: Scalars['JSON']['input'];
}


export interface QueryProphecySimulateArgs {
  context: ProphecyContext;
  data: Scalars['JSON']['input'];
  limit?: Scalars['Int']['input'];
  unpublished?: Scalars['Boolean']['input'];
}


export interface QueryProphecyValidateArgs {
  data: Scalars['String']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  parameter: Scalars['String']['input'];
}

export interface QueryProphecyFunnel {
  /** Get all funnels categories (tags) */
  categories?: Maybe<Array<ProphecyCategoryFunnel>>;
  /** Get all funnel containing 'search' param in their name */
  search?: Maybe<Array<ProphecyFunnel>>;
  /** Get all funnel without categories (tags) */
  uncategorized?: Maybe<Array<ProphecyFunnel>>;
}


export interface QueryProphecyFunnelSearchArgs {
  context?: InputMaybe<ProphecyContext>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
  search: Scalars['String']['input'];
}


export interface QueryProphecyFunnelUncategorizedArgs {
  context?: InputMaybe<ProphecyContext>;
}

export interface QueryProphecyProfile {
  /** Get all profile data */
  dataList?: Maybe<Array<ProphecyProfileData>>;
  /** Get all tag of tagType containing 'search' param in their names */
  search?: Maybe<Array<ProphecyProfile>>;
}


export interface QueryProphecyProfileSearchArgs {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
  search?: Scalars['String']['input'];
}

export interface QueryProphecyStep {
  /** Get all steps categories (tags) */
  categories?: Maybe<Array<ProphecyCategoryStep>>;
  /** Get all steps containing 'search' param in their name */
  search?: Maybe<Array<ProphecyStep>>;
  /** Get all steps without categories (tags) */
  uncategorized?: Maybe<Array<ProphecyStep>>;
}


export interface QueryProphecyStepSearchArgs {
  context?: InputMaybe<ProphecyContext>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
  search: Scalars['String']['input'];
}


export interface QueryProphecyStepUncategorizedArgs {
  context?: InputMaybe<ProphecyContext>;
}

export interface QueryProphecyTag {
  /** Get all tag of tagType containing 'search' param in their names */
  search?: Maybe<Array<ProphecyTag>>;
}


export interface QueryProphecyTagSearchArgs {
  search?: Scalars['String']['input'];
  tagType: ProphecyTagType;
}

export interface QueryProphecyTest {
  /** Get all AB test categories (tags) */
  categories?: Maybe<Array<ProphecyCategoryTest>>;
  /** Get all AB test containing 'search' param in their name */
  search?: Maybe<Array<ProphecyTest>>;
  /** Get all AB test without categories (tags) */
  uncategorized?: Maybe<Array<ProphecyTest>>;
}


export interface QueryProphecyTestSearchArgs {
  context?: InputMaybe<ProphecyContext>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: Scalars['String']['input'];
  search: Scalars['String']['input'];
}


export interface QueryProphecyTestUncategorizedArgs {
  context?: InputMaybe<ProphecyContext>;
}

export interface QueryReview {
  left?: Maybe<Scalars['Int']['output']>;
}

export interface QuerySite {
  portalRedirects?: Maybe<Array<PortalRedirect>>;
  upsell?: Maybe<Array<Upsell>>;
}


export interface QuerySiteUpsellArgs {
  hosts: Array<Scalars['String']['input']>;
}

export interface QueryUhcSearch {
  /** Get list of user's searched criteria value */
  criteriaValue?: Maybe<Array<CriteriaValue>>;
  /** Get default search for user: age -10/+10 from user's age, location from user current location if user don't have UserSearchLocation (does NOT save the search into user searches) */
  default?: Maybe<SearchResultFull>;
  /** Get user search location */
  location?: Maybe<UserSearchLocation>;
  /** Get searchable gender list based on user gender and channel */
  searcheableGender: Array<GenderModel>;
  /** Get list of user's searches */
  searches?: Maybe<Array<UserSearch>>;
  /** Speedflirt users to review matching: use new matching system */
  speedflirt?: Maybe<Array<SpeedflirtList>>;
}


export interface QueryUhcSearchDefaultArgs {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<DefaultSearchFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSort>>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
  withAddons?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryUhcSearchSpeedflirtArgs {
  allowNoPicture?: InputMaybe<Scalars['Boolean']['input']>;
  alreadyLoaded?: InputMaybe<Array<Scalars['Int']['input']>>;
  availabilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hobbyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matching?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipTagId?: InputMaybe<RelationshipTagValue>;
  sort?: InputMaybe<SpeedflirtSort>;
  zodiacs?: InputMaybe<Array<ZodiacSign>>;
}

/** Contains queries related to users */
export interface QueryUser {
  /** Get number of created users for a channel, if no channelId is given, will count all users */
  count?: Maybe<Scalars['Int']['output']>;
  /** Current user's device infos */
  currentUsedDevice?: Maybe<CurrentDevice>;
  /** Requesting currently authentified user */
  me?: Maybe<UserHasChannel>;
  /** Searching users */
  search?: Maybe<SearchResult>;
  /** Snap entry point to get other user's snaps */
  snap?: Maybe<SnapQuery>;
  /** Request uhc list */
  userHasChannels?: Maybe<Array<UserHasChannelInterface>>;
}


/** Contains queries related to users */
export interface QueryUserCountArgs {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<IntervalUhc>;
}


/** Contains queries related to users */
export interface QueryUserSearchArgs {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  filter: UserFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSort>>;
}


/** Contains queries related to users */
export interface QueryUserUserHasChannelsArgs {
  users: Array<IUserHasChannel>;
}

export interface QueryWithWebmaster {
  landingPage?: Maybe<QueryBizLandingPageWithWebmaster>;
}

export interface RateLimitingConfig {
  fromConfig?: InputMaybe<RateLimitingConfigKey>;
  fromParam: Scalars['String']['input'];
}

/** Rate limiting directive for GraphQL fields. period: The time period in seconds for which the rate limit is applied. limit: The maximum number of requests that can be made in the given period. key: An array of strings that are used to identify the rate limit. A string starting with $ refers to an input to the field, key always include the field name & the userId/channelId. Warning: A user can exceed the rate limit if they make requests between periods. For example, if the period is 30 seconds and the limit is 1, a user can make a request at T+29 and another at T+31 */
export enum RateLimitingConfigKey {
  AfkLayer = 'AFK_LAYER',
  OctopusAdsSfTracking = 'OCTOPUS_ADS_SF_TRACKING'
}

export interface RawDateRange {
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
}

export interface Reactable {
  /** Give array of user who liked with pagination If no reaction is provided, return legacy likes */
  likedBy?: Maybe<PaginationConnection>;
  /** Give reactions done by user */
  myReactions?: Maybe<Array<Reaction>>;
  /** Give number of reaction for each reaction type */
  reactions?: Maybe<Array<ReactionLikes>>;
}


export interface ReactableLikedByArgs {
  options?: InputMaybe<PaginationOptions>;
  reaction?: InputMaybe<Scalars['Int']['input']>;
}

export interface Reaction {
  /** The reaction label, host is optional and will be computed based on the host of the request if not provided */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
}


export interface ReactionIconArgs {
  host?: InputMaybe<Scalars['String']['input']>;
}

export interface ReactionLikes {
  count: Scalars['Int']['output'];
  reaction: Reaction;
}

export enum Reason {
  CpgCode = 'CPG_CODE',
  SupportFormRetract = 'SUPPORT_FORM_RETRACT',
  SupportFraudOnline = 'SUPPORT_FRAUD_ONLINE',
  SupportFree = 'SUPPORT_FREE',
  SupportMineur = 'SUPPORT_MINEUR',
  TransactionExpired = 'TRANSACTION_EXPIRED',
  TransactionExpiredFailed = 'TRANSACTION_EXPIRED_FAILED'
}

export interface Rebill {
  done?: Maybe<Array<RebillOrder>>;
  income?: Maybe<Array<Maybe<RebillOrder>>>;
}

export interface RebillOrder {
  lastTry?: Maybe<Scalars['DateTime']['output']>;
  nextTry?: Maybe<Scalars['DateTime']['output']>;
  order?: Maybe<Order>;
  status?: Maybe<Scalars['String']['output']>;
}

export enum RebillStatus {
  Active = 'ACTIVE',
  Stopped = 'STOPPED'
}

export interface RedirectResult {
  errors?: Maybe<Array<CustomError>>;
  redirect: Scalars['URL']['output'];
}

export enum RedisServerEnum {
  Redis = 'REDIS'
}

export interface RefundStatus {
  date?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Boolean']['output'];
}

export interface Refundable {
  refundable: Scalars['Boolean']['output'];
}

export interface Regex {
  description: Scalars['String']['output'];
  highlightDescription?: Maybe<Scalars['String']['output']>;
  regex: Scalars['String']['output'];
}

export interface RegisterInternalInput {
  bannerIdUpsell?: InputMaybe<Scalars['Int']['input']>;
  device?: InputMaybe<DeviceInput>;
  displayId?: InputMaybe<Scalars['Int']['input']>;
  nameUpsell?: InputMaybe<Scalars['String']['input']>;
  paymentKey?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  showcaseId: Scalars['Int']['input'];
  slotUpsell?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<RegistrationSource>;
  typeUpsell?: InputMaybe<AdsType>;
}

export interface RegisteredSiteExternal extends RegistrationSite {
  backgroundCard: Scalars['URL']['output'];
  backgroundDetails: Scalars['URL']['output'];
  connectionLink?: Maybe<Scalars['URL']['output']>;
  host: Scalars['String']['output'];
  key: Scalars['String']['output'];
  logo: Scalars['URL']['output'];
  logoCard: Scalars['URL']['output'];
  mediaLabel: Scalars['String']['output'];
  miniLogo: Scalars['URL']['output'];
  platformCategory?: Maybe<PlatformCat>;
  title: Scalars['String']['output'];
}

export interface RegisteredSiteInternal extends RegistrationSite {
  backgroundCard: Scalars['URL']['output'];
  backgroundDetails: Scalars['URL']['output'];
  backgroundPreview: Scalars['URL']['output'];
  channel: Channel;
  connectionLink: Scalars['URL']['output'];
  host: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logo: Scalars['URL']['output'];
  logoCard: Scalars['URL']['output'];
  /** Old backgroundImg */
  mediaLabel: Scalars['String']['output'];
  miniLogo: Scalars['URL']['output'];
  title: Scalars['String']['output'];
  unreadMessage: Scalars['Int']['output'];
  url: Scalars['URL']['output'];
}

export interface RegistrationMutation {
  /** Cross registration (call fusion) slot and name are for internal upsell */
  crossSite?: Maybe<Scalars['JSON']['output']>;
  registerInternal?: Maybe<InternalRegistrationResponse>;
  validateRegistration?: Maybe<Scalars['URL']['output']>;
}


export interface RegistrationMutationCrossSiteArgs {
  bannerIdUpsell?: InputMaybe<Scalars['Int']['input']>;
  nameUpsell?: InputMaybe<Scalars['String']['input']>;
  slotUpsell?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<RegistrationSource>;
  sourceLink?: InputMaybe<Scalars['Int']['input']>;
  typeUpsell?: InputMaybe<AdsType>;
  url: Scalars['String']['input'];
}


export interface RegistrationMutationRegisterInternalArgs {
  input: RegisterInternalInput;
}

export interface RegistrationProgression {
  redirectTo: Scalars['URL']['output'];
  registrationStatus: RegistrationStatus;
}

export interface RegistrationQuery {
  /** Get the list of registered external sites (return all types if no types are specified) */
  registeredExternal: Array<RegisteredSiteExternal>;
  registeredInternal: Array<RegisteredSiteInternal>;
  /** Get the list of unregistered sites (for externals, return all types if no types are specified) */
  unregisteredSites: Array<UnregisteredSite>;
}


export interface RegistrationQueryRegisteredExternalArgs {
  externalTypes?: InputMaybe<Array<PlatformCat>>;
}


export interface RegistrationQueryUnregisteredSitesArgs {
  externalTypes?: InputMaybe<Array<PlatformCat>>;
}

export interface RegistrationSite {
  backgroundCard: Scalars['URL']['output'];
  backgroundDetails: Scalars['URL']['output'];
  host: Scalars['String']['output'];
  logo: Scalars['URL']['output'];
  logoCard: Scalars['URL']['output'];
  mediaLabel: Scalars['String']['output'];
  miniLogo: Scalars['URL']['output'];
  title: Scalars['String']['output'];
}

export enum RegistrationSource {
  ApiPremium = 'API_PREMIUM',
  AppAndroid = 'APP_ANDROID',
  AppIos = 'APP_IOS',
  CoregBatch = 'COREG_BATCH',
  CoregLive = 'COREG_LIVE',
  CrossMailing = 'CROSS_MAILING',
  CrossRegister = 'CROSS_REGISTER',
  CrossRegistrationDesktop = 'CROSS_REGISTRATION_DESKTOP',
  CrossRegistrationMobile = 'CROSS_REGISTRATION_MOBILE',
  CrossRegistrationSpeedflirtLayer = 'CROSS_REGISTRATION_SPEEDFLIRT_LAYER',
  Datacollect = 'DATACOLLECT',
  Destidyll = 'DESTIDYLL',
  FormMatch = 'FORM_MATCH',
  FormRsipa = 'FORM_RSIPA',
  FormV4 = 'FORM_V4',
  FormV5 = 'FORM_V5',
  FormV5Mobile = 'FORM_V5_MOBILE',
  FormV5Slide = 'FORM_V5_SLIDE',
  FormV5SlideMobile = 'FORM_V5_SLIDE_MOBILE',
  InternalApiDesktop = 'INTERNAL_API_DESKTOP',
  InternalApiMobile = 'INTERNAL_API_MOBILE',
  MobileApp = 'MOBILE_APP',
  MobileSite = 'MOBILE_SITE',
  MultiStep = 'MULTI_STEP',
  MultiStepMobile = 'MULTI_STEP_MOBILE',
  NodeApi = 'NODE_API',
  NodeApiPremium = 'NODE_API_PREMIUM',
  PromotoolsCarbon = 'PROMOTOOLS_CARBON',
  PromotoolsCarbonMobile = 'PROMOTOOLS_CARBON_MOBILE',
  PromotoolsContact = 'PROMOTOOLS_CONTACT',
  PromotoolsContactMobile = 'PROMOTOOLS_CONTACT_MOBILE',
  PromotoolsDefault = 'PROMOTOOLS_DEFAULT',
  PromotoolsDefaultMobile = 'PROMOTOOLS_DEFAULT_MOBILE',
  PromotoolsGold = 'PROMOTOOLS_GOLD',
  PromotoolsGoldMobile = 'PROMOTOOLS_GOLD_MOBILE',
  PromotoolsGoogleButton = 'PROMOTOOLS_GOOGLE_BUTTON',
  PromotoolsGoogleButtonMobile = 'PROMOTOOLS_GOOGLE_BUTTON_MOBILE',
  PromotoolsGranite = 'PROMOTOOLS_GRANITE',
  PromotoolsGraniteMobile = 'PROMOTOOLS_GRANITE_MOBILE',
  PromotoolsIron = 'PROMOTOOLS_IRON',
  PromotoolsIronMobile = 'PROMOTOOLS_IRON_MOBILE',
  PromotoolsOsmium = 'PROMOTOOLS_OSMIUM',
  PromotoolsOsmiumMobile = 'PROMOTOOLS_OSMIUM_MOBILE',
  PromotoolsPlutonium = 'PROMOTOOLS_PLUTONIUM',
  PromotoolsPlutoniumMobile = 'PROMOTOOLS_PLUTONIUM_MOBILE',
  PromotoolsSilver = 'PROMOTOOLS_SILVER',
  PromotoolsSilverMobile = 'PROMOTOOLS_SILVER_MOBILE',
  PromotoolsTitanium = 'PROMOTOOLS_TITANIUM',
  PromotoolsTitaniumMobile = 'PROMOTOOLS_TITANIUM_MOBILE',
  RegTeaser = 'REG_TEASER',
  RegVanilla = 'REG_VANILLA',
  SourceRegDesktop = 'SOURCE_REG_DESKTOP',
  SourceRegMobile = 'SOURCE_REG_MOBILE',
  SwitchApiPremium = 'SWITCH_API_PREMIUM',
  SwitchFallback = 'SWITCH_FALLBACK',
  SwitchFallbackMobile = 'SWITCH_FALLBACK_MOBILE',
  SwitchFormV5 = 'SWITCH_FORM_V5',
  SwitchFormV5Mobile = 'SWITCH_FORM_V5_MOBILE',
  SwitchFormV6 = 'SWITCH_FORM_V6',
  SwitchFormV6Mobile = 'SWITCH_FORM_V6_MOBILE',
  SwitchPromotoolsGoogleButton = 'SWITCH_PROMOTOOLS_GOOGLE_BUTTON',
  SwitchPromotoolsGoogleButtonMobile = 'SWITCH_PROMOTOOLS_GOOGLE_BUTTON_MOBILE',
  SwitchRsipa = 'SWITCH_RSIPA',
  SwitchRsipaMobile = 'SWITCH_RSIPA_MOBILE',
  Upsell = 'UPSELL',
  UpsellDesktopSubscriber = 'UPSELL_DESKTOP_SUBSCRIBER',
  UpsellDesktopUnsubscribe = 'UPSELL_DESKTOP_UNSUBSCRIBE',
  UpsellMobileSubscriber = 'UPSELL_MOBILE_SUBSCRIBER',
  UpsellMobileUnsubscribe = 'UPSELL_MOBILE_UNSUBSCRIBE',
  UpsellPayment = 'UPSELL_PAYMENT',
  UpsellRotator = 'UPSELL_ROTATOR',
  UpsellUnsubscription = 'UPSELL_UNSUBSCRIPTION',
  VisionDesktop = 'VISION_DESKTOP',
  VisionMobile = 'VISION_MOBILE',
  WhiteLabel = 'WHITE_LABEL'
}

export enum RegistrationStatus {
  Done = 'DONE',
  Prophecy = 'PROPHECY',
  Start = 'START'
}

export interface RelationshipTag extends IRelationshipTag {
  background: Scalars['URL']['output'];
  /** @deprecated use iconUrl instead */
  icon: Scalars['String']['output'];
  iconUrl: Scalars['URL']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelShort: Scalars['String']['output'];
}

export enum RelationshipTagValue {
  Hard = 'HARD',
  Sexy = 'SEXY',
  Soft = 'SOFT'
}

export interface RemainingSubscription {
  appStorePurchases?: Maybe<Array<Maybe<Purchase>>>;
}

export interface RemoveResponse {
  value: Scalars['Boolean']['output'];
}

export interface Report extends Sluggable {
  abuseType?: Maybe<AbuseType>;
  from: UserHasChannelInterface;
  slug: Scalars['ID']['output'];
  to: UserHasChannelInterface;
}

export interface ReportReason {
  label: Scalars['String']['output'];
  type: ReportType;
}

export enum ReportType {
  Ads = 'ADS',
  Boring = 'BORING',
  FakePhoto = 'FAKE_PHOTO',
  Language = 'LANGUAGE',
  Spam = 'SPAM',
  SpamTchat = 'SPAM_TCHAT',
  Underage = 'UNDERAGE',
  WrongGender = 'WRONG_GENDER'
}

export interface Reportable {
  report?: Maybe<Scalars['Boolean']['output']>;
}


export interface ReportableReportArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: ReportType;
}

export interface RequestPaymentAdminInput {
  affiliateId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['Int']['input'];
}

export interface RequestPaymentError extends Error {
  message: Scalars['String']['output'];
}

export interface RequestPaymentInput {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['Int']['input'];
}

export type RequestPaymentResponse = PendingPayment | RequestPaymentError;

export enum RetractionRenunciationSource {
  AcceptedRetractionRenunciationPayment = 'ACCEPTED_RETRACTION_RENUNCIATION_PAYMENT',
  AcceptedRetractionRenunciationVision = 'ACCEPTED_RETRACTION_RENUNCIATION_VISION'
}

export enum ReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export interface Reviewable {
  rejectedReason?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Reviewed>;
  slug: Scalars['ID']['output'];
}

export enum ReviewableObject {
  Description = 'DESCRIPTION',
  Picture = 'PICTURE',
  Snap = 'SNAP'
}

export interface Reviewed {
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<AdminUser>;
  status?: Maybe<ReviewStatus>;
}

export enum RevokeActionModel {
  Extra = 'extra',
  Purchase = 'purchase'
}

export enum RevokeMembershipModel {
  Membership = 'membership',
  Purchase = 'purchase'
}

export interface Reward {
  pool: Array<GamificationRewardItemType>;
  won: Array<GamificationRewardItemType>;
}

export interface RewardEvent {
  eventType: GamificationEventType;
  reward?: Maybe<Reward>;
}

export interface Rule {
  admin?: Maybe<AdminUser>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  group: RuleGroup;
  history?: Maybe<Array<Rule>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  resultIfTrue: Scalars['String']['output'];
  rule?: Maybe<Scalars['TopLevelCondition']['output']>;
  startAt: Scalars['DateTime']['output'];
}

export interface RuleEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Rule>;
}

export interface RuleGroup {
  catType: Scalars['String']['output'];
  checkRule?: Maybe<BooleanResult>;
  company?: Maybe<Company>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Scalars['String']['output']>>;
  resultsFromUserId?: Maybe<Array<Scalars['String']['output']>>;
  rules?: Maybe<Array<Rule>>;
  variables?: Maybe<Array<RulerVariable>>;
}


export interface RuleGroupCheckRuleArgs {
  rule: Scalars['String']['input'];
}


export interface RuleGroupDetailsArgs {
  channelId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}


export interface RuleGroupResultsArgs {
  facts: Scalars['JSON']['input'];
}


export interface RuleGroupResultsFromUserIdArgs {
  channelId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}


export interface RuleGroupRulesArgs {
  withEndedRules?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface RuleList extends PaginationConnection {
  edges?: Maybe<Array<RuleEdge>>;
  pageInfo?: Maybe<PageInfoNext>;
  totalCount: Scalars['Int']['output'];
}

export interface RuleSchedule {
  label?: Maybe<Scalars['String']['output']>;
  preset: Scalars['Boolean']['output'];
  rule: Scalars['RRule']['output'];
}

export enum RulerCategoryType {
  Cgu = 'CGU',
  Coaching = 'Coaching',
  Dating = 'Dating',
  Mail = 'Mail',
  Payment = 'Payment'
}

export interface RulerMutation {
  addVariableToGroup?: Maybe<Scalars['Boolean']['output']>;
  createGroup?: Maybe<RuleGroup>;
  createRule?: Maybe<Rule>;
  createVariable?: Maybe<RulerVariable>;
  deleteRule?: Maybe<Scalars['Boolean']['output']>;
  deleteVariable?: Maybe<Scalars['Boolean']['output']>;
  editRule?: Maybe<Scalars['Boolean']['output']>;
  editVariable?: Maybe<Scalars['Boolean']['output']>;
  endRule?: Maybe<Scalars['Boolean']['output']>;
  removeVariableFromGroup?: Maybe<Scalars['Boolean']['output']>;
}


export interface RulerMutationAddVariableToGroupArgs {
  groupId: Scalars['Int']['input'];
  variableId: Scalars['Int']['input'];
}


export interface RulerMutationCreateGroupArgs {
  catType: RulerCategoryType;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  defaultResult?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}


export interface RulerMutationCreateRuleArgs {
  categoryId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  resultIfTrue?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['TopLevelCondition']['input']>;
}


export interface RulerMutationCreateVariableArgs {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  varType: RulerVariableType;
}


export interface RulerMutationDeleteRuleArgs {
  ruleId: Scalars['Int']['input'];
}


export interface RulerMutationDeleteVariableArgs {
  id: Scalars['Int']['input'];
}


export interface RulerMutationEditRuleArgs {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  resultIfTrue: Scalars['String']['input'];
  rule: Scalars['TopLevelCondition']['input'];
  ruleId: Scalars['Int']['input'];
}


export interface RulerMutationEditVariableArgs {
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}


export interface RulerMutationEndRuleArgs {
  reactivate?: InputMaybe<Scalars['Boolean']['input']>;
  ruleId: Scalars['Int']['input'];
}


export interface RulerMutationRemoveVariableFromGroupArgs {
  groupId: Scalars['Int']['input'];
  variableId: Scalars['Int']['input'];
}

export interface RulerQuery {
  group: RuleGroup;
  groups?: Maybe<Array<RuleGroup>>;
  operators?: Maybe<Array<Operators>>;
  recentChanges?: Maybe<RuleList>;
  rule: Rule;
  variables?: Maybe<Array<RulerVariable>>;
}


export interface RulerQueryGroupArgs {
  id: Scalars['Int']['input'];
}


export interface RulerQueryGroupsArgs {
  companyId?: InputMaybe<Scalars['Int']['input']>;
}


export interface RulerQueryRecentChangesArgs {
  options?: InputMaybe<PaginationOptions>;
}


export interface RulerQueryRuleArgs {
  id: Scalars['Int']['input'];
}

export interface RulerVariable {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  varType: RulerVariableType;
}

export enum RulerVariableType {
  Array = 'ARRAY',
  Bool = 'BOOL',
  Date = 'DATE',
  Int = 'INT',
  String = 'STRING'
}

export interface Rules {
  descriptionRules?: Maybe<Array<Regex>>;
  displayNameRules?: Maybe<Array<Regex>>;
  emailRules?: Maybe<Array<Regex>>;
  passwordRules?: Maybe<Array<Regex>>;
}

export enum Safemode {
  Disabled = 'DISABLED',
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2'
}

export enum ScenarioType {
  Disabled = 'Disabled',
  Easy = 'Easy',
  ExternalUnsubscription = 'ExternalUnsubscription',
  ProcessingDate = 'ProcessingDate',
  ProcessingStart = 'ProcessingStart'
}

export interface SearchResult {
  edges?: Maybe<Array<UserSearchDocument>>;
  pageInfo: PageInfo;
}

export interface SearchResultFull {
  edges?: Maybe<Array<UserSearchResult>>;
  pageInfo: PageInfo;
}

export interface SendNewsletterInput {
  /** The affiliate ids to send the newsletter to If not provided, the newsletter will be sent to all affiliates with newsletter enabled */
  affiliateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Set a specific delay to raven */
  delay?: InputMaybe<Scalars['Int']['input']>;
  /** The affiliate email to send the newsletter to If not provided, the newsletter will be sent to all affiliates with newsletter enabled */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Send newsletter to affiliates who speak these languages If not provided, the newsletter will be sent in all languages */
  languageCode?: InputMaybe<Array<ActiveLanguage>>;
  /** Activated sample mode will send the newsletter to a specified affiliates in 5 languages we must specify the affiliates to send the newsletter to */
  sample?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum SexDefaultSearch {
  Female = 'FEMALE',
  Male = 'MALE'
}

export interface Shadowban {
  at: Scalars['DateTime']['output'];
  by: AdminUser;
  reason: ShadowbanReason;
}

export interface ShadowbanReason {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface SignInBizResult extends SignInSucceed {
  token?: Maybe<Token>;
}

export interface SignInError extends Error, SignInFailed {
  message: Scalars['String']['output'];
}

export interface SignInFailed {
  message: Scalars['String']['output'];
}

export interface SignInFlApiResult {
  flApiAccessToken: Scalars['String']['output'];
  signInResult: SignInBizResult;
}

export type SignInResponse = SignInBizResult | SignInError;

export interface SignInResult {
  errors?: Maybe<Array<DefaultError>>;
  /** Used in case of an external signup */
  external?: Maybe<ExternalSignInResult>;
  token?: Maybe<Token>;
  /** Front end url to redirect to */
  url?: Maybe<Scalars['URL']['output']>;
  user?: Maybe<UserHasChannel>;
}


export interface SignInResultUrlArgs {
  overrideHost?: InputMaybe<Scalars['String']['input']>;
  overrideSiteId?: InputMaybe<Scalars['Int']['input']>;
}

export interface SignInSucceed {
  token?: Maybe<Token>;
}

export interface SignUpError extends Error, SignInFailed {
  message: Scalars['String']['output'];
}

export type SignUpResponse = SignInBizResult | SignUpError;

export interface SimulationResult {
  base_price: Scalars['Int']['output'];
  coefficients: Array<Scalars['Float']['output']>;
  no_override_price: Scalars['Int']['output'];
  override?: Maybe<PriceOverride>;
  product: PaymentProductInterface;
  valuesLabels?: Maybe<Array<Scalars['String']['output']>>;
}

export interface SingleHeightWeight {
  height?: Maybe<Scalars['Int']['output']>;
  sex: Sex;
  weight?: Maybe<Scalars['Int']['output']>;
}

export type SingleRowAction = CtaBtn | IconFeed;

export interface Site extends Sluggable, WithTermsOfService {
  affiliate: Affiliate;
  alias: Scalars['String']['output'];
  channelDomain: ChannelDomain;
  /** Return site url */
  clickTag?: Maybe<ClickTag>;
  company?: Maybe<Company>;
  cssUrl?: Maybe<Scalars['URL']['output']>;
  defaultSearchShowcase?: Maybe<DefaultSearchShowcase>;
  facebookApplication?: Maybe<FacebookApplication>;
  facebookUri?: Maybe<Scalars['URL']['output']>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  landing?: Maybe<Scalars['URL']['output']>;
  /** landing media */
  landingMedia: Array<LandingMediaChannel>;
  logo?: Maybe<SiteLogo>;
  /** Get all site options or specific one from the filter */
  options?: Maybe<Array<SiteOptions>>;
  publicLogoUrl: Scalars['URL']['output'];
  /** Get site niche type (love, sexy, gay...) */
  registrationNiche: Scalars['String']['output'];
  returnPath?: Maybe<SiteHasReturnpath>;
  showCookies: Scalars['Boolean']['output'];
  siteInternal?: Maybe<RegisteredSiteInternal>;
  slug: Scalars['ID']['output'];
  style?: Maybe<Style>;
  termsOfService?: Maybe<Scalars['Markdown']['output']>;
  termsOfServiceHTML?: Maybe<Scalars['HTML']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  webmaster?: Maybe<Webmaster>;
}


export interface SiteLandingMediaArgs {
  tpl?: InputMaybe<Scalars['String']['input']>;
}


export interface SiteOptionsArgs {
  filter?: InputMaybe<SiteOptionFilter>;
}


export interface SiteTermsOfServiceArgs {
  type: TermsOfServiceType;
}


export interface SiteTermsOfServiceHtmlArgs {
  type: TermsOfServiceType;
}

export interface SiteEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Site>;
}

export interface SiteHasReturnpath {
  companyName?: Maybe<Scalars['String']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
}

export interface SiteInfo {
  affiliateId?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  siteGroupId?: Maybe<Scalars['Int']['output']>;
  siteId?: Maybe<Scalars['Int']['output']>;
}

export interface SiteList extends PaginationConnection {
  edges?: Maybe<Array<SiteEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface SiteLogo {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  url: Scalars['URL']['output'];
  webmaster?: Maybe<Webmaster>;
}

export interface SiteOption {
  option: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface SiteOptionFilter {
  internalLabel: Scalars['String']['input'];
}

export interface SiteOptionQuery {
  /** For the given site, return the list of options and their values. This should be freely available (by example, on landing page) */
  siteOptions: Array<Maybe<SiteOption>>;
}


export interface SiteOptionQuerySiteOptionsArgs {
  siteID: Scalars['Int']['input'];
}

export interface SiteOptions {
  internalLabel: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
}

export interface SiteStyle {
  colorMode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  primaryColor: Scalars['String']['output'];
}

export interface Sluggable {
  slug: Scalars['ID']['output'];
}

export interface Snap extends BelongsToUhc, Commentable, Reactable, Reviewable, Sluggable, WithCreatedAt, WithRating {
  comments?: Maybe<CommentConnection>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Seconds allowed to see the snap for user */
  duration: Scalars['Int']['output'];
  labelStatus?: Maybe<ReviewStatus>;
  likedBy?: Maybe<SnapLikeConnection>;
  media: SnapMediaInterface;
  /** @deprecated use media */
  medias?: Maybe<Array<SnapMedia>>;
  myReactions?: Maybe<Array<Reaction>>;
  nbLikes?: Maybe<Scalars['Int']['output']>;
  nbViews?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<UserHasChannelInterface>;
  popularity?: Maybe<Scalars['Float']['output']>;
  rating: MediaRating;
  reactions?: Maybe<Array<ReactionLikes>>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Reviewed>;
  slug: Scalars['ID']['output'];
  style?: Maybe<SnapStyle>;
  /** @deprecated use thumbnailURL */
  thumbnail?: Maybe<PictureSrcSet>;
  thumbnailURL?: Maybe<Scalars['URL']['output']>;
  transferredToPicture?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserHasChannelInterface>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
}


export interface SnapCommentsArgs {
  options?: InputMaybe<PaginationOptions>;
}


export interface SnapLikedByArgs {
  options?: InputMaybe<PaginationOptions>;
  reaction?: InputMaybe<Scalars['Int']['input']>;
}


export interface SnapThumbnailArgs {
  size?: InputMaybe<Scalars['Int']['input']>;
}


export interface SnapThumbnailUrlArgs {
  blurred?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface SnapEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  snap: Snap;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
}


export interface SnapEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export enum SnapFilter {
  Filter_1977 = 'FILTER_1977',
  FilterEarlybird = 'FILTER_EARLYBIRD',
  FilterHudson = 'FILTER_HUDSON',
  FilterInkwell = 'FILTER_INKWELL',
  FilterMayfair = 'FILTER_MAYFAIR',
  FilterReyes = 'FILTER_REYES'
}

export enum SnapFont {
  Lobster = 'LOBSTER',
  OpenSans = 'OPEN_SANS',
  OpenSansBold = 'OPEN_SANS_BOLD'
}

export interface SnapLikeConnection extends PaginationConnection {
  edges?: Maybe<Array<SnapLikeEdge>>;
  pageInfo?: Maybe<PageInfoNext>;
  /** @deprecated Also count shadowban, use `nbLikes` instead. */
  totalCount: Scalars['Int']['output'];
}

export interface SnapLikeEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<UserEvent>;
}

export interface SnapLikeEvent extends InteractionEvent, ListEvent, ListViewableEvent, Sluggable, SnapEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  slug: Scalars['ID']['output'];
  snap: Snap;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface SnapLikeEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export type SnapList = AdItem | Snap;

export interface SnapMedia {
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['URL']['output']>;
}

export interface SnapMediaInterface {
  url?: Maybe<Scalars['URL']['output']>;
}

export interface SnapMediaPicture extends SnapMediaInterface {
  url?: Maybe<Scalars['URL']['output']>;
}

export interface SnapMediaVideo extends SnapMediaInterface {
  url?: Maybe<Scalars['URL']['output']>;
}

export interface SnapPreset {
  defaultFont: SnapFont;
  defaultPositionX: Scalars['Int']['output'];
  defaultPositionY: Scalars['Int']['output'];
  defaultTextBackground: Scalars['String']['output'];
  defaultTextColor: Scalars['String']['output'];
  defaultTextSize: Scalars['Int']['output'];
  positionXLimit: PositionLimit;
  positionYLimit: PositionLimit;
  snapFilters: Array<Scalars['String']['output']>;
  snapFonts: Array<Scalars['String']['output']>;
  snapTextColors: Array<Scalars['String']['output']>;
}

export interface SnapQuery {
  /** Get list of new snaps available to watch */
  list?: Maybe<Array<SnapList>>;
  /** Get number of new snaps available to watch */
  new?: Maybe<Scalars['Int']['output']>;
}


export interface SnapQueryListArgs {
  limit: Scalars['Int']['input'];
}

export interface SnapStyle {
  filter?: Maybe<SnapFilter>;
  font?: Maybe<SnapFont>;
  positionX?: Maybe<Scalars['Int']['output']>;
  positionY?: Maybe<Scalars['Int']['output']>;
  textBackground?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  textSize?: Maybe<Scalars['Int']['output']>;
}

export interface SnapViewEvent extends ListEvent, SnapEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  snap: Snap;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
}


export interface SnapViewEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export interface Source {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface Speedflirt {
  createdAt: Scalars['DateTime']['output'];
  type: SpeedflirtType;
}

export enum SpeedflirtAction {
  Back = 'BACK',
  No = 'NO',
  Superyes = 'SUPERYES',
  Yes = 'YES'
}

export type SpeedflirtList = AdItem | SpeedflirtListNode;

export interface SpeedflirtListNode {
  node: UserSearchDocument;
  willMatch: Scalars['Boolean']['output'];
}

export enum SpeedflirtSort {
  Distance = 'DISTANCE',
  LastLogin = 'LAST_LOGIN',
  Online = 'ONLINE',
  Picture = 'PICTURE',
  Registration = 'REGISTRATION',
  Score = 'SCORE'
}

export enum SpeedflirtType {
  Match = 'MATCH',
  No = 'NO',
  Yes = 'YES'
}

export interface SponsorshipError extends Error {
  message: Scalars['String']['output'];
}

export interface SponsorshipInfo {
  isEditable: Scalars['Boolean']['output'];
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  rate: Scalars['Float']['output'];
  sponsored: Affiliate;
}

export interface SponsorshipMutation {
  addSponsor: AffiliateResults;
  addSponsoree: AffiliateResults;
  removeSponsor: BooleanResults;
  removeSponsoree: BooleanResults;
  updateSponsorship: SponsorshipResults;
}


export interface SponsorshipMutationAddSponsorArgs {
  affiliateId: Scalars['Int']['input'];
  sponsorId: Scalars['Int']['input'];
}


export interface SponsorshipMutationAddSponsoreeArgs {
  affiliateId: Scalars['Int']['input'];
  sponsoreeId: Scalars['Int']['input'];
}


export interface SponsorshipMutationRemoveSponsorArgs {
  affiliateId: Scalars['Int']['input'];
}


export interface SponsorshipMutationRemoveSponsoreeArgs {
  affiliateId: Scalars['Int']['input'];
  sponsoreeId: Scalars['Int']['input'];
}


export interface SponsorshipMutationUpdateSponsorshipArgs {
  input: UpdateSponsorshipInput;
}

export type SponsorshipResults = SponsorshipError | SponsorshipInfo;

export interface StepsInput {
  order: Scalars['Int']['input'];
  step: Scalars['ID']['input'];
}

export interface StopRebill {
  category?: Maybe<StopRebillCategory>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  who?: Maybe<Scalars['String']['output']>;
}

export enum StopRebillCategory {
  App = 'APP',
  Cron = 'CRON',
  CustomerService = 'CUSTOMER_SERVICE',
  Ivr = 'IVR',
  Pay = 'PAY',
  Pga = 'PGA',
  PgaCoaching = 'PGA_COACHING',
  PgaDating = 'PGA_DATING',
  Rebill = 'REBILL',
  Self = 'SELF',
  Unknown = 'UNKNOWN'
}

export interface Style {
  label: Scalars['String']['output'];
  variables: Array<StyleVariable>;
}


export interface StyleVariablesArgs {
  convert?: InputMaybe<ColorConversionTo>;
  includeComponent?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface StyleVariable {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface SubTitle {
  icon?: Maybe<IconFeed>;
  text: Scalars['String']['output'];
}

export interface SubscriberEvent extends InteractionEvent, ListViewableEvent, Sluggable {
  createdAt: Scalars['DateTime']['output'];
  slug: Scalars['ID']['output'];
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}

export interface Subscription {
  accesses: Array<Maybe<Access>>;
  /** Sent whenever there is a new visit / subscriber event */
  bump: BumpEvent;
  /** Tells whenever an event has been created (for event between users, use eventInteraction) */
  eventCreated: ListEvent;
  /** Tells whenever an interaction event has been created */
  eventInteraction: InteractionEvent;
  /** Tells whenever an event has been updated */
  eventUpdated: ListEvent;
  gamification: GamificationEventResult;
  layer: Layer;
  /** Send a ping every minute */
  ping: Scalars['DateTime']['output'];
  /** Subscribe to users's presence */
  presence: Presence;
  servers: NodeServer;
}


export interface SubscriptionEventCreatedArgs {
  direction?: InputMaybe<Direction>;
}


export interface SubscriptionPresenceArgs {
  users: Array<IUserHasChannel>;
}

export enum SubscriptionType {
  Free = 'FREE',
  Premium = 'PREMIUM',
  Trial = 'TRIAL'
}

export interface SuperUser {
  commonUserId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastname: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
}

export interface SuperlikeEvent extends InteractionEvent, ListEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
}


export interface SuperlikeEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface SurveyChoice extends SurveyInput, UnsubscribeComponent {
  label: Scalars['String']['output'];
  multipleChoice: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  possibleAnswers?: Maybe<Array<SurveyChoiceAnswer>>;
  required: Scalars['Boolean']['output'];
}

export interface SurveyChoiceAnswer {
  dbkey: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface SurveyInput {
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
}

export interface SurveyInputSubmit {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export interface SurveyTextArea extends SurveyInput, UnsubscribeComponent {
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
}

export interface Tag {
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface TagConnection extends PaginationConnection {
  edges?: Maybe<Array<TagEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface TagCount {
  count: Scalars['Int']['output'];
  tag: RelationshipTag;
}

export interface TagEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<Tag>;
}

export interface TagsInput {
  tag: Scalars['ID']['input'];
}

export interface Task {
  authorId: Scalars['Int']['output'];
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetAffiliateId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface TemplateType {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export enum TermsOfServiceType {
  AntispamCharter = 'ANTISPAM_CHARTER',
  LegalsNotices = 'LEGALS_NOTICES',
  ModerationCharter = 'MODERATION_CHARTER',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsOfServices = 'TERMS_OF_SERVICES',
  TrustCharter = 'TRUST_CHARTER'
}

export interface ThreedsData {
  acceptHeader?: InputMaybe<Scalars['String']['input']>;
  colorDepth: Scalars['Int']['input'];
  javaEnabled: Scalars['Boolean']['input'];
  javascriptEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timezone: Scalars['Int']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
}

export interface Token {
  access?: Maybe<Scalars['String']['output']>;
  refresh?: Maybe<Scalars['String']['output']>;
}

export interface TotalBalance {
  affiliate: Affiliate;
  amount: Scalars['Float']['output'];
}

export enum TrackerDisplay {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export enum TrackerEventType {
  Change = 'CHANGE',
  Click = 'CLICK',
  Fail = 'FAIL',
  Loaded = 'LOADED',
  Submit = 'SUBMIT',
  View = 'VIEW'
}

export enum TrackerType {
  Cgu = 'CGU',
  CrossRegistrationMyAccess = 'CROSS_REGISTRATION_MY_ACCESS',
  CrossRegistrationNotification = 'CROSS_REGISTRATION_NOTIFICATION',
  LinkLivecamMenuMobile = 'LINK_LIVECAM_MENU_MOBILE',
  LinkLivecamMyAccess = 'LINK_LIVECAM_MY_ACCESS',
  ListCallToActions = 'LIST_CALL_TO_ACTIONS',
  Pdp = 'PDP',
  PolePosition = 'POLE_POSITION',
  Popunder = 'POPUNDER',
  PopupLivecamGridMobile = 'POPUP_LIVECAM_GRID_MOBILE',
  PopupLivecamListingDesktop = 'POPUP_LIVECAM_LISTING_DESKTOP',
  PopupLivecamListingMobile = 'POPUP_LIVECAM_LISTING_MOBILE',
  Prophecy = 'PROPHECY',
  RegistrationStep = 'REGISTRATION_STEP',
  ReportAbuseChat = 'REPORT_ABUSE_CHAT',
  ReportAbuseProfile = 'REPORT_ABUSE_PROFILE',
  StopMySubscription = 'STOP_MY_SUBSCRIPTION',
  VmpiAlert = 'VMPI_ALERT'
}

export interface Transaction {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface TranslateResult {
  metadata?: Maybe<Scalars['JSON']['output']>;
  text?: Maybe<Scalars['String']['output']>;
}

export interface TypeaheadResult {
  country?: Maybe<Scalars['String']['output']>;
  /** Country iso 3 */
  country_a?: Maybe<Scalars['String']['output']>;
  geoname?: Maybe<Geoname>;
  geonameId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  region_a?: Maybe<Scalars['String']['output']>;
}

export interface TypingEvent extends ListEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
}


export interface TypingEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface UhcDeleteResponse extends UserDeleteResponseInterface {
  info: UserDeleteResponseInfo;
  result: BooleanResult;
}

export interface UhcDeleteResponseChannelized extends UserDeleteResponseInterface {
  channelId: Scalars['Int']['output'];
  info: UserDeleteResponseInfo;
  result: BooleanResult;
}

export interface UhcEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<UserHasChannelInterface>;
}

export interface UhcEdgeWithAds extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<UhcEdgeWithAdsNode>;
}

export type UhcEdgeWithAdsNode = AdItem | UhcNotFound | UserHasChannel;

export interface UhcNotFound extends CustomError, Error, MutableSluggable, Sluggable, UserHasChannelInterface {
  channel: Channel;
  channelId: Scalars['Int']['output'];
  code: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  site?: Maybe<Site>;
  slug: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
}


export interface UhcNotFoundOrdersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export enum UhcType {
  Free = 'FREE',
  Premium = 'PREMIUM',
  Vip = 'VIP'
}

export type UnregisteredSite = UnregisteredSiteExternal | UnregisteredSiteInternal;

export interface UnregisteredSiteExternal extends RegistrationSite {
  backgroundCard: Scalars['URL']['output'];
  backgroundDetails: Scalars['URL']['output'];
  extra: UpsellExtra;
  host: Scalars['String']['output'];
  key: Scalars['String']['output'];
  logo: Scalars['URL']['output'];
  logoCard: Scalars['URL']['output'];
  mediaLabel: Scalars['String']['output'];
  miniLogo: Scalars['URL']['output'];
  notice?: Maybe<Scalars['String']['output']>;
  platformCategory: PlatformCat;
  productSubtitle?: Maybe<Scalars['String']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  registrationLink: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface UnregisteredSiteInternal extends RegistrationSite {
  backgroundCard: Scalars['URL']['output'];
  backgroundDetails: Scalars['URL']['output'];
  channel: Channel;
  extra: UpsellExtra;
  host: Scalars['String']['output'];
  key: Scalars['String']['output'];
  logo: Scalars['URL']['output'];
  logoCard: Scalars['URL']['output'];
  mediaLabel: Scalars['String']['output'];
  miniLogo: Scalars['URL']['output'];
  primaryColor: Scalars['String']['output'];
  product?: Maybe<Product>;
  productMembership?: Maybe<PaymentProductInterface>;
  /** withproduct will return the url with the product as parameters, which means that if the user has an agreement, it will auto pay (= DO NOT USE ON UNREGISTRATION) default False */
  registrationLink: Scalars['String']['output'];
  site: Site;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['URL']['output']>;
}


export interface UnregisteredSiteInternalRegistrationLinkArgs {
  withProduct?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UnsubscribeBtn {
  class: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface UnsubscribeComponent {
  label: Scalars['String']['output'];
}

export interface UnsubscribeComponentProfiles extends UnsubscribeComponent {
  label: Scalars['String']['output'];
  labelNextLine?: Maybe<Scalars['String']['output']>;
  noProfile: Scalars['String']['output'];
  size: Scalars['Int']['output'];
}

export interface UnsubscribeComponentPromo extends UnsubscribeComponent {
  label: Scalars['String']['output'];
  offerText: Scalars['String']['output'];
  promoPicturePath: Scalars['String']['output'];
  specialOffer: Scalars['String']['output'];
  subscribeButtonText: Scalars['String']['output'];
}

export interface UnsubscribeComponentText extends UnsubscribeComponent {
  label: Scalars['String']['output'];
}

export interface UnsubscribePolicy {
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** If the user unsubscribe between theses dates, he will be rebilled one last time */
  extraPeriod?: Maybe<DateRange>;
  fees?: Maybe<Price>;
  /** Bought from appstore or google play */
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  isGift?: Maybe<Scalars['Boolean']['output']>;
  isNoticeApplicableOnProduct: Scalars['Boolean']['output'];
  isRebillable?: Maybe<Scalars['Boolean']['output']>;
  scenarioType: ScenarioType;
  startAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface UnsubscribePolicyRaw {
  end?: Maybe<Scalars['DateTime']['output']>;
  extraPeriod?: Maybe<RawDateRange>;
  fees?: Maybe<Fees>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  isGift?: Maybe<Scalars['Boolean']['output']>;
  isNoticeApplicableOnProduct?: Maybe<Scalars['Boolean']['output']>;
  isRebillable?: Maybe<Scalars['Boolean']['output']>;
  nextUnsubscribableWindow?: Maybe<RawDateRange>;
  start?: Maybe<Scalars['DateTime']['output']>;
  unsubscribableCode?: Maybe<Scalars['String']['output']>;
}

export interface UnsubscribeStep {
  cancelBtn?: Maybe<UnsubscribeBtn>;
  components?: Maybe<Array<UnsubscribeComponent>>;
  step: UnsubscriptionStep;
  submitBtn?: Maybe<UnsubscribeBtn>;
  unsubscribeOnSubmit?: Maybe<Scalars['Boolean']['output']>;
  unsubscribeTitle: Scalars['String']['output'];
}

export interface UnsubscribeStepSubmit {
  inputs: Array<SurveyInputSubmit>;
  step: UnsubscriptionStep;
}

export interface Unsubscribtable {
  scenario?: Maybe<PaymentUnsubscriptionScenario>;
}

export interface UnsubscriptionScenario {
  endAt?: Maybe<Scalars['DateTime']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  type: ScenarioType;
}

export enum UnsubscriptionStep {
  AreYouSure = 'AreYouSure',
  Confirmation = 'Confirmation',
  Profiles = 'Profiles',
  Profiles2 = 'Profiles2',
  Promo = 'Promo',
  Survey = 'Survey'
}

export interface Updatable {
  updated?: Maybe<Updated>;
}

export interface UpdateBusinessUnitInput {
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
}

export type UpdateBusinessUnitResponse = BusinessUnit | BusinessUnitError;

export interface UpdateMainEmailErrorValidation extends Error {
  message: Scalars['String']['output'];
}

export type UpdateMainEmailResponse = UpdateMainEmailErrorValidation | UpdateMainEmailSuccess;

export interface UpdateMainEmailSuccess {
  updatedEmail: Scalars['String']['output'];
}

export interface UpdateOptionAssignmentInput {
  id: Scalars['Int']['input'];
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  levelId?: InputMaybe<Scalars['Int']['input']>;
  levelType?: InputMaybe<OptionAssignmentLevelType>;
  optionId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export type UpdateOptionAssignmentResponse = OptionAssignment | OptionAssignmentError;

export interface UpdateOptionDefinitionInput {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}

export type UpdateOptionDefinitionResponse = OptionDefinition | OptionDefinitionError;

export interface UpdateSponsorshipInput {
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  sponsoreeId: Scalars['Int']['input'];
}

export interface Updated {
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<AdminUser>;
}

export type UpdatedInflowsResponse = InflowError | InflowItems;

export interface Upsell {
  description: Scalars['String']['output'];
  icons: Array<Scalars['Int']['output']>;
  iconsFull?: Maybe<Array<UpsellIcon>>;
  title: Scalars['String']['output'];
  upsell: Scalars['String']['output'];
}

export interface UpsellExtra {
  description: Scalars['String']['output'];
  host: Scalars['String']['output'];
  icons: Array<Icon>;
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface UpsellIcon {
  id: Scalars['Int']['output'];
  imgPath: Scalars['URL']['output'];
  label: Scalars['String']['output'];
}

export enum UpsellLabel {
  Octopus = 'OCTOPUS'
}

export enum UpsellSpotType {
  Boost = 'BOOST',
  Coaching = 'COACHING',
  Dating = 'DATING',
  None = 'NONE'
}

export interface UpsellSubscription {
  connect?: Maybe<Scalars['URL']['output']>;
  deleted?: Maybe<DeletedInfo>;
  endAt?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  startAt?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
}

/** User Type */
export interface User extends HasCoordinates, HasPaymentHistory, Sluggable {
  abTestResults?: Maybe<Array<UserAbTestResult>>;
  age: Scalars['Int']['output'];
  /** If the user was pulled from the archive */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Tells if the user has already changed his birthday */
  birthdayAlreadyChanged: Scalars['Boolean']['output'];
  bornDate: Scalars['Date']['output'];
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  details?: Maybe<UserDetails>;
  email: Scalars['EmailAddress']['output'];
  emailStatus?: Maybe<Array<EmailStatus>>;
  facebookUsers: Array<FacebookUser>;
  gender: Gender;
  geoname?: Maybe<Geoname>;
  gsm?: Maybe<PhoneNumber>;
  /** tell if user has generated password */
  hasGeneratedPassword: Scalars['Boolean']['output'];
  /** User's height / weight */
  heightWeight?: Maybe<HeightWeight>;
  id: Scalars['Int']['output'];
  isGsmValidated?: Maybe<Scalars['Boolean']['output']>;
  /** Check if the user is shadowbanned */
  isShadowbanned: Scalars['Boolean']['output'];
  isSuspect?: Maybe<Scalars['Boolean']['output']>;
  isWhitelisted?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Locale>;
  orders?: Maybe<Array<Order>>;
  paymentHistory?: Maybe<Array<UserHistory>>;
  purchaseHistory?: Maybe<Array<PaymentPurchase>>;
  shadowban?: Maybe<Shadowban>;
  slug: Scalars['ID']['output'];
  /**
   * Until further evolution, only supports 'octopus' upsell
   * @deprecated use registeredSites instead
   */
  upsellSubscription?: Maybe<UpsellSubscription>;
  userHasChannels?: Maybe<Array<UserHasChannelInterface>>;
  /** visible status inverse anonymous alias for isShadowbanned */
  vs: Scalars['Boolean']['output'];
  /** Retrieve specific associated user has channel */
  withChannel?: Maybe<UserHasChannel>;
  /** Retrieve all associated user has channel */
  withChannels?: Maybe<Array<UserHasChannel>>;
  /** Zodiac astrological sign internal label */
  zodiac?: Maybe<ZodiacSign>;
}


/** User Type */
export interface UserAbTestResultsArgs {
  abTestId: Scalars['Int']['input'];
}


/** User Type */
export interface UserPurchaseHistoryArgs {
  successfulOnly?: Scalars['Boolean']['input'];
}


/** User Type */
export interface UserUpsellSubscriptionArgs {
  upsell: UpsellLabel;
}


/** User Type */
export interface UserWithChannelArgs {
  channelId: Scalars['Int']['input'];
}


/** User Type */
export interface UserWithChannelsArgs {
  excludeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  includeCoaching?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EnableStatus>;
}

export interface UserAbTestResult {
  channelId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  distribution: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface UserBoost extends UserConsumableInterface {
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  lengthLastConsumablePurchased: Scalars['Int']['output'];
  quantityLastConsumablePurchased: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  type: ConsumableType;
}

export interface UserConsumableInterface {
  lengthLastConsumablePurchased: Scalars['Int']['output'];
  quantityLastConsumablePurchased: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  type: ConsumableType;
}

export interface UserCounters {
  bookmarks?: Maybe<Scalars['Int']['output']>;
  connections?: Maybe<Scalars['Int']['output']>;
  fans?: Maybe<Scalars['Int']['output']>;
  kisses?: Maybe<Scalars['Int']['output']>;
  likesReceived?: Maybe<Scalars['Int']['output']>;
  likesRemaining?: Maybe<Scalars['Int']['output']>;
  matches?: Maybe<Scalars['Int']['output']>;
  mediaLikes?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Scalars['Int']['output']>;
  pictureViews?: Maybe<Scalars['Int']['output']>;
  pictures: Scalars['Int']['output'];
  snapViews?: Maybe<Scalars['Int']['output']>;
  snaps?: Maybe<Scalars['Int']['output']>;
  snapsLastLikes: Scalars['Int']['output'];
  snapsLastViews: Scalars['Int']['output'];
  speedflirt?: Maybe<Scalars['Int']['output']>;
  subscribers?: Maybe<Scalars['Int']['output']>;
  subscriptions?: Maybe<Scalars['Int']['output']>;
  /** UnreadOnly does not work with before/after counter options */
  visits?: Maybe<Scalars['Int']['output']>;
}


export interface UserCountersLikesReceivedArgs {
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface UserCountersLikesRemainingArgs {
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface UserCountersMessagesArgs {
  messageTypes?: InputMaybe<Array<MessageTypes>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface UserCountersPicturesArgs {
  status?: InputMaybe<Array<ReviewStatus>>;
}


export interface UserCountersSpeedflirtArgs {
  type: SpeedflirtType;
}


export interface UserCountersSubscribersArgs {
  excludeMatch?: InputMaybe<Scalars['Boolean']['input']>;
  excludeRejected?: InputMaybe<Scalars['Boolean']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface UserCountersVisitsArgs {
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UserCrm {
  role: UserCrmRole;
  user: UserCrmInfo;
}

export type UserCrmInfo = AffiliateManager | SuperUser;

export enum UserCrmRole {
  AffiliateManager = 'AFFILIATE_MANAGER',
  Superuser = 'SUPERUSER'
}

export interface UserDatingProductsList {
  products: Array<ProductWithSite>;
  upSells: Array<ProductWithSite>;
}

export interface UserDeleteResponseInfo {
  remainingSubscriptions?: Maybe<RemainingSubscription>;
}

export interface UserDeleteResponseInterface {
  info: UserDeleteResponseInfo;
  result: BooleanResult;
}

export interface UserDescription extends BelongsToUhc, Reviewable, Sluggable, WithCreatedAt {
  createdAt: Scalars['DateTime']['output'];
  descriptionHighlighted?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Reviewed>;
  slug: Scalars['ID']['output'];
  /** Can be null for viewer if not approved */
  text?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserHasChannelInterface>;
}

export interface UserDetails {
  firstname?: Maybe<Scalars['String']['output']>;
  /** Computed Fullname firstname + lastname */
  fullName?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
}

export interface UserEvent {
  createdAt: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserHasChannelInterface>;
}

export interface UserFeedback extends BelongsToUhc, Sluggable {
  by?: Maybe<AdminUser>;
  createdAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
  type?: Maybe<FeedbackType>;
  user?: Maybe<UserHasChannelInterface>;
}

/** Define user filters */
export interface UserFilter {
  /** User's age */
  age?: InputMaybe<MinMaxInt>;
  /** Default to connected user's channel */
  channelId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<DateFilter>;
  /** User's criteria */
  criteria?: InputMaybe<Array<CriterionFilter>>;
  /** User's criteria @deprecated use criteria */
  criterias?: InputMaybe<Array<CriteriaParam>>;
  /** User's defaultPicture */
  defaultPicture?: InputMaybe<DefaultPictureFilter>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Hides user real name (promo-tools) */
  fakerName?: InputMaybe<Scalars['String']['input']>;
  /** User's gender */
  genders?: InputMaybe<Array<Gender>>;
  /** Only users with/out picture */
  hasPicture?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's height in cm */
  height?: InputMaybe<MinMaxInt>;
  /** @deprecated no replacement */
  isAttractive?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<DateFilter>;
  /** @deprecated use lastLogin instead */
  lastlogin?: InputMaybe<Scalars['DateTime']['input']>;
  /** User's location */
  location?: InputMaybe<LocationSearch>;
  /** Get user with specific Relationship Tag */
  relationshipTag?: InputMaybe<Array<RelationshipTagValue>>;
  /** User's genders interested into */
  searchingGenders?: InputMaybe<Array<Gender>>;
  /** User's weight in kg */
  weight?: InputMaybe<MinMaxInt>;
}

/** Define UserHasChannel Type */
export interface UserHasChannel extends ConversationInterface, HasPaymentCapabilities, HasPaymentHistory, HasSnaps, Sluggable, UserHasChannelInterface {
  /** Get Result from an AB Test */
  abTest?: Maybe<Scalars['String']['output']>;
  abTests?: Maybe<Array<UserAbTestResult>>;
  access: Access;
  accesses: Array<Access>;
  /** Return the active purchase if it has been stopped, null otherwise (no active purchase or active purchase not stopped) */
  activePurchaseStopped?: Maybe<Purchase>;
  /** Get user activity log */
  activityDoneAt?: Maybe<Scalars['DateTime']['output']>;
  /** Return the agreements of the user, type is deprecated and do nothing */
  agreements: Array<AgreementInterface>;
  alreadyPurchasedProduct?: Maybe<Scalars['Boolean']['output']>;
  /** Return self availability */
  availabilityOutdated: Scalars['Boolean']['output'];
  /** @deprecated Use availableMethodsWithConfig instead */
  availableMethods?: Maybe<Array<MethodType>>;
  availableMethodsWithConfig?: Maybe<Array<MethodTypeWithConfig>>;
  /** Blacklisted users */
  blacklist: UserListConnection;
  /** If I (auth) blacklisted this user */
  blacklisted: Scalars['Boolean']['output'];
  /** If I (auth) bookmarked this user */
  bookmarked: Scalars['Boolean']['output'];
  /** User can send image in conversation if the other user send at least 3 messages to him Return false if user don't have rights to send message in conversation */
  canSendImageInConversation: Scalars['Boolean']['output'];
  /** Tells if the user can unregister or not (if user has active rebill subscription, he can't unregister) */
  canUnregister: Scalars['Boolean']['output'];
  certificationTags: CertifTag;
  channel: Channel;
  channelId: Scalars['Int']['output'];
  company?: Maybe<Company>;
  /** User connections logs (Maximum 100 elements) */
  connections?: Maybe<Array<IpLog>>;
  /** Consumable entrypoint */
  consumables: Array<UserConsumableInterface>;
  /** List chat contacts Users contacted by the user + For VIP: conversation from matches, for Premium: all conversation */
  contacts?: Maybe<ContactConnection>;
  /** Events between users (connected) */
  conversation?: Maybe<MessageFeed>;
  /** If I already sent a message to the user */
  conversationAlreadyStarted: Scalars['Boolean']['output'];
  /** User counters entry point */
  counters: UserCounters;
  createdAt: Scalars['DateTime']['output'];
  /** Users possible criteria (form) */
  criteria?: Maybe<Array<Criteria>>;
  /** Users selected criteria */
  criteriaValueNext?: Maybe<Array<ICriteriaValue>>;
  /** Users selected criteria for all channels */
  criteriaValueUnFiltered: Array<CriteriaValue>;
  /** Get list of allowed call to actions for the user */
  cta?: Maybe<Array<Cta>>;
  /** Users default searching criteria values for their channel */
  defaultCriteriaSearchValue: Array<CriteriaValue>;
  deleted?: Maybe<DeletedInfo>;
  description?: Maybe<UserDescription>;
  /** Already request description */
  descriptionRequestAlreadySent: Scalars['Boolean']['output'];
  /**
   * Descriptor for recent purchase
   * @deprecated use layersToShow instead
   */
  descriptor?: Maybe<Scalars['String']['output']>;
  /** Discovery entry point. Get discovery page content. */
  discovery: Array<DiscoveryCategory>;
  displayName: Scalars['String']['output'];
  /** Tells if the user has already changed his displayName (user can have oldDisplayName without changing if it has been replaced during the sign-up) */
  displayNameAlreadyChanged: Scalars['Boolean']['output'];
  eligibleToUnsubscriptionGift?: Maybe<Product>;
  /** Returns the next step the user should complete to have a complete profile (picture, hobbies, description, snap). */
  emptyPageTip: EmptyPageTip;
  enabled: Scalars['Boolean']['output'];
  /** Generic name FanList. PSC : Fan list if woman / Conquest list if man */
  fanList?: Maybe<Array<UserEvent>>;
  /** Favorite game standalone from feed */
  favoriteGame: Array<FavoriteGame>;
  /** Get the feed of the user Max: number of feed to get (max is 30) exclude: array of feeds slugs that should be excluded from the result (typically feeds that are displayed on the screen but not already viewed) fastLoad: if set to true, loading feed will be quicker (but won't load every type of feed available) only: only load certain type of feed (disabled in production) */
  feed?: Maybe<FeedList>;
  /** Get user support feedbacks */
  feedbacks?: Maybe<Array<UserFeedback>>;
  /** Get list of user's fingerprint */
  fingerprints?: Maybe<Array<Fingerprint>>;
  /** First text message I received from a user */
  firstMessageReceived?: Maybe<MessageText>;
  /** Get FraudScore details */
  fraudGroups?: Maybe<Array<FraudRuleGroup>>;
  /** Get FraudScore */
  fraudScore?: Maybe<Scalars['Float']['output']>;
  generatedIceBreaker?: Maybe<Scalars['String']['output']>;
  hasAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasAlreadySendPrivatePictureRequest: Scalars['Boolean']['output'];
  /** Tell if the users has full access to site */
  hasPermission: Scalars['Boolean']['output'];
  /** Tells if user has push browser */
  hasRegistredWebpush?: Maybe<Scalars['Boolean']['output']>;
  /** Tell if user has trial subscription */
  hasTrialMembership: Scalars['Boolean']['output'];
  icebreaker?: Maybe<IceBreaker>;
  informationRotation: ProfileTemplate;
  /** Get informations for second chance list */
  infosSecondChance?: Maybe<InformationsSecondChance>;
  /** Interaction CTA between connected user and target user */
  interactionCta: InteractionCta;
  /** Return users who have interacted with a boosted user, interaction since avec enum en apramètre (pour l'instant 'BOOST'), retourne un tableau d'objet d'event + uhc) */
  interactionsSince?: Maybe<Array<UserInteraction>>;
  isEligibleCoachingAds: Scalars['Boolean']['output'];
  /** Get hibernation status */
  isHibernating: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isOnlineNow: Scalars['Boolean']['output'];
  /** True if user has received a warning from the support in the last 15 days */
  isWarned?: Maybe<Scalars['Boolean']['output']>;
  /** If I (auth) kissed this user */
  kissed: Scalars['Boolean']['output'];
  /** If user send a message I didn't open */
  lastUnreadMessage?: Maybe<IMessage>;
  lastloginAt?: Maybe<Scalars['DateTime']['output']>;
  /** Get layers to show to user, if checkLayers is empty, will check all layers */
  layersToShow: Array<Layer>;
  levelInfo: LevelInfo;
  /** List of users like */
  likeList?: Maybe<Array<UserHasChannelInterface>>;
  /** List of followers + welcomes received */
  likesReceived: LikesReceivedConnection;
  likesRemaining: LikesRemainingConnection;
  /** Admin auto connect link */
  link?: Maybe<Scalars['URL']['output']>;
  listExtraAction: Array<ActionExtra>;
  listUserDatingProducts?: Maybe<UserDatingProductsList>;
  /**
   * Must see the mail validation warning layer aka Le Pénible
   * @deprecated use layersToShow instead
   */
  mailValidationLayer: ValidationLayerOption;
  /** If I (auth) matched with this user */
  matched?: Maybe<InteractionEvent>;
  /** List of matches */
  matches: UserListConnectionWithAds;
  membership: MembershipDetails;
  /** Get menu banners for user */
  menuBanners?: Maybe<Array<MenuBanner>>;
  /**
   * Number of message invitations
   * @deprecated Replaced by newMatches counter
   */
  messageInvitationsCount: Scalars['Int']['output'];
  /** list of events that have been missed by the user (not yet viewed) Also trigger login achievement and XP reward */
  missedEvents: Array<GamificationEvent>;
  /** Matches without started conversation notExpired: DEPRECATED: computed by the back notViewed: if true only shows unviewed matches (default false) */
  newMatches: MatchListConnection;
  /** New matches counter */
  newMatchesCount: Scalars['Int']['output'];
  nextPaymentAccount?: Maybe<Scalars['Int']['output']>;
  /** Get user's notifiable list */
  notifiables?: Maybe<Array<Notifiable>>;
  notificationHistory?: Maybe<Array<NotificationReceived>>;
  /** Get list of unviewed events */
  notificationList?: Maybe<Array<ListViewableEvent>>;
  /** Get user notifications settings */
  notificationSettings?: Maybe<NotificationSettings>;
  oldDisplayName?: Maybe<UserHasOldDisplayName>;
  /** @todo move */
  onlineMembers: UserListConnection;
  orders?: Maybe<Array<Order>>;
  /** Compile all infos needed to make a payment (country, locale, currency, site, company, webmaster, channelDomain ....) */
  paymentKey: Scalars['ID']['output'];
  paymentUrl?: Maybe<Scalars['URL']['output']>;
  picture?: Maybe<DefaultPicture>;
  /**
   * Already request picture
   * @deprecated Use privatePictureAuthorizationRequestAlreadySent or sendPictureRequestAlreadySent instead
   */
  pictureRequestAlreadySent: Scalars['Boolean']['output'];
  /** Return user's picture - status optionally only with given status default to APPROVED/PENDING only - withDeleted optionally include deleted picture default false */
  pictures?: Maybe<Array<UserPicture>>;
  /** Get list of predefined icebreaker for the user */
  predefinedIcebreakerList: Array<PredefinedIceBreaker>;
  presentationPhrase?: Maybe<UserPresentation>;
  preventPayment?: Maybe<Scalars['Boolean']['output']>;
  /** If I (auth) gave this user permission to view my private pictures with date */
  privatePictureAllowed: PictureAuthorization;
  /** If I (auth) have the permission to view user's private pictures */
  privatePictureAuthorization: Scalars['Boolean']['output'];
  /** True if I (auth) already send a private picture authorization request to the user */
  privatePictureAuthorizationRequestAlreadySent: Scalars['Boolean']['output'];
  /** List of users who can view my privates pictures */
  privatePictureAuthorizations: UserListConnectionWithAds;
  /**
   * If I (auth) gave this user permission to view my private pictures
   * @deprecated Use privatePictureAllowed
   */
  privatePictureAuthorized: Scalars['Boolean']['output'];
  product: UserProduct;
  /** Give the list of products to display to the user */
  products?: Maybe<Array<Product>>;
  promptPhoneValidation?: Maybe<Scalars['Boolean']['output']>;
  purchaseHistory?: Maybe<Array<PaymentPurchase>>;
  purchases?: Maybe<Array<Purchase>>;
  /** Should trigger RED IP redirect */
  redIPRedirect?: Maybe<Scalars['URL']['output']>;
  /** Should the user be put back into Prophecy */
  registrationProgression: RegistrationProgression;
  /** Get user relationship tag (Default is second relationshipTag of the channel/domain) */
  relationshipTag?: Maybe<UserRelationshipTag>;
  /** Get all relationship tags available for the user */
  relationshipTagList?: Maybe<Array<RelationshipTag>>;
  /** User safe mode to blur (or not) pictures and snaps */
  safeMode: Safemode;
  /** Get user's score, return 0 if not allowed, score otherwise */
  score?: Maybe<Scalars['Int']['output']>;
  /** User search entry point */
  search: QueryUhcSearch;
  /** List of secondChance */
  secondChance: UserListConnection;
  /** True if I (auth) already send a picture request to the user */
  sendPictureRequestAlreadySent: Scalars['Boolean']['output'];
  site?: Maybe<Site>;
  slug: Scalars['ID']['output'];
  snaps?: Maybe<Array<Snap>>;
  /** User registration source (form) */
  source?: Maybe<Source>;
  /** direction TO : My action against user direction FROM : User's action against me */
  speedflirt?: Maybe<Speedflirt>;
  /** If I (auth) subscribed TO this user / If this user has a subscription FROM me */
  subscribed?: Maybe<InteractionEvent>;
  /** List of followers */
  subscribers: UserListConnection;
  /** List of following people */
  subscriptions: UserListConnectionWithAds;
  token?: Maybe<Token>;
  totalDiscountPrice?: Maybe<TotalDiscountUser>;
  /** Users account type (VIP / Premium) */
  uhcType: UhcType;
  uniqueRegistrationId: Scalars['Int']['output'];
  unsubscriptionNextStep?: Maybe<UnsubscribeStep>;
  unsubscriptionScenario?: Maybe<UnsubscriptionScenario>;
  /** Return if internal ads spot is coaching or upsell or nothing */
  upsellSpotType: UpsellSpotType;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  /** Give pagination of user which I like one of their pictures */
  usersLikedPictures?: Maybe<UserListConnection>;
  /** Event if I (auth) visited this user (TO) or if user visited my profile (FROM) */
  visited?: Maybe<VisitEvent>;
  /** List of users who visited user's profile */
  visits: VisitEventListConnection;
  willMatch: Scalars['Boolean']['output'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelAbTestArgs {
  id: Scalars['Int']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelAccessArgs {
  name: AccessName;
}


/** Define UserHasChannel Type */
export interface UserHasChannelAccessesArgs {
  names?: InputMaybe<Array<AccessName>>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelActivityDoneAtArgs {
  activity: ActivityLogType;
}


/** Define UserHasChannel Type */
export interface UserHasChannelAgreementsArgs {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<AgreementType>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelAlreadyPurchasedProductArgs {
  metaData: Scalars['String']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelAvailableMethodsArgs {
  tryCount: Scalars['Int']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelAvailableMethodsWithConfigArgs {
  tryCount: Scalars['Int']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelBlacklistArgs {
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelConnectionsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelConsumablesArgs {
  typeConsumable: ConsumableType;
}


/** Define UserHasChannel Type */
export interface UserHasChannelContactsArgs {
  filter?: InputMaybe<ContactFilter>;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelConversationArgs {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageType?: InputMaybe<MessageType>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelCountersArgs {
  after?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Direction>;
  preset?: InputMaybe<InteractionType>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelCriteriaValueNextArgs {
  criteriaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelFavoriteGameArgs {
  userPair?: InputMaybe<UserPair>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelFeedArgs {
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  fastLoad?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelInformationRotationArgs {
  fromMyLikes?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelInteractionCtaArgs {
  ctaContext: CtaContext;
}


/** Define UserHasChannel Type */
export interface UserHasChannelInteractionsSinceArgs {
  typeInteraction?: InputMaybe<InteractionType>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelLayersToShowArgs {
  checkLayers?: InputMaybe<Array<LayerName>>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelLikesReceivedArgs {
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelLikesRemainingArgs {
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelListExtraActionArgs {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelListUserDatingProductsArgs {
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelMatchesArgs {
  notExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notViewed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelNewMatchesArgs {
  notExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notViewed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelNewMatchesCountArgs {
  notViewed?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelOnlineMembersArgs {
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelOrdersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelPaymentUrlArgs {
  accessType: Scalars['ID']['input'];
  cancel?: InputMaybe<Scalars['URL']['input']>;
  followProfile?: InputMaybe<Scalars['ID']['input']>;
  pageType?: InputMaybe<PaymentPageType>;
  success?: InputMaybe<Scalars['URL']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelPicturesArgs {
  status?: InputMaybe<Array<ReviewStatus>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelPreventPaymentArgs {
  target?: InputMaybe<PreventPaymentTarget>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelPrivatePictureAuthorizationsArgs {
  direction?: Direction;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelProductArgs {
  productId: Scalars['Int']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelPurchaseHistoryArgs {
  successfulOnly?: Scalars['Boolean']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelPurchasesArgs {
  filter?: InputMaybe<PurchaseFilter>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelRedIpRedirectArgs {
  cancel: Scalars['URL']['input'];
  success: Scalars['URL']['input'];
}


/** Define UserHasChannel Type */
export interface UserHasChannelSecondChanceArgs {
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelSnapsArgs {
  newOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelSpeedflirtArgs {
  direction: Direction;
}


/** Define UserHasChannel Type */
export interface UserHasChannelSubscribedArgs {
  direction?: Direction;
}


/** Define UserHasChannel Type */
export interface UserHasChannelSubscribersArgs {
  excludeMatch?: InputMaybe<Scalars['Boolean']['input']>;
  excludeRejected?: InputMaybe<Scalars['Boolean']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelSubscriptionsArgs {
  excludeMatch?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelUnsubscriptionNextStepArgs {
  currentStep?: InputMaybe<UnsubscriptionStep>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelUnsubscriptionScenarioArgs {
  fakeDate?: InputMaybe<Scalars['Date']['input']>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelUsersLikedPicturesArgs {
  options?: InputMaybe<PaginationOptions>;
}


/** Define UserHasChannel Type */
export interface UserHasChannelVisitedArgs {
  direction?: Direction;
}


/** Define UserHasChannel Type */
export interface UserHasChannelVisitsArgs {
  direction: Direction;
  options?: InputMaybe<PaginationOptions>;
}

export interface UserHasChannelArchived extends Sluggable, UserHasChannelInterface {
  channel: Channel;
  channelId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  site?: Maybe<Site>;
  slug: Scalars['ID']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
}


export interface UserHasChannelArchivedOrdersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserHasChannelInterface {
  channel: Channel;
  channelId: Scalars['Int']['output'];
  orders?: Maybe<Array<Order>>;
  site?: Maybe<Site>;
  slug: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
}


export interface UserHasChannelInterfaceOrdersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserHasChannelSignUpInput {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** Admin purpose only */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  siteId: Scalars['Int']['input'];
  sourceId?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserHasMediaTimecode {
  mediaType: MediaType;
  model: UserHasMediaTimecodeModel;
  modelId: Scalars['Int']['output'];
  registrationUniqueId: Scalars['Int']['output'];
  timecodeInSeconds: Scalars['Int']['output'];
}

export enum UserHasMediaTimecodeModel {
  Article = 'ARTICLE',
  Niche = 'NICHE',
  Theme = 'THEME'
}

export interface UserHasOldDisplayName {
  displayName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
}

export interface UserHistory {
  action: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  info: Scalars['String']['output'];
  platform: Scalars['String']['output'];
}

export interface UserHistoryCoaching {
  lastPurchase?: Maybe<PurchaseOrRebill>;
  nicheId?: Maybe<Scalars['Int']['output']>;
  premiumDays: Scalars['Int']['output'];
  purchasesNumber: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
}

export interface UserHistoryDating {
  channelId?: Maybe<Scalars['Int']['output']>;
  lastPurchase?: Maybe<PurchaseOrRebill>;
  premiumDays: Scalars['Int']['output'];
  purchasesNumber: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
}

export interface UserInteraction {
  interaction: Interaction;
  users: Array<UserHasChannel>;
}

export interface UserLanguage {
  code: Scalars['String']['output'];
  flag: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  translatedLabel: Scalars['String']['output'];
}

export interface UserListConnection extends PaginationConnection {
  edges?: Maybe<Array<UhcEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface UserListConnectionWithAds extends PaginationConnection {
  edges?: Maybe<Array<UhcEdgeWithAds>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export interface UserPair {
  user1: Scalars['Int']['input'];
  user2: Scalars['Int']['input'];
}

export type UserPaymentHistory = UserHistoryCoaching | UserHistoryDating;

export interface UserPicture extends BelongsToUhc, Commentable, PictureInterface, Reactable, Reviewable, Sluggable, WithCreatedAt, WithRating {
  access: MediaAccess;
  /** Get the blur status of a photo based on the user's authorization. If isPreview is true, get the user's own pictures blurStatus without authorization */
  blurStatus: BlurReason;
  /** Default picture blurhash */
  blurhash?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentConnection>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  isGenerated: Scalars['Boolean']['output'];
  /** Tell if the viewer like that picture */
  liked: Scalars['Boolean']['output'];
  likedBy?: Maybe<PictureLikeConnection>;
  /** Give number of likes per user */
  likes: Scalars['Int']['output'];
  /** S3 File hash */
  mediaId: Scalars['String']['output'];
  myReactions?: Maybe<Array<Reaction>>;
  owner?: Maybe<UserHasChannelInterface>;
  rating: MediaRating;
  reactions?: Maybe<Array<ReactionLikes>>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Reviewed>;
  slug: Scalars['ID']['output'];
  /** Safemode disabled if not provided If isPreview is true, get the user's own pictures without authorization */
  sources: PictureSrcSet;
  user?: Maybe<UserHasChannelInterface>;
}


export interface UserPictureBlurStatusArgs {
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface UserPictureCommentsArgs {
  options?: InputMaybe<PaginationOptions>;
}


export interface UserPictureLikedByArgs {
  options?: InputMaybe<PaginationOptions>;
  reaction?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserPictureSourcesArgs {
  forceBlur?: InputMaybe<Scalars['Boolean']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  original?: InputMaybe<Scalars['Boolean']['input']>;
  safemode?: InputMaybe<Safemode>;
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}

export interface UserPresentation {
  displayName: Scalars['String']['output'];
  distance: Scalars['String']['output'];
  lookingFor: Scalars['String']['output'];
  where: Scalars['String']['output'];
  who: Scalars['String']['output'];
}

export interface UserProduct {
  /** Translated title */
  coachingLabel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Price;
  title: Scalars['String']['output'];
  type: DatingProductType;
}

export interface UserProductMembership extends UserProduct {
  /** Translated title */
  coachingLabel: Scalars['String']['output'];
  duration: Scalars['RRule']['output'];
  id: Scalars['Int']['output'];
  isTrial: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  price: Price;
  rebillProduct?: Maybe<UserProduct>;
  title: Scalars['String']['output'];
  type: DatingProductType;
}

export interface UserProductOther extends UserProduct {
  /** Translated title */
  coachingLabel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Price;
  title: Scalars['String']['output'];
  type: DatingProductType;
}

export interface UserProductQuota extends UserProduct {
  actions?: Maybe<Array<UserProductQuotaAction>>;
  /** Translated title */
  coachingLabel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Price;
  title: Scalars['String']['output'];
  type: DatingProductType;
}

export interface UserProductQuotaAction {
  amount: Scalars['Int']['output'];
  duration?: Maybe<Scalars['RRule']['output']>;
  id: Scalars['Int']['output'];
  type: DatingProductType;
}

export interface UserRelationshipTag extends IRelationshipTag {
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  labelShort: Scalars['String']['output'];
}

export type UserRemote = CoachingUserHasNiche | UserHasChannel;

export interface UserSearch {
  age?: Maybe<MinMax>;
  gender: GenderModel;
  height?: Maybe<MinMax>;
  weight?: Maybe<MinMax>;
}

/** Elastic search document result */
export interface UserSearchDocument extends HasCoordinates, UserHasChannelInterface {
  age: Scalars['Int']['output'];
  bounced?: Maybe<Scalars['Boolean']['output']>;
  channel: Channel;
  channelId: Scalars['Int']['output'];
  clickTag?: Maybe<ClickTag>;
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  criteriasValues?: Maybe<Array<CriteriaValue>>;
  /** User's description */
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** Distance relative to the filter or logged in user expressed in meters */
  distance?: Maybe<Scalars['Int']['output']>;
  fakerName?: Maybe<Scalars['String']['output']>;
  gender: Gender;
  geoname?: Maybe<Geoname>;
  hasMembership?: Maybe<Scalars['Boolean']['output']>;
  /** Is the user has a default/public picture */
  hasPicture: Scalars['Boolean']['output'];
  /** User's height in cm */
  height?: Maybe<Scalars['Int']['output']>;
  /** Is the user online */
  isOnline: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `HasCoordinates` interface instead */
  location?: Maybe<Location>;
  orders?: Maybe<Array<Order>>;
  picture?: Maybe<DefaultPicture>;
  /**
   * Safemode disabled if not provided
   * @deprecated use picture instead
   */
  pictures: PictureSrcSet;
  /** User Relationship Tag */
  relationshipTag?: Maybe<RelationshipTagValue>;
  score: Scalars['Float']['output'];
  site?: Maybe<Site>;
  slug: Scalars['ID']['output'];
  /** @deprecated Use `slug` */
  slugUHC: Scalars['ID']['output'];
  slugUser: Scalars['ID']['output'];
  strict?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use picture instead */
  thumbURL?: Maybe<Scalars['URL']['output']>;
  /** ⚠️ Avoid using uhc */
  uhc?: Maybe<UserHasChannelInterface>;
  userId: Scalars['Int']['output'];
  /** User's weight in kg */
  weight?: Maybe<Scalars['Int']['output']>;
  zodiac?: Maybe<Zodiac>;
}


/** Elastic search document result */
export interface UserSearchDocumentClickTagArgs {
  siteId: Scalars['Int']['input'];
}


/** Elastic search document result */
export interface UserSearchDocumentOrdersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


/** Elastic search document result */
export interface UserSearchDocumentPicturesArgs {
  safemode?: InputMaybe<Safemode>;
  size: Scalars['Int']['input'];
  type?: InputMaybe<PictureType>;
}


/** Elastic search document result */
export interface UserSearchDocumentThumbUrlArgs {
  square?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserSearchLocation extends HasCoordinates {
  coordinates: Coordinates;
  country?: Maybe<Country>;
  geoname?: Maybe<Geoname>;
  limitToCountry: Scalars['Boolean']['output'];
  radius: Scalars['Int']['output'];
}

export interface UserSearchLocationParams {
  coordinates: ICoordinates;
  geoname?: InputMaybe<Scalars['Int']['input']>;
  limitToCountry: Scalars['Boolean']['input'];
  /** in kilometers */
  radius: Scalars['Int']['input'];
}

export interface UserSearchParams {
  age?: InputMaybe<MinMaxInt>;
  gender: Gender;
  height?: InputMaybe<MinMaxInt>;
  sexId?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<MinMaxInt>;
}

export type UserSearchResult = AdItem | Cta | UserSearchDocument;

export interface UserSignUpInput {
  bornDate: Scalars['Date']['input'];
  canUseExternal?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['EmailAddress']['input'];
  gender: Gender;
  /** Language tag like fr-FR Will default to accept-language header, "fr" if not provided */
  language?: InputMaybe<Scalars['String']['input']>;
  /** If not provided one will be generated randomly */
  password?: InputMaybe<Scalars['String']['input']>;
}

export interface UserSort {
  direction: SortDirection;
  sort: UserSortField;
}

export enum UserSortField {
  /** @deprecated no replacement */
  Attractive = 'ATTRACTIVE',
  Channel = 'CHANNEL',
  /** - When used in combination with UserSortField::location, distance relative to the center - When requested by an authentifed user, distance relative to the logged in user */
  Distance = 'DISTANCE',
  Height = 'HEIGHT',
  /** User Id */
  Id = 'ID',
  LastLogin = 'LAST_LOGIN',
  Online = 'ONLINE',
  Registration = 'REGISTRATION',
  Score = 'SCORE',
  Weight = 'WEIGHT',
  WithPicture = 'WITH_PICTURE'
}

export enum UserSourceType {
  Coaching = 'COACHING',
  Dating = 'DATING'
}

export interface UserSystem extends ConversationInterface, Sluggable, UserHasChannelInterface {
  channel: Channel;
  channelId: Scalars['Int']['output'];
  /** Events between users (connected) */
  conversation?: Maybe<MessageFeed>;
  displayName: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  picture?: Maybe<GeneratedPicture>;
  site?: Maybe<Site>;
  slug: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
}


export interface UserSystemConversationArgs {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageType?: InputMaybe<MessageType>;
}


export interface UserSystemOrdersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface ValidatePendingPaymentError extends Error {
  message: Scalars['String']['output'];
}

export interface ValidatePendingPaymentInput {
  affiliateId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['Int']['input'];
}

export type ValidatePendingPaymentResponse = PendingPayment | ValidatePendingPaymentError;

export enum ValidationLayer {
  EmailChange = 'EMAIL_CHANGE',
  EmailValidate = 'EMAIL_VALIDATE',
  None = 'NONE'
}

export interface ValidationLayerOption {
  canBeClosed?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<ValidationLayer>;
}

export enum VersionApplePay {
  EcV1 = 'EC_v1',
  RsaV1 = 'RSA_v1'
}

export enum VersionGooglePay {
  ECv1 = 'ECv1',
  ECv2 = 'ECv2'
}

export interface VisitEdge extends ConnectionEdge {
  cursor: Scalars['ID']['output'];
  node?: Maybe<VisitEventNode>;
}

export interface VisitEvent extends InteractionEvent, ListEvent, ListViewableEvent {
  createdAt: Scalars['DateTime']['output'];
  direction: Direction;
  from: UserHasChannelInterface;
  to: UserHasChannelInterface;
  user: UserHasChannelInterface;
  viewed: Scalars['Boolean']['output'];
}


export interface VisitEventDirectionArgs {
  relativeTo?: InputMaybe<IUserHasChannel>;
}

export interface VisitEventListConnection extends PaginationConnection {
  edges?: Maybe<Array<VisitEdge>>;
  pageInfo: PageInfoNext;
  totalCount: Scalars['Int']['output'];
}

export type VisitEventNode = AdItem | VisitEvent;

export interface Webmaster extends Sluggable {
  email: Scalars['EmailAddress']['output'];
  id: Scalars['Int']['output'];
  login: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
}

export interface WithCreatedAt {
  createdAt: Scalars['DateTime']['output'];
}

export interface WithRating {
  rating: MediaRating;
}

export interface WithTermsOfService {
  termsOfService?: Maybe<Scalars['Markdown']['output']>;
  termsOfServiceHTML?: Maybe<Scalars['HTML']['output']>;
}


export interface WithTermsOfServiceTermsOfServiceArgs {
  type: TermsOfServiceType;
}


export interface WithTermsOfServiceTermsOfServiceHtmlArgs {
  type: TermsOfServiceType;
}

export interface ZendeskContactInput {
  captcha: Scalars['String']['input'];
  email: Scalars['String']['input'];
  host: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface ZendeskInput {
  ticketId: Scalars['Int']['input'];
}

export interface Zodiac {
  backgroundUrl?: Maybe<Scalars['URL']['output']>;
  label: Scalars['String']['output'];
  sign: ZodiacSign;
}

export enum ZodiacSign {
  Aquarius = 'AQUARIUS',
  Aries = 'ARIES',
  Cancer = 'CANCER',
  Capricorn = 'CAPRICORN',
  Gemini = 'GEMINI',
  Leo = 'LEO',
  Libra = 'LIBRA',
  Pisces = 'PISCES',
  Sagittarius = 'SAGITTARIUS',
  Scorpius = 'SCORPIUS',
  Taurus = 'TAURUS',
  Virgo = 'VIRGO'
}

export interface DetailValueInput {
  inputId: Scalars['Int']['input'];
  vals: Scalars['JSON']['input'];
}

export interface ICoordinates {
  /** GPS Latitude */
  lat: Scalars['Latitude']['input'];
  /** GPS Longitude */
  lng: Scalars['Longitude']['input'];
}

export interface IUserHasChannel {
  channelId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}

export interface LandingMediaChannel {
  channel: Channel;
  url?: Maybe<Scalars['URL']['output']>;
}

/** The returned purchases match all filters */
export interface PurchaseFilter {
  cancellable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Returns the purchases that exist in a specified period, ignores the period if it is not defined or empty. */
  period?: InputMaybe<Array<Period>>;
  rebillable?: InputMaybe<Scalars['Boolean']['input']>;
  status: EnableStatus;
}

export interface TotalDiscountUser {
  currency: Currency;
  defaultPrice: Scalars['Float']['output'];
  paidPrice: Scalars['Float']['output'];
}

export type GetAbTestQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAbTestQuery = { Coaching: { me: { abTest?: string | null } } };

export type GetArticleQueryVariables = Exact<{
  input: CoachingCapsuleByUserInput;
}>;


export type GetArticleQuery = { Coaching: { me: { capsule?: { id: number, levelPosition: number, title?: string | null, thumbnail?: string | null, position: number, htmlContent?: string | null, videoContent?: string | null, audioContent?: string | null, status: CoachingCapsuleStatus, slug: string, theme?: { slug: string, internalName: string, capsules?: Array<{ id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null }> | null } | null, pagination?: { next?: { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null } | null, previous?: { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null } | null } | null } | null } } };

export type StatusArticleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: CoachingCapsuleStatus;
}>;


export type StatusArticleMutation = { Coaching: { me?: { capsuleStatus?: boolean | null } | null } };

export type GetEbookQueryVariables = Exact<{
  model: CoachingEbookModel;
  modelId: Scalars['Int']['input'];
}>;


export type GetEbookQuery = { Coaching: { ebook?: { id: number, hasAudio: boolean, hasPdf: boolean } | null } };

export type DetailUserFragment = { needPreferenceThemes: boolean, hasPreferenceThemes: boolean, hasStandaloneAccess: boolean, permanentAccess?: boolean | null, datingToken?: string | null, displayName?: string | null, hasPassword: boolean, notificationFrequency: CoachingNotificationFrequency, legend: boolean, beRebilled: boolean, premium: boolean, premiumDays: number, nicheId: number, trialDays: number, webmasterId: number, paymentLayerAbTest?: string | null, user: { id: number, email: string, gender: Gender, birthdate?: Date | null, emailValidatedAt?: Date | null, userHasNiches?: Array<{ autoconnectLink: string, niche: { id: number, internalName: string }, site: { thumbnail?: string | null } }> | null }, site: { domain: string, redirectURL?: string | null }, coachingOrders?: Array<{ refunded?: boolean | null }> | null, language?: { id: number, code: string } | null, mediaTimecodes?: Array<{ model: UserHasMediaTimecodeModel, modelId: number, mediaType: MediaType, timecodeInSeconds: number } | null> | null };

export type FreeDetailThemeFragment = { id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null };

export type DetailThemeFragment = { id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, audioContent?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null };

export type CarouselArticleFragment = { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null };

export type DisplayArticleFragment = { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null };

export type FreeDisplayArticleFragment = { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, internalName?: string | null, theme?: { internalName: string, slug: string } | null };

export type DisplayLevelFragment = { label: string, position: number, current: boolean, unlocked: boolean, count: number, capsules?: Array<{ id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null }> | null };

export type DetailPaginationArticleFragment = { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null };

export type DetailCoachingOrderFragment = { source: CoachingOrderSource, slug?: string | null, rebillSlug?: string | null, refunded?: boolean | null, active?: boolean | null, lengthPeriod?: number | null, rebillable?: boolean | null, amount?: number | null, symbol?: string | null, enablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, disablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, nextDisablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null };

type ProductPrice_UserProductMembership_Fragment = { duration: string, isTrial: boolean, id: number, label: string, rebillProduct?: { duration: string, label: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } };

type ProductPrice_UserProductOther_Fragment = { id: number, label: string, price: { amount?: number | null, currencyCode?: any | null } };

type ProductPrice_UserProductQuota_Fragment = { id: number, label: string, price: { amount?: number | null, currencyCode?: any | null } };

export type ProductPriceFragment = ProductPrice_UserProductMembership_Fragment | ProductPrice_UserProductOther_Fragment | ProductPrice_UserProductQuota_Fragment;

type BuyResponse_BuyResponseError_Fragment = { __typename: 'BuyResponseError', failedPurchase?: { id: number } | null };

type BuyResponse_BuyResponseRedirect_Fragment = { __typename: 'BuyResponseRedirect', redirectURL: string, redirectPurchase: { id: number } };

type BuyResponse_BuyResponseSuccess_Fragment = { __typename: 'BuyResponseSuccess', successPurchase: { id: number } };

export type BuyResponseFragment = BuyResponse_BuyResponseError_Fragment | BuyResponse_BuyResponseRedirect_Fragment | BuyResponse_BuyResponseSuccess_Fragment;

export type MemberDetailsFragment = { isp?: string | null, ip?: string | null, startsAt?: Date | null, expiresAt?: Date | null, product?: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, account?: { id: number, method?: { label: string, description: string } | null, company?: { name: string, domainName?: string | null, phoneSupport?: { number: { countryCallingCode?: string | null, number?: string | null, nationalNumber?: string | null } } | null } | null } | { id: number, method?: { label: string, description: string } | null, company?: { name: string, domainName?: string | null, phoneSupport?: { number: { countryCallingCode?: string | null, number?: string | null, nationalNumber?: string | null } } | null } | null } | null };

export type GetCoachingGtmLtrQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  nicheId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  countryIso?: InputMaybe<Scalars['CountryCode']['input']>;
}>;


export type GetCoachingGtmLtrQuery = { GoogleTagManager?: { coachingLtr?: { conversion?: number | null, register?: number | null, mail_validation_doi?: number | null } | null } | null };

export type LevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type LevelsQuery = { Coaching: { me: { capsule?: { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null } | null, levels: Array<{ label: string, position: number, current: boolean, unlocked: boolean, count: number, capsules?: Array<{ id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null }> | null }> } } };

type ProductPriceFragment_UserProductMembership_Fragment = { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } };

type ProductPriceFragment_UserProductOther_Fragment = { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } };

type ProductPriceFragment_UserProductQuota_Fragment = { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } };

export type ProductPriceFragmentFragment = ProductPriceFragment_UserProductMembership_Fragment | ProductPriceFragment_UserProductOther_Fragment | ProductPriceFragment_UserProductQuota_Fragment;

export type CoachingProductQueryVariables = Exact<{
  trialId?: Scalars['Int']['input'];
  classicId?: Scalars['Int']['input'];
  oneYearId?: Scalars['Int']['input'];
}>;


export type CoachingProductQuery = { Coaching: { me: { trialProduct: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } }, classicProduct: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } }, oneYearProduct: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } } } };

export type CoachingClassicProductQueryVariables = Exact<{ [key: string]: never; }>;


export type CoachingClassicProductQuery = { Coaching: { me: { classicProduct: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } } } };

export type CoachingOneYearProductQueryVariables = Exact<{ [key: string]: never; }>;


export type CoachingOneYearProductQuery = { Coaching: { me: { oneYearProduct: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } } } };

export type CoachingOneYearDiscountedProductQueryVariables = Exact<{ [key: string]: never; }>;


export type CoachingOneYearDiscountedProductQuery = { Coaching: { me: { oneYearDiscountedProduct: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } } } };

export type CoachingFreeEbookProductQueryVariables = Exact<{ [key: string]: never; }>;


export type CoachingFreeEbookProductQuery = { Coaching: { me: { freeEbook: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } } } };

export type GetDataPaymentQueryVariables = Exact<{
  count: Scalars['Int']['input'];
}>;


export type GetDataPaymentQuery = { Coaching: { me: { paymentKey: string, availableMethods?: Array<MethodType> | null, availableMethodsWithConfig?: Array<{ script: Array<string>, type: MethodType, config?: { environment: string, gateway: string, gatewayMerchantId: string, merchantId: string, merchantName: string } | null }> | null } } };

export type PaymentCardDataQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type PaymentCardDataQuery = { model?: { cpgConfig?: { jsKey: string, publicKey: string } | null } | {} | null };

export type GetConfirmationPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfirmationPaymentQuery = { Coaching: { me: { displayName?: string | null, nicheId: number, user: { id: number, email: string }, language?: { code: string } | null, currentCoachingOrder?: { slug?: string | null } | null, membership: { isp?: string | null, ip?: string | null, startsAt?: Date | null, expiresAt?: Date | null, product?: { duration: string, isTrial: boolean, id: number, label: string, coachingLabel: string, rebillProduct?: { duration: string, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | { id: number, label: string, coachingLabel: string, price: { amount?: number | null, currencyCode?: any | null } } | null, account?: { id: number, method?: { label: string, description: string } | null, company?: { name: string, domainName?: string | null, phoneSupport?: { number: { countryCallingCode?: string | null, number?: string | null, nationalNumber?: string | null } } | null } | null } | { id: number, method?: { label: string, description: string } | null, company?: { name: string, domainName?: string | null, phoneSupport?: { number: { countryCallingCode?: string | null, number?: string | null, nationalNumber?: string | null } } | null } | null } | null } } } };

export type GetCurrentOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentOrderQuery = { Coaching: { me: { currentCoachingOrder?: { source: CoachingOrderSource, slug?: string | null, rebillSlug?: string | null, refunded?: boolean | null, active?: boolean | null, lengthPeriod?: number | null, rebillable?: boolean | null, amount?: number | null, symbol?: string | null, enablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, disablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, nextDisablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null } | null } } };

export type GetOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersQuery = { Coaching: { me: { coachingOrders?: Array<{ source: CoachingOrderSource, slug?: string | null, rebillSlug?: string | null, refunded?: boolean | null, active?: boolean | null, lengthPeriod?: number | null, rebillable?: boolean | null, amount?: number | null, symbol?: string | null, enablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, disablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, nextDisablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null }> | null } } };

export type HitDisplayMutationVariables = Exact<{
  extFor: Scalars['Int']['input'];
}>;


export type HitDisplayMutation = { Payment: { logDisplay?: number | null } };

export type BuyWithCardMutationVariables = Exact<{
  buy: BuyInput;
  device: DeviceInput;
  card: CardInput;
}>;


export type BuyWithCardMutation = { Payment: { buyWithCard?: { __typename: 'BuyResponseError', failedPurchase?: { id: number } | null } | { __typename: 'BuyResponseRedirect', redirectURL: string, redirectPurchase: { id: number } } | { __typename: 'BuyResponseSuccess', successPurchase: { id: number } } | null } };

export type InitAppleMutationVariables = Exact<{
  host: Scalars['String']['input'];
  validationURL: Scalars['URL']['input'];
}>;


export type InitAppleMutation = { Payment: { applePayValidation?: any | null } };

export type BuyWithApplePayMutationVariables = Exact<{
  buy: BuyInput;
  device: DeviceInput;
  applePayToken: ApplePayToken;
  customerInfo: CustomerInfoInput;
}>;


export type BuyWithApplePayMutation = { Payment: { buyWithApplePay?: { __typename: 'BuyResponseError', failedPurchase?: { id: number } | null } | { __typename: 'BuyResponseRedirect', redirectURL: string, redirectPurchase: { id: number } } | { __typename: 'BuyResponseSuccess', successPurchase: { id: number } } | null } };

export type BuyWithAgreementMutationVariables = Exact<{
  buy: BuyInput;
  device: DeviceInput;
}>;


export type BuyWithAgreementMutation = { Payment: { buyWithAgreement?: { __typename: 'BuyResponseError', failedPurchase?: { id: number } | null } | { __typename: 'BuyResponseRedirect', redirectURL: string, redirectPurchase: { id: number } } | { __typename: 'BuyResponseSuccess', successPurchase: { id: number } } | null } };

export type BuyWithGooglePayMutationVariables = Exact<{
  buy: BuyInput;
  device: DeviceInput;
  googlePayToken: GooglePayToken;
}>;


export type BuyWithGooglePayMutation = { Payment: { buyWithGooglePay?: { __typename: 'BuyResponseError', failedPurchase?: { id: number } | null } | { __typename: 'BuyResponseRedirect', redirectURL: string, redirectPurchase: { id: number } } | { __typename: 'BuyResponseSuccess', successPurchase: { id: number } } | null } };

export type StopRebillMutationVariables = Exact<{
  purchaseId: Scalars['Int']['input'];
  reason?: Scalars['String']['input'];
}>;


export type StopRebillMutation = { Payment: { stopRebill?: boolean | null } };

export type ActiveRebillMutationVariables = Exact<{
  purchaseId: Scalars['Int']['input'];
}>;


export type ActiveRebillMutation = { Payment: { resumeRebill?: boolean | null } };

export type DatingRebillUserMutationVariables = Exact<{
  slug: Scalars['ID']['input'];
  rebillable: Scalars['Boolean']['input'];
  category?: InputMaybe<StopRebillCategory>;
}>;


export type DatingRebillUserMutation = { model?: { updateRebill?: { succeed: boolean, errors?: Array<{ code: string, message: string } | { code: string, message: string } | { code: string, message: string } | { code: string, message: string }> | null } | null } | {} | null };

export type SendRebillMailCoachingMutationVariables = Exact<{
  rebillable: Scalars['Boolean']['input'];
}>;


export type SendRebillMailCoachingMutation = { Coaching: { rebill: boolean } };

export type GetInvoiceOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
  isNewPay: Scalars['Boolean']['input'];
}>;


export type GetInvoiceOrderQuery = { Coaching: { me: { getInvoiceUrl?: string | null } } };

export type GetContentLayerPaymentQueryVariables = Exact<{
  model: CoachingContentLayerPaymentModel;
  modelId: Scalars['Int']['input'];
}>;


export type GetContentLayerPaymentQuery = { Coaching: { contentLayerPayment: Array<{ model: CoachingContentLayerPaymentModel, modelId: number, position: number, thumbnail: string, content: string } | null> } };

export type GetOrdersByCreditCardQueryVariables = Exact<{
  panStart: Scalars['String']['input'];
  panEnd: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  amount: Scalars['Float']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrdersByCreditCardQuery = { Coaching: { pga?: { ordersByCreditCard: Array<{ source: CoachingOrderSource, slug?: string | null, token?: string | null, rebillSlug?: string | null, refunded?: boolean | null, active?: boolean | null, rebillable?: boolean | null, lengthPeriod?: number | null, amount?: number | null, symbol?: string | null, enablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, disablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null, nextDisablePeriod?: { startAt?: Date | null, endAt?: Date | null } | null }> } | null } };

export type GetOrdersByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  nicheId: Scalars['Int']['input'];
}>;


export type GetOrdersByEmailQuery = { Coaching: { pga?: { ordersByEmail: boolean } | null } };

export type SiteQueryVariables = Exact<{
  host: Scalars['String']['input'];
}>;


export type SiteQuery = { Coaching: { site?: { https: boolean, domain: string, icon?: string | null, name: string, redirectURL?: string | null, termsOfService?: any | null, thumbnailLight?: string | null, thumbnailDark?: string | null, privacyPolicy?: any | null, legalNotices?: any | null, options?: { company?: string | null, site?: string | null, hotjar?: string | null, mail?: string | null, phone?: string | null, description?: string | null, descripteur?: string | null, style?: { theme?: any | null } | null, google?: { analytics?: string | null, recaptcha?: string | null } | null, zendesk?: { key?: string | null, support?: string | null, phone?: string | null } | null } | null, niche?: { id: number, internalName: string } | null, company?: { name: string, address: string } | null } | null, languages: Array<{ id: number, code: string, label: string, translatedLabel: string, flag: string }> } };

export type SiteByCompanyQueryVariables = Exact<{
  company: Scalars['Int']['input'];
}>;


export type SiteByCompanyQuery = { Coaching: { sites?: Array<{ domain: string, niche?: { id: number, internalName: string } | null }> | null } };

export type ZendeskContactMutationVariables = Exact<{
  input: ZendeskContactInput;
}>;


export type ZendeskContactMutation = { Coaching: { zendeskContact: number } };

export type CompanyRedirectQueryVariables = Exact<{
  host: Scalars['String']['input'];
}>;


export type CompanyRedirectQuery = { Coaching: { companyRedirect?: { id: number } | null } };

export type UnloggedThemeQueryVariables = Exact<{
  host: Scalars['String']['input'];
}>;


export type UnloggedThemeQuery = { Coaching: { site?: { niche?: { themes?: Array<{ internalName: string, icon?: string | null }> | null } | null } | null } };

export type LoggedThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedThemesQuery = { Coaching: { me: { themes: Array<{ id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, audioContent?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null }> } } };

export type FreeLoggedThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type FreeLoggedThemesQuery = { Coaching: { me: { themes: Array<{ id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null }> } } };

export type LoggedThemeQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type LoggedThemeQuery = { Coaching: { me: { theme: { id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, audioContent?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null, capsules?: Array<{ id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null }> | null } } } };

export type FreeLoggedThemeQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FreeLoggedThemeQuery = { Coaching: { me: { theme: { id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null, capsules?: Array<{ id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, internalName?: string | null, theme?: { internalName: string, slug: string } | null }> | null } } } };

export type LoggedThemesWithoutCapsulesQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedThemesWithoutCapsulesQuery = { Coaching: { me: { themes: Array<{ id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, audioContent?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null }>, capsule?: { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, audioContent?: string | null, internalName?: string | null, theme?: { internalName: string, slug: string } | null } | null } } };

export type FreeLoggedThemesWithoutCapsulesQueryVariables = Exact<{ [key: string]: never; }>;


export type FreeLoggedThemesWithoutCapsulesQuery = { Coaching: { me: { themes: Array<{ id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null }>, capsule?: { id: number, levelPosition: number, release?: string | null, title?: string | null, uriSlug: string, thumbnail?: string | null, status: CoachingCapsuleStatus, position: number, internalName?: string | null, theme?: { internalName: string, slug: string } | null } | null } } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { Coaching: { me: { needPreferenceThemes: boolean, hasPreferenceThemes: boolean, hasStandaloneAccess: boolean, permanentAccess?: boolean | null, datingToken?: string | null, displayName?: string | null, hasPassword: boolean, notificationFrequency: CoachingNotificationFrequency, legend: boolean, beRebilled: boolean, premium: boolean, premiumDays: number, nicheId: number, trialDays: number, webmasterId: number, paymentLayerAbTest?: string | null, user: { id: number, email: string, gender: Gender, birthdate?: Date | null, emailValidatedAt?: Date | null, userHasNiches?: Array<{ autoconnectLink: string, niche: { id: number, internalName: string }, site: { thumbnail?: string | null } }> | null }, site: { domain: string, redirectURL?: string | null }, coachingOrders?: Array<{ refunded?: boolean | null }> | null, language?: { id: number, code: string } | null, mediaTimecodes?: Array<{ model: UserHasMediaTimecodeModel, modelId: number, mediaType: MediaType, timecodeInSeconds: number } | null> | null } } };

export type CheckEmailQueryVariables = Exact<{
  host: Scalars['String']['input'];
  email: Scalars['String']['input'];
  useIpqs?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CheckEmailQuery = { Coaching: { checkEmail: { switchDomain?: string | null, user: boolean, userHasNiche: boolean, message?: string | null } } };

export type TransformDatingTokenQueryVariables = Exact<{
  datingToken: Scalars['String']['input'];
}>;


export type TransformDatingTokenQuery = { Coaching: { transformDatingToken: string } };

export type RandomUsernamesQueryVariables = Exact<{ [key: string]: never; }>;


export type RandomUsernamesQuery = { Coaching: { randomUsernames: Array<string> } };

export type LogConnectionMutationVariables = Exact<{
  source?: InputMaybe<CoachingSourceConnection>;
}>;


export type LogConnectionMutation = { Coaching: { me?: { logConnection?: boolean | null } | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  host: Scalars['String']['input'];
}>;


export type LoginMutation = { Coaching: { signIn: string } };

export type ForgotMutationVariables = Exact<{
  email: Scalars['String']['input'];
  host: Scalars['String']['input'];
}>;


export type ForgotMutation = { Coaching: { resetPassword: { success: boolean, refunded?: boolean | null } } };

export type PasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type PasswordMutation = { Coaching: { me?: { generatePassword?: boolean | null } | null } };

export type RegisterMutationVariables = Exact<{
  data: CoachingRegisterUserInput;
}>;


export type RegisterMutation = { Coaching: { registerUser: { redirectURL: string, token: string } } };

export type UpdateUserMutationVariables = Exact<{
  input: CoachingUserUpdateInput;
}>;


export type UpdateUserMutation = { Coaching: { me?: { update?: { needPreferenceThemes: boolean, hasPreferenceThemes: boolean, hasStandaloneAccess: boolean, permanentAccess?: boolean | null, datingToken?: string | null, displayName?: string | null, hasPassword: boolean, notificationFrequency: CoachingNotificationFrequency, legend: boolean, beRebilled: boolean, premium: boolean, premiumDays: number, nicheId: number, trialDays: number, webmasterId: number, paymentLayerAbTest?: string | null, user: { id: number, email: string, gender: Gender, birthdate?: Date | null, emailValidatedAt?: Date | null, userHasNiches?: Array<{ autoconnectLink: string, niche: { id: number, internalName: string }, site: { thumbnail?: string | null } }> | null }, site: { domain: string, redirectURL?: string | null }, coachingOrders?: Array<{ refunded?: boolean | null }> | null, language?: { id: number, code: string } | null, mediaTimecodes?: Array<{ model: UserHasMediaTimecodeModel, modelId: number, mediaType: MediaType, timecodeInSeconds: number } | null> | null } | null } | null } };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { Coaching: { me?: { delete: boolean } | null } };

export type AskConfirmationEmailMutationVariables = Exact<{
  host: Scalars['String']['input'];
}>;


export type AskConfirmationEmailMutation = { Coaching: { me?: { askConfirmationEmail: boolean } | null } };

export type ConfirmEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ConfirmEmailMutation = { Coaching: { me?: { confirmEmail: boolean } | null } };

export type PrefThemesMutationVariables = Exact<{
  input?: InputMaybe<Array<CoachingMutationThemePreference> | CoachingMutationThemePreference>;
}>;


export type PrefThemesMutation = { Coaching: { me?: { setThemePreference: Array<{ id: number, internalName: string, thumbnail?: string | null, slug: string, icon?: string | null, description?: string | null, audioContent?: string | null, progressPercentage: number, position?: number | null, preferencePosition?: number | null }> } | null } };

export type SetPseudoMutationVariables = Exact<{
  pseudo: Scalars['String']['input'];
}>;


export type SetPseudoMutation = { Coaching: { me?: { setPseudo: boolean } | null } };

export type SetBirthDateMutationVariables = Exact<{
  bornDate: Scalars['String']['input'];
}>;


export type SetBirthDateMutation = { Coaching: { me?: { setBirthDate: boolean } | null } };

export type SetMediaTimecodeMutationVariables = Exact<{
  model: UserHasMediaTimecodeModel;
  modelId: Scalars['Int']['input'];
  mediaType: MediaType;
  timecodeInSeconds: Scalars['Int']['input'];
}>;


export type SetMediaTimecodeMutation = { Coaching: { me?: { setMediaTimecode: boolean } | null } };

export type GetWordingContentsQueryVariables = Exact<{
  model: CoachingWordingContentModel;
  modelId: Scalars['Int']['input'];
  category: Scalars['String']['input'];
}>;


export type GetWordingContentsQuery = { Coaching: { wordingContents: Array<{ content: string } | null> } };

export type GetWordingContentOfferPdpQueryVariables = Exact<{
  ebookId: Scalars['Int']['input'];
}>;


export type GetWordingContentOfferPdpQuery = { image: { wordingContents: Array<{ content: string } | null> }, text: { wordingContents: Array<{ content: string } | null> } };

export type GetWordingContentEbookFilenameQueryVariables = Exact<{
  ebookId: Scalars['Int']['input'];
}>;


export type GetWordingContentEbookFilenameQuery = { Coaching: { wordingContents: Array<{ content: string } | null> } };

export const DetailUserFragmentDoc = gql`
    fragment detailUser on CoachingUserHasNiche {
  user {
    id
    email
    gender
    birthdate
    emailValidatedAt
    userHasNiches {
      autoconnectLink
      niche {
        id
        internalName
      }
      site {
        thumbnail
      }
    }
  }
  needPreferenceThemes
  hasPreferenceThemes
  hasStandaloneAccess
  permanentAccess
  datingToken
  displayName
  hasPassword
  notificationFrequency
  legend
  beRebilled
  premium
  premiumDays
  nicheId
  trialDays
  webmasterId
  site {
    domain
    redirectURL
  }
  coachingOrders {
    refunded
  }
  paymentLayerAbTest: abTest(id: 2)
  language {
    id
    code
  }
  mediaTimecodes {
    model
    modelId
    mediaType
    timecodeInSeconds
  }
}
    `;
export const FreeDetailThemeFragmentDoc = gql`
    fragment freeDetailTheme on CoachingTheme {
  id
  internalName
  thumbnail
  slug
  icon
  description
  progressPercentage
  position
  preferencePosition
}
    `;
export const DetailThemeFragmentDoc = gql`
    fragment detailTheme on CoachingTheme {
  id
  internalName
  thumbnail
  slug
  icon
  description
  audioContent
  progressPercentage
  position
  preferencePosition
}
    `;
export const CarouselArticleFragmentDoc = gql`
    fragment carouselArticle on CoachingCapsule {
  id
  levelPosition
  release
  title
  uriSlug
  thumbnail
  status
  position
  audioContent
  internalName
}
    `;
export const FreeDisplayArticleFragmentDoc = gql`
    fragment freeDisplayArticle on CoachingCapsule {
  id
  levelPosition
  release
  title
  uriSlug
  thumbnail
  status
  position
  theme {
    internalName
    slug
  }
  internalName
}
    `;
export const DisplayArticleFragmentDoc = gql`
    fragment displayArticle on CoachingCapsule {
  id
  levelPosition
  release
  title
  uriSlug
  thumbnail
  status
  position
  audioContent
  theme {
    internalName
    slug
  }
  internalName
}
    `;
export const DisplayLevelFragmentDoc = gql`
    fragment displayLevel on CoachingLevel {
  label
  position
  current
  unlocked
  count
  capsules {
    ...displayArticle
  }
}
    ${DisplayArticleFragmentDoc}`;
export const DetailPaginationArticleFragmentDoc = gql`
    fragment detailPaginationArticle on CoachingCapsule {
  id
  levelPosition
  release
  title
  uriSlug
  thumbnail
  status
  position
  audioContent
  theme {
    internalName
    slug
  }
  internalName
}
    `;
export const DetailCoachingOrderFragmentDoc = gql`
    fragment detailCoachingOrder on CoachingOrder {
  source
  slug
  rebillSlug
  refunded
  active
  lengthPeriod
  rebillable
  enablePeriod {
    startAt
    endAt
  }
  disablePeriod {
    startAt
    endAt
  }
  nextDisablePeriod {
    startAt
    endAt
  }
  amount
  symbol
}
    `;
export const ProductPriceFragmentDoc = gql`
    fragment productPrice on UserProduct {
  id
  label
  price {
    amount
    currencyCode
  }
  ... on UserProductMembership {
    duration
    isTrial
    rebillProduct {
      label
      price {
        amount
        currencyCode
      }
      ... on UserProductMembership {
        duration
      }
    }
  }
}
    `;
export const BuyResponseFragmentDoc = gql`
    fragment buyResponse on BuyResponse {
  ... on BuyResponseSuccess {
    successPurchase: purchase {
      id
    }
    __typename
  }
  ... on BuyResponseRedirect {
    redirectPurchase: purchase {
      id
    }
    redirectURL
    __typename
  }
  ... on BuyResponseError {
    failedPurchase: purchase {
      id
    }
    __typename
  }
}
    `;
export const ProductPriceFragmentFragmentDoc = gql`
    fragment productPriceFragment on UserProduct {
  id
  label
  coachingLabel
  price {
    amount
    currencyCode
  }
  ... on UserProductMembership {
    duration
    isTrial
    rebillProduct {
      label
      coachingLabel
      price {
        amount
        currencyCode
      }
      ... on UserProductMembership {
        duration
      }
    }
  }
}
    `;
export const MemberDetailsFragmentDoc = gql`
    fragment memberDetails on MembershipDetails {
  product {
    ...productPriceFragment
  }
  isp
  ip
  startsAt
  expiresAt
  account {
    id
    method {
      label
      description
    }
    company {
      name
      domainName
      phoneSupport {
        number {
          countryCallingCode
          number
          nationalNumber
        }
      }
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;
export const GetAbTestDocument = gql`
    query getAbTest($id: Int!) {
  Coaching {
    me {
      abTest(id: $id)
    }
  }
}
    `;

/**
 * __useGetAbTestQuery__
 *
 * To run a query within a Vue component, call `useGetAbTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbTestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAbTestQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAbTestQuery(variables: GetAbTestQueryVariables | VueCompositionApi.Ref<GetAbTestQueryVariables> | ReactiveFunction<GetAbTestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAbTestQuery, GetAbTestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAbTestQuery, GetAbTestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAbTestQuery, GetAbTestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAbTestQuery, GetAbTestQueryVariables>(GetAbTestDocument, variables, options);
}
export function useGetAbTestLazyQuery(variables?: GetAbTestQueryVariables | VueCompositionApi.Ref<GetAbTestQueryVariables> | ReactiveFunction<GetAbTestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAbTestQuery, GetAbTestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAbTestQuery, GetAbTestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAbTestQuery, GetAbTestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAbTestQuery, GetAbTestQueryVariables>(GetAbTestDocument, variables, options);
}
export type GetAbTestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAbTestQuery, GetAbTestQueryVariables>;
export const GetArticleDocument = gql`
    query getArticle($input: CoachingCapsuleByUserInput!) {
  Coaching {
    me {
      capsule(search: $input) {
        id
        levelPosition
        title
        thumbnail
        position
        htmlContent
        videoContent
        audioContent
        status
        slug
        theme {
          slug
          internalName
          capsules {
            ...carouselArticle
          }
        }
        pagination(next: true, previous: true) {
          next {
            ...detailPaginationArticle
          }
          previous {
            ...detailPaginationArticle
          }
        }
      }
    }
  }
}
    ${CarouselArticleFragmentDoc}
${DetailPaginationArticleFragmentDoc}`;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a Vue component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetArticleQuery(variables: GetArticleQueryVariables | VueCompositionApi.Ref<GetArticleQueryVariables> | ReactiveFunction<GetArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, variables, options);
}
export function useGetArticleLazyQuery(variables?: GetArticleQueryVariables | VueCompositionApi.Ref<GetArticleQueryVariables> | ReactiveFunction<GetArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, variables, options);
}
export type GetArticleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleQuery, GetArticleQueryVariables>;
export const StatusArticleDocument = gql`
    mutation statusArticle($id: Int!, $status: CoachingCapsuleStatus!) {
  Coaching {
    me {
      capsuleStatus(id: $id, status: $status)
    }
  }
}
    `;

/**
 * __useStatusArticleMutation__
 *
 * To run a mutation, you first call `useStatusArticleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStatusArticleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStatusArticleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useStatusArticleMutation(options: VueApolloComposable.UseMutationOptions<StatusArticleMutation, StatusArticleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StatusArticleMutation, StatusArticleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StatusArticleMutation, StatusArticleMutationVariables>(StatusArticleDocument, options);
}
export type StatusArticleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StatusArticleMutation, StatusArticleMutationVariables>;
export const GetEbookDocument = gql`
    query getEbook($model: CoachingEbookModel!, $modelId: Int!) {
  Coaching {
    ebook(model: $model, modelId: $modelId) {
      id
      hasAudio
      hasPdf
    }
  }
}
    `;

/**
 * __useGetEbookQuery__
 *
 * To run a query within a Vue component, call `useGetEbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEbookQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEbookQuery({
 *   model: // value for 'model'
 *   modelId: // value for 'modelId'
 * });
 */
export function useGetEbookQuery(variables: GetEbookQueryVariables | VueCompositionApi.Ref<GetEbookQueryVariables> | ReactiveFunction<GetEbookQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEbookQuery, GetEbookQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEbookQuery, GetEbookQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEbookQuery, GetEbookQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEbookQuery, GetEbookQueryVariables>(GetEbookDocument, variables, options);
}
export function useGetEbookLazyQuery(variables?: GetEbookQueryVariables | VueCompositionApi.Ref<GetEbookQueryVariables> | ReactiveFunction<GetEbookQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEbookQuery, GetEbookQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEbookQuery, GetEbookQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEbookQuery, GetEbookQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEbookQuery, GetEbookQueryVariables>(GetEbookDocument, variables, options);
}
export type GetEbookQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEbookQuery, GetEbookQueryVariables>;
export const GetCoachingGtmLtrDocument = gql`
    query getCoachingGtmLtr($userId: Int, $nicheId: Int, $productId: Int, $countryIso: CountryCode) {
  GoogleTagManager {
    coachingLtr(
      userId: $userId
      nicheId: $nicheId
      productId: $productId
      countryIso: $countryIso
    ) {
      conversion
      register
      mail_validation_doi
    }
  }
}
    `;

/**
 * __useGetCoachingGtmLtrQuery__
 *
 * To run a query within a Vue component, call `useGetCoachingGtmLtrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingGtmLtrQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoachingGtmLtrQuery({
 *   userId: // value for 'userId'
 *   nicheId: // value for 'nicheId'
 *   productId: // value for 'productId'
 *   countryIso: // value for 'countryIso'
 * });
 */
export function useGetCoachingGtmLtrQuery(variables: GetCoachingGtmLtrQueryVariables | VueCompositionApi.Ref<GetCoachingGtmLtrQueryVariables> | ReactiveFunction<GetCoachingGtmLtrQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>(GetCoachingGtmLtrDocument, variables, options);
}
export function useGetCoachingGtmLtrLazyQuery(variables: GetCoachingGtmLtrQueryVariables | VueCompositionApi.Ref<GetCoachingGtmLtrQueryVariables> | ReactiveFunction<GetCoachingGtmLtrQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>(GetCoachingGtmLtrDocument, variables, options);
}
export type GetCoachingGtmLtrQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCoachingGtmLtrQuery, GetCoachingGtmLtrQueryVariables>;
export const LevelsDocument = gql`
    query levels {
  Coaching {
    me {
      capsule(search: {progress: true}) {
        ...displayArticle
      }
      levels {
        ...displayLevel
      }
    }
  }
}
    ${DisplayArticleFragmentDoc}
${DisplayLevelFragmentDoc}`;

/**
 * __useLevelsQuery__
 *
 * To run a query within a Vue component, call `useLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLevelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLevelsQuery();
 */
export function useLevelsQuery(options: VueApolloComposable.UseQueryOptions<LevelsQuery, LevelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LevelsQuery, LevelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LevelsQuery, LevelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LevelsQuery, LevelsQueryVariables>(LevelsDocument, {}, options);
}
export function useLevelsLazyQuery(options: VueApolloComposable.UseQueryOptions<LevelsQuery, LevelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LevelsQuery, LevelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LevelsQuery, LevelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LevelsQuery, LevelsQueryVariables>(LevelsDocument, {}, options);
}
export type LevelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LevelsQuery, LevelsQueryVariables>;
export const CoachingProductDocument = gql`
    query coachingProduct($trialId: Int! = 1, $classicId: Int! = 2, $oneYearId: Int! = 12) {
  Coaching {
    me {
      trialProduct: product(productId: $trialId) {
        ...productPriceFragment
      }
      classicProduct: product(productId: $classicId) {
        ...productPriceFragment
      }
      oneYearProduct: product(productId: $oneYearId) {
        ...productPriceFragment
      }
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;

/**
 * __useCoachingProductQuery__
 *
 * To run a query within a Vue component, call `useCoachingProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCoachingProductQuery({
 *   trialId: // value for 'trialId'
 *   classicId: // value for 'classicId'
 *   oneYearId: // value for 'oneYearId'
 * });
 */
export function useCoachingProductQuery(variables: CoachingProductQueryVariables | VueCompositionApi.Ref<CoachingProductQueryVariables> | ReactiveFunction<CoachingProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<CoachingProductQuery, CoachingProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingProductQuery, CoachingProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingProductQuery, CoachingProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CoachingProductQuery, CoachingProductQueryVariables>(CoachingProductDocument, variables, options);
}
export function useCoachingProductLazyQuery(variables?: CoachingProductQueryVariables | VueCompositionApi.Ref<CoachingProductQueryVariables> | ReactiveFunction<CoachingProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<CoachingProductQuery, CoachingProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingProductQuery, CoachingProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingProductQuery, CoachingProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CoachingProductQuery, CoachingProductQueryVariables>(CoachingProductDocument, variables, options);
}
export type CoachingProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CoachingProductQuery, CoachingProductQueryVariables>;
export const CoachingClassicProductDocument = gql`
    query coachingClassicProduct {
  Coaching {
    me {
      classicProduct: product(productId: 2) {
        ...productPriceFragment
      }
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;

/**
 * __useCoachingClassicProductQuery__
 *
 * To run a query within a Vue component, call `useCoachingClassicProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingClassicProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCoachingClassicProductQuery();
 */
export function useCoachingClassicProductQuery(options: VueApolloComposable.UseQueryOptions<CoachingClassicProductQuery, CoachingClassicProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>(CoachingClassicProductDocument, {}, options);
}
export function useCoachingClassicProductLazyQuery(options: VueApolloComposable.UseQueryOptions<CoachingClassicProductQuery, CoachingClassicProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>(CoachingClassicProductDocument, {}, options);
}
export type CoachingClassicProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CoachingClassicProductQuery, CoachingClassicProductQueryVariables>;
export const CoachingOneYearProductDocument = gql`
    query coachingOneYearProduct {
  Coaching {
    me {
      oneYearProduct: product(productId: 12) {
        ...productPriceFragment
      }
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;

/**
 * __useCoachingOneYearProductQuery__
 *
 * To run a query within a Vue component, call `useCoachingOneYearProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingOneYearProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCoachingOneYearProductQuery();
 */
export function useCoachingOneYearProductQuery(options: VueApolloComposable.UseQueryOptions<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>(CoachingOneYearProductDocument, {}, options);
}
export function useCoachingOneYearProductLazyQuery(options: VueApolloComposable.UseQueryOptions<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>(CoachingOneYearProductDocument, {}, options);
}
export type CoachingOneYearProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CoachingOneYearProductQuery, CoachingOneYearProductQueryVariables>;
export const CoachingOneYearDiscountedProductDocument = gql`
    query coachingOneYearDiscountedProduct {
  Coaching {
    me {
      oneYearDiscountedProduct: product(productId: 15) {
        ...productPriceFragment
      }
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;

/**
 * __useCoachingOneYearDiscountedProductQuery__
 *
 * To run a query within a Vue component, call `useCoachingOneYearDiscountedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingOneYearDiscountedProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCoachingOneYearDiscountedProductQuery();
 */
export function useCoachingOneYearDiscountedProductQuery(options: VueApolloComposable.UseQueryOptions<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>(CoachingOneYearDiscountedProductDocument, {}, options);
}
export function useCoachingOneYearDiscountedProductLazyQuery(options: VueApolloComposable.UseQueryOptions<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>(CoachingOneYearDiscountedProductDocument, {}, options);
}
export type CoachingOneYearDiscountedProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CoachingOneYearDiscountedProductQuery, CoachingOneYearDiscountedProductQueryVariables>;
export const CoachingFreeEbookProductDocument = gql`
    query coachingFreeEbookProduct {
  Coaching {
    me {
      freeEbook: product(productId: 14) {
        ...productPriceFragment
      }
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;

/**
 * __useCoachingFreeEbookProductQuery__
 *
 * To run a query within a Vue component, call `useCoachingFreeEbookProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingFreeEbookProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCoachingFreeEbookProductQuery();
 */
export function useCoachingFreeEbookProductQuery(options: VueApolloComposable.UseQueryOptions<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>(CoachingFreeEbookProductDocument, {}, options);
}
export function useCoachingFreeEbookProductLazyQuery(options: VueApolloComposable.UseQueryOptions<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>(CoachingFreeEbookProductDocument, {}, options);
}
export type CoachingFreeEbookProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CoachingFreeEbookProductQuery, CoachingFreeEbookProductQueryVariables>;
export const GetDataPaymentDocument = gql`
    query getDataPayment($count: Int!) {
  Coaching {
    me {
      paymentKey
      availableMethods(tryCount: $count)
      availableMethodsWithConfig(tryCount: $count) {
        config {
          environment
          gateway
          gatewayMerchantId
          merchantId
          merchantName
        }
        script
        type
      }
    }
  }
}
    `;

/**
 * __useGetDataPaymentQuery__
 *
 * To run a query within a Vue component, call `useGetDataPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDataPaymentQuery({
 *   count: // value for 'count'
 * });
 */
export function useGetDataPaymentQuery(variables: GetDataPaymentQueryVariables | VueCompositionApi.Ref<GetDataPaymentQueryVariables> | ReactiveFunction<GetDataPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDataPaymentQuery, GetDataPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDataPaymentQuery, GetDataPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDataPaymentQuery, GetDataPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDataPaymentQuery, GetDataPaymentQueryVariables>(GetDataPaymentDocument, variables, options);
}
export function useGetDataPaymentLazyQuery(variables?: GetDataPaymentQueryVariables | VueCompositionApi.Ref<GetDataPaymentQueryVariables> | ReactiveFunction<GetDataPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDataPaymentQuery, GetDataPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDataPaymentQuery, GetDataPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDataPaymentQuery, GetDataPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDataPaymentQuery, GetDataPaymentQueryVariables>(GetDataPaymentDocument, variables, options);
}
export type GetDataPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDataPaymentQuery, GetDataPaymentQueryVariables>;
export const PaymentCardDataDocument = gql`
    query paymentCardData($slug: ID!) {
  model(slug: $slug) {
    ... on Company {
      cpgConfig {
        jsKey
        publicKey
      }
    }
  }
}
    `;

/**
 * __usePaymentCardDataQuery__
 *
 * To run a query within a Vue component, call `usePaymentCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCardDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePaymentCardDataQuery({
 *   slug: // value for 'slug'
 * });
 */
export function usePaymentCardDataQuery(variables: PaymentCardDataQueryVariables | VueCompositionApi.Ref<PaymentCardDataQueryVariables> | ReactiveFunction<PaymentCardDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<PaymentCardDataQuery, PaymentCardDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PaymentCardDataQuery, PaymentCardDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PaymentCardDataQuery, PaymentCardDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PaymentCardDataQuery, PaymentCardDataQueryVariables>(PaymentCardDataDocument, variables, options);
}
export function usePaymentCardDataLazyQuery(variables?: PaymentCardDataQueryVariables | VueCompositionApi.Ref<PaymentCardDataQueryVariables> | ReactiveFunction<PaymentCardDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<PaymentCardDataQuery, PaymentCardDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PaymentCardDataQuery, PaymentCardDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PaymentCardDataQuery, PaymentCardDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PaymentCardDataQuery, PaymentCardDataQueryVariables>(PaymentCardDataDocument, variables, options);
}
export type PaymentCardDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PaymentCardDataQuery, PaymentCardDataQueryVariables>;
export const GetConfirmationPaymentDocument = gql`
    query getConfirmationPayment {
  Coaching {
    me {
      displayName
      user {
        id
        email
      }
      nicheId
      language {
        code
      }
      currentCoachingOrder {
        slug
      }
      membership {
        ...memberDetails
      }
    }
  }
}
    ${MemberDetailsFragmentDoc}`;

/**
 * __useGetConfirmationPaymentQuery__
 *
 * To run a query within a Vue component, call `useGetConfirmationPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfirmationPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConfirmationPaymentQuery();
 */
export function useGetConfirmationPaymentQuery(options: VueApolloComposable.UseQueryOptions<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>(GetConfirmationPaymentDocument, {}, options);
}
export function useGetConfirmationPaymentLazyQuery(options: VueApolloComposable.UseQueryOptions<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>(GetConfirmationPaymentDocument, {}, options);
}
export type GetConfirmationPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConfirmationPaymentQuery, GetConfirmationPaymentQueryVariables>;
export const GetCurrentOrderDocument = gql`
    query getCurrentOrder {
  Coaching {
    me {
      currentCoachingOrder {
        ...detailCoachingOrder
      }
    }
  }
}
    ${DetailCoachingOrderFragmentDoc}`;

/**
 * __useGetCurrentOrderQuery__
 *
 * To run a query within a Vue component, call `useGetCurrentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentOrderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCurrentOrderQuery();
 */
export function useGetCurrentOrderQuery(options: VueApolloComposable.UseQueryOptions<GetCurrentOrderQuery, GetCurrentOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>(GetCurrentOrderDocument, {}, options);
}
export function useGetCurrentOrderLazyQuery(options: VueApolloComposable.UseQueryOptions<GetCurrentOrderQuery, GetCurrentOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>(GetCurrentOrderDocument, {}, options);
}
export type GetCurrentOrderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCurrentOrderQuery, GetCurrentOrderQueryVariables>;
export const GetOrdersDocument = gql`
    query getOrders {
  Coaching {
    me {
      coachingOrders {
        ...detailCoachingOrder
      }
    }
  }
}
    ${DetailCoachingOrderFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a Vue component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrdersQuery();
 */
export function useGetOrdersQuery(options: VueApolloComposable.UseQueryOptions<GetOrdersQuery, GetOrdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrdersQuery, GetOrdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrdersQuery, GetOrdersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, {}, options);
}
export function useGetOrdersLazyQuery(options: VueApolloComposable.UseQueryOptions<GetOrdersQuery, GetOrdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrdersQuery, GetOrdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrdersQuery, GetOrdersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, {}, options);
}
export type GetOrdersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrdersQuery, GetOrdersQueryVariables>;
export const HitDisplayDocument = gql`
    mutation hitDisplay($extFor: Int!) {
  Payment {
    logDisplay(extForId: $extFor)
  }
}
    `;

/**
 * __useHitDisplayMutation__
 *
 * To run a mutation, you first call `useHitDisplayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useHitDisplayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useHitDisplayMutation({
 *   variables: {
 *     extFor: // value for 'extFor'
 *   },
 * });
 */
export function useHitDisplayMutation(options: VueApolloComposable.UseMutationOptions<HitDisplayMutation, HitDisplayMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<HitDisplayMutation, HitDisplayMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<HitDisplayMutation, HitDisplayMutationVariables>(HitDisplayDocument, options);
}
export type HitDisplayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<HitDisplayMutation, HitDisplayMutationVariables>;
export const BuyWithCardDocument = gql`
    mutation buyWithCard($buy: BuyInput!, $device: DeviceInput!, $card: CardInput!) {
  Payment {
    buyWithCard(buy: $buy, device: $device, card: $card) {
      ...buyResponse
    }
  }
}
    ${BuyResponseFragmentDoc}`;

/**
 * __useBuyWithCardMutation__
 *
 * To run a mutation, you first call `useBuyWithCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBuyWithCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBuyWithCardMutation({
 *   variables: {
 *     buy: // value for 'buy'
 *     device: // value for 'device'
 *     card: // value for 'card'
 *   },
 * });
 */
export function useBuyWithCardMutation(options: VueApolloComposable.UseMutationOptions<BuyWithCardMutation, BuyWithCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BuyWithCardMutation, BuyWithCardMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BuyWithCardMutation, BuyWithCardMutationVariables>(BuyWithCardDocument, options);
}
export type BuyWithCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BuyWithCardMutation, BuyWithCardMutationVariables>;
export const InitAppleDocument = gql`
    mutation initApple($host: String!, $validationURL: URL!) {
  Payment {
    applePayValidation(host: $host, validationURL: $validationURL)
  }
}
    `;

/**
 * __useInitAppleMutation__
 *
 * To run a mutation, you first call `useInitAppleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInitAppleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInitAppleMutation({
 *   variables: {
 *     host: // value for 'host'
 *     validationURL: // value for 'validationURL'
 *   },
 * });
 */
export function useInitAppleMutation(options: VueApolloComposable.UseMutationOptions<InitAppleMutation, InitAppleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InitAppleMutation, InitAppleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InitAppleMutation, InitAppleMutationVariables>(InitAppleDocument, options);
}
export type InitAppleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InitAppleMutation, InitAppleMutationVariables>;
export const BuyWithApplePayDocument = gql`
    mutation buyWithApplePay($buy: BuyInput!, $device: DeviceInput!, $applePayToken: ApplePayToken!, $customerInfo: CustomerInfoInput!) {
  Payment {
    buyWithApplePay(
      buy: $buy
      device: $device
      applePayToken: $applePayToken
      customerInfo: $customerInfo
    ) {
      ...buyResponse
    }
  }
}
    ${BuyResponseFragmentDoc}`;

/**
 * __useBuyWithApplePayMutation__
 *
 * To run a mutation, you first call `useBuyWithApplePayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBuyWithApplePayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBuyWithApplePayMutation({
 *   variables: {
 *     buy: // value for 'buy'
 *     device: // value for 'device'
 *     applePayToken: // value for 'applePayToken'
 *     customerInfo: // value for 'customerInfo'
 *   },
 * });
 */
export function useBuyWithApplePayMutation(options: VueApolloComposable.UseMutationOptions<BuyWithApplePayMutation, BuyWithApplePayMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BuyWithApplePayMutation, BuyWithApplePayMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BuyWithApplePayMutation, BuyWithApplePayMutationVariables>(BuyWithApplePayDocument, options);
}
export type BuyWithApplePayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BuyWithApplePayMutation, BuyWithApplePayMutationVariables>;
export const BuyWithAgreementDocument = gql`
    mutation buyWithAgreement($buy: BuyInput!, $device: DeviceInput!) {
  Payment {
    buyWithAgreement(buy: $buy, device: $device) {
      ...buyResponse
    }
  }
}
    ${BuyResponseFragmentDoc}`;

/**
 * __useBuyWithAgreementMutation__
 *
 * To run a mutation, you first call `useBuyWithAgreementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBuyWithAgreementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBuyWithAgreementMutation({
 *   variables: {
 *     buy: // value for 'buy'
 *     device: // value for 'device'
 *   },
 * });
 */
export function useBuyWithAgreementMutation(options: VueApolloComposable.UseMutationOptions<BuyWithAgreementMutation, BuyWithAgreementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BuyWithAgreementMutation, BuyWithAgreementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BuyWithAgreementMutation, BuyWithAgreementMutationVariables>(BuyWithAgreementDocument, options);
}
export type BuyWithAgreementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BuyWithAgreementMutation, BuyWithAgreementMutationVariables>;
export const BuyWithGooglePayDocument = gql`
    mutation buyWithGooglePay($buy: BuyInput!, $device: DeviceInput!, $googlePayToken: GooglePayToken!) {
  Payment {
    buyWithGooglePay(buy: $buy, device: $device, googlePayToken: $googlePayToken) {
      ...buyResponse
    }
  }
}
    ${BuyResponseFragmentDoc}`;

/**
 * __useBuyWithGooglePayMutation__
 *
 * To run a mutation, you first call `useBuyWithGooglePayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBuyWithGooglePayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBuyWithGooglePayMutation({
 *   variables: {
 *     buy: // value for 'buy'
 *     device: // value for 'device'
 *     googlePayToken: // value for 'googlePayToken'
 *   },
 * });
 */
export function useBuyWithGooglePayMutation(options: VueApolloComposable.UseMutationOptions<BuyWithGooglePayMutation, BuyWithGooglePayMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BuyWithGooglePayMutation, BuyWithGooglePayMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BuyWithGooglePayMutation, BuyWithGooglePayMutationVariables>(BuyWithGooglePayDocument, options);
}
export type BuyWithGooglePayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BuyWithGooglePayMutation, BuyWithGooglePayMutationVariables>;
export const StopRebillDocument = gql`
    mutation stopRebill($purchaseId: Int!, $reason: String! = "self") {
  Payment {
    stopRebill(itemId: $purchaseId, reason: $reason)
  }
}
    `;

/**
 * __useStopRebillMutation__
 *
 * To run a mutation, you first call `useStopRebillMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopRebillMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopRebillMutation({
 *   variables: {
 *     purchaseId: // value for 'purchaseId'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useStopRebillMutation(options: VueApolloComposable.UseMutationOptions<StopRebillMutation, StopRebillMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StopRebillMutation, StopRebillMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StopRebillMutation, StopRebillMutationVariables>(StopRebillDocument, options);
}
export type StopRebillMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StopRebillMutation, StopRebillMutationVariables>;
export const ActiveRebillDocument = gql`
    mutation activeRebill($purchaseId: Int!) {
  Payment {
    resumeRebill(itemId: $purchaseId)
  }
}
    `;

/**
 * __useActiveRebillMutation__
 *
 * To run a mutation, you first call `useActiveRebillMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActiveRebillMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActiveRebillMutation({
 *   variables: {
 *     purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useActiveRebillMutation(options: VueApolloComposable.UseMutationOptions<ActiveRebillMutation, ActiveRebillMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActiveRebillMutation, ActiveRebillMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActiveRebillMutation, ActiveRebillMutationVariables>(ActiveRebillDocument, options);
}
export type ActiveRebillMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActiveRebillMutation, ActiveRebillMutationVariables>;
export const DatingRebillUserDocument = gql`
    mutation datingRebillUser($slug: ID!, $rebillable: Boolean!, $category: StopRebillCategory) {
  model(slug: $slug) {
    ... on MutablePurchase {
      updateRebill(rebillable: $rebillable, category: $category) {
        succeed
        errors {
          code
          message
        }
      }
    }
  }
}
    `;

/**
 * __useDatingRebillUserMutation__
 *
 * To run a mutation, you first call `useDatingRebillUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDatingRebillUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDatingRebillUserMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     rebillable: // value for 'rebillable'
 *     category: // value for 'category'
 *   },
 * });
 */
export function useDatingRebillUserMutation(options: VueApolloComposable.UseMutationOptions<DatingRebillUserMutation, DatingRebillUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DatingRebillUserMutation, DatingRebillUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DatingRebillUserMutation, DatingRebillUserMutationVariables>(DatingRebillUserDocument, options);
}
export type DatingRebillUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DatingRebillUserMutation, DatingRebillUserMutationVariables>;
export const SendRebillMailCoachingDocument = gql`
    mutation sendRebillMailCoaching($rebillable: Boolean!) {
  Coaching {
    rebill(rebillable: $rebillable)
  }
}
    `;

/**
 * __useSendRebillMailCoachingMutation__
 *
 * To run a mutation, you first call `useSendRebillMailCoachingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendRebillMailCoachingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendRebillMailCoachingMutation({
 *   variables: {
 *     rebillable: // value for 'rebillable'
 *   },
 * });
 */
export function useSendRebillMailCoachingMutation(options: VueApolloComposable.UseMutationOptions<SendRebillMailCoachingMutation, SendRebillMailCoachingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendRebillMailCoachingMutation, SendRebillMailCoachingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendRebillMailCoachingMutation, SendRebillMailCoachingMutationVariables>(SendRebillMailCoachingDocument, options);
}
export type SendRebillMailCoachingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendRebillMailCoachingMutation, SendRebillMailCoachingMutationVariables>;
export const GetInvoiceOrderDocument = gql`
    query getInvoiceOrder($orderId: String!, $isNewPay: Boolean!) {
  Coaching {
    me {
      getInvoiceUrl(orderId: $orderId, isNewPay: $isNewPay)
    }
  }
}
    `;

/**
 * __useGetInvoiceOrderQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceOrderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceOrderQuery({
 *   orderId: // value for 'orderId'
 *   isNewPay: // value for 'isNewPay'
 * });
 */
export function useGetInvoiceOrderQuery(variables: GetInvoiceOrderQueryVariables | VueCompositionApi.Ref<GetInvoiceOrderQueryVariables> | ReactiveFunction<GetInvoiceOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>(GetInvoiceOrderDocument, variables, options);
}
export function useGetInvoiceOrderLazyQuery(variables?: GetInvoiceOrderQueryVariables | VueCompositionApi.Ref<GetInvoiceOrderQueryVariables> | ReactiveFunction<GetInvoiceOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>(GetInvoiceOrderDocument, variables, options);
}
export type GetInvoiceOrderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceOrderQuery, GetInvoiceOrderQueryVariables>;
export const GetContentLayerPaymentDocument = gql`
    query getContentLayerPayment($model: CoachingContentLayerPaymentModel!, $modelId: Int!) {
  Coaching {
    contentLayerPayment(model: $model, modelId: $modelId) {
      model
      modelId
      position
      thumbnail
      content
    }
  }
}
    `;

/**
 * __useGetContentLayerPaymentQuery__
 *
 * To run a query within a Vue component, call `useGetContentLayerPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentLayerPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContentLayerPaymentQuery({
 *   model: // value for 'model'
 *   modelId: // value for 'modelId'
 * });
 */
export function useGetContentLayerPaymentQuery(variables: GetContentLayerPaymentQueryVariables | VueCompositionApi.Ref<GetContentLayerPaymentQueryVariables> | ReactiveFunction<GetContentLayerPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>(GetContentLayerPaymentDocument, variables, options);
}
export function useGetContentLayerPaymentLazyQuery(variables?: GetContentLayerPaymentQueryVariables | VueCompositionApi.Ref<GetContentLayerPaymentQueryVariables> | ReactiveFunction<GetContentLayerPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>(GetContentLayerPaymentDocument, variables, options);
}
export type GetContentLayerPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContentLayerPaymentQuery, GetContentLayerPaymentQueryVariables>;
export const GetOrdersByCreditCardDocument = gql`
    query getOrdersByCreditCard($panStart: String!, $panEnd: String!, $date: Date!, $amount: Float!, $email: String) {
  Coaching {
    pga {
      ordersByCreditCard(
        panStart: $panStart
        panEnd: $panEnd
        date: $date
        amount: $amount
        email: $email
      ) {
        source
        slug
        token
        rebillSlug
        refunded
        active
        rebillable
        lengthPeriod
        enablePeriod {
          startAt
          endAt
        }
        amount
        symbol
        disablePeriod {
          startAt
          endAt
        }
        nextDisablePeriod {
          startAt
          endAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrdersByCreditCardQuery__
 *
 * To run a query within a Vue component, call `useGetOrdersByCreditCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersByCreditCardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrdersByCreditCardQuery({
 *   panStart: // value for 'panStart'
 *   panEnd: // value for 'panEnd'
 *   date: // value for 'date'
 *   amount: // value for 'amount'
 *   email: // value for 'email'
 * });
 */
export function useGetOrdersByCreditCardQuery(variables: GetOrdersByCreditCardQueryVariables | VueCompositionApi.Ref<GetOrdersByCreditCardQueryVariables> | ReactiveFunction<GetOrdersByCreditCardQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>(GetOrdersByCreditCardDocument, variables, options);
}
export function useGetOrdersByCreditCardLazyQuery(variables?: GetOrdersByCreditCardQueryVariables | VueCompositionApi.Ref<GetOrdersByCreditCardQueryVariables> | ReactiveFunction<GetOrdersByCreditCardQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>(GetOrdersByCreditCardDocument, variables, options);
}
export type GetOrdersByCreditCardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrdersByCreditCardQuery, GetOrdersByCreditCardQueryVariables>;
export const GetOrdersByEmailDocument = gql`
    query getOrdersByEmail($email: String!, $nicheId: Int!) {
  Coaching {
    pga {
      ordersByEmail(email: $email, nicheId: $nicheId)
    }
  }
}
    `;

/**
 * __useGetOrdersByEmailQuery__
 *
 * To run a query within a Vue component, call `useGetOrdersByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersByEmailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrdersByEmailQuery({
 *   email: // value for 'email'
 *   nicheId: // value for 'nicheId'
 * });
 */
export function useGetOrdersByEmailQuery(variables: GetOrdersByEmailQueryVariables | VueCompositionApi.Ref<GetOrdersByEmailQueryVariables> | ReactiveFunction<GetOrdersByEmailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>(GetOrdersByEmailDocument, variables, options);
}
export function useGetOrdersByEmailLazyQuery(variables?: GetOrdersByEmailQueryVariables | VueCompositionApi.Ref<GetOrdersByEmailQueryVariables> | ReactiveFunction<GetOrdersByEmailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>(GetOrdersByEmailDocument, variables, options);
}
export type GetOrdersByEmailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrdersByEmailQuery, GetOrdersByEmailQueryVariables>;
export const SiteDocument = gql`
    query site($host: String!) {
  Coaching {
    site(host: $host) {
      https
      domain
      icon
      name
      redirectURL
      thumbnailLight: thumbnail(type: LIGHT)
      thumbnailDark: thumbnail(type: DARK)
      termsOfService(type: TERMS_OF_SERVICES)
      privacyPolicy: termsOfService(type: PRIVACY_POLICY)
      legalNotices: termsOfService(type: LEGALS_NOTICES)
      options {
        company
        site
        style {
          theme
        }
        google {
          analytics
          recaptcha
        }
        hotjar
        mail
        phone
        zendesk {
          key
          support
          phone
        }
        description
        descripteur
      }
      niche {
        id
        internalName
      }
      company {
        name
        address
      }
    }
    languages {
      id
      code
      label
      translatedLabel
      flag
    }
  }
}
    `;

/**
 * __useSiteQuery__
 *
 * To run a query within a Vue component, call `useSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSiteQuery({
 *   host: // value for 'host'
 * });
 */
export function useSiteQuery(variables: SiteQueryVariables | VueCompositionApi.Ref<SiteQueryVariables> | ReactiveFunction<SiteQueryVariables>, options: VueApolloComposable.UseQueryOptions<SiteQuery, SiteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SiteQuery, SiteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SiteQuery, SiteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SiteQuery, SiteQueryVariables>(SiteDocument, variables, options);
}
export function useSiteLazyQuery(variables?: SiteQueryVariables | VueCompositionApi.Ref<SiteQueryVariables> | ReactiveFunction<SiteQueryVariables>, options: VueApolloComposable.UseQueryOptions<SiteQuery, SiteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SiteQuery, SiteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SiteQuery, SiteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SiteQuery, SiteQueryVariables>(SiteDocument, variables, options);
}
export type SiteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SiteQuery, SiteQueryVariables>;
export const SiteByCompanyDocument = gql`
    query siteByCompany($company: Int!) {
  Coaching {
    sites(company: $company) {
      domain
      niche {
        id
        internalName
      }
    }
  }
}
    `;

/**
 * __useSiteByCompanyQuery__
 *
 * To run a query within a Vue component, call `useSiteByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteByCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSiteByCompanyQuery({
 *   company: // value for 'company'
 * });
 */
export function useSiteByCompanyQuery(variables: SiteByCompanyQueryVariables | VueCompositionApi.Ref<SiteByCompanyQueryVariables> | ReactiveFunction<SiteByCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<SiteByCompanyQuery, SiteByCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SiteByCompanyQuery, SiteByCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SiteByCompanyQuery, SiteByCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SiteByCompanyQuery, SiteByCompanyQueryVariables>(SiteByCompanyDocument, variables, options);
}
export function useSiteByCompanyLazyQuery(variables?: SiteByCompanyQueryVariables | VueCompositionApi.Ref<SiteByCompanyQueryVariables> | ReactiveFunction<SiteByCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<SiteByCompanyQuery, SiteByCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SiteByCompanyQuery, SiteByCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SiteByCompanyQuery, SiteByCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SiteByCompanyQuery, SiteByCompanyQueryVariables>(SiteByCompanyDocument, variables, options);
}
export type SiteByCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SiteByCompanyQuery, SiteByCompanyQueryVariables>;
export const ZendeskContactDocument = gql`
    mutation zendeskContact($input: ZendeskContactInput!) {
  Coaching {
    zendeskContact(input: $input)
  }
}
    `;

/**
 * __useZendeskContactMutation__
 *
 * To run a mutation, you first call `useZendeskContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useZendeskContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useZendeskContactMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useZendeskContactMutation(options: VueApolloComposable.UseMutationOptions<ZendeskContactMutation, ZendeskContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ZendeskContactMutation, ZendeskContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ZendeskContactMutation, ZendeskContactMutationVariables>(ZendeskContactDocument, options);
}
export type ZendeskContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ZendeskContactMutation, ZendeskContactMutationVariables>;
export const CompanyRedirectDocument = gql`
    query companyRedirect($host: String!) {
  Coaching {
    companyRedirect(host: $host) {
      id
    }
  }
}
    `;

/**
 * __useCompanyRedirectQuery__
 *
 * To run a query within a Vue component, call `useCompanyRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRedirectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompanyRedirectQuery({
 *   host: // value for 'host'
 * });
 */
export function useCompanyRedirectQuery(variables: CompanyRedirectQueryVariables | VueCompositionApi.Ref<CompanyRedirectQueryVariables> | ReactiveFunction<CompanyRedirectQueryVariables>, options: VueApolloComposable.UseQueryOptions<CompanyRedirectQuery, CompanyRedirectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompanyRedirectQuery, CompanyRedirectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompanyRedirectQuery, CompanyRedirectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CompanyRedirectQuery, CompanyRedirectQueryVariables>(CompanyRedirectDocument, variables, options);
}
export function useCompanyRedirectLazyQuery(variables?: CompanyRedirectQueryVariables | VueCompositionApi.Ref<CompanyRedirectQueryVariables> | ReactiveFunction<CompanyRedirectQueryVariables>, options: VueApolloComposable.UseQueryOptions<CompanyRedirectQuery, CompanyRedirectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompanyRedirectQuery, CompanyRedirectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompanyRedirectQuery, CompanyRedirectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CompanyRedirectQuery, CompanyRedirectQueryVariables>(CompanyRedirectDocument, variables, options);
}
export type CompanyRedirectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CompanyRedirectQuery, CompanyRedirectQueryVariables>;
export const UnloggedThemeDocument = gql`
    query unloggedTheme($host: String!) {
  Coaching {
    site(host: $host) {
      niche {
        themes {
          internalName
          icon
        }
      }
    }
  }
}
    `;

/**
 * __useUnloggedThemeQuery__
 *
 * To run a query within a Vue component, call `useUnloggedThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnloggedThemeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUnloggedThemeQuery({
 *   host: // value for 'host'
 * });
 */
export function useUnloggedThemeQuery(variables: UnloggedThemeQueryVariables | VueCompositionApi.Ref<UnloggedThemeQueryVariables> | ReactiveFunction<UnloggedThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<UnloggedThemeQuery, UnloggedThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UnloggedThemeQuery, UnloggedThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UnloggedThemeQuery, UnloggedThemeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UnloggedThemeQuery, UnloggedThemeQueryVariables>(UnloggedThemeDocument, variables, options);
}
export function useUnloggedThemeLazyQuery(variables?: UnloggedThemeQueryVariables | VueCompositionApi.Ref<UnloggedThemeQueryVariables> | ReactiveFunction<UnloggedThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<UnloggedThemeQuery, UnloggedThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UnloggedThemeQuery, UnloggedThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UnloggedThemeQuery, UnloggedThemeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UnloggedThemeQuery, UnloggedThemeQueryVariables>(UnloggedThemeDocument, variables, options);
}
export type UnloggedThemeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UnloggedThemeQuery, UnloggedThemeQueryVariables>;
export const LoggedThemesDocument = gql`
    query loggedThemes {
  Coaching {
    me {
      themes {
        ...detailTheme
      }
    }
  }
}
    ${DetailThemeFragmentDoc}`;

/**
 * __useLoggedThemesQuery__
 *
 * To run a query within a Vue component, call `useLoggedThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedThemesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoggedThemesQuery();
 */
export function useLoggedThemesQuery(options: VueApolloComposable.UseQueryOptions<LoggedThemesQuery, LoggedThemesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoggedThemesQuery, LoggedThemesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoggedThemesQuery, LoggedThemesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LoggedThemesQuery, LoggedThemesQueryVariables>(LoggedThemesDocument, {}, options);
}
export function useLoggedThemesLazyQuery(options: VueApolloComposable.UseQueryOptions<LoggedThemesQuery, LoggedThemesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoggedThemesQuery, LoggedThemesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoggedThemesQuery, LoggedThemesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LoggedThemesQuery, LoggedThemesQueryVariables>(LoggedThemesDocument, {}, options);
}
export type LoggedThemesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoggedThemesQuery, LoggedThemesQueryVariables>;
export const FreeLoggedThemesDocument = gql`
    query freeLoggedThemes {
  Coaching {
    me {
      themes {
        ...freeDetailTheme
      }
    }
  }
}
    ${FreeDetailThemeFragmentDoc}`;

/**
 * __useFreeLoggedThemesQuery__
 *
 * To run a query within a Vue component, call `useFreeLoggedThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreeLoggedThemesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFreeLoggedThemesQuery();
 */
export function useFreeLoggedThemesQuery(options: VueApolloComposable.UseQueryOptions<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>(FreeLoggedThemesDocument, {}, options);
}
export function useFreeLoggedThemesLazyQuery(options: VueApolloComposable.UseQueryOptions<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>(FreeLoggedThemesDocument, {}, options);
}
export type FreeLoggedThemesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FreeLoggedThemesQuery, FreeLoggedThemesQueryVariables>;
export const LoggedThemeDocument = gql`
    query loggedTheme($slug: String!) {
  Coaching {
    me {
      theme(slug: $slug) {
        ...detailTheme
        capsules {
          ...displayArticle
        }
      }
    }
  }
}
    ${DetailThemeFragmentDoc}
${DisplayArticleFragmentDoc}`;

/**
 * __useLoggedThemeQuery__
 *
 * To run a query within a Vue component, call `useLoggedThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedThemeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoggedThemeQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useLoggedThemeQuery(variables: LoggedThemeQueryVariables | VueCompositionApi.Ref<LoggedThemeQueryVariables> | ReactiveFunction<LoggedThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<LoggedThemeQuery, LoggedThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoggedThemeQuery, LoggedThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoggedThemeQuery, LoggedThemeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LoggedThemeQuery, LoggedThemeQueryVariables>(LoggedThemeDocument, variables, options);
}
export function useLoggedThemeLazyQuery(variables?: LoggedThemeQueryVariables | VueCompositionApi.Ref<LoggedThemeQueryVariables> | ReactiveFunction<LoggedThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<LoggedThemeQuery, LoggedThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoggedThemeQuery, LoggedThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoggedThemeQuery, LoggedThemeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LoggedThemeQuery, LoggedThemeQueryVariables>(LoggedThemeDocument, variables, options);
}
export type LoggedThemeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoggedThemeQuery, LoggedThemeQueryVariables>;
export const FreeLoggedThemeDocument = gql`
    query freeLoggedTheme($slug: String!) {
  Coaching {
    me {
      theme(slug: $slug) {
        ...freeDetailTheme
        capsules {
          ...freeDisplayArticle
        }
      }
    }
  }
}
    ${FreeDetailThemeFragmentDoc}
${FreeDisplayArticleFragmentDoc}`;

/**
 * __useFreeLoggedThemeQuery__
 *
 * To run a query within a Vue component, call `useFreeLoggedThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreeLoggedThemeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFreeLoggedThemeQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useFreeLoggedThemeQuery(variables: FreeLoggedThemeQueryVariables | VueCompositionApi.Ref<FreeLoggedThemeQueryVariables> | ReactiveFunction<FreeLoggedThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>(FreeLoggedThemeDocument, variables, options);
}
export function useFreeLoggedThemeLazyQuery(variables?: FreeLoggedThemeQueryVariables | VueCompositionApi.Ref<FreeLoggedThemeQueryVariables> | ReactiveFunction<FreeLoggedThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>(FreeLoggedThemeDocument, variables, options);
}
export type FreeLoggedThemeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FreeLoggedThemeQuery, FreeLoggedThemeQueryVariables>;
export const LoggedThemesWithoutCapsulesDocument = gql`
    query loggedThemesWithoutCapsules {
  Coaching {
    me {
      themes {
        ...detailTheme
      }
      capsule(search: {progress: true}) {
        ...displayArticle
      }
    }
  }
}
    ${DetailThemeFragmentDoc}
${DisplayArticleFragmentDoc}`;

/**
 * __useLoggedThemesWithoutCapsulesQuery__
 *
 * To run a query within a Vue component, call `useLoggedThemesWithoutCapsulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedThemesWithoutCapsulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoggedThemesWithoutCapsulesQuery();
 */
export function useLoggedThemesWithoutCapsulesQuery(options: VueApolloComposable.UseQueryOptions<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>(LoggedThemesWithoutCapsulesDocument, {}, options);
}
export function useLoggedThemesWithoutCapsulesLazyQuery(options: VueApolloComposable.UseQueryOptions<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>(LoggedThemesWithoutCapsulesDocument, {}, options);
}
export type LoggedThemesWithoutCapsulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoggedThemesWithoutCapsulesQuery, LoggedThemesWithoutCapsulesQueryVariables>;
export const FreeLoggedThemesWithoutCapsulesDocument = gql`
    query freeLoggedThemesWithoutCapsules {
  Coaching {
    me {
      themes {
        ...freeDetailTheme
      }
      capsule(search: {progress: true}) {
        ...freeDisplayArticle
      }
    }
  }
}
    ${FreeDetailThemeFragmentDoc}
${FreeDisplayArticleFragmentDoc}`;

/**
 * __useFreeLoggedThemesWithoutCapsulesQuery__
 *
 * To run a query within a Vue component, call `useFreeLoggedThemesWithoutCapsulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreeLoggedThemesWithoutCapsulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFreeLoggedThemesWithoutCapsulesQuery();
 */
export function useFreeLoggedThemesWithoutCapsulesQuery(options: VueApolloComposable.UseQueryOptions<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>(FreeLoggedThemesWithoutCapsulesDocument, {}, options);
}
export function useFreeLoggedThemesWithoutCapsulesLazyQuery(options: VueApolloComposable.UseQueryOptions<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>(FreeLoggedThemesWithoutCapsulesDocument, {}, options);
}
export type FreeLoggedThemesWithoutCapsulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FreeLoggedThemesWithoutCapsulesQuery, FreeLoggedThemesWithoutCapsulesQueryVariables>;
export const UserDocument = gql`
    query user {
  Coaching {
    me {
      ...detailUser
    }
  }
}
    ${DetailUserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a Vue component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserQuery();
 */
export function useUserQuery(options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserQuery, UserQueryVariables>(UserDocument, {}, options);
}
export function useUserLazyQuery(options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, {}, options);
}
export type UserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserQuery, UserQueryVariables>;
export const CheckEmailDocument = gql`
    query checkEmail($host: String!, $email: String!, $useIpqs: Boolean) {
  Coaching {
    checkEmail(host: $host, email: $email, useIpqs: $useIpqs) {
      switchDomain
      user
      userHasNiche
      message
    }
  }
}
    `;

/**
 * __useCheckEmailQuery__
 *
 * To run a query within a Vue component, call `useCheckEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckEmailQuery({
 *   host: // value for 'host'
 *   email: // value for 'email'
 *   useIpqs: // value for 'useIpqs'
 * });
 */
export function useCheckEmailQuery(variables: CheckEmailQueryVariables | VueCompositionApi.Ref<CheckEmailQueryVariables> | ReactiveFunction<CheckEmailQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckEmailQuery, CheckEmailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckEmailQuery, CheckEmailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckEmailQuery, CheckEmailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CheckEmailQuery, CheckEmailQueryVariables>(CheckEmailDocument, variables, options);
}
export function useCheckEmailLazyQuery(variables?: CheckEmailQueryVariables | VueCompositionApi.Ref<CheckEmailQueryVariables> | ReactiveFunction<CheckEmailQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckEmailQuery, CheckEmailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckEmailQuery, CheckEmailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckEmailQuery, CheckEmailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CheckEmailQuery, CheckEmailQueryVariables>(CheckEmailDocument, variables, options);
}
export type CheckEmailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CheckEmailQuery, CheckEmailQueryVariables>;
export const TransformDatingTokenDocument = gql`
    query transformDatingToken($datingToken: String!) {
  Coaching {
    transformDatingToken(datingToken: $datingToken)
  }
}
    `;

/**
 * __useTransformDatingTokenQuery__
 *
 * To run a query within a Vue component, call `useTransformDatingTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransformDatingTokenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTransformDatingTokenQuery({
 *   datingToken: // value for 'datingToken'
 * });
 */
export function useTransformDatingTokenQuery(variables: TransformDatingTokenQueryVariables | VueCompositionApi.Ref<TransformDatingTokenQueryVariables> | ReactiveFunction<TransformDatingTokenQueryVariables>, options: VueApolloComposable.UseQueryOptions<TransformDatingTokenQuery, TransformDatingTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>(TransformDatingTokenDocument, variables, options);
}
export function useTransformDatingTokenLazyQuery(variables?: TransformDatingTokenQueryVariables | VueCompositionApi.Ref<TransformDatingTokenQueryVariables> | ReactiveFunction<TransformDatingTokenQueryVariables>, options: VueApolloComposable.UseQueryOptions<TransformDatingTokenQuery, TransformDatingTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>(TransformDatingTokenDocument, variables, options);
}
export type TransformDatingTokenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TransformDatingTokenQuery, TransformDatingTokenQueryVariables>;
export const RandomUsernamesDocument = gql`
    query randomUsernames {
  Coaching {
    randomUsernames
  }
}
    `;

/**
 * __useRandomUsernamesQuery__
 *
 * To run a query within a Vue component, call `useRandomUsernamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomUsernamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRandomUsernamesQuery();
 */
export function useRandomUsernamesQuery(options: VueApolloComposable.UseQueryOptions<RandomUsernamesQuery, RandomUsernamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RandomUsernamesQuery, RandomUsernamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RandomUsernamesQuery, RandomUsernamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RandomUsernamesQuery, RandomUsernamesQueryVariables>(RandomUsernamesDocument, {}, options);
}
export function useRandomUsernamesLazyQuery(options: VueApolloComposable.UseQueryOptions<RandomUsernamesQuery, RandomUsernamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RandomUsernamesQuery, RandomUsernamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RandomUsernamesQuery, RandomUsernamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RandomUsernamesQuery, RandomUsernamesQueryVariables>(RandomUsernamesDocument, {}, options);
}
export type RandomUsernamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RandomUsernamesQuery, RandomUsernamesQueryVariables>;
export const LogConnectionDocument = gql`
    mutation logConnection($source: CoachingSourceConnection) {
  Coaching {
    me {
      logConnection(source: $source)
    }
  }
}
    `;

/**
 * __useLogConnectionMutation__
 *
 * To run a mutation, you first call `useLogConnectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLogConnectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLogConnectionMutation({
 *   variables: {
 *     source: // value for 'source'
 *   },
 * });
 */
export function useLogConnectionMutation(options: VueApolloComposable.UseMutationOptions<LogConnectionMutation, LogConnectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LogConnectionMutation, LogConnectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LogConnectionMutation, LogConnectionMutationVariables>(LogConnectionDocument, options);
}
export type LogConnectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LogConnectionMutation, LogConnectionMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!, $host: String!) {
  Coaching {
    signIn(email: $email, password: $password, host: $host)
  }
}
    `;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutation({
 *   variables: {
 *     email: // value for 'email'
 *     password: // value for 'password'
 *     host: // value for 'host'
 *   },
 * });
 */
export function useLoginMutation(options: VueApolloComposable.UseMutationOptions<LoginMutation, LoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LoginMutation, LoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LoginMutation, LoginMutationVariables>;
export const ForgotDocument = gql`
    mutation forgot($email: String!, $host: String!) {
  Coaching {
    resetPassword(email: $email, host: $host) {
      success
      refunded
    }
  }
}
    `;

/**
 * __useForgotMutation__
 *
 * To run a mutation, you first call `useForgotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForgotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForgotMutation({
 *   variables: {
 *     email: // value for 'email'
 *     host: // value for 'host'
 *   },
 * });
 */
export function useForgotMutation(options: VueApolloComposable.UseMutationOptions<ForgotMutation, ForgotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ForgotMutation, ForgotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ForgotMutation, ForgotMutationVariables>(ForgotDocument, options);
}
export type ForgotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ForgotMutation, ForgotMutationVariables>;
export const PasswordDocument = gql`
    mutation password($password: String!) {
  Coaching {
    me {
      generatePassword(password: $password)
    }
  }
}
    `;

/**
 * __usePasswordMutation__
 *
 * To run a mutation, you first call `usePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePasswordMutation({
 *   variables: {
 *     password: // value for 'password'
 *   },
 * });
 */
export function usePasswordMutation(options: VueApolloComposable.UseMutationOptions<PasswordMutation, PasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PasswordMutation, PasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PasswordMutation, PasswordMutationVariables>(PasswordDocument, options);
}
export type PasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PasswordMutation, PasswordMutationVariables>;
export const RegisterDocument = gql`
    mutation register($data: CoachingRegisterUserInput!) {
  Coaching {
    registerUser(data: $data) {
      redirectURL
      token
    }
  }
}
    `;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useRegisterMutation(options: VueApolloComposable.UseMutationOptions<RegisterMutation, RegisterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterMutation, RegisterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
}
export type RegisterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterMutation, RegisterMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: CoachingUserUpdateInput!) {
  Coaching {
    me {
      update(data: $input) {
        ...detailUser
      }
    }
  }
}
    ${DetailUserFragmentDoc}`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser {
  Coaching {
    me {
      delete
    }
  }
}
    `;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserMutation();
 */
export function useDeleteUserMutation(options: VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUserMutation, DeleteUserMutationVariables>;
export const AskConfirmationEmailDocument = gql`
    mutation askConfirmationEmail($host: String!) {
  Coaching {
    me {
      askConfirmationEmail(host: $host)
    }
  }
}
    `;

/**
 * __useAskConfirmationEmailMutation__
 *
 * To run a mutation, you first call `useAskConfirmationEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAskConfirmationEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAskConfirmationEmailMutation({
 *   variables: {
 *     host: // value for 'host'
 *   },
 * });
 */
export function useAskConfirmationEmailMutation(options: VueApolloComposable.UseMutationOptions<AskConfirmationEmailMutation, AskConfirmationEmailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AskConfirmationEmailMutation, AskConfirmationEmailMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AskConfirmationEmailMutation, AskConfirmationEmailMutationVariables>(AskConfirmationEmailDocument, options);
}
export type AskConfirmationEmailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AskConfirmationEmailMutation, AskConfirmationEmailMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation confirmEmail {
  Coaching {
    me {
      confirmEmail
    }
  }
}
    `;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmEmailMutation();
 */
export function useConfirmEmailMutation(options: VueApolloComposable.UseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
}
export type ConfirmEmailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const PrefThemesDocument = gql`
    mutation prefThemes($input: [CoachingMutationThemePreference!]) {
  Coaching {
    me {
      setThemePreference(input: $input) {
        ...detailTheme
      }
    }
  }
}
    ${DetailThemeFragmentDoc}`;

/**
 * __usePrefThemesMutation__
 *
 * To run a mutation, you first call `usePrefThemesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePrefThemesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePrefThemesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePrefThemesMutation(options: VueApolloComposable.UseMutationOptions<PrefThemesMutation, PrefThemesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PrefThemesMutation, PrefThemesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PrefThemesMutation, PrefThemesMutationVariables>(PrefThemesDocument, options);
}
export type PrefThemesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PrefThemesMutation, PrefThemesMutationVariables>;
export const SetPseudoDocument = gql`
    mutation setPseudo($pseudo: String!) {
  Coaching {
    me {
      setPseudo(pseudo: $pseudo)
    }
  }
}
    `;

/**
 * __useSetPseudoMutation__
 *
 * To run a mutation, you first call `useSetPseudoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPseudoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPseudoMutation({
 *   variables: {
 *     pseudo: // value for 'pseudo'
 *   },
 * });
 */
export function useSetPseudoMutation(options: VueApolloComposable.UseMutationOptions<SetPseudoMutation, SetPseudoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetPseudoMutation, SetPseudoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetPseudoMutation, SetPseudoMutationVariables>(SetPseudoDocument, options);
}
export type SetPseudoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetPseudoMutation, SetPseudoMutationVariables>;
export const SetBirthDateDocument = gql`
    mutation setBirthDate($bornDate: String!) {
  Coaching {
    me {
      setBirthDate(bornDate: $bornDate)
    }
  }
}
    `;

/**
 * __useSetBirthDateMutation__
 *
 * To run a mutation, you first call `useSetBirthDateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetBirthDateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetBirthDateMutation({
 *   variables: {
 *     bornDate: // value for 'bornDate'
 *   },
 * });
 */
export function useSetBirthDateMutation(options: VueApolloComposable.UseMutationOptions<SetBirthDateMutation, SetBirthDateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetBirthDateMutation, SetBirthDateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetBirthDateMutation, SetBirthDateMutationVariables>(SetBirthDateDocument, options);
}
export type SetBirthDateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetBirthDateMutation, SetBirthDateMutationVariables>;
export const SetMediaTimecodeDocument = gql`
    mutation setMediaTimecode($model: UserHasMediaTimecodeModel!, $modelId: Int!, $mediaType: MediaType!, $timecodeInSeconds: Int!) {
  Coaching {
    me {
      setMediaTimecode(
        input: {model: $model, modelId: $modelId, mediaType: $mediaType, timecodeInSeconds: $timecodeInSeconds}
      )
    }
  }
}
    `;

/**
 * __useSetMediaTimecodeMutation__
 *
 * To run a mutation, you first call `useSetMediaTimecodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetMediaTimecodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetMediaTimecodeMutation({
 *   variables: {
 *     model: // value for 'model'
 *     modelId: // value for 'modelId'
 *     mediaType: // value for 'mediaType'
 *     timecodeInSeconds: // value for 'timecodeInSeconds'
 *   },
 * });
 */
export function useSetMediaTimecodeMutation(options: VueApolloComposable.UseMutationOptions<SetMediaTimecodeMutation, SetMediaTimecodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetMediaTimecodeMutation, SetMediaTimecodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetMediaTimecodeMutation, SetMediaTimecodeMutationVariables>(SetMediaTimecodeDocument, options);
}
export type SetMediaTimecodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetMediaTimecodeMutation, SetMediaTimecodeMutationVariables>;
export const GetWordingContentsDocument = gql`
    query getWordingContents($model: CoachingWordingContentModel!, $modelId: Int!, $category: String!) {
  Coaching {
    wordingContents(model: $model, modelId: $modelId, category: $category) {
      content
    }
  }
}
    `;

/**
 * __useGetWordingContentsQuery__
 *
 * To run a query within a Vue component, call `useGetWordingContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordingContentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWordingContentsQuery({
 *   model: // value for 'model'
 *   modelId: // value for 'modelId'
 *   category: // value for 'category'
 * });
 */
export function useGetWordingContentsQuery(variables: GetWordingContentsQueryVariables | VueCompositionApi.Ref<GetWordingContentsQueryVariables> | ReactiveFunction<GetWordingContentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWordingContentsQuery, GetWordingContentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWordingContentsQuery, GetWordingContentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWordingContentsQuery, GetWordingContentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWordingContentsQuery, GetWordingContentsQueryVariables>(GetWordingContentsDocument, variables, options);
}
export function useGetWordingContentsLazyQuery(variables?: GetWordingContentsQueryVariables | VueCompositionApi.Ref<GetWordingContentsQueryVariables> | ReactiveFunction<GetWordingContentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWordingContentsQuery, GetWordingContentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWordingContentsQuery, GetWordingContentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWordingContentsQuery, GetWordingContentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetWordingContentsQuery, GetWordingContentsQueryVariables>(GetWordingContentsDocument, variables, options);
}
export type GetWordingContentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWordingContentsQuery, GetWordingContentsQueryVariables>;
export const GetWordingContentOfferPdpDocument = gql`
    query getWordingContentOfferPdp($ebookId: Int!) {
  image: Coaching {
    wordingContents(category: "offer-pdp-image", modelId: $ebookId, model: EBOOK) {
      content
    }
  }
  text: Coaching {
    wordingContents(category: "offer-pdp-text", modelId: $ebookId, model: EBOOK) {
      content
    }
  }
}
    `;

/**
 * __useGetWordingContentOfferPdpQuery__
 *
 * To run a query within a Vue component, call `useGetWordingContentOfferPdpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordingContentOfferPdpQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWordingContentOfferPdpQuery({
 *   ebookId: // value for 'ebookId'
 * });
 */
export function useGetWordingContentOfferPdpQuery(variables: GetWordingContentOfferPdpQueryVariables | VueCompositionApi.Ref<GetWordingContentOfferPdpQueryVariables> | ReactiveFunction<GetWordingContentOfferPdpQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>(GetWordingContentOfferPdpDocument, variables, options);
}
export function useGetWordingContentOfferPdpLazyQuery(variables?: GetWordingContentOfferPdpQueryVariables | VueCompositionApi.Ref<GetWordingContentOfferPdpQueryVariables> | ReactiveFunction<GetWordingContentOfferPdpQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>(GetWordingContentOfferPdpDocument, variables, options);
}
export type GetWordingContentOfferPdpQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWordingContentOfferPdpQuery, GetWordingContentOfferPdpQueryVariables>;
export const GetWordingContentEbookFilenameDocument = gql`
    query getWordingContentEbookFilename($ebookId: Int!) {
  Coaching {
    wordingContents(category: "offer-pdp-filename", modelId: $ebookId, model: EBOOK) {
      content
    }
  }
}
    `;

/**
 * __useGetWordingContentEbookFilenameQuery__
 *
 * To run a query within a Vue component, call `useGetWordingContentEbookFilenameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordingContentEbookFilenameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWordingContentEbookFilenameQuery({
 *   ebookId: // value for 'ebookId'
 * });
 */
export function useGetWordingContentEbookFilenameQuery(variables: GetWordingContentEbookFilenameQueryVariables | VueCompositionApi.Ref<GetWordingContentEbookFilenameQueryVariables> | ReactiveFunction<GetWordingContentEbookFilenameQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>(GetWordingContentEbookFilenameDocument, variables, options);
}
export function useGetWordingContentEbookFilenameLazyQuery(variables?: GetWordingContentEbookFilenameQueryVariables | VueCompositionApi.Ref<GetWordingContentEbookFilenameQueryVariables> | ReactiveFunction<GetWordingContentEbookFilenameQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>(GetWordingContentEbookFilenameDocument, variables, options);
}
export type GetWordingContentEbookFilenameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWordingContentEbookFilenameQuery, GetWordingContentEbookFilenameQueryVariables>;